export default {
  "Modo escuro": "Mode sombre",
  "Modo claro": "Mode clair",
  "Escuro": "Sombre",
  "Claro": "Clair",
  " (as de maior volume)": " (les plus fréquentées)",
  " (inativa)": " (inactive)",
  " (seleção manual)": " (sélection manuelle)",
  " Esta ação não afeta o vídeo já enviado.": " Cette action n'affecte pas la vidéo déjà envoyée.",
  " de ": " de ",
  " em {value0}": " dans {value0}",
  " · o player mostra \"Conteúdo indisponível\" enquanto pausado": " · le lecteur affiche « Contenu indisponible » pendant la pause",
  " · vencedora": " · gagnante",
  " Último: {value0}.": " Dernier : {value0}.",
  " • {value0} de conteúdo": " • {value0} de contenu",
  "\" aparece.": " » apparaît.",
  "\" será removida deste teste.": " » sera supprimée de ce test.",
  "\" será removido da fila de upload.": " » sera retiré de la file d'envoi.",
  "\" será removido da lista.": " » sera retiré de la liste.",
  "\" será removido permanentemente.": " » sera supprimé définitivement.",
  "\"5 Dicas Secretas\" vs \"Dicas Secretas\"": "« 5 astuces secrètes » vs « Astuces secrètes »",
  "\"? Ela deixará de funcionar imediatamente.": " » ? Elle cessera de fonctionner immédiatement.",
  "\"? Esta ação não pode ser desfeita.": " » ? Cette action est irréversible.",
  "\"Assista esse vídeo\"": "« Regardez cette vidéo »",
  "\"Ganhe R$ 1.000/mês\" vs \"Ganhe dinheiro\"": "« Gagnez R$ 1.000/mois » vs « Gagnez de l'argent »",
  "\"{value0}\" enviado. O processamento começou.": "« {value0} » envoyé. Le traitement a commencé.",
  "\"{value0}\" está completamente pronto e disponível para visualização!": "« {value0} » est entièrement prêt et disponible au visionnage !",
  "\"{value0}\" está pronto para personalização": "« {value0} » est prêt à personnaliser",
  "\"{value0}\" está pronto para personalização (configurações padrão)": "« {value0} » est prêt à personnaliser (paramètres par défaut)",
  "\"{value0}\" já pode ser personalizado! O MP4 ainda está sendo gerado.": "« {value0} » peut déjà être personnalisé ! Le MP4 est encore en cours de génération.",
  "\"Últimas 24h\", \"Vagas Limitadas\"": "« Dernières 24 h », « Places limitées »",
  "#meuElemento ou .minha-classe": "#meuElemento ou .minha-classe",
  "% (ajuste para 100%)": "% (ajustez à 100%)",
  "% Engajamento": "% d'engagement",
  "% OFF ativo": "% DE RÉDUCTION active",
  "% PlayRate": "% de taux de lecture",
  "% abaixo do desktop. Otimize sua experiência mobile.": "% de moins que sur ordinateur. Optimisez votre expérience mobile.",
  "% ainda assistindo": "% regardent encore",
  "% concluído": "% terminé",
  "% convertem": "% convertissent",
  "% da audiência ainda está assistindo.": "% de l'audience regarde encore.",
  "% das views": "% des vues",
  "% das visualizações": "% des vues",
  "% de engajamento neste ponto": "% d'engagement à cet instant",
  "% de participação": "% de participation",
  "% de retenção": "% de rétention",
  "% de visitantes que deram play no vídeo. Avalia título + thumbnail.": "% des visiteurs ont lancé la vidéo. Évalue le titre et la miniature.",
  "% do horário de pico": "% de l'heure de pointe",
  "% do limite": "% de la limite",
  "% do pico": "% du pic",
  "% do pico do período": "% du pic de la période",
  "% do total": "% du total",
  "% do tráfego": "% du trafic",
  "% do vídeo": "% de la vidéo",
  "% dos espectadores saem aqui": "% des spectateurs quittent ici",
  "% dos espectadores saíram aqui": "% des spectateurs ont quitté ici",
  "% dos plays do período.": "% des lectures de la période.",
  "% engajamento": "% d'engagement",
  "% médio de tempo assistido. Indica profundidade da retenção.": "% moyen de durée regardée. Indique la profondeur de rétention.",
  "% retenção": "% de rétention",
  "% variação": "% de variation",
  "% vs 4 sem": "% par rapport à 4 semaines",
  "% vs período anterior": "% par rapport à la période précédente",
  "% vs. período anterior": "% par rapport à la période précédente",
  "' da lista?": "» de la liste ?",
  "(Mais alta)": "(La plus élevée)",
  "(Mais baixa)": "(La plus faible)",
  "(Produto)": "(Produit)",
  "(Recomendado:": "(Recommandé :",
  "(Visível só para você)": "(Visible uniquement par vous)",
  "(XX) XXXXX-XXXX": "(XX) XXXXX-XXXX",
  "(cópia)": "(copie)",
  "(deve ser 100%)": "(doit être égal à 100%)",
  "(fim)": "(fin)",
  "(mínimo 4.5:1)": "(minimum 4.5:1)",
  "(não usado neste template)": "(non utilisé dans ce modèle)",
  "(opcional)": "(facultatif)",
  "(recomendado)": "(recommandé)",
  "). Ou o VSL não foi aberto nas últimas 24h, ou o envio server-side falhou (credencial/endpoint) — ou a URL vinculada não é a página do vídeo.": "). Soit la VSL n'a pas été ouverte dans les dernières 24 h, soit l'envoi côté serveur a échoué (identifiants/endpoint), soit l'URL associée ne correspond pas à la page de la vidéo.",
  "+ Adicionar": "+ Ajouter",
  "+ Adicionar Plays Extras": "+ Ajouter des lectures supplémentaires",
  "+ Adicionar ao Plano": "+ Ajouter au forfait",
  "+ Adicionar mais": "+ Ajouter davantage",
  "+ Adicionar parâmetro": "+ Ajouter un paramètre",
  "+ Adicionar vídeos": "+ Ajouter des vidéos",
  "+ Conectar Novo Pixel": "+ Connecter un nouveau pixel",
  "+ Conectar Plataforma": "+ Connecter une plateforme",
  "+ Etapa": "+ Étape",
  "+ Novo Vídeo": "+ Nouvelle vidéo",
  ", todas ligadas": ", toutes associées",
  ". Ao confirmar, você reconhece que recebeu acesso autorizado para usar este vídeo na sua conta HostVSL e concorda em não redistribuir este conteúdo para outras pessoas fora do fluxo oficial de compartilhamento.": ". En confirmant, vous reconnaissez avoir reçu l'autorisation d'utiliser cette vidéo dans votre compte HostVSL et vous vous engagez à ne pas redistribuer ce contenu en dehors du processus officiel de partage.",
  ". Cancele quando quiser.": ". Résiliez quand vous le souhaitez.",
  ". Clique em uma célula para ver detalhes e abrir no Tracking.": ". Cliquez sur une cellule pour voir les détails et ouvrir le suivi.",
  ". Cole apenas o valor, sem escrever nada antes dele.": ". Collez uniquement la valeur, sans ajouter de texte avant.",
  ". Deseja continuar?": ". Voulez-vous continuer ?",
  ". Ele será usado para todas as intros do teste.": ". Il sera utilisé pour toutes les intros du test.",
  ". Use esses dados para planejar estratégias de tráfego.": ". Utilisez ces données pour planifier vos stratégies de trafic.",
  ".SRT": ".SRT",
  ".VTT": ".VTT",
  "/ mês": "/ mois",
  "/mês": "/mois",
  "0 = exibir até o final do vídeo": "0 = afficher jusqu'à la fin de la vidéo",
  "0 participantes": "0 participant",
  "001 - Banco do Brasil S.A.": "001 - Banco do Brasil S.A.",
  "004 - Banco do Nordeste do Brasil S.A.": "004 - Banco do Nordeste do Brasil S.A.",
  "02 JAN 2026": "02 JANV. 2026",
  "021 - BANESTES S.A. Banco do Estado do Espírito Santo": "021 - BANESTES S.A. Banco do Estado do Espírito Santo",
  "033 - Banco Santander (Brasil) S.A.": "033 - Banco Santander (Brasil) S.A.",
  "041 - Banco do Estado do Rio Grande do Sul S.A. (Banrisul)": "041 - Banco do Estado do Rio Grande do Sul S.A. (Banrisul)",
  "070 - Banco de Brasília S.A. (BRB)": "070 - Banco de Brasília S.A. (BRB)",
  "077 - Banco Inter S.A.": "077 - Banco Inter S.A.",
  "085 - Cooperativa Central de Crédito Ailos": "085 - Cooperativa Central de Crédito Ailos",
  "09 JAN 2026": "09 JANV. 2026",
  "1 = maior prioridade. Regras com maior prioridade são avaliadas primeiro.": "1 = priorité la plus élevée. Les règles prioritaires sont évaluées en premier.",
  "1 Play = R$": "1 lecture = R$",
  "1 Play = R$ 0,02": "1 lecture = R$ 0,02",
  "1 USD = BRL": "1 USD = BRL",
  "1 linha": "1 ligne",
  "1. Crie o fluxo": "1. Créez le parcours",
  "1. Crie um teste": "1. Créez un test",
  "1. Para PlayRate Baixo (abaixo de 45%):": "1. Pour un faible taux de lecture (moins de 45%) :",
  "1. Pegue o seu link": "1. Récupérez votre lien",
  "1. Selecione duas VSLs": "1. Sélectionnez deux VSL",
  "1.0x (Normal)": "1.0x (Normal)",
  "1.8 GB": "1.8 GB",
  "10 minutos": "10 minutes",
  "10 p/ pág": "10 par page",
  "10 segundos": "10 secondes",
  "10% das comissões deles": "10% de leurs commissions",
  "100 p/ pág": "100 par page",
  "104 - Caixa Econômica Federal": "104 - Caixa Econômica Federal",
  "12% menos": "12% de moins",
  "136 - Confederação Nacional das Cooperativas Unicred": "136 - Confederação Nacional das Cooperativas Unicred",
  "15 dias grátis": "15 jours gratuits",
  "15 dias grátis — você só paga após o período de teste": "15 jours gratuits — vous ne payez qu'après la période d'essai",
  "15 minutos": "15 minutes",
  "15 segundos": "15 secondes",
  "16 JAN 2026": "16 JANV. 2026",
  "197 - Stone Co. (Stone Pagamentos)": "197 - Stone Co. (Stone Pagamentos)",
  "2 dias atrás": "Il y a 2 jours",
  "2 linhas": "2 lignes",
  "2 segundos": "2 secondes",
  "2. Acompanhe os cliques": "2. Suivez les clics",
  "2. Analise os dados reais": "2. Analysez les données réelles",
  "2. Distribuição automática": "2. Répartition automatique",
  "2. Distribução automática": "2. Répartition automatique",
  "2. Envie os vídeos": "2. Envoyez les vidéos",
  "2. Para Engajamento Baixo (abaixo de 50%):": "2. Pour un faible engagement (moins de 50%) :",
  "20 p/ pág": "20 par page",
  "20% de comissão recorrente": "20% de commission récurrente",
  "208 - Banco BTG Pactual S.A.": "208 - Banco BTG Pactual S.A.",
  "212 - Banco Original S.A.": "212 - Banco Original S.A.",
  "23 JAN 2026": "23 JANV. 2026",
  "237 - Banco Bradesco S.A.": "237 - Banco Bradesco S.A.",
  "25 p/ pág": "25 par page",
  "25% recorrente": "25% récurrents",
  "26 DEZ 2025": "26 DÉC. 2025",
  "260 - Nu Pagamentos S.A. (Nubank)": "260 - Nu Pagamentos S.A. (Nubank)",
  "290 - Pagseguro Internet S.A. (PagBank)": "290 - Pagseguro Internet S.A. (PagBank)",
  "3 dias úteis": "3 jours ouvrés",
  "3 linhas": "3 lignes",
  "3 segundos": "3 secondes",
  "3. Análise de métricas": "3. Analyse des indicateurs",
  "3. Identifique a vencedora": "3. Identifiez la gagnante",
  "3. Monte as etapas": "3. Organisez les étapes",
  "3. Para Cliques Baixos no CTA:": "3. Pour un faible nombre de clics sur le CTA :",
  "3. Receba os pagamentos": "3. Recevez les paiements",
  "30 dias": "30 jours",
  "30 minutos": "30 minutes",
  "30.000 plays por mês": "30.000 lectures par mois",
  "323 - Mercado Pago Caixa Eletrônica do MP Ltda.": "323 - Mercado Pago Caixa Eletrônica do MP Ltda.",
  "336 - Banco C6 S.A. (C6 Bank)": "336 - Banco C6 S.A. (C6 Bank)",
  "341 - Itaú Unibanco S.A.": "341 - Itaú Unibanco S.A.",
  "389 - Banco Mercantil do Brasil S.A.": "389 - Banco Mercantil do Brasil S.A.",
  "390 × 844 · iPhone": "390 × 844 · iPhone",
  "399 - Kirton Bank S.A. (Banco Múltiplo)": "399 - Kirton Bank S.A. (Banco Múltiplo)",
  "4. Identifique o vencedor": "4. Identifiez le gagnant",
  "4. Otimize suas decisões": "4. Optimisez vos décisions",
  "4. Personalize o player": "4. Personnalisez le lecteur",
  "403 - Cora Sociedade de Crédito Direto S.A.": "403 - Cora Sociedade de Crédito Direto S.A.",
  "422 - Banco Safra S.A.": "422 - Banco Safra S.A.",
  "5 minutos": "5 minutes",
  "5 segundos": "5 secondes",
  "5. Publique e cole o código": "5. Publiez et collez le code",
  "50 p/ pág": "50 par page",
  "50% OFF": "50% DE RÉDUCTION",
  "536 - Neon Pagamentos S.A. (Banco Neon)": "536 - Neon Pagamentos S.A. (Banco Neon)",
  "6 cards premium com métricas essenciais": "6 cartes premium avec les indicateurs essentiels",
  "6. Acompanhe as métricas": "6. Suivez les indicateurs",
  "6.000 plays por mês": "6.000 lectures par mois",
  "60.000 plays por mês": "60.000 lectures par mois",
  "623 - Banco Pan S.A.": "623 - Banco Pan S.A.",
  "637 - Banco Sofisa S.A.": "637 - Banco Sofisa S.A.",
  "65% = VSL magnética.": "65% = VSL captivante.",
  "655 - Banco Votorantim S.A. (Banco BV)": "655 - Banco Votorantim S.A. (Banco BV)",
  "67% dos visitantes entram neste ponto": "67% des visiteurs commencent à cet endroit",
  "7 dias": "7 jours",
  "745 - Banco Citibank S.A.": "745 - Banco Citibank S.A.",
  "748 - Banco Cooperativo Sicredi S.A.": "748 - Banco Cooperativo Sicredi S.A.",
  "756 - Banco Cooperativo do Brasil S.A. (Sicoob)": "756 - Banco Cooperativo do Brasil S.A. (Sicoob)",
  "756 - Banco Ourinvest S.A. (Nomad)": "756 - Banco Ourinvest S.A. (Nomad)",
  "80% das vagas preenchidas": "80% des places occupées",
  "820 × 1180 · iPad": "820 × 1180 · iPad",
  "90 dias": "90 jours",
  ": a pré-visualização pode ter etapas sem vídeo ou opções sem destino.": ": l'aperçu peut contenir des étapes sans vidéo ou des options sans destination.",
  ":1). Recomendado: mínimo 4.5:1 para acessibilidade (WCAG AA).": ":1). Recommandation : au moins 4.5:1 pour l'accessibilité (WCAG AA).",
  "? Esta ação não pode ser desfeita.": "? Cette action est irréversible.",
  "@empresa.com, @outra.com": "@empresa.com, @outra.com",
  "A = Ativo": "A = Actif",
  "A Academy chegou para acelerar seu domínio da plataforma. Trilha organizada por módulos, com aulas curtas e objetivas sobre cada recurso, do básico ao avançado, com progresso salvo automaticamente.": "Academy est là pour accélérer votre maîtrise de la plateforme. Un parcours organisé en modules, avec des cours courts et précis sur chaque fonctionnalité, du niveau débutant au niveau avancé, et une progression enregistrée automatiquement.",
  "A Builderall oferece a plataforma mais completa de marketing e automação para você expandir seus negócios.": "Builderall propose la plateforme de marketing et d'automatisation la plus complète pour développer votre activité.",
  "A Ferramenta Mais Fácil Para Criar Chatbots Sem Código Do Brasil. Agora você pode automatizar seu marketing, geração de lead, atendimento e muito mais com um robô.": "L'outil le plus simple du Brésil pour créer des chatbots sans code. Automatisez désormais votre marketing, la génération de leads, le service client et bien plus encore avec un robot.",
  "A FunnelX é a nossa ferramenta para criar quizzes interativos de alta performance. Engaje sua audiência, qualifique leads e direcione cada pessoa para a oferta certa, com lógica condicional e visual premium.": "FunnelX est notre outil pour créer des quiz interactifs performants. Engagez votre audience, qualifiez vos leads et orientez chaque personne vers l'offre adaptée grâce à une logique conditionnelle et un design premium.",
  "A Host VSL Transforma Recursos em Resultados": "Host VSL transforme les fonctionnalités en résultats",
  "A Host VSL entrou em uma nova fase. O Front 2.0 foi criado para quem quer operar com mais clareza, mais velocidade e mais controle.": "Host VSL entre dans une nouvelle phase. Front 2.0 a été conçu pour travailler avec plus de clarté, de rapidité et de contrôle.",
  "A Host VSL entrou em uma nova fase. O Front 2.0 foi criado para quem quer operar com mais clareza, mais velocidade e mais controle. Tudo ficou mais consistente, mais fluido e pronto para acompanhar o crescimento de quem escala vendas todos os dias.": "Host VSL entre dans une nouvelle phase. Front 2.0 a été conçu pour travailler avec plus de clarté, de rapidité et de contrôle. Tout est plus cohérent, plus fluide et prêt à accompagner la croissance de ceux qui développent leurs ventes chaque jour.",
  "A HostVSL funciona em sistema pré-pago. Você paga antecipadamente pelo seu plano e pelos plays inclusos. Se precisar de mais plays, pode comprá-los avulsos ou configurar a recarga automática.": "HostVSL fonctionne en prépaiement. Vous payez à l'avance votre forfait et les lectures incluses. Si vous avez besoin de lectures supplémentaires, vous pouvez les acheter séparément ou configurer la recharge automatique.",
  "A HostVSL segue um design system premium inspirado na Apple, com foco em minimalismo, elegância e consistência visual.": "HostVSL utilise un système de design premium inspiré d'Apple, axé sur le minimalisme, l'élégance et la cohérence visuelle.",
  "A HostVSL utiliza Zustand para gerenciamento de estado global. Cada store é responsável por um domínio específico da aplicação, com persistência automática via localStorage quando necessário.": "HostVSL utilise Zustand pour la gestion de l'état global. Chaque store gère un domaine spécifique de l'application, avec persistance automatique via localStorage si nécessaire.",
  "A URL deve começar com http:// ou https://": "L'URL doit commencer par http:// ou https://",
  "A URL não pode estar vazia": "L'URL ne peut pas être vide",
  "A VSL protegida não foi encontrada.": "La VSL protégée est introuvable.",
  "A agência deve conter exatamente 4 dígitos.": "Le code agence doit comporter exactement 4 chiffres.",
  "A aplicação utiliza uma arquitetura de componentes modular, com componentes reutilizáveis organizados por domínio.": "L'application utilise une architecture modulaire, avec des composants réutilisables organisés par domaine.",
  "A borda será aplicada ao redor do player conforme largura e cor escolhidas.": "La bordure sera appliquée autour du lecteur selon la largeur et la couleur choisies.",
  "A cada visitante, uma nova intro é exibida aleatoriamente para coleta de dados.": "Une nouvelle introduction est affichée aléatoirement à chaque visiteur pour recueillir des données.",
  "A captura foi desativada com sucesso.": "La capture a été désactivée avec succès.",
  "A captura por senha foi configurada com sucesso.": "La capture par mot de passe a été configurée avec succès.",
  "A captura por senha foi desativada com sucesso.": "La capture par mot de passe a été désactivée avec succès.",
  "A configuração de Teste A/B foi movida para a aba \"Teste A/B\" no menu de configurações do Autoplay.": "La configuration du test A/B a été déplacée vers l'onglet « Test A/B » dans les paramètres de l'Autoplay.",
  "A conta informada deve pertencer ao mesmo titular do CPF cadastrado.": "Le compte indiqué doit appartenir au titulaire du CPF enregistré.",
  "A conta precisa de atenção ou envio de novos documentos.": "Le compte nécessite votre attention ou l'envoi de nouveaux documents.",
  "A contagem será exibida automaticamente com base no tempo definido.": "Le décompte s'affichera automatiquement selon la durée définie.",
  "A curva mostra o play rate de cada hora": "La courbe montre le taux de lecture de chaque heure",
  "A data de término foi atingida e o teste foi encerrado.": "La date de fin est atteinte et le test est terminé.",
  "A data não pode ser no passado.": "La date ne peut pas être antérieure à aujourd'hui.",
  "A distribuição de tráfego foi atualizada com sucesso": "La répartition du trafic a été mise à jour avec succès",
  "A distribuição de tráfego foi atualizada com sucesso.": "La répartition du trafic a été mise à jour avec succès.",
  "A distribuição precisa somar 100%": "La répartition doit totaliser 100%",
  "A distribuição precisa totalizar 100%": "La répartition doit totaliser 100%",
  "A estratégia foi atualizada com sucesso.": "La stratégie a été mise à jour avec succès.",
  "A estratégia foi {value0}.": "La stratégie a été {value0}.",
  "A etapa {value0} não tem vídeo.": "L'étape {value0} n'a pas de vidéo.",
  "A etapa {value0} não é alcançada a partir do início.": "L'étape {value0} n'est pas accessible depuis le début.",
  "A exclusão de registros estará disponível em breve.": "La suppression des enregistrements sera bientôt disponible.",
  "A imagem deve ter no máximo 2MB": "L'image doit faire au maximum 2 Mo",
  "A imagem foi enviada e salva com sucesso": "L'image a été envoyée et enregistrée avec succès",
  "A integração com {value0} foi configurada.": "L'intégration avec {value0} a été configurée.",
  "A legenda ficará desativada para o espectador.": "Les sous-titres seront désactivés pour le spectateur.",
  "A legenda já começa ativa quando o vídeo carregar": "Les sous-titres sont activés dès le chargement de la vidéo",
  "A linha vertical amarela indica o ponto do pitch de vendas": "La ligne verticale jaune indique le début de l'argumentaire de vente",
  "A logo foi enviada e salva com sucesso": "Le logo a été envoyé et enregistré avec succès",
  "A logo foi removida com sucesso": "Le logo a été supprimé avec succès",
  "A maioria dos espectadores inicia o vídeo do começo. Otimize seus primeiros 10 segundos para maximizar a retenção.": "La plupart des spectateurs regardent la vidéo depuis le début. Optimisez les 10 premières secondes pour maximiser la rétention.",
  "A melhorar": "À améliorer",
  "A notificação pode virar um link clicável que abre a sua oferta em uma nova aba": "La notification peut devenir un lien cliquable ouvrant votre offre dans un nouvel onglet",
  "A nova thumbnail foi aplicada à sua playlist.": "La nouvelle miniature a été appliquée à votre playlist.",
  "A pasta \"{value0}\" foi criada com sucesso.": "Le dossier « {value0} » a été créé avec succès.",
  "A pausa precisa vir depois de as opções aparecerem.": "La pause doit survenir après l'affichage des options.",
  "A pausa também foi removida: ela depende de quando as opções aparecem.": "La pause a également été supprimée : elle dépend du moment où les options apparaissent.",
  "A plataforma integra com Supabase para backend (autenticação, banco de dados, storage) e utiliza React Query para cache e sincronização de dados.": "La plateforme intègre Supabase pour le backend (authentification, base de données, stockage) et utilise React Query pour le cache et la synchronisation des données.",
  "A playlist foi removida com sucesso.": "La playlist a été supprimée avec succès.",
  "A playlist precisa ter pelo menos 1 vídeo para gerar a thumbnail.": "La playlist doit contenir au moins 1 vidéo pour générer la miniature.",
  "A playlist precisa ter pelo menos 1 vídeo.": "La playlist doit contenir au moins 1 vidéo.",
  "A playlist que você está procurando não existe ou foi removida.": "La playlist que vous recherchez n'existe pas ou a été supprimée.",
  "A prioridade dos testes foi alterada": "L'ordre de priorité des tests a été modifié",
  "A processar...": "Traitement...",
  "A prévia para marcar os tempos aparece assim que o vídeo começar a ficar pronto. Enquanto isso, você pode digitar os tempos.": "L'aperçu permettant de définir les repères temporels apparaîtra dès que la vidéo commencera à être prête. En attendant, vous pouvez saisir les temps.",
  "A queda acentuada no início sugere que seu gancho não está forte o suficiente. Teste um problema mais urgente ou curiosidade mais intensa.": "La forte baisse au début suggère que votre accroche manque d'impact. Testez un problème plus urgent ou suscitez davantage de curiosité.",
  "A regra do cloaker foi atualizada.": "La règle du cloaker a été mise à jour.",
  "A regra foi excluída com sucesso": "La règle a été supprimée avec succès",
  "A reprodução automática cria a sensação de início imediato, aumentando o engajamento dos usuários. O vídeo começa sem som para cumprir as políticas dos navegadores, e o overlay incentiva a ativação do áudio.": "La lecture automatique donne une impression de démarrage immédiat et augmente l'engagement. La vidéo commence sans son pour respecter les règles des navigateurs, et la superposition encourage l'activation du son.",
  "A senha deve ter pelo menos 6 caracteres": "Le mot de passe doit comporter au moins 6 caractères",
  "A senha deve ter pelo menos 6 caracteres.": "Le mot de passe doit comporter au moins 6 caractères.",
  "A solução perfeita para aumentar suas vendas! Com SMS Funnel você divulga seu produto ou serviço em tempo real para todo Brasil e todas as operadoras.": "La solution idéale pour augmenter vos ventes ! Avec SMS Funnel, faites connaître votre produit ou service en temps réel dans tout le Brésil, auprès de tous les opérateurs.",
  "A soma da distribuição de tráfego deve ser 100%": "La somme des répartitions du trafic doit être égale à 100%",
  "A thumbnail de final foi configurada": "La miniature de fin a été configurée",
  "A thumbnail de início foi configurada": "La miniature de début a été configurée",
  "A thumbnail foi removida": "La miniature a été supprimée",
  "A thumbnail foi removida com sucesso": "La miniature a été supprimée avec succès",
  "A thumbnail inicial só funciona se os Controles de Vídeo estiverem ativados. Ative os Controles nas configurações.": "La miniature initiale nécessite l'activation des commandes vidéo. Activez les commandes dans les paramètres.",
  "A venda será contabilizada para o afiliado detentor do último link acessado pelo cliente antes do registo.": "La vente sera attribuée à l'affilié dont le lien a été consulté en dernier par le client avant son inscription.",
  "A verificar conta...": "Vérification du compte...",
  "A versão no ar já é igual ao rascunho.": "La version en ligne est déjà identique au brouillon.",
  "A versão publicada continua no ar como está.": "La version publiée reste en ligne telle quelle.",
  "ANO": "ANNÉE",
  "AS senhas não correspondem!": "Les mots de passe ne correspondent pas !",
  "ATIVAR AUTOPLAY": "ACTIVER L'AUTOPLAY",
  "ATIVO": "ACTIF",
  "AWS": "AWS",
  "Abaixo": "En dessous",
  "Abaixo de 45%:": "Moins de 45% :",
  "Abaixo de 50%:": "Moins de 50% :",
  "Abaixo do Vídeo": "Sous la vidéo",
  "Abaixo do vídeo": "Sous la vidéo",
  "Abertura do link": "Ouverture du lien",
  "Abra a pré-visualização e percorra os caminhos como um visitante. Também dá para começar por uma etapa específica. A prévia não contabiliza plays e mostra o endereço das saídas sem abrir a página. Confira a aba Problemas e resolva as pendências antes de publicar.": "Ouvrez l'aperçu et parcourez les chemins comme un visiteur. Vous pouvez aussi commencer par une étape précise. L'aperçu ne comptabilise pas de lectures et affiche les adresses des sorties sans ouvrir les pages. Consultez l'onglet Problèmes et résolvez les points en attente avant de publier.",
  "Abra as métricas do fluxo para entender quantas pessoas começaram a assistir, por quais etapas passaram e quais opções escolheram. Na aba Vídeos, selecione um vídeo para analisar sua curva de retenção, a duração, a retenção média e a quantidade de plays usada na análise.": "Ouvrez les indicateurs du parcours pour connaître le nombre de personnes ayant commencé à regarder, les étapes traversées et les options choisies. Dans l'onglet Vidéos, sélectionnez une vidéo pour analyser sa courbe de rétention, sa durée, sa rétention moyenne et le nombre de lectures utilisé dans l'analyse.",
  "Abra no computador para editar": "Ouvrez sur un ordinateur pour modifier",
  "Abra o app direto da tela inicial, sem precisar abrir o navegador": "Ouvrez l'application depuis l'écran d'accueil, sans ouvrir le navigateur",
  "Abra o seletor do Google e marque os vídeos. Eles entram direto na fila de envio.": "Ouvrez le sélecteur Google et cochez les vidéos. Elles rejoindront directement la file d'envoi.",
  "Abre o vídeo em tela cheia ao clicar no overlay": "Ouvre la vidéo en plein écran lors d'un clic sur la superposition",
  "Abre uma URL ao clicar na notificação.": "Ouvre une URL lors d'un clic sur la notification.",
  "Abrindo preview do vídeo {value0}": "Ouverture de l'aperçu de la vidéo {value0}",
  "Abrir": "Ouvrir",
  "Abrir Modal de Incorporação": "Ouvrir la fenêtre d'intégration",
  "Abrir Original": "Ouvrir l'original",
  "Abrir URL": "Ouvrir l'URL",
  "Abrir URL em nova aba": "Ouvrir l'URL dans un nouvel onglet",
  "Abrir Vídeos Compartilhados": "Ouvrir les vidéos partagées",
  "Abrir em": "Ouvrir dans",
  "Abrir em nova aba": "Ouvrir dans un nouvel onglet",
  "Abrir em nova guia": "Ouvrir dans un nouvel onglet",
  "Abrir link": "Ouvrir le lien",
  "Abrir link do botão em nova aba": "Ouvrir le lien du bouton dans un nouvel onglet",
  "Abrir menu": "Ouvrir le menu",
  "Abrir menu de ações": "Ouvrir le menu d'actions",
  "Abrir menu de conta": "Ouvrir le menu du compte",
  "Abrir na mesma aba": "Ouvrir dans le même onglet",
  "Abrir nova aba": "Ouvrir un nouvel onglet",
  "Abrir pasta": "Ouvrir le dossier",
  "Abrir playlist {value0}": "Ouvrir la playlist {value0}",
  "Abrir página": "Ouvrir la page",
  "Abrir vídeo agora": "Ouvrir la vidéo maintenant",
  "Academy": "Academy",
  "Academy com tutoriais": "Academy avec tutoriels",
  "Accordion de Estilo Avançado agora inicia aberto por padrão. Texto atualizado de \"overlay\" para \"Autoplay\".": "L'accordéon de style avancé est désormais ouvert par défaut. Le texte « overlay » a été remplacé par « Autoplay ».",
  "Aceita HTML e CSS inline. Scripts não são permitidos.": "Accepte le HTML et le CSS inline. Les scripts ne sont pas autorisés.",
  "Aceita Vimeo, Bunny, Cloudflare ou MP4 direto": "Accepte Vimeo, Bunny, Cloudflare ou un lien MP4 direct",
  "Aceita: seusite.com, www.seusite.com ou https://seusite.com": "Accepte : seusite.com, www.seusite.com ou https://seusite.com",
  "Aceitar e adicionar": "Accepter et ajouter",
  "Aceite de uso": "Acceptation des conditions d'utilisation",
  "Aceito os termos de uso e a política de privacidade": "J'accepte les conditions d'utilisation et la politique de confidentialité",
  "Acelere levemente o meio do vídeo": "Accélérez légèrement le milieu de la vidéo",
  "Acelere momentos menos importantes e destaque momentos chave com ritmo mais lento e foco.": "Accélérez les passages moins importants et mettez en valeur les moments clés avec un rythme plus lent et ciblé.",
  "Acessando...": "Accès en cours...",
  "Acessar": "Accéder",
  "Acessar central de ajuda": "Accéder au centre d'aide",
  "Acessar o checkout não significa comprar. A Taxa de acesso ao checkout mede esse avanço no funil; ela é diferente da Conversão em venda. Para acompanhar vendas aprovadas e receita atribuída, use Conectar rastreamento, escolha a saída de checkout e a plataforma de vendas e siga as instruções para cadastrar o webhook na plataforma, direcionado às compras desse checkout. Sem conexão, os indicadores de vendas aparecem como “—”.": "Accéder au paiement ne signifie pas acheter. Le taux d'accès au paiement mesure cette avancée dans le tunnel et diffère de la conversion en vente. Pour suivre les ventes approuvées et le chiffre d'affaires attribué, utilisez Connecter le suivi, choisissez la sortie de paiement et la plateforme de vente, puis suivez les instructions pour enregistrer le webhook sur cette plateforme en le réservant aux achats de ce paiement. Sans connexion, les indicateurs de vente affichent « — ».",
  "Acessar vídeo": "Accéder à la vidéo",
  "Acesse Métricas para ver detalhes por vídeo": "Ouvrez Indicateurs pour voir les détails par vidéo",
  "Acesse Métricas para ver por vídeo": "Ouvrez Indicateurs pour consulter chaque vidéo",
  "Acesse Teste de hook para otimizar retenção": "Ouvrez Test d'accroche pour optimiser la rétention",
  "Acesse VSL Dinâmica no menu do painel e monte o primeiro caminho do seu funil.": "Ouvrez VSL dynamique dans le menu du panneau et créez le premier chemin de votre tunnel.",
  "Acesse a sua conta": "Connectez-vous à votre compte",
  "Acesse o conteúdo e receba o link no seu e-mail": "Accédez au contenu et recevez le lien par e-mail",
  "Acesse o vídeo": "Accéder à la vidéo",
  "Acesse pelo menu lateral em Análises → Tempo Real": "Dans le menu latéral, ouvrez Analyses → Temps réel",
  "Acesse pelo seu avatar, no canto superior direito, em \"Membros\"": "Cliquez sur votre avatar en haut à droite, puis sur « Membres »",
  "Acesse suas métricas e vídeos diretamente da tela inicial do seu dispositivo. Funciona offline e carrega instantaneamente!": "Accédez à vos indicateurs et vidéos directement depuis l'écran d'accueil de votre appareil. Fonctionne hors ligne et se charge instantanément !",
  "Acesse suas métricas mesmo sem conexão com a internet": "Accédez à vos indicateurs même sans connexion Internet",
  "Acesse uma trilha completa de aulas para dominar todos os recursos da Host VSL.": "Accédez à un parcours complet de cours pour maîtriser toutes les fonctionnalités de Host VSL.",
  "Acessibilidade e retenção em um só recurso.": "Accessibilité et rétention réunies dans une seule fonctionnalité.",
  "Acesso Facilitado": "Accès facilité",
  "Acesso Rota": "Accès à la route",
  "Acesso Rápido": "Accès rapide",
  "Acesso bloqueado": "Accès bloqué",
  "Acesso de Suporte": "Accès du support",
  "Acesso permitido": "Accès autorisé",
  "Acesso por pasta: libere só as pastas de vídeos que aquela pessoa precisa": "Accès par dossier : autorisez uniquement les dossiers vidéo nécessaires à chaque personne",
  "Acesso total, incluindo gestão de usuários": "Accès complet, y compris la gestion des utilisateurs",
  "Acesso total, incluindo gestão de usuários e faturamento": "Accès complet, y compris la gestion des utilisateurs et la facturation",
  "Acessos ao checkout": "Accès au paiement",
  "Acessos sem UTM aparecem como “Direto” na tabela, mas não têm curva de retenção no gráfico.": "Les accès sans UTM apparaissent comme « Direct » dans le tableau, mais n'ont pas de courbe de rétention sur le graphique.",
  "Acessos únicos": "Accès uniques",
  "Acessos únicos ao checkout": "Accès uniques au paiement",
  "Acessou a Sala": "A rejoint la salle",
  "Acima": "Au-dessus",
  "Acima de 65%:": "Plus de 65% :",
  "Acima de 70%:": "Plus de 70% :",
  "Acionar vendas simuladas": "Déclencher des ventes simulées",
  "Acompanhe a performance detalhada do seu webinário.": "Suivez les performances détaillées de votre webinaire.",
  "Acompanhe a performance dos seus vídeos.": "Suivez les performances de vos vidéos.",
  "Acompanhe a saúde de cada pixel: registrando, mudo há mais de 24h ou aguardando o 1º disparo": "Suivez l'état de chaque pixel : enregistrement, silencieux depuis plus de 24 h ou en attente du 1er déclenchement",
  "Acompanhe as métricas individuais de cada vídeo deste teste.": "Suivez les indicateurs individuels de chaque vidéo de ce test.",
  "Acompanhe cada lead em um pipeline visual com histórico completo.": "Suivez chaque lead dans un pipeline visuel avec un historique complet.",
  "Acompanhe cópias por dia, top estados e histórico completo de eventos": "Suivez les copies par jour, les principaux États et l'historique complet des événements",
  "Acompanhe de forma visual e intuitiva cada etapa da jornada do espectador. O funil mostra desde os carregamentos da página até as conversões finais, com percentuais e valores absolutos para cada etapa.": "Suivez visuellement et intuitivement chaque étape du parcours du spectateur. Le tunnel montre les chargements de page jusqu'aux conversions finales, avec des pourcentages et des valeurs absolues à chaque étape.",
  "Acompanhe entradas, plays, escolhas, acessos às saídas e a retenção de cada vídeo nas métricas do fluxo.": "Suivez les entrées, les lectures, les choix, les accès aux sorties et la rétention de chaque vidéo dans les indicateurs du parcours.",
  "Acompanhe métricas de compartilhamento": "Suivez les indicateurs de partage",
  "Acompanhe o desempenho das suas VSL's em tempo real": "Suivez les performances de vos VSL en temps réel",
  "Acompanhe os padrões que mais convertem": "Suivez les tendances qui convertissent le plus",
  "Acompanhe qual variação converte mais.": "Suivez la variante qui convertit le plus.",
  "Acompanhe quantos acessos cada proteção já bloqueou direto nos cards": "Suivez le nombre d'accès bloqués par chaque protection directement sur les cartes",
  "Acompanhe seu consumo de plays mensais": "Suivez votre consommation mensuelle de lectures",
  "Acompanhe todas as atualizações e novos recursos da Host VSL": "Suivez toutes les mises à jour et les nouvelles fonctionnalités de Host VSL",
  "Acompanhe todas as conversões em um só painel.": "Suivez toutes les conversions dans un seul tableau de bord.",
  "Acompanhe todas as vendas em tempo real": "Suivez toutes les ventes en temps réel",
  "Acompanhe visualizações, engajamento, cliques e outras métricas importantes para cada variante.": "Suivez les vues, l'engagement, les clics et d'autres indicateurs importants pour chaque variante.",
  "Acompanhe visualizações, engajamento, retenção e outras métricas importantes para cada introdução.": "Suivez les vues, l'engagement, la rétention et d'autres indicateurs importants pour chaque introduction.",
  "Acumulado": "Cumulé",
  "Acumulado por todos os afiliados.": "Cumul de tous les affiliés.",
  "Adapte o formato Atenção, Interesse, Desejo e Ação para sua narrativa em vídeo.": "Adaptez la méthode Attention, Intérêt, Désir et Action à votre narration vidéo.",
  "Add to favorites": "Ajouter aux favoris",
  "Adiciona blur sutil ao vídeo de fundo": "Ajoute un léger flou à la vidéo d'arrière-plan",
  "Adiciona botão para avançar 10 segundos no vídeo": "Ajoute un bouton pour avancer de 10 secondes dans la vidéo",
  "Adiciona botão para retroceder 10 segundos no vídeo": "Ajoute un bouton pour reculer de 10 secondes dans la vidéo",
  "Adiciona efeito pulsante para chamar atenção": "Ajoute un effet de pulsation pour attirer l'attention",
  "Adiciona sombras nos cards para maior profundidade": "Ajoute des ombres aux cartes pour donner plus de profondeur",
  "Adiciona um botão nos controles que abre o seletor nativo de dispositivos do navegador (AirPlay no Safari, Chromecast no Chrome). Só aparece pra quem tem receptor compatível na rede.": "Ajoute un bouton aux commandes pour ouvrir le sélecteur natif d'appareils du navigateur (AirPlay dans Safari, Chromecast dans Chrome). Il apparaît uniquement lorsqu'un récepteur compatible est présent sur le réseau.",
  "Adiciona uma camada colorida sobre o vídeo quando o formulário aparece. A cor é definida em \"Background do Vídeo\" acima": "Ajoute une couche colorée sur la vidéo lorsque le formulaire apparaît. La couleur est définie dans « Arrière-plan de la vidéo » ci-dessus",
  "Adicionada aba \"Parceiros\" com ícone Handshake no menu lateral desktop (Sidebar) e mobile (DrawerContent), posicionada após \"Membros\".": "Ajout de l'onglet « Partenaires » avec l'icône Handshake dans le menu latéral sur ordinateur (Sidebar) et mobile (DrawerContent), après « Membres ».",
  "Adicionamos um novo botão de transmissão para Smart TV nos controles do player. Com ele ativo, seu espectador clica e escolhe transmitir o vídeo pra uma Chromecast (no Chrome) ou Apple TV/AirPlay (no Safari) que esteja na mesma rede Wi-Fi. Ótimo pra ofertas high-ticket onde o cliente quer assistir junto com cônjuge ou sócio antes de fechar.": "Nous avons ajouté un bouton de diffusion vers une Smart TV dans les commandes du lecteur. Une fois activé, il permet au spectateur de diffuser la vidéo sur un Chromecast (dans Chrome) ou une Apple TV/AirPlay (dans Safari) connecté au même réseau Wi-Fi. Idéal pour les offres haut de gamme lorsque le client souhaite regarder avec son conjoint ou son associé avant de se décider.",
  "Adicionando...": "Ajout...",
  "Adicionar": "Ajouter",
  "Adicionar 10 exemplos": "Ajouter 10 exemples",
  "Adicionar Aula": "Ajouter un cours",
  "Adicionar Bônus": "Ajouter un bonus",
  "Adicionar Campo Extra": "Ajouter un champ supplémentaire",
  "Adicionar Cartão": "Ajouter une carte",
  "Adicionar Intros": "Ajouter des intros",
  "Adicionar Link": "Ajouter un lien",
  "Adicionar Membro": "Ajouter un membre",
  "Adicionar Mini Hook": "Ajouter un Mini Hook",
  "Adicionar Módulo": "Ajouter un module",
  "Adicionar País": "Ajouter un pays",
  "Adicionar Pixel": "Ajouter un pixel",
  "Adicionar Plataforma": "Ajouter une plateforme",
  "Adicionar Plays ao Plano": "Ajouter des lectures au forfait",
  "Adicionar Primeiro Membro": "Ajouter le premier membre",
  "Adicionar Primeiro Vídeo": "Ajouter la première vidéo",
  "Adicionar Região": "Ajouter une région",
  "Adicionar Regra UTM": "Ajouter une règle UTM",
  "Adicionar UTM": "Ajouter une UTM",
  "Adicionar Variação": "Ajouter une variante",
  "Adicionar Vídeos": "Ajouter des vidéos",
  "Adicionar aos favoritos": "Ajouter aux favoris",
  "Adicionar borda": "Ajouter une bordure",
  "Adicionar cartão": "Ajouter une carte",
  "Adicionar classe": "Ajouter une classe",
  "Adicionar imagem": "Ajouter une image",
  "Adicionar legenda": "Ajouter des sous-titres",
  "Adicionar logo": "Ajouter un logo",
  "Adicionar novo cartão": "Ajouter une nouvelle carte",
  "Adicionar novos campos": "Ajouter de nouveaux champs",
  "Adicionar opção": "Ajouter une option",
  "Adicionar pagamento": "Ajouter un paiement",
  "Adicionar parâmetros UTM": "Ajouter des paramètres UTM",
  "Adicionar pitch": "Ajouter un argumentaire de vente",
  "Adicionar primeiro domínio": "Ajouter le premier domaine",
  "Adicionar regra UTM": "Ajouter une règle UTM",
  "Adicionar sombra": "Ajouter une ombre",
  "Adicionar sombra externa": "Ajouter une ombre externe",
  "Adicionar texto personalizado": "Ajouter un texte personnalisé",
  "Adicionar um botão abaixo do vídeo da playlist para enviar o usuário a um link externo.": "Ajouter un bouton sous la vidéo de la playlist pour diriger l'utilisateur vers un lien externe.",
  "Adicionar vídeo": "Ajouter une vidéo",
  "Adicionar vídeo por URL": "Ajouter une vidéo par URL",
  "Adicionar vídeos": "Ajouter des vidéos",
  "Adicionar...": "Ajouter...",
  "Adicione Botões": "Ajoutez des boutons",
  "Adicione VITE_GOOGLE_CLIENT_ID e VITE_GOOGLE_DEVELOPER_KEY no .env e reinicie o servidor.": "Ajoutez VITE_GOOGLE_CLIENT_ID et VITE_GOOGLE_DEVELOPER_KEY au fichier .env, puis redémarrez le serveur.",
  "Adicione a sua marca ao vídeo e controle posição, tamanho, transparência e link de destino.": "Ajoutez votre marque à la vidéo et réglez sa position, sa taille, sa transparence et son lien de destination.",
  "Adicione arquivos de legenda ao vídeo para melhorar acessibilidade e retenção do público.": "Ajoutez des fichiers de sous-titres à la vidéo pour améliorer l'accessibilité et la rétention de l'audience.",
  "Adicione as introduções que você deseja testar com o vídeo principal. Você pode adicionar quantas introduções desejar.": "Ajoutez les introductions que vous souhaitez tester avec la vidéo principale. Vous pouvez en ajouter autant que vous le souhaitez.",
  "Adicione até": "Ajoutez jusqu'à",
  "Adicione aulas a este módulo no painel de edição": "Ajoutez des cours à ce module dans le panneau d'édition",
  "Adicione cidades para usar a variável {cidade}": "Ajoutez des villes pour utiliser la variable {cidade}",
  "Adicione código HTML para visualizar": "Ajoutez du code HTML pour afficher l'aperçu",
  "Adicione domínios para proteger sua VSL": "Ajoutez des domaines pour protéger votre VSL",
  "Adicione e organize os vídeos da sua playlist": "Ajoutez et organisez les vidéos de votre playlist",
  "Adicione elementos de \"open loops\" para manter curiosidade": "Ajoutez des éléments de suspense pour entretenir la curiosité",
  "Adicione elementos de escassez": "Ajoutez des éléments de rareté",
  "Adicione elementos de urgência ou escassez antes do botão": "Ajoutez des éléments d'urgence ou de rareté avant le bouton",
  "Adicione elementos gráficos ou pausas dramáticas nos momentos pré-CTA para aumentar conversões.": "Ajoutez des éléments graphiques ou des pauses dramatiques avant le CTA pour augmenter les conversions.",
  "Adicione elementos visuais": "Ajoutez des éléments visuels",
  "Adicione elementos visuais para reforçar os pontos principais": "Ajoutez des éléments visuels pour renforcer les points principaux",
  "Adicione essa oferta ao seu pedido agora e aproveite por apenas:": "Ajoutez cette offre à votre commande maintenant et profitez-en pour seulement :",
  "Adicione essa oferta ao seu pedido antes de continuar": "Ajoutez cette offre à votre commande avant de continuer",
  "Adicione este cupom no checkout do plano que você gostar.": "Ajoutez ce code promo au paiement du forfait de votre choix.",
  "Adicione headlines persuasivas ao player.": "Ajoutez des titres persuasifs au lecteur.",
  "Adicione imagens específicas para desktop e mobile": "Ajoutez des images spécifiques pour ordinateur et mobile",
  "Adicione introduções ao seu teste para visualizar métricas.": "Ajoutez des introductions à votre test pour afficher les indicateurs.",
  "Adicione legendas .VTT ou .SRT ao seu vídeo.": "Ajoutez des sous-titres .VTT ou .SRT à votre vidéo.",
  "Adicione legendas aos seus vídeos com suporte a arquivos .VTT e .SRT. Edite textos e tempos diretamente no painel, reordene blocos e escolha entre 4 animações de exibição.": "Ajoutez des sous-titres à vos vidéos à partir de fichiers .VTT et .SRT. Modifiez les textes et les temps directement dans le panneau, réorganisez les blocs et choisissez parmi 4 animations d'affichage.",
  "Adicione legendas para melhorar a acessibilidade.": "Ajoutez des sous-titres pour améliorer l'accessibilité.",
  "Adicione legendas sincronizadas ao seu vídeo. Suporta .SRT e .VTT.": "Ajoutez des sous-titres synchronisés à votre vidéo. Accepte les formats .SRT et .VTT.",
  "Adicione links de termos, privacidade, etc.": "Ajoutez des liens vers les conditions, la confidentialité, etc.",
  "Adicione nomes para usar a variável {nome}": "Ajoutez des noms pour utiliser la variable {nome}",
  "Adicione o produto para usar a variável {produto}": "Ajoutez le produit pour utiliser la variable {produto}",
  "Adicione observações internas sobre este pagamento.": "Ajoutez des notes internes sur ce paiement.",
  "Adicione observações sobre esta regra...": "Ajoutez des notes sur cette règle...",
  "Adicione padrões de interrupção": "Ajoutez des ruptures de rythme",
  "Adicione pelo menos 1 vídeo para ativar": "Ajoutez au moins 1 vidéo pour activer",
  "Adicione pelo menos um nome": "Ajoutez au moins un nom",
  "Adicione pelo menos uma cidade": "Ajoutez au moins une ville",
  "Adicione pelo menos uma opção antes de pausar.": "Ajoutez au moins une option avant la pause.",
  "Adicione profundidade e destaque ao player.": "Donnez de la profondeur et de la visibilité au lecteur.",
  "Adicione sua logo marca no vídeo": "Ajoutez votre logo à la vidéo",
  "Adicione títulos chamativos com upload de imagem e A/B test integrado": "Ajoutez des titres accrocheurs avec importation d'image et test A/B intégré",
  "Adicione um botão de compra ou call-to-action": "Ajoutez un bouton d'achat ou un appel à l'action",
  "Adicione um botão secundário, como WhatsApp": "Ajoutez un bouton secondaire, comme WhatsApp",
  "Adicione um pixel para começar a rastrear conversões nos seus vídeos.": "Ajoutez un pixel pour commencer à suivre les conversions de vos vidéos.",
  "Adicione um vídeo": "Ajoutez une vidéo",
  "Adicione uma borda animada e personalizada": "Ajoutez une bordure animée et personnalisée",
  "Adicione uma borda colorida em volta do thumbnail para destacar": "Ajoutez une bordure colorée autour de la miniature pour la mettre en valeur",
  "Adicione uma conta para receber seus saques.": "Ajoutez un compte pour recevoir vos retraits.",
  "Adicione uma descrição para ajudar a lembrar do objetivo deste teste...": "Ajoutez une description pour vous souvenir de l'objectif de ce test...",
  "Adicione uma mensagem": "Ajoutez un message",
  "Adicione uma mensagem extra no rodapé (opcional)": "Ajoutez un message supplémentaire en pied de page (facultatif)",
  "Adicione uma pergunta de engajamento aos 25s para reter atenção": "Ajoutez une question d'engagement à 25 s pour maintenir l'attention",
  "Adicione uma saída de checkout no editor para conectar o rastreamento.": "Ajoutez une sortie vers le paiement dans l'éditeur pour connecter le suivi.",
  "Adicione vários hooks com tempo de início e fim independentes": "Ajoutez plusieurs accroches avec des temps de début et de fin indépendants",
  "Adicione vídeos": "Ajoutez des vidéos",
  "Adicione vídeos a esta pasta para começar a organizar seu conteúdo.": "Ajoutez des vidéos à ce dossier pour commencer à organiser votre contenu.",
  "Adicione vídeos antes e depois do conteúdo principal para aquecer, conduzir e converter espectadores.": "Ajoutez des vidéos avant et après le contenu principal pour préparer, guider et convertir les spectateurs.",
  "Adicione vídeos da sua biblioteca para criar a sequência da playlist.": "Ajoutez des vidéos de votre bibliothèque pour créer la séquence de la playlist.",
  "Adicione vídeos para começar a criar sua playlist": "Ajoutez des vidéos pour commencer à créer votre playlist",
  "Adicione vídeos para usar este recurso.": "Ajoutez des vidéos pour utiliser cette fonctionnalité.",
  "Adicione vídeos primeiro": "Ajoutez d'abord des vidéos",
  "Administrador": "Administrateur",
  "Afiliado": "Affilié",
  "Afiliado Gerente": "Affilié gestionnaire",
  "Afiliado copia o vídeo com um clique e já pode usar sem upload": "L'affilié copie la vidéo en un clic et peut l'utiliser sans envoi",
  "Afiliado vendedor": "Affilié vendeur",
  "Afiliados": "Affiliés",
  "Ag:": "Agence :",
  "Agendada": "Programmée",
  "Agendado": "Programmé",
  "Agendamento": "Programmation",
  "Agendamento de recarga cancelado.": "Recharge programmée annulée.",
  "Agendando...": "Programmation...",
  "Agendar Oferta": "Programmer une offre",
  "Agende ofertas e eventos nesses períodos para maximizar resultados.": "Programmez des offres et des événements à ces périodes pour maximiser les résultats.",
  "Agora a HostVSL também fala com o Google Ads. Você cadastra o ID de conversão da sua conta (AW-) e o rótulo de cada ação que quer medir — o play do vídeo, o momento em que a oferta aparece e o clique no botão de compra. A partir daí, você enxerga dentro do próprio Google Ads quais campanhas levam as pessoas a assistir e a clicar na sua oferta.": "HostVSL communique désormais avec Google Ads. Enregistrez l'identifiant de conversion de votre compte (AW-) et le libellé de chaque action à mesurer : lancement de la vidéo, apparition de l'offre et clic sur le bouton d'achat. Vous pouvez ensuite voir directement dans Google Ads quelles campagnes incitent les internautes à regarder et à cliquer sur votre offre.",
  "Agora adicione vídeos à sua playlist.": "Ajoutez maintenant des vidéos à votre playlist.",
  "Agora escolha o fim do intervalo": "Choisissez maintenant la fin de l'intervalle",
  "Agora não": "Pas maintenant",
  "Agora seus vídeos pausam automaticamente quando o espectador sai da aba do navegador. Ao retornar, a reprodução continua exatamente de onde parou, sem perder nenhum segundo de conteúdo.": "Vos vidéos se mettent désormais automatiquement en pause lorsque le spectateur quitte l'onglet du navigateur. À son retour, la lecture reprend exactement là où elle s'était arrêtée, sans perdre une seconde de contenu.",
  "Agora você pode compartilhar seus vídeos com afiliados por link. O afiliado copia o vídeo direto no painel com um clique, sem precisar baixar no Drive ou fazer upload demorado. Você acompanha quem copiou e toda a atividade do compartilhamento.": "Vous pouvez désormais partager vos vidéos avec des affiliés par lien. L'affilié copie la vidéo directement dans son panneau en un clic, sans téléchargement depuis Drive ni long envoi. Vous pouvez voir qui a copié la vidéo et suivre toute l'activité du partage.",
  "Agora você pode compartilhar seus vídeos diretamente com membros da sua equipe ou afiliados. Ideal para co-produtores que precisam distribuir conteúdo sem perder o controle.": "Vous pouvez désormais partager vos vidéos directement avec les membres de votre équipe ou vos affiliés. Idéal pour les coproducteurs qui doivent diffuser du contenu tout en gardant le contrôle.",
  "Agora você pode exibir avisos de compra por cima da sua VSL, no estilo prova social ao vivo. Você escreve o texto do aviso com nome, cidade e produto, escolhe a plataforma de venda que aparece ao lado e deixa as notificações rodando enquanto o vídeo toca. Dá pra segurar os avisos nos primeiros minutos e só então começar o rodízio, ajustando o intervalo entre eles e quanto tempo cada um fica na tela. E, se quiser, a notificação vira um link clicável que abre a sua oferta em uma nova aba.": "Vous pouvez désormais afficher des notifications d'achat par-dessus votre VSL, comme preuve sociale en direct. Rédigez le texte avec le nom, la ville et le produit, choisissez la plateforme de vente affichée à côté et laissez les notifications défiler pendant la vidéo. Vous pouvez attendre les premières minutes avant de lancer la rotation, puis régler l'intervalle entre les notifications et leur durée d'affichage. Si vous le souhaitez, chaque notification devient un lien cliquable ouvrant votre offre dans un nouvel onglet.",
  "Agora você pode importar vídeos diretamente da sua conta do Google Drive, sem precisar baixar primeiro pro computador. No modal de envio, escolha \"Google Drive\" como origem, conecte sua conta com segurança e selecione os vídeos que quiser mandar pra plataforma.": "Vous pouvez désormais importer des vidéos directement depuis votre compte Google Drive, sans les télécharger d'abord sur votre ordinateur. Dans la fenêtre d'envoi, choisissez « Google Drive » comme source, connectez votre compte de manière sécurisée et sélectionnez les vidéos à envoyer sur la plateforme.",
  "Agora você pode personalizar a caixa de autoplay de forma visual e intuitiva. Arraste para mover, use os handles para redimensionar e veja as alterações em tempo real no preview do player.": "Vous pouvez désormais personnaliser visuellement et intuitivement la zone d'Autoplay. Faites-la glisser pour la déplacer, utilisez les poignées pour la redimensionner et observez les modifications en temps réel dans l'aperçu du lecteur.",
  "Agora você pode personalizar seu vídeo com as opções do editor": "Vous pouvez maintenant personnaliser votre vidéo avec les options de l'éditeur",
  "Aguardando 1ª venda": "En attente de la 1re vente",
  "Aguardando 1º disparo": "En attente du 1er déclenchement",
  "Aguardando dados": "En attente de données",
  "Aguardando dados de visualização para determinar o desempenho dos vídeos.": "En attente de données de visionnage pour déterminer les performances des vidéos.",
  "Aguardando dados de visualização para gerar análise de performance.": "En attente de données de visionnage pour générer une analyse des performances.",
  "Aguardando dados de visualização para gerar o gráfico de retenção.": "En attente de données de visionnage pour générer le graphique de rétention.",
  "Aguardando pagamento.": "En attente de paiement.",
  "Aguardando primeiro evento": "En attente du premier événement",
  "Aguardando seleção": "En attente de sélection",
  "Aguardando seleção...": "En attente de sélection...",
  "Aguardando visualizações": "En attente de vues",
  "Aguardar clique do espectador": "Attendre un clic du spectateur",
  "Aguarde enquanto buscamos os dados do teste": "Veuillez patienter pendant la récupération des données du test",
  "Aguarde enquanto buscamos seus vídeos": "Veuillez patienter pendant la récupération de vos vidéos",
  "Aguarde enquanto preparamos seu vídeo": "Veuillez patienter pendant la préparation de votre vidéo",
  "Aguarde os envios atuais terminarem ou cancele alguns para enviar novos vídeos.": "Attendez la fin des envois en cours ou annulez-en quelques-uns pour envoyer de nouvelles vidéos.",
  "Aguarde os envios atuais terminarem ou cancele alguns.": "Attendez la fin des envois en cours ou annulez-en quelques-uns.",
  "Aguarde pelo menos 300 visualizações por intro para dados confiáveis": "Attendez au moins 300 vues par intro pour obtenir des données fiables",
  "Aguarde pelo menos 7 dias para que o teste colete dados suficientes": "Attendez au moins 7 jours pour que le test recueille suffisamment de données",
  "Aguarde um momento": "Veuillez patienter un instant",
  "Agência": "Agence",
  "Agência/Conta": "Agence/Compte",
  "Agências de Marketing": "Agences marketing",
  "Ainda não há conversões registradas neste período para gerar um insight.": "Aucune conversion enregistrée pendant cette période pour générer une analyse.",
  "Ainda não há dados de retenção": "Aucune donnée de rétention pour le moment",
  "Ainda não há dados de retenção para as variações deste teste. Assim que forem coletados, a curva comparativa aparecerá aqui.": "Aucune donnée de rétention n'est encore disponible pour les variantes de ce test. La courbe comparative apparaîtra ici dès que ces données seront recueillies.",
  "Ainda não há dados suficientes": "Les données sont encore insuffisantes",
  "Ainda não há plays deste vídeo no período.": "Aucune lecture de cette vidéo pendant la période.",
  "Ainda não há visitas neste período. As métricas aparecem quando o fluxo publicado recebe visitas.": "Aucune visite pendant cette période. Les indicateurs apparaîtront lorsque le parcours publié recevra des visites.",
  "Ainda não identificamos sites ou páginas enviando tráfego para este vídeo. Quando houver acessos externos, as referências aparecerão aqui.": "Nous n'avons pas encore identifié de sites ou de pages envoyant du trafic vers cette vidéo. Les sources apparaîtront ici dès les premiers accès externes.",
  "Ainda não temos dados de conversão suficientes neste período.": "Nous n'avons pas encore suffisamment de données de conversion pour cette période.",
  "Ainda não temos dados suficientes para gerar métricas avançadas.": "Nous n'avons pas encore suffisamment de données pour générer les indicateurs avancés.",
  "Ainda não temos tráfego suficiente neste período.": "Nous n'avons pas encore suffisamment de trafic pour cette période.",
  "Ainda sem dados aqui": "Aucune donnée ici pour le moment",
  "Ainda tem dúvidas": "Vous avez encore des questions",
  "Ajuda": "Aide",
  "Ajuda sobre autoplay": "Aide sur l'Autoplay",
  "Ajuda: {value0}": "Aide : {value0}",
  "Ajustamos o intervalo para manter a ordem correta.": "Nous avons ajusté l'intervalle pour préserver l'ordre correct.",
  "Ajustar automaticamente o último valor para fechar 100%": "Ajuster automatiquement la dernière valeur pour atteindre 100%",
  "Ajustar valor": "Ajuster la valeur",
  "Ajuste a aparência do overlay de autoplay": "Ajustez l'apparence de la superposition d'Autoplay",
  "Ajuste a configuração para gerar horários": "Ajustez la configuration pour générer des horaires",
  "Ajuste a copy de abertura (gancho, avatar ou história)": "Ajustez le texte d'ouverture (accroche, avatar ou histoire)",
  "Ajuste a distribuição para 100% para continuar.": "Ajustez la répartition à 100% pour continuer.",
  "Ajuste a visibilidade dos controles do player.": "Réglez la visibilité des commandes du lecteur.",
  "Ajuste cor, desfoque e intensidade.": "Réglez la couleur, le flou et l'intensité.",
  "Ajuste o período e tente novamente.": "Ajustez la période et réessayez.",
  "Ajuste o player para cada tipo de dispositivo.": "Adaptez le lecteur à chaque type d'appareil.",
  "Ajuste o tamanho e espaçamento do formulário": "Ajustez la taille et l'espacement du formulaire",
  "Ajuste o volume do som da notificação (0-100%).": "Réglez le volume sonore de la notification (0-100%).",
  "Ajuste os filtros ou cadastre uma despesa manual.": "Ajustez les filtres ou ajoutez une dépense manuelle.",
  "Ajuste os percentuais de tráfego para cada vídeo": "Ajustez les pourcentages de trafic pour chaque vidéo",
  "Ajuste os tempos: Início define quando as opções aparecem; Final, que é opcional, define quando o vídeo pausa para a escolha. Se Início ficar vazio, as opções aparecem no fim do vídeo. Se o visitante não escolher, o último quadro permanece com as opções disponíveis.": "Ajustez les temps : Début définit l'apparition des options ; Fin, facultatif, définit la pause vidéo pour le choix. Si Début est vide, les options apparaissent à la fin de la vidéo. Sans choix du visiteur, la dernière image reste affichée avec les options disponibles.",
  "Ajuste título, subtítulo, texto do botão, mensagem de agradecimento, estilo, cor, posição e tamanho": "Ajustez le titre, le sous-titre, le texte du bouton, le message de remerciement, le style, la couleur, la position et la taille",
  "Ajuste velocidade e visibilidade dos controles.": "Réglez la vitesse et la visibilité des commandes.",
  "Ajustes automáticos de layout e interação por tela": "Ajustements automatiques de la présentation et des interactions selon l'écran",
  "Ajustes finos": "Réglages précis",
  "Ajustes rápidos": "Réglages rapides",
  "Alertas importantes": "Alertes importantes",
  "Alertas quando seus vídeos tiverem picos de engajamento": "Alertes lorsque vos vidéos connaissent des pics d'engagement",
  "Algo deu errado": "Une erreur est survenue",
  "Algo deu errado. Recuperando...": "Une erreur est survenue. Récupération...",
  "Alguns arquivos não são vídeos e foram ignorados.": "Certains fichiers ne sont pas des vidéos et ont été ignorés.",
  "Alinhada com quem busca escala, performance e operação profissional.": "Adaptée à ceux qui recherchent la croissance, la performance et une gestion professionnelle.",
  "Alinhamento": "Alignement",
  "Alinhamento do Logo": "Alignement du logo",
  "Alinhar à direita": "Aligner à droite",
  "Alinhar à esquerda": "Aligner à gauche",
  "Alinhe melhor o gancho curiosidade com o tema central": "Alignez mieux l'accroche de curiosité avec le thème central",
  "Alta Conversão Garantida": "Taux de conversion élevé garanti",
  "Alta Reprodução + Alto Engajamento = Copy matadora": "Taux de lecture élevé + engagement élevé = texte percutant",
  "Alta Taxa de Reprodução + Engajamento": "Taux de lecture élevé + engagement",
  "Alterar": "Modifier",
  "Alterar Senha": "Changer le mot de passe",
  "Alterar estilo": "Changer le style",
  "Alterar foto": "Changer la photo",
  "Alterar número": "Modifier le numéro",
  "Alterar plano": "Changer de forfait",
  "Alterar texto": "Modifier le texte",
  "Alterar vídeo": "Changer la vidéo",
  "Alterações futuras no vídeo": "Modifications futures de la vidéo",
  "Alterações não publicadas": "Modifications non publiées",
  "Alterações não salvas": "Modifications non enregistrées",
  "Alterações pendentes": "Modifications en attente",
  "Alterações salvas": "Modifications enregistrées",
  "Alterações salvas com sucesso": "Modifications enregistrées avec succès",
  "Altere a data e horário de encerramento automático do teste.": "Modifiez la date et l'heure de fin automatique du test.",
  "Altere a quantidade de clicks de incremento para este usuário.": "Modifiez le nombre de clics supplémentaires pour cet utilisateur.",
  "Altere seu plano atual": "Changez votre forfait actuel",
  "Alternar modo teatro": "Basculer en mode cinéma",
  "Alternativo:": "Autre option :",
  "Alto Engajamento": "Engagement élevé",
  "Alto engajamento": "Engagement élevé",
  "Alto volume": "Volume élevé",
  "Altura visual da barra durante a reprodução": "Hauteur visuelle de la barre pendant la lecture",
  "America/New York": "America/New York",
  "America/São Paulo": "America/São Paulo",
  "Ana, João, Maria, Pedro, Lucas": "Ana, João, Maria, Pedro, Lucas",
  "Analisando…": "Analyse…",
  "Analise conversões": "Analysez les conversions",
  "Analise de onde vem sua audiência e como ela se comporta": "Analysez la provenance et le comportement de votre audience",
  "Analise o mapa de calor por dia e hora para enxergar padrões": "Analysez la carte de chaleur par jour et heure pour repérer les tendances",
  "Analise o mapa de calor por dia e hora para enxergar padrões de audiência em segundos": "Analysez la carte de chaleur par jour et heure pour repérer les tendances d'audience en quelques secondes",
  "Analise os elementos que estão gerando mais engajamento": "Analysez les éléments qui génèrent le plus d'engagement",
  "Analise os pontos de queda": "Analysez les points de décrochage",
  "Analise retenção, plays, conversão e desempenho em uma visão comparativa completa com dados reais": "Analysez la rétention, les lectures, les conversions et les performances dans une vue comparative complète fondée sur des données réelles",
  "Analytics por etapa e evento": "Analyses par étape et événement",
  "Analítico para recomendação.": "Analyse pour la recommandation.",
  "Anima o botão em um pulso contínuo para chamar atenção": "Anime le bouton avec une pulsation continue pour attirer l'attention",
  "Animação": "Animation",
  "Animação Pulsar": "Animation de pulsation",
  "Animação de entrada": "Animation d'entrée",
  "Animação e Timing": "Animation et synchronisation",
  "Animações suaves de entrada e saída sem quebrar a imersão": "Animations fluides d'entrée et de sortie préservant l'immersion",
  "Antecipe o Pitch": "Avancez l'argumentaire de vente",
  "Anterior": "Précédent",
  "Antes de copiar para sua conta, confirme os termos de uso.": "Avant de copier vers votre compte, confirmez les conditions d'utilisation.",
  "Antes do principal": "Avant la vidéo principale",
  "Antes e depois": "Avant et après",
  "Anti-Plágio": "Anti-plagiat",
  "Análise Detalhada": "Analyse détaillée",
  "Análise Inteligente": "Analyse intelligente",
  "Análise competitiva": "Analyse concurrentielle",
  "Análise de Custos por Usuário": "Analyse des coûts par utilisateur",
  "Análise de Desempenho": "Analyse des performances",
  "Análise de Locais": "Analyse des lieux",
  "Análise de Performance": "Analyse des performances",
  "Análise de Retenção": "Analyse de rétention",
  "Análise de comportamento de usuários com mapas de calor e gravações de sessões.": "Analyse du comportement des utilisateurs avec cartes de chaleur et enregistrements de sessions.",
  "Análise detalhada de performance e engajamento": "Analyse détaillée des performances et de l'engagement",
  "Análise detalhada do desempenho desta introdução": "Analyse détaillée des performances de cette introduction",
  "Análises": "Analyses",
  "Análises inteligentes baseadas nos seus dados": "Analyses intelligentes fondées sur vos données",
  "Anônimo": "Anonyme",
  "Ao Pausar": "À la pause",
  "Ao Reproduzir": "À la lecture",
  "Ao adicionar o connector da HostVSL, cole a chave no campo de header": "Lors de l'ajout du connecteur HostVSL, collez la clé dans le champ d'en-tête",
  "Ao ativar a sua conta, ganhará acesso imediato ao seu painel administrativo para obter o seu link e começar a indicar.": "En activant votre compte, vous accéderez immédiatement à votre panneau d'administration pour obtenir votre lien et commencer à parrainer.",
  "Ao ativar, a headline será exibida diretamente sobre o vídeo conforme suas configurações.": "Une fois activé, le titre s'affichera directement sur la vidéo selon vos paramètres.",
  "Ao cancelar sua assinatura:": "Lors de la résiliation de votre abonnement :",
  "Ao clicar na notificação, abrir esta URL em nova aba.": "Au clic sur la notification, ouvrir cette URL dans un nouvel onglet.",
  "Ao clicar nesse botão você aceita e concorda com nossos termos de uso": "En cliquant sur ce bouton, vous acceptez nos conditions d'utilisation",
  "Ao clicar, abrir link": "Au clic, ouvrir le lien",
  "Ao confirmar, sua assinatura será cancelada imediatamente e o acesso será encerrado.": "Après confirmation, votre abonnement sera immédiatement résilié et votre accès prendra fin.",
  "Ao continuar, você concorda com os": "En continuant, vous acceptez les",
  "Ao editar, o último vídeo será compensado automaticamente": "Lors d'une modification, la dernière vidéo sera ajustée automatiquement",
  "Ao finalizar": "À la fin",
  "Ao finalizar, a velocidade com melhor engajamento será definida como principal.": "À la fin, la vitesse générant le meilleur engagement sera définie comme vitesse principale.",
  "Ao finalizar, o tráfego volta para a VSL Principal. Esta ação não pode ser desfeita.": "À la fin, le trafic revient vers la VSL principale. Cette action est irréversible.",
  "Ao finalizar, o vídeo volta ao início automaticamente, mantendo a reprodução em loop.": "À la fin, la vidéo revient automatiquement au début pour poursuivre la lecture en boucle.",
  "Ao me inscrever, concordo em receber comunicações e aceito a política de privacidade.": "En m'inscrivant, j'accepte de recevoir des communications et j'accepte la politique de confidentialité.",
  "Ao pausar o vídeo": "Lors de la pause de la vidéo",
  "Ao terminar o vídeo, mostre uma contagem regressiva e leve o espectador ao checkout": "À la fin de la vidéo, affichez un compte à rebours et dirigez le spectateur vers le paiement",
  "Ao vivo — {count} pessoas assistindo agora": "En direct — {count} personnes regardent en ce moment",
  "Aos 100% Visualizados": "À 100% de visionnage",
  "Aos 25% Visualizados": "À 25% de visionnage",
  "Aos 50% Visualizados": "À 50% de visionnage",
  "Aparece na sidebar do player público": "Apparaît dans la barre latérale du lecteur public",
  "Aparece no header e sidebar do player público": "Apparaît dans l'en-tête et la barre latérale du lecteur public",
  "Aparecer após iniciar o vídeo": "Apparaître après le démarrage de la vidéo",
  "Aparecer em": "Apparaître dans",
  "Aparência": "Apparence",
  "Aparência do Player": "Apparence du lecteur",
  "Aparência do link de recusa exibido abaixo do botão.": "Apparence du lien de refus affiché sous le bouton.",
  "Aparência dos Cards": "Apparence des cartes",
  "Aparência dos Controles": "Apparence des commandes",
  "Aparência geral do formulário": "Apparence générale du formulaire",
  "Apenas 3 passos simples para começar a ganhar": "3 étapes simples pour commencer à gagner",
  "Apenas em um trecho específico": "Uniquement sur un passage spécifique",
  "Apenas exibir o aviso": "Afficher uniquement la notification",
  "Apenas visualização de vídeos e métricas": "Consultation des vidéos et des indicateurs uniquement",
  "Aplica overlay escuro para destacar o CTA": "Applique une superposition sombre pour mettre le CTA en valeur",
  "Aplica uma sombra sob o botão para destacá-lo do fundo": "Applique une ombre sous le bouton pour le distinguer du fond",
  "Aplicada em barra de controle, play, volume e botões principais": "Appliquée à la barre de commandes, à la lecture, au volume et aux boutons principaux",
  "Aplicada em ícones secundários e textos do player": "Appliquée aux icônes secondaires et aux textes du lecteur",
  "Aplicada no botão e detalhes": "Appliquée au bouton et aux détails",
  "Aplicado": "Appliqué",
  "Aplicando...": "Application...",
  "Aplicar": "Appliquer",
  "Aplicar Configurações": "Appliquer les paramètres",
  "Aplicar Template": "Appliquer le modèle",
  "Aplicar como padrão": "Définir par défaut",
  "Aplicar desfoque na imagem de fundo (blur 8px)": "Appliquer un flou à l'image d'arrière-plan (flou de 8px)",
  "Aplicar em {value0} {value1}": "Appliquer à {value0} {value1}",
  "Aplicar leve desfoque": "Appliquer un léger flou",
  "Aplicação": "Application",
  "Aplicação & Metadados": "Application et métadonnées",
  "Aplique as estratégias vencedoras nos outros vídeos": "Appliquez les stratégies gagnantes à vos autres vidéos",
  "Aplique configurações padrão em vários vídeos de uma só vez para acelerar seu fluxo.": "Appliquez des paramètres par défaut à plusieurs vidéos en une fois pour accélérer votre travail.",
  "App instalado com sucesso!": "Application installée avec succès !",
  "App já instalado!": "Application déjà installée !",
  "Aprenda as melhores estratégias de marketing digital": "Découvrez les meilleures stratégies de marketing numérique",
  "Aprenda as melhores estratégias e técnicas neste curso completo. Conteúdo exclusivo desenvolvido para transformar seus resultados.": "Découvrez les meilleures stratégies et techniques dans cette formation complète. Du contenu exclusif conçu pour transformer vos résultats.",
  "Aprenda no seu ritmo, direto do menu Academy.": "Apprenez à votre rythme, directement depuis le menu Academy.",
  "Aprenda sobre legendas": "En savoir plus sur les sous-titres",
  "Aprendizado": "Apprentissage",
  "Aprimoradores de Conversão": "Optimisation des conversions",
  "Aprofunde no storytelling": "Développez la narration",
  "Aproveite essa condição especial": "Profitez de cette offre spéciale",
  "Após 15 dias": "Après 15 jours",
  "Após a ativação, terá acesso instantâneo a um link parametrizado exclusivo para divulgar nas suas redes ou site.": "Après activation, vous accéderez immédiatement à un lien paramétré unique à diffuser sur vos réseaux ou votre site.",
  "Após identificar um vencedor, crie um novo teste usando aquele como controle vs novas variações.": "Après avoir identifié un gagnant, créez un nouveau test en l'utilisant comme référence face à de nouvelles variantes.",
  "Após o envio": "Après l'envoi",
  "Após o vídeo de entrada": "Après la vidéo d'entrée",
  "Aqui ficam todos os recursos para personalizar seu player. Ative controles, botões, headline e muito mais.": "Retrouvez ici toutes les fonctionnalités pour personnaliser votre lecteur. Activez les commandes, les boutons, les titres et bien plus encore.",
  "Aqui você define as introduções.": "Définissez ici les introductions.",
  "Argentina": "Argentine",
  "Arial": "Arial",
  "Armazenamento cheio. Reduza o tamanho das imagens (logo, favicon, thumbnails) ou remova playlists antigas.": "Stockage plein. Réduisez la taille des images (logo, favicon, miniatures) ou supprimez d'anciennes playlists.",
  "Armazenamento:": "Stockage :",
  "Arquitetura Zustand": "Architecture Zustand",
  "Arquitetura de gerenciamento de estado da HostVSL": "Architecture de gestion de l'état de HostVSL",
  "Arquivado": "Archivé",
  "Arquivo": "Fichier",
  "Arquivo da legenda": "Fichier de sous-titres",
  "Arquivo excede o limite de {value0}MB": "Le fichier dépasse la limite de {value0} Mo",
  "Arquivo exportado com sucesso": "Fichier exporté avec succès",
  "Arquivo grande demais": "Fichier trop volumineux",
  "Arquivo inválido ou corrompido. Nenhuma legenda encontrada.": "Fichier invalide ou corrompu. Aucun sous-titre trouvé.",
  "Arquivo leve": "Fichier léger",
  "Arquivo maior que {n}MB": "Fichier supérieur à {n} Mo",
  "Arquivo muito grande": "Fichier trop volumineux",
  "Arquivo muito grande. Máximo: 20 MB": "Fichier trop volumineux. Maximum : 20 Mo",
  "Arquivo muito grande. Tamanho máximo: 5GB.": "Fichier trop volumineux. Taille maximale : 5 Go.",
  "Arrastando...": "Glissement...",
  "Arraste a caixa para qualquer posição dentro do player": "Faites glisser la zone vers n'importe quelle position dans le lecteur",
  "Arraste arquivos aqui ou clique": "Déposez les fichiers ici ou cliquez",
  "Arraste e solte o vídeo aqui": "Glissez-déposez la vidéo ici",
  "Arraste e solte ou escolha arquivos do seu computador.": "Glissez-déposez ou choisissez des fichiers sur votre ordinateur.",
  "Arraste e solte seu vídeo aqui": "Glissez-déposez votre vidéo ici",
  "Arraste e solte vídeos entre pastas": "Glissez-déposez des vidéos entre les dossiers",
  "Arraste e solte vídeos para carregar": "Glissez-déposez des vidéos pour les importer",
  "Arraste o vídeo aqui ou clique no botão abaixo para selecionar": "Déposez la vidéo ici ou cliquez sur le bouton ci-dessous pour la sélectionner",
  "Arraste os sliders ou digite valores. A soma sempre será ajustada para 100%.": "Faites glisser les curseurs ou saisissez les valeurs. La somme sera toujours ajustée à 100%.",
  "Arraste ou clique para enviar": "Déposez ou cliquez pour envoyer",
  "Arraste para enviar": "Déposez pour envoyer",
  "Arraste para reordenar, configure obrigatoriedade e placeholders": "Faites glisser pour réorganiser, définissez les champs obligatoires et les textes indicatifs",
  "Arraste seu arquivo ou clique para enviar": "Déposez votre fichier ou cliquez pour l'envoyer",
  "Arraste seu vídeo aqui ou clique no botão abaixo para selecionar": "Déposez votre vidéo ici ou cliquez sur le bouton ci-dessous pour la sélectionner",
  "Arraste seu vídeo aqui ou clique para enviar um arquivo": "Déposez votre vidéo ici ou cliquez pour envoyer un fichier",
  "Arraste sua imagem de fundo": "Déposez votre image d'arrière-plan",
  "Arraste um vídeo aqui ou clique para enviar": "Déposez une vidéo ici ou cliquez pour l'envoyer",
  "Arraste um vídeo da lista para cá ou use": "Faites glisser une vidéo de la liste ici ou utilisez",
  "Arraste um vídeo para o quadro para criar uma etapa com ele.": "Déposez une vidéo sur le tableau pour créer une étape avec celle-ci.",
  "Arraste uma imagem ou clique para selecionar": "Déposez une image ou cliquez pour la sélectionner",
  "Arraste vídeos aqui": "Déposez des vidéos ici",
  "Arraste vídeos da biblioteca para organizá-los aqui.": "Faites glisser des vidéos depuis la bibliothèque pour les organiser ici.",
  "Arredondado": "Arrondi",
  "Arredondado (16px)": "Arrondi (16px)",
  "Arredondamento": "Arrondi",
  "Arredondamento da Borda": "Arrondi de la bordure",
  "Arredondamento dos Cards": "Arrondi des cartes",
  "Arredondamento dos cantos": "Arrondi des coins",
  "As alterações aparecerão aqui em tempo real": "Les modifications apparaîtront ici en temps réel",
  "As alterações foram salvas com sucesso.": "Les modifications ont été enregistrées avec succès.",
  "As alterações não foram salvas.": "Les modifications n'ont pas été enregistrées.",
  "As alterações não salvas serão perdidas.": "Les modifications non enregistrées seront perdues.",
  "As comissões são pagas mensalmente via PIX ou transferência bancária, desde que o cliente indicado mantenha o plano ativo.": "Les commissions sont versées mensuellement par PIX ou virement bancaire, à condition que le client parrainé conserve son forfait actif.",
  "As configurações ainda não foram salvas. Clique no botão \"Aplicar\" no canto superior direito para iniciar o teste.": "Les paramètres n'ont pas encore été enregistrés. Cliquez sur le bouton « Appliquer » en haut à droite pour lancer le test.",
  "As configurações da logo foram salvas com sucesso": "Les paramètres du logo ont été enregistrés avec succès",
  "As configurações da thumbnail de pausa foram salvas com sucesso": "Les paramètres de la miniature de pause ont été enregistrés avec succès",
  "As configurações de legenda foram aplicadas com sucesso.": "Les paramètres des sous-titres ont été appliqués avec succès.",
  "As configurações de velocidade foram salvas com sucesso": "Les paramètres de vitesse ont été enregistrés avec succès",
  "As configurações do botão de ação foram salvas com sucesso": "Les paramètres du bouton d'action ont été enregistrés avec succès",
  "As configurações foram aplicadas com sucesso.": "Les paramètres ont été appliqués avec succès.",
  "As configurações foram salvas com sucesso": "Les paramètres ont été enregistrés avec succès",
  "As configurações são salvas individualmente por dispositivo.": "Les paramètres sont enregistrés séparément pour chaque appareil.",
  "As cores indicam horários com": "Les couleurs indiquent les horaires avec",
  "As cores mais intensas indicam horários com maior": "Les couleurs les plus intenses indiquent les horaires avec davantage de",
  "As cores mais intensas indicam horários com maior volume de": "Les couleurs les plus intenses indiquent les horaires avec un volume plus élevé de",
  "As cores mais intensas indicam horários com maior volume de plays.": "Les couleurs les plus intenses indiquent les horaires ayant le plus de lectures.",
  "As curvas de retenção aparecerão assim que houver visualizações no teste.": "Les courbes de rétention apparaîtront dès que le test recevra des vues.",
  "As imagens foram enviadas e salvas com sucesso": "Les images ont été envoyées et enregistrées avec succès",
  "As informações aparecerão quando houver cópias do vídeo": "Les informations apparaîtront lorsque la vidéo aura été copiée",
  "As linhas mostram a porcentagem de espectadores que continuam assistindo em cada momento do vídeo": "Les lignes montrent le pourcentage de spectateurs qui continuent à regarder à chaque instant de la vidéo",
  "As mudanças já estão visíveis na URL pública.": "Les modifications sont déjà visibles sur l'URL publique.",
  "As métricas aparecerão quando houver visualizações nos vídeos do teste": "Les indicateurs apparaîtront lorsque les vidéos du test recevront des vues",
  "As métricas começam quando o fluxo é publicado.": "Les indicateurs commencent à être recueillis lorsque le parcours est publié.",
  "As métricas da Jornada aparecem aqui assim que os espectadores começarem a assistir aos vídeos de entrada e saída.": "Les indicateurs du parcours apparaîtront ici dès que les spectateurs commenceront à regarder les vidéos d'entrée et de sortie.",
  "As opções precisam aparecer antes da pausa.": "Les options doivent apparaître avant la pause.",
  "As opções que levam a ela ficam sem destino. O vídeo continua na lista do fluxo.": "Les options qui y mènent n'ont plus de destination. La vidéo reste dans la liste du parcours.",
  "As personalizações serão aplicadas ao abrir o vídeo.": "Les personnalisations seront appliquées à l'ouverture de la vidéo.",
  "As senhas não coincidem": "Les mots de passe ne correspondent pas",
  "As senhas não conferem": "Les mots de passe ne correspondent pas",
  "As senhas precisam ser iguais.": "Les mots de passe doivent être identiques.",
  "As solicitações de saque dos afiliados aparecerão aqui.": "Les demandes de retrait des affiliés apparaîtront ici.",
  "Asia/Tokyo": "Asia/Tokyo",
  "Assim que alguém der play numa VSL (com som), o ponto aparece aqui no mapa.": "Dès qu'une personne lance une VSL avec le son, son point apparaît ici sur la carte.",
  "Assim que o teste começar a receber visualizações, você verá a comparação de retenção entre as introduções aqui.": "Dès que le test commencera à recevoir des vues, la comparaison de rétention entre les introductions apparaîtra ici.",
  "Assim que suas visualizações começarem, mostraremos os dispositivos e origens.": "Dès les premières vues, nous afficherons les appareils et les sources.",
  "Assim que um evento for detectado, ele aparece aqui.": "Dès qu'un événement est détecté, il apparaît ici.",
  "Assinatura": "Abonnement",
  "Assinatura atualizada com sucesso.": "Abonnement mis à jour avec succès.",
  "Assinatura cancelada com sucesso": "Abonnement résilié avec succès",
  "Assinatura criada com sucesso": "Abonnement créé avec succès",
  "Assistido": "Regardé",
  "Assistido em média": "Durée moyenne regardée",
  "Assistir Novamente": "Regarder à nouveau",
  "Assistir de novo": "Regarder à nouveau",
  "Assistir do início": "Regarder depuis le début",
  "Assistir na Smart TV": "Regarder sur une Smart TV",
  "Assistir tutorial": "Voir le tutoriel",
  "Assistiram até o fim": "Ont regardé jusqu'à la fin",
  "At least one thumbnail URL is required": "Au moins une URL de miniature est requise",
  "Atalhos": "Raccourcis",
  "Atendimento": "Assistance",
  "Atenção": "Attention",
  "Atenção antes de criar o teste": "À vérifier avant de créer le test",
  "Atenção:": "Attention :",
  "Ativa": "Active",
  "Ativa a reprodução automática do vídeo": "Active la lecture automatique de la vidéo",
  "Ativa o som ao detectar ação do visitante (clique, scroll ou toque)": "Active le son après une action du visiteur (clic, défilement ou toucher)",
  "Ativa tanto as áreas de linguagem quanto as de processamento sensorial": "Active à la fois les zones du langage et celles du traitement sensoriel",
  "Ativada": "Activée",
  "Ativadas": "Activées",
  "Ativando métricas": "Activation des indicateurs",
  "Ativar": "Activer",
  "Ativar Autoplay": "Activer l'Autoplay",
  "Ativar Ações Sincronizadas": "Activer les actions synchronisées",
  "Ativar Borda": "Activer la bordure",
  "Ativar Captura por Tempo": "Activer la capture programmée",
  "Ativar Continuar Assistindo": "Activer la reprise du visionnage",
  "Ativar Exibição por Dispositivo": "Activer l'affichage par appareil",
  "Ativar Logo": "Activer le logo",
  "Ativar Minha Conta de Afiliado": "Activer mon compte affilié",
  "Ativar Notificações Push": "Activer les notifications push",
  "Ativar Perfil Gratuitamente": "Activer le profil gratuitement",
  "Ativar Pixel": "Activer le pixel",
  "Ativar Rastreamento de Afiliados": "Activer le suivi des affiliés",
  "Ativar Spark Points": "Activer les Spark Points",
  "Ativar VSLeads": "Activer VSLeads",
  "Ativar Velocidade": "Activer la vitesse",
  "Ativar acesso grátis": "Activer l'accès gratuit",
  "Ativar agora": "Activer maintenant",
  "Ativar borda no player": "Activer la bordure du lecteur",
  "Ativar botão": "Activer le bouton",
  "Ativar botão de ação": "Activer le bouton d'action",
  "Ativar com teste grátis": "Activer avec un essai gratuit",
  "Ativar compartilhamento": "Activer le partage",
  "Ativar horários de silêncio": "Activer les heures de silence",
  "Ativar link de afiliado": "Activer le lien affilié",
  "Ativar notificações": "Activer les notifications",
  "Ativar o plano": "Activer le forfait",
  "Ativar reprodução automática": "Activer la lecture automatique",
  "Ativar segundo botão": "Activer le deuxième bouton",
  "Ativar som": "Activer le son",
  "Ativar sombra": "Activer l'ombre",
  "Ativar tema do player": "Activer le thème du lecteur",
  "Ativar temporizador": "Activer le minuteur",
  "Ativar teste automático": "Activer le test automatique",
  "Ativar teste automático com múltiplas velocidades": "Activer le test automatique à plusieurs vitesses",
  "Ativar teste de velocidade": "Activer le test de vitesse",
  "Ativar velocidade personalizada": "Activer la vitesse personnalisée",
  "Ative a estratégia para copiar o código": "Activez la stratégie pour copier le code",
  "Ative a exibição por dispositivo para personalizar Desktop, Tablet e Mobile.": "Activez l'affichage par appareil pour personnaliser les versions ordinateur, tablette et mobile.",
  "Ative a recarga para nunca ficar sem plays": "Activez la recharge pour ne jamais manquer de lectures",
  "Ative a sua conta gratuitamente, partilhe o seu link exclusivo e construa uma nova fonte de rendimento acompanhando tudo em tempo real através de um painel analítico completo.": "Activez votre compte gratuitement, partagez votre lien unique et créez une nouvelle source de revenus en suivant tout en temps réel dans un tableau de bord analytique complet.",
  "Ative as notificações para receber alertas em tempo real sobre conversões, métricas e atualizações importantes.": "Activez les notifications pour recevoir des alertes en temps réel sur les conversions, les indicateurs et les mises à jour importantes.",
  "Ative as notificações primeiro para enviar testes.": "Activez d'abord les notifications pour envoyer des tests.",
  "Ative com um clique direto no painel de recursos": "Activez en un clic directement dans le panneau des fonctionnalités",
  "Ative com um clique no painel de recursos do vídeo": "Activez en un clic dans le panneau des fonctionnalités de la vidéo",
  "Ative comportamentos extras do Autoplay": "Activez des comportements supplémentaires pour l'Autoplay",
  "Ative comportamentos extras do botão": "Activez des comportements supplémentaires pour le bouton",
  "Ative na aba \"Controles\" da personalização do vídeo, na opção \"Assistir na Smart TV\"": "Activez dans l'onglet « Commandes » de la personnalisation vidéo, avec l'option « Regarder sur une Smart TV »",
  "Ative na aba \"Controles\" da personalização do vídeo, na opção \"Preview na Timeline\"": "Activez dans l'onglet « Commandes » de la personnalisation vidéo, avec l'option « Aperçu sur la timeline »",
  "Ative na personalização do vídeo e simule a contagem no preview do player ao lado": "Activez dans la personnalisation vidéo et simulez le compte à rebours dans l'aperçu du lecteur à côté",
  "Ative na personalização do vídeo, na categoria Conversão, em \"Feedback do Vídeo\"": "Activez dans la personnalisation vidéo, catégorie Conversion, avec « Avis sur la vidéo »",
  "Ative na personalização do vídeo, na opção \"Jornada de Conversão\"": "Activez dans la personnalisation vidéo avec l'option « Parcours de conversion »",
  "Ative na personalização do vídeo, na opção \"Notificação de Vendas\"": "Activez dans la personnalisation vidéo avec l'option « Notification de ventes »",
  "Ative o Smart Autoplay na aba \"Configuração\" para personalizar o estilo visual.": "Activez Smart Autoplay dans l'onglet « Configuration » pour personnaliser le style visuel.",
  "Ative o Smart Autoplay para personalizar o estilo visual.": "Activez Smart Autoplay pour personnaliser le style visuel.",
  "Ative o autoplay na aba Configuração para configurar testes A/B": "Activez l'Autoplay dans l'onglet Configuration pour configurer les tests A/B",
  "Ative o autoplay para ver o preview": "Activez l'Autoplay pour voir l'aperçu",
  "Ative o bloco de saída para visualizar suas métricas aqui.": "Activez le bloc de sortie pour voir ses indicateurs ici.",
  "Ative o botão de ação na aba Configuração para configurar a exibição": "Activez le bouton d'action dans l'onglet Configuration pour configurer l'affichage",
  "Ative o botão de ação na aba Configuração para personalizar o estilo": "Activez le bouton d'action dans l'onglet Configuration pour personnaliser le style",
  "Ative o botão para ver o preview": "Activez le bouton pour voir l'aperçu",
  "Ative o formulário VSLeads para capturar emails e informações dos seus visitantes.": "Activez le formulaire VSLeads pour recueillir les e-mails et les informations de vos visiteurs.",
  "Ative o recurso acima para pausar o vídeo quando o visitante sair da aba do navegador.": "Activez la fonctionnalité ci-dessus pour mettre la vidéo en pause lorsque le visiteur quitte l'onglet du navigateur.",
  "Ative o recurso acima para pausar o vídeo quando o visitante sair da aba.": "Activez la fonctionnalité ci-dessus pour mettre la vidéo en pause lorsque le visiteur quitte l'onglet.",
  "Ative o recurso acima para reiniciar o vídeo automaticamente ao chegar ao fim.": "Activez la fonctionnalité ci-dessus pour relancer automatiquement la vidéo à la fin.",
  "Ative o recurso de headline para visualizar as métricas": "Activez la fonctionnalité de titre pour afficher les indicateurs",
  "Ative o recurso para configurar": "Activez la fonctionnalité pour la configurer",
  "Ative o recurso para ver o preview": "Activez la fonctionnalité pour voir l'aperçu",
  "Ative o som": "Activez le son",
  "Ative o switch acima para começar a configurar suas legendas.": "Activez l'interrupteur ci-dessus pour commencer à configurer vos sous-titres.",
  "Ative os controles do player para o espectador.": "Activez les commandes du lecteur pour le spectateur.",
  "Ative ou desative o formulário de captura neste vídeo. Quando ativo, o formulário será exibido no momento configurado.": "Activez ou désactivez le formulaire de capture pour cette vidéo. Une fois activé, le formulaire s'affichera au moment défini.",
  "Ative ou desative os campos que deseja coletar no formulário": "Activez ou désactivez les champs à recueillir dans le formulaire",
  "Ative para exibir a barra de progresso no vídeo.": "Activez pour afficher la barre de progression sur la vidéo.",
  "Ative para exibir o formulário de captura de dados neste vídeo no momento configurado. Quando ativo, o formulário será exibido automaticamente.": "Activez pour afficher le formulaire de collecte de données dans cette vidéo au moment défini. Une fois activé, le formulaire s'affichera automatiquement.",
  "Ative para rastrear eventos e conversões em plataformas de anúncios": "Activez pour suivre les événements et les conversions sur les plateformes publicitaires",
  "Atividade Recente": "Activité récente",
  "Ativo": "Actif",
  "Ativo · 1 notificação a cada {freq}s · {pos}": "Actif · 1 notification toutes les {freq}s · {pos}",
  "Ativos": "Actifs",
  "Ativável por vídeo na personalização.": "Activable par vidéo dans la personnalisation.",
  "Atraia atenção com um título impactante": "Attirez l'attention avec un titre percutant",
  "Atraso inicial": "Délai initial",
  "Atraso inicial ({value}s)": "Délai initial ({value}s)",
  "Atraso inicial de até 3 minutos, intervalo de 5 segundos a 5 minutos e duração de 1 a 20 segundos": "Délai initial jusqu'à 3 minutes, intervalle de 5 secondes à 5 minutes et durée de 1 à 20 secondes",
  "Atribuição por Último Clique": "Attribution au dernier clic",
  "Atualizado": "Mis à jour",
  "Atualizado em": "Mis à jour le",
  "Atualizado:": "Mis à jour :",
  "Atualizando...": "Mise à jour...",
  "Atualizar": "Mettre à jour",
  "Atualizar Clicks": "Mettre à jour les clics",
  "Atualizar Documentação": "Mettre à jour la documentation",
  "Atualizar Pagamento": "Mettre à jour le paiement",
  "Atualizar Permissões": "Mettre à jour les autorisations",
  "Atualizar Senha": "Mettre à jour le mot de passe",
  "Atualizar dados": "Mettre à jour les données",
  "Atualização de Pagamento": "Mise à jour du paiement",
  "Atualização de toda documentação para usar Azul Host (#1D4FFF) como cor primária única. Corrigidas inconsistências entre DESIGN_SYSTEM.md, FEATURE_CONFIGS_STANDARD.md, PWA_README.md e colors.ts.": "Mise à jour de toute la documentation pour utiliser le bleu Host (#1D4FFF) comme unique couleur primaire. Correction des incohérences entre DESIGN_SYSTEM.md, FEATURE_CONFIGS_STANDARD.md, PWA_README.md et colors.ts.",
  "Atualização do Pagamento": "Mise à jour du paiement",
  "Atualização do sistema": "Mise à jour du système",
  "Atualização em tempo real": "Mise à jour en temps réel",
  "Atualização em tempo real dos resultados do teste": "Mise à jour des résultats du test en temps réel",
  "Atualize as informações do cartão.": "Mettez à jour les informations de la carte.",
  "Atualize seus dados de contato": "Mettez à jour vos coordonnées",
  "Atualize seus dados pessoais e avatar": "Mettez à jour vos informations personnelles et votre avatar",
  "Atualize sua senha e configurações de segurança": "Mettez à jour votre mot de passe et vos paramètres de sécurité",
  "Até": "Jusqu'à",
  "Até 23:59": "Jusqu'à 23:59",
  "Auditoria": "Audit",
  "Auditoria Anti-Fraude": "Audit antifraude",
  "Auditoria de Membros": "Audit des membres",
  "Audiência": "Audience",
  "Audiência Predominantemente Mobile": "Audience principalement mobile",
  "Audiência Simulada": "Audience simulée",
  "Audiência em Tempo Real": "Audience en temps réel",
  "Aula": "Cours",
  "Aula Concluída": "Cours terminé",
  "Aula Gratuita - Marketing": "Cours gratuit - Marketing",
  "Aula concluída! 🎉": "Cours terminé ! 🎉",
  "Aula não encontrada": "Cours introuvable",
  "Aula {value0}": "Cours {value0}",
  "Aulas": "Cours",
  "Aulas (": "Cours (",
  "Aulas curtas e objetivas com player premium integrado": "Cours courts et précis avec lecteur premium intégré",
  "Aulas do Curso": "Cours de la formation",
  "Aulas exclusivas para acelerar sua evolução": "Cours exclusifs pour accélérer votre progression",
  "Aulas exclusivas para aumente suas conversões imediatamente.": "Des cours exclusifs pour augmenter immédiatement vos conversions.",
  "Aumenta retenção em vídeos longos": "Augmente la rétention sur les longues vidéos",
  "Aumentar 5%": "Augmenter de 5%",
  "Aumentar valor": "Augmenter la valeur",
  "Aumente a retenção com um vídeo gancho no autoplay": "Augmentez la rétention avec une vidéo d'accroche dans l'Autoplay",
  "Aumento de 35% na retenção da VSL": "Augmentation de 35% de la rétention de la VSL",
  "Autenticado com sucesso!": "Authentification réussie !",
  "Auto": "Auto",
  "Auto usa o formato do vídeo da etapa inicial.": "Le mode Auto utilise le format de la vidéo de l'étape initiale.",
  "Auto-ajustado": "Ajusté automatiquement",
  "Auto-balancear": "Équilibrer automatiquement",
  "Auto-fechar ao enviar": "Fermer automatiquement après l'envoi",
  "Auto-gerado": "Généré automatiquement",
  "Auto-indicação ou práticas abusivas de SPAM resultarão no cancelamento imediato das comissões e da conta.": "L'auto-parrainage ou les pratiques abusives de spam entraîneront l'annulation immédiate des commissions et du compte.",
  "Auto-play Próxima Aula": "Lecture automatique du cours suivant",
  "Automatize emails personalizados, escale experiências únicas para clientes e transforme leads em receita.": "Automatisez des e-mails personnalisés, développez des expériences uniques pour vos clients et transformez les leads en chiffre d'affaires.",
  "Automatize mensagens de texto, áudio e vídeo, recupere vendas perdidas de Pix e boletos, compras canceladas e carrinhos abandonados, crie chatbots, envie mensagens em massa, rastreie vendas e mais com nossas 271 funções.": "Automatisez les messages texte, audio et vidéo, récupérez les ventes perdues par PIX et boleto, les achats annulés et les paniers abandonnés, créez des chatbots, envoyez des messages en masse, suivez les ventes et bien plus grâce à nos 271 fonctions.",
  "Automatize tarefas integrando mais de 5.000 aplicativos diferentes.": "Automatisez les tâches en intégrant plus de 5.000 applications différentes.",
  "Automação de emails e fluxos de trabalho para marketing e vendas.": "Automatisation des e-mails et des processus de marketing et de vente.",
  "Automático": "Automatique",
  "Autoplay": "Autoplay",
  "Autoplay ativado": "Autoplay activé",
  "Autoplay desativado": "Autoplay désactivé",
  "Autoplay e Teste A/B": "Autoplay et test A/B",
  "Autoplay e controles não podem estar ativos ao mesmo tempo.": "L'Autoplay et les commandes ne peuvent pas être actifs simultanément.",
  "Autoplay foi desativado automaticamente. Autoplay e controles não podem estar ativos ao mesmo tempo.": "L'Autoplay a été désactivé automatiquement. L'Autoplay et les commandes ne peuvent pas être actifs simultanément.",
  "AutoplayStyleSection - Accordion Aberto por Padrão": "AutoplayStyleSection - Accordéon ouvert par défaut",
  "Avaliações": "Évaluations",
  "Avalie o contexto do seu conteúdo - vídeos técnicos podem funcionar melhor em velocidades mais baixas": "Évaluez le contexte de votre contenu : les vidéos techniques peuvent être plus efficaces à une vitesse réduite",
  "Avançado": "Avancé",
  "Avançar": "Suivant",
  "Avançar 10 segundos": "Avancer de 10 secondes",
  "Avançar 10s": "Avancer de 10 s",
  "Avançar para Intros em Teste": "Passer aux intros en test",
  "Avançaram ao conteúdo": "Ont poursuivi vers le contenu",
  "Avatar": "Avatar",
  "Avisa que o vídeo iniciou automaticamente.": "Indique que la vidéo a démarré automatiquement.",
  "Avisos": "Notifications",
  "Azul Host claro - hover states": "Bleu Host clair - états au survol",
  "Azul Host escuro - estados pressionados": "Bleu Host foncé - états appuyés",
  "Azul Host oficial - cor principal": "Bleu Host officiel - couleur principale",
  "Ação": "Action",
  "Ação & Destino": "Action et destination",
  "Ação Ativada": "Action activée",
  "Ação aplicada:": "Action appliquée :",
  "Ação atualizada com sucesso!": "Action mise à jour avec succès !",
  "Ação criada com sucesso!": "Action créée avec succès !",
  "Ação de Play obrigatória, disparada no primeiro play do vídeo": "Action de lecture obligatoire, déclenchée au premier lancement de la vidéo",
  "Ação do botão": "Action du bouton",
  "Ação excluída com sucesso!": "Action supprimée avec succès !",
  "Ação quando zerar": "Action à la fin du décompte",
  "Ação:": "Action :",
  "Ações": "Actions",
  "Ações Configuradas (": "Actions configurées (",
  "Ações Necessárias": "Actions requises",
  "Ações de Pitch (quando a oferta aparece) e Checkout (clique no botão de compra) opcionais": "Actions Pitch (apparition de l'offre) et Checkout (clic sur le bouton d'achat) facultatives",
  "Ações do vídeo": "Actions de la vidéo",
  "Ações do vídeo {value0}": "Actions de la vidéo {value0}",
  "Ações geradas": "Actions générées",
  "BRL": "BRL",
  "BRL + Taxas estimadas": "BRL + frais estimés",
  "Backend": "Backend",
  "Background": "Arrière-plan",
  "Background Botão": "Arrière-plan du bouton",
  "Background do Vídeo": "Arrière-plan de la vidéo",
  "Badge \"Sessão atualizada hoje\"": "Badge « Session mise à jour aujourd'hui »",
  "Badge personalizado": "Badge personnalisé",
  "Badges de urgência": "Badges d'urgence",
  "Baixa amostra": "Échantillon réduit",
  "Baixando seus vídeos do Google Drive...": "Téléchargement de vos vidéos depuis Google Drive...",
  "Baixando {value0} vídeo{value1}...": "Téléchargement de {value0} vidéo{value1}...",
  "Baixar": "Télécharger",
  "Baixar QR Code": "Télécharger le QR code",
  "Baixar comprovante": "Télécharger le justificatif",
  "Baixar fatura": "Télécharger la facture",
  "Baixar modelo (.TXT)": "Télécharger le modèle (.TXT)",
  "Baixe o arquivo modelo para ver o formato correto": "Téléchargez le fichier modèle pour voir le format attendu",
  "Baixe um exemplo simples para preencher suas legendas.": "Téléchargez un exemple simple pour remplir vos sous-titres.",
  "Baixo": "Faible",
  "Baixo Direita": "En bas à droite",
  "Baixo Esquerda": "En bas à gauche",
  "Banco": "Banque",
  "Bancos Vinculados": "Banques associées",
  "Banner": "Bannière",
  "Banner hero": "Bannière principale",
  "Barra Fake": "Barre fictive",
  "Barra Inferior": "Barre inférieure",
  "Barra de Controles": "Barre de commandes",
  "Barra de Progresso": "Barre de progression",
  "Barra de progresso": "Barre de progression",
  "Barra fake foi desativada automaticamente. Barra fake e controles não podem estar ativos ao mesmo tempo.": "La barre fictive a été désactivée automatiquement. La barre fictive et les commandes ne peuvent pas être actives simultanément.",
  "Barras": "Barres",
  "Base (opcional)": "Base (facultative)",
  "Base preparada para liberar novas funcionalidades com mais velocidade": "Base préparée pour déployer plus rapidement de nouvelles fonctionnalités",
  "Base preparada para novas funcionalidades com mais velocidade": "Base préparée pour de nouvelles fonctionnalités plus rapidement",
  "Base: últimos 7 dias": "Base : les 7 derniers jours",
  "Baseado no desempenho do período": "Selon les performances de la période",
  "Bem-vindo": "Bienvenue",
  "Bem-vindo ao HostVSL": "Bienvenue sur HostVSL",
  "Bem-vindo de volta,": "Bon retour,",
  "Benefícios do Programa": "Avantages du programme",
  "Biblioteca": "Bibliothèque",
  "Biblioteca Host VSL": "Bibliothèque Host VSL",
  "Bloco de oferta": "Bloc d'offre",
  "Bloq.": "Bloq.",
  "Bloqueada": "Bloquée",
  "Bloqueadas": "Bloquées",
  "Bloqueado": "Bloqué",
  "Bloqueados": "Bloqués",
  "Bloquear": "Bloquer",
  "Bloquear Proxy/VPN": "Bloquer les proxys/VPN",
  "Bloquear acesso": "Bloquer l'accès",
  "Bloquear fechamento (segundos)": "Bloquer la fermeture (secondes)",
  "Bloquear fechar até enviar": "Empêcher la fermeture avant l'envoi",
  "Bloquear número": "Bloquer le numéro",
  "Bloquear pause": "Bloquer la pause",
  "Bloquear por Domínio": "Bloquer par domaine",
  "Bloquear selecionados": "Bloquer la sélection",
  "Bloquear visualização": "Bloquer le visionnage",
  "Bloqueia acessos suspeitos usando proxy, VPN ou mascaramento de localização.": "Bloque les accès suspects via proxy, VPN ou masquage de localisation.",
  "Bloqueie a exibição dos vídeos fora do seu site.": "Empêchez l'affichage des vidéos en dehors de votre site.",
  "Bloqueie ou remova o acesso na hora em que alguém sair do time": "Bloquez ou supprimez immédiatement l'accès lorsqu'une personne quitte l'équipe",
  "Bloqueio por dispositivo (desktop, celular, tablet) e por VPN/Proxy": "Blocage par appareil (ordinateur, téléphone, tablette) et par VPN/proxy",
  "Bloqueios detectados": "Blocages détectés",
  "Blur de Fundo (Glass Effect)": "Flou d'arrière-plan (effet de verre)",
  "Boa Performance": "Bonnes performances",
  "Bold": "Gras",
  "Bom": "Bon",
  "Bom Desempenho": "Bonnes performances",
  "Bom desempenho": "Bonnes performances",
  "Borda": "Bordure",
  "Borda Customizada": "Bordure personnalisée",
  "Borda branca": "Bordure blanche",
  "Borda customizada": "Bordure personnalisée",
  "Borda do Player": "Bordure du lecteur",
  "Borda do player": "Bordure du lecteur",
  "Bordas Arredondadas:": "Coins arrondis :",
  "Bordas Personalizadas": "Bordures personnalisées",
  "Bordas arredondadas": "Bordures arrondies",
  "Bordas padrão": "Bordures par défaut",
  "Border Radius": "Rayon des coins",
  "Border-radius de botões": "Rayon des coins des boutons",
  "Border-radius de cards": "Rayon des coins des cartes",
  "Border-radius de dropdowns": "Rayon des coins des menus déroulants",
  "Border-radius de modais": "Rayon des coins des fenêtres",
  "Border-radius de switch cards": "Rayon des coins des cartes à interrupteur",
  "Botão": "Bouton",
  "Botão \"Ir Agora\"": "Bouton « Y aller maintenant »",
  "Botão \"Ir Agora\" opcional, pra quem já decidiu e não quer esperar a contagem terminar": "Bouton « Y aller maintenant » facultatif pour les personnes déjà décidées qui ne souhaitent pas attendre la fin du décompte",
  "Botão \"Pular\"": "Bouton « Passer »",
  "Botão CTA": "Bouton CTA",
  "Botão Play Pequeno": "Petit bouton de lecture",
  "Botão Principal": "Bouton principal",
  "Botão Principal (CTA)": "Bouton principal (CTA)",
  "Botão WhatsApp": "Bouton WhatsApp",
  "Botão adicionado": "Bouton ajouté",
  "Botão ativo": "Bouton actif",
  "Botão continuar": "Bouton Continuer",
  "Botão de Ação": "Bouton d'action",
  "Botão de Ação (CTA)": "Bouton d'action (CTA)",
  "Botão de Thumb": "Bouton de miniature",
  "Botão de aceite com um link de recusa discreto abaixo.": "Bouton d'acceptation avec un lien de refus discret en dessous.",
  "Botão de ação": "Bouton d'action",
  "Botão de ação atualizado": "Bouton d'action mis à jour",
  "Botão de pular": "Bouton Passer",
  "Botão de pular com contagem regressiva no vídeo de entrada": "Bouton Passer avec compte à rebours dans la vidéo d'entrée",
  "Botão desativado": "Bouton désactivé",
  "Botão discreto sobre o vídeo": "Bouton discret sur la vidéo",
  "Botão não visível neste momento": "Bouton invisible pour le moment",
  "Botão para transmitir o vídeo": "Bouton de diffusion de la vidéo",
  "Botão play pequeno": "Petit bouton de lecture",
  "Botão reiniciar": "Bouton Recommencer",
  "Botão removido": "Bouton supprimé",
  "Botões Inteligentes com Tempo e Ação": "Boutons intelligents avec programmation et action",
  "Botões das opções": "Boutons des options",
  "Braip": "Braip",
  "Branco": "Blanc",
  "Brasil": "Brésil",
  "Brasília (GMT-3)": "Brasília (GMT-3)",
  "Breadcrumb": "Fil d'Ariane",
  "Broip lidera com 53% das conversões hoje.": "Broip est en tête avec 53% des conversions aujourd'hui.",
  "Build Tool": "Outil de build",
  "Bunny": "Bunny",
  "Busca rápida por aula em qualquer módulo": "Recherche rapide d'un cours dans n'importe quel module",
  "Buscando...": "Recherche...",
  "Buscar": "Rechercher",
  "Buscar Mini-Hook": "Rechercher un Mini-Hook",
  "Buscar Registro por E-mail": "Rechercher un enregistrement par e-mail",
  "Buscar URL, domínio ou página": "Rechercher une URL, un domaine ou une page",
  "Buscar Usuário": "Rechercher un utilisateur",
  "Buscar Usuário por E-mail": "Rechercher un utilisateur par e-mail",
  "Buscar aula...": "Rechercher un cours...",
  "Buscar comentário": "Rechercher un commentaire",
  "Buscar domínio...": "Rechercher un domaine...",
  "Buscar e selecionar idiomas": "Rechercher et sélectionner des langues",
  "Buscar e selecionar países": "Rechercher et sélectionner des pays",
  "Buscar e selecionar regiões": "Rechercher et sélectionner des régions",
  "Buscar e-mail...": "Rechercher un e-mail...",
  "Buscar em {value0}": "Rechercher dans {value0}",
  "Buscar fluxo": "Rechercher un parcours",
  "Buscar fluxo pelo nome": "Rechercher un parcours par nom",
  "Buscar integração...": "Rechercher une intégration...",
  "Buscar intro...": "Rechercher une intro...",
  "Buscar legenda...": "Rechercher des sous-titres...",
  "Buscar origem...": "Rechercher une source...",
  "Buscar por E-mail": "Rechercher par e-mail",
  "Buscar por URL, Token ou Vídeo": "Rechercher par URL, jeton ou vidéo",
  "Buscar por e-mail": "Rechercher par e-mail",
  "Buscar por email...": "Rechercher par e-mail...",
  "Buscar por nome ou email...": "Rechercher par nom ou e-mail...",
  "Buscar por nome, e-mail ou telefone": "Rechercher par nom, e-mail ou téléphone",
  "Buscar por título, pasta ou tag...": "Rechercher par titre, dossier ou tag...",
  "Buscar recurso...": "Rechercher une fonctionnalité...",
  "Buscar vídeo...": "Rechercher une vidéo...",
  "Buscar vídeos": "Rechercher des vidéos",
  "Buscar vídeos ou pastas…": "Rechercher des vidéos ou des dossiers…",
  "Buscar vídeos...": "Rechercher des vidéos...",
  "Buscar vídeo…": "Rechercher une vidéo…",
  "Buscar...": "Rechercher...",
  "Busque e selecione múltiplos vídeos de uma vez": "Recherchez et sélectionnez plusieurs vidéos à la fois",
  "Busque um usuário para gerenciar nível, status, plano e cliques operacionais.": "Recherchez un utilisateur pour gérer son niveau, son statut, son forfait et ses clics opérationnels.",
  "Busque, crie, edite ou exclua registros de incremento condicional de clicks por usuário.": "Recherchez, créez, modifiez ou supprimez les enregistrements d'ajout conditionnel de clics par utilisateur.",
  "Button text is required": "Le texte du bouton est obligatoire",
  "Button text too long": "Le texte du bouton est trop long",
  "Bônus": "Bonus",
  "Bônus (até 6)": "Bonus (jusqu'à 6)",
  "Bônus por tempo limitado": "Bonus à durée limitée",
  "C. no Botão": "Clics sur le bouton",
  "C. no botão": "Clics sur le bouton",
  "CC": "CC",
  "CEP (00000-000)": "Code postal brésilien (00000-000)",
  "CONTINUAR SEM ESSA OFERTA": "CONTINUER SANS CETTE OFFRE",
  "CONVERSÃO": "CONVERSION",
  "CPF": "CPF",
  "CPF inválido.": "CPF invalide.",
  "CSV": "CSV",
  "CSV (.csv)": "CSV (.csv)",
  "CSV exportado com sucesso": "CSV exporté avec succès",
  "CSV exportado com sucesso!": "CSV exporté avec succès !",
  "CSV exportado!": "CSV exporté !",
  "CTA centralizado": "CTA centré",
  "CTA do vídeo de entrada": "CTA de la vidéo d'entrée",
  "CTA do vídeo de saída": "CTA de la vidéo de sortie",
  "CTR": "CTR",
  "CTR Geral": "CTR global",
  "CTR do CTA final": "CTR du CTA final",
  "CVC": "CVC",
  "CVC inválido": "CVC invalide",
  "Cabeçalho desktop": "En-tête sur ordinateur",
  "Cabeçalho mobile": "En-tête sur mobile",
  "Cache limpo! Recarregando...": "Cache vidé ! Rechargement...",
  "Cada etapa é um vídeo com uma pergunta e até 4 opções. Cada opção leva a outra etapa ou a uma saída, como o checkout ou o WhatsApp. Você escolhe quando as opções aparecem e se o vídeo pausa até o visitante responder.": "Chaque étape est une vidéo avec une question et jusqu'à 4 options. Chaque option mène à une autre étape ou à une sortie, comme le paiement ou WhatsApp. Choisissez quand les options apparaissent et si la vidéo reste en pause jusqu'à la réponse du visiteur.",
  "Cada linha mostra a % de pessoas que continuam assistindo ao longo do tempo.": "Chaque ligne montre le pourcentage de personnes qui continuent à regarder au fil du temps.",
  "Cada linha representa um tipo de introdução testada.": "Chaque ligne représente un type d'introduction testé.",
  "Cada opção pode levar a outro vídeo ou a uma saída, como uma oferta, um checkout ou o WhatsApp.": "Chaque option peut mener à une autre vidéo ou à une sortie, comme une offre, un paiement ou WhatsApp.",
  "Cada visitante vê um começo diferente e, ao final, a VSL principal continua automaticamente, como se fosse um único vídeo.": "Chaque visiteur voit un début différent, puis la VSL principale se poursuit automatiquement, comme s'il s'agissait d'une seule vidéo.",
  "Cadastrar": "Enregistrer",
  "Cadastre este webhook na plataforma, para as compras deste checkout:": "Enregistrez ce webhook sur la plateforme pour les achats de ce paiement :",
  "Cadastre quantas pessoas precisar, cada uma com o próprio e-mail e a própria senha": "Ajoutez autant de personnes que nécessaire, chacune avec son propre e-mail et son propre mot de passe",
  "Cadastre um cartão antes de comprar": "Enregistrez une carte avant d'acheter",
  "Cadastre-se": "S'inscrire",
  "Cadastro": "Inscription",
  "Cakto": "Cakto",
  "Calendário de Disponibilidade": "Calendrier des disponibilités",
  "Campanha (Campaign)": "Campagne (Campaign)",
  "Campeão da Semana": "Champion de la semaine",
  "Campo Extra": "Champ supplémentaire",
  "Campo de Senha": "Champ de mot de passe",
  "Campo de cupom": "Champ de code promo",
  "Campo desconhecido: {value0}": "Champ inconnu : {value0}",
  "Campo não usado neste template": "Champ non utilisé dans ce modèle",
  "Campo obrigatório": "Champ obligatoire",
  "Campo obrigatório para proteção por senha": "Champ obligatoire pour la protection par mot de passe",
  "Campos": "Champs",
  "Campos Preenchidos": "Champs remplis",
  "Campos Selecionados": "Champs sélectionnés",
  "Campos ativos:": "Champs actifs :",
  "Campos de Entrada": "Champs de saisie",
  "Campos do Formulário": "Champs du formulaire",
  "Campos inválidos": "Champs invalides",
  "Campos obrigatórios": "Champs obligatoires",
  "Campos para Captura": "Champs à recueillir",
  "Campos um abaixo do outro, com o botão em largura total": "Champs les uns sous les autres, avec le bouton sur toute la largeur",
  "Cancelado": "Annulé",
  "Cancelamento confirmado": "Résiliation confirmée",
  "Cancelando...": "Annulation...",
  "Cancelar": "Annuler",
  "Cancelar Agendamento": "Annuler la programmation",
  "Cancelar Assinatura": "Résilier l'abonnement",
  "Cancelar edição": "Annuler la modification",
  "Cancelar envio": "Annuler l'envoi",
  "Cancelar o envio de": "Annuler l'envoi de",
  "Cancelar uploads": "Annuler les envois",
  "Cantos Arredondados": "Coins arrondis",
  "Capa Principal (Hero)": "Couverture principale (Hero)",
  "Capacidade e Acesso": "Capacité et accès",
  "Capacidade por slot (opcional)": "Capacité par créneau (facultative)",
  "Caps Lock está ativado": "Le verrouillage des majuscules est activé",
  "Captura com E-mail": "Capture par e-mail",
  "Captura com Senha": "Capture par mot de passe",
  "Captura de Dados": "Collecte de données",
  "Captura de Leads": "Capture de leads",
  "Captura de leads": "Capture de leads",
  "Captura desativada": "Capture désactivée",
  "Capturar E-mail": "Recueillir l'e-mail",
  "Capturar Nome": "Recueillir le nom",
  "Capturar WhatsApp": "Recueillir le WhatsApp",
  "Capturas nos Últimos 7 Dias": "Captures des 7 derniers jours",
  "Card com a sua cara: título, descrição, cores, tamanho, arredondamento e animação de entrada": "Une carte à votre image : titre, description, couleurs, taille, arrondi et animation d'entrée",
  "Card de CTA clicável estilo YouTube: título, descrição, botão e link pra sua oferta": "Carte CTA cliquable de style YouTube : titre, description, bouton et lien vers votre offre",
  "Card de métricas unificado": "Carte d'indicateurs unifiée",
  "Card de parceiro premium": "Carte de partenaire premium",
  "Card de playlist": "Carte de playlist",
  "Card de teste na lista": "Carte de test dans la liste",
  "Card de vídeo": "Carte vidéo",
  "Card sortável com slider": "Carte réorganisable avec curseur",
  "Cards de métricas": "Cartes d'indicateurs",
  "Cards de regras com footer mostrando data de criação, toggle de ativação, modais de seleção de vídeo premium.": "Cartes de règles avec pied de page indiquant la date de création, l'interrupteur d'activation et des fenêtres de sélection vidéo premium.",
  "Carregado": "Chargé",
  "Carregamento mais rápido no início do vídeo": "Chargement plus rapide au début de la vidéo",
  "Carregando análise de custos...": "Chargement de l'analyse des coûts...",
  "Carregando custos...": "Chargement des coûts...",
  "Carregando dados da estratégia...": "Chargement des données de la stratégie...",
  "Carregando dados de retenção...": "Chargement des données de rétention...",
  "Carregando dados do pagamento...": "Chargement des données du paiement...",
  "Carregando dados...": "Chargement des données...",
  "Carregando detalhes do compartilhamento…": "Chargement des détails du partage…",
  "Carregando detalhes...": "Chargement des détails...",
  "Carregando estratégias...": "Chargement des stratégies...",
  "Carregando integrações...": "Chargement des intégrations...",
  "Carregando logs...": "Chargement des journaux...",
  "Carregando mais vídeos...": "Chargement de vidéos supplémentaires...",
  "Carregando membros...": "Chargement des membres...",
  "Carregando métricas...": "Chargement des indicateurs...",
  "Carregando o fluxo": "Chargement du parcours",
  "Carregando o mapa…": "Chargement de la carte…",
  "Carregando pastas...": "Chargement des dossiers...",
  "Carregando plataformas": "Chargement des plateformes",
  "Carregando plataformas...": "Chargement des plateformes...",
  "Carregando proteções...": "Chargement des protections...",
  "Carregando rastreamentos...": "Chargement des suivis...",
  "Carregando recursos...": "Chargement des fonctionnalités...",
  "Carregando registros da rede...": "Chargement des journaux réseau...",
  "Carregando registros...": "Chargement des enregistrements...",
  "Carregando solicitações...": "Chargement des demandes...",
  "Carregando vídeo...": "Chargement de la vidéo...",
  "Carregando vídeos...": "Chargement des vidéos...",
  "Carregando vídeos…": "Chargement des vidéos…",
  "Carregando...": "Chargement...",
  "Carregar bloco": "Charger le bloc",
  "Carregar do celular": "Importer depuis le téléphone",
  "Carregar um novo vídeo": "Importer une nouvelle vidéo",
  "Carregaram o fluxo": "Ont chargé le parcours",
  "CartPanda": "CartPanda",
  "Cartão": "Carte",
  "Cartão adicionado com sucesso!": "Carte ajoutée avec succès !",
  "Cartão adicionado, mas não foi possível defini-lo como padrão.": "Carte ajoutée, mais impossible de la définir par défaut.",
  "Cartão atualizado com sucesso!": "Carte mise à jour avec succès !",
  "Cartão expirado": "Carte expirée",
  "Cartão padrão atualizado!": "Carte par défaut mise à jour !",
  "Cartão removido com sucesso!": "Carte supprimée avec succès !",
  "Cartão selecionado!": "Carte sélectionnée !",
  "Catálogo moderno com fundo escuro e carrossel horizontal. Ideal para playlists longas.": "Catalogue moderne avec fond sombre et carrousel horizontal. Idéal pour les longues playlists.",
  "Celular": "Téléphone portable",
  "Central": "Central",
  "Central de Ajuda": "Centre d'aide",
  "Central de ajuda": "Centre d'aide",
  "Centralizado": "Centré",
  "Centralizar": "Centrer",
  "Centro": "Centre",
  "Centro Direita": "Au centre à droite",
  "Centro Direito": "Au centre à droite",
  "Centro Esquerda": "Au centre à gauche",
  "Centro Esquerdo": "Au centre à gauche",
  "Certifique-se de que seu vídeo carrega rapidamente em todos os dispositivos e conexões.": "Assurez-vous que votre vidéo se charge rapidement sur tous les appareils et toutes les connexions.",
  "Chama atenção sem poluir": "Attire l'attention sans surcharger",
  "Chamada Principal (CTA)": "Appel à l'action principal (CTA)",
  "Chamada da oferta": "Accroche de l'offre",
  "Chamada de oferta com botão e link de saída.": "Présentation de l'offre avec bouton et lien de sortie.",
  "Chamar no chat": "Contacter par chat",
  "Chat": "Chat",
  "Chat com Suporte": "Chat avec le support",
  "Chat com suporte": "Chat avec le support",
  "Chave": "Clé",
  "Chave / Identificador": "Clé / Identifiant",
  "Chave PIX": "Clé PIX",
  "Chave PIX (CPF, E-mail, Celular ou Aleatória)": "Clé PIX (CPF, e-mail, téléphone ou clé aléatoire)",
  "Chave PIX cadastrada": "Clé PIX enregistrée",
  "Chave copiada": "Clé copiée",
  "Chave criada": "Clé créée",
  "Chave de integração Payt (integration_key)": "Clé d'intégration Payt (integration_key)",
  "Chave revogada": "Clé révoquée",
  "Chaves de API": "Clés API",
  "Checkout": "Paiement",
  "Checkout de alta conversão para negócios digitais.": "Page de paiement à fort taux de conversion pour les activités numériques.",
  "Checkout do plano": "Paiement du forfait",
  "Checkout ÷ plays. Não confirma a compra.": "Paiements ÷ lectures. Ne confirme pas l'achat.",
  "Chegaram ao principal": "Ont atteint la vidéo principale",
  "Chegou a Audiência em Tempo Real: um mapa-múndi que mostra, ao vivo, quem está assistindo às suas VSLs neste exato momento e de onde no mundo. Acompanhe quantas pessoas estão na sua oferta agora, quais vídeos estão bombando e de quais fontes de tráfego elas vieram — tudo atualizando sozinho.": "Découvrez l'audience en temps réel : une carte du monde qui affiche en direct les personnes regardant vos VSL en ce moment et leur localisation. Suivez le nombre de personnes consultant votre offre, les vidéos les plus populaires et leurs sources de trafic, avec une mise à jour automatique.",
  "Chegou a Contagem Final Inteligente: assim que o vídeo acaba, um card com contagem regressiva aparece e leva o espectador ao próximo passo, sem aquele silêncio depois do último argumento. Você define o tempo da contagem, escreve o título e a descrição do card e decide o desfecho — redirecionar automaticamente para o seu link ou apenas exibir o aviso, deixando a pessoa fechar e voltar ao vídeo. O card ainda combina com a sua marca: cores, tamanho, arredondamento e animação de entrada são todos ajustáveis.": "Découvrez le compte à rebours final intelligent : dès la fin de la vidéo, une carte avec un compte à rebours apparaît pour guider le spectateur vers l'étape suivante, sans silence après le dernier argument. Définissez la durée, le titre et la description de la carte, puis choisissez la suite : redirection automatique vers votre lien ou simple notification permettant de fermer la carte et de revenir à la vidéo. La carte s'adapte à votre marque : couleurs, taille, arrondi et animation d'entrée sont réglables.",
  "Chegou a Jornada de Conversão: agora você encaixa um vídeo de entrada antes da sua VSL principal e, se quiser, um vídeo de saída logo depois — tudo no estilo anúncio do YouTube. Use a entrada pra criar contexto, qualificar ou aquecer o lead antes do conteúdo principal, e a saída pra reforçar a oferta e chamar pra ação assim que o vídeo termina. Os vídeos saem da sua própria biblioteca, com botão de pular, card de CTA clicável e métricas de cada etapa.": "Découvrez le parcours de conversion : insérez désormais une vidéo d'entrée avant votre VSL principale et, si vous le souhaitez, une vidéo de sortie juste après, comme une publicité YouTube. Utilisez l'entrée pour créer du contexte, qualifier ou préparer le lead, et la sortie pour renforcer l'offre et inciter à l'action à la fin de la vidéo. Les vidéos proviennent de votre bibliothèque, avec un bouton Passer, une carte CTA cliquable et des indicateurs pour chaque étape.",
  "Chegou a integração com o TikTok Ads. Cadastre o ID do pixel e o token de acesso do seu Events Manager e a HostVSL passa a enviar ao TikTok os eventos de quem assiste às suas VSLs: visualização da página, play, retenção e tempo assistido. O envio é feito direto do nosso servidor pela API de eventos do TikTok, então você não precisa colar nenhum código extra na sua página e o seu token fica guardado com segurança.": "Découvrez l'intégration TikTok Ads. Enregistrez l'identifiant du pixel et le jeton d'accès de votre Events Manager : HostVSL enverra à TikTok les événements des spectateurs de vos VSL, notamment les pages vues, les lectures, la rétention et la durée regardée. L'envoi s'effectue directement depuis notre serveur via l'API d'événements TikTok : aucun code supplémentaire à coller sur votre page et votre jeton reste stocké en toute sécurité.",
  "Chegou no Pitch": "A atteint l'argumentaire de vente",
  "Chegou o Storyboard, um novo recurso dos controles do player. Ao passar o mouse pela barra de progresso, o espectador vê uma miniatura do frame correspondente àquele instante do vídeo. Ajuda a encontrar rapidamente um trecho específico ou voltar pra um ponto de interesse.": "Découvrez Storyboard, une nouvelle fonctionnalité des commandes du lecteur. En survolant la barre de progression, le spectateur voit une miniature de l'image correspondant à cet instant de la vidéo. Cela permet de trouver rapidement un passage précis ou de revenir à un point d'intérêt.",
  "Chegou o recurso Picos de Horário. Agora você identifica com clareza quando seu público mais assiste, em quais dias e em quais faixas de horário.": "Découvrez les pics horaires. Identifiez clairement les jours et les plages horaires où votre audience regarde le plus vos vidéos.",
  "Chegou o recurso Picos de Horário. Agora você identifica com clareza quando seu público mais assiste, em quais dias e em quais faixas de horário. Isso permite publicar com mais precisão, otimizar suas campanhas e aumentar o desempenho do vídeo com base em dados reais.": "Découvrez les pics horaires. Identifiez clairement les jours et les plages horaires où votre audience regarde le plus vos vidéos. Publiez ainsi avec plus de précision, optimisez vos campagnes et améliorez les performances des vidéos grâce à des données réelles.",
  "Chrome": "Chrome",
  "Cidade": "Ville",
  "Cidade/UF": "Ville/État",
  "Cidades": "Villes",
  "Cinco etapas do funil: Carregamentos, Visualizações Únicas, Plays Únicos, Cliques no Botão e Conversões": "Cinq étapes du tunnel : chargements, vues uniques, lectures uniques, clics sur le bouton et conversions",
  "Cinza claro": "Gris clair",
  "Circular": "Circulaire",
  "Clarear 5%": "Éclaircir de 5%",
  "Claro premium": "Clair premium",
  "Claude no notebook": "Claude sur ordinateur portable",
  "Clean 2.0 — Template Horizontal": "Clean 2.0 — Modèle horizontal",
  "Clean:": "Épuré :",
  "Clicar para iniciar": "Cliquer pour démarrer",
  "Clicaram em pular": "Ont cliqué sur Passer",
  "Clicaram no botão": "Ont cliqué sur le bouton",
  "Clicaram para assistir": "Ont cliqué pour regarder",
  "Click": "Clic",
  "Click Here": "Cliquez ici",
  "Click Rate": "Taux de clics",
  "Click to activate sound": "Cliquez pour activer le son",
  "Clicks": "Clics",
  "Clicks Configurados:": "Clics configurés :",
  "Clicks Restantes:": "Clics restants :",
  "Clicks a Incrementar": "Clics à ajouter",
  "Clicks atualizados com sucesso!": "Clics mis à jour avec succès !",
  "Clicou na Oferta": "A cliqué sur l'offre",
  "Cliente Stripe não encontrado": "Client Stripe introuvable",
  "Cliente assinou um plano de R$ 100/mês": "Le client a souscrit un forfait de R$ 100/mois",
  "Clientes Ativos": "Clients actifs",
  "Clientes que assinaram através do seu link.": "Clients ayant souscrit via votre lien.",
  "Clique Aqui": "Cliquez ici",
  "Clique Automático": "Clic automatique",
  "Clique aqui e ative agora!": "Cliquez ici et activez maintenant !",
  "Clique do usuário abrirá:": "Le clic de l'utilisateur ouvrira :",
  "Clique em \"Buscar por E-mail\" para localizar um registro existente, ou \"Novo Registro\" para criar um novo incremento.": "Cliquez sur « Rechercher par e-mail » pour trouver un enregistrement existant, ou sur « Nouvel enregistrement » pour créer un nouvel ajout.",
  "Clique em \"Usar Esta Thumbnail\" para aplicar.": "Cliquez sur « Utiliser cette miniature » pour l'appliquer.",
  "Clique no botão \"Buscar Usuário\" localizado no topo para pesquisar e gerenciar uma conta por e-mail.": "Cliquez sur le bouton « Rechercher un utilisateur » en haut pour rechercher et gérer un compte par e-mail.",
  "Clique no botão abaixo para visualizar o modal premium de incorporação de vídeo HostVSL.": "Cliquez sur le bouton ci-dessous pour afficher la fenêtre premium d'intégration vidéo HostVSL.",
  "Clique no botão acima para instalar o app no seu dispositivo": "Cliquez sur le bouton ci-dessus pour installer l'application sur votre appareil",
  "Clique no botão azul para abrir o upload e enviar seu primeiro vídeo.": "Cliquez sur le bouton bleu pour ouvrir l'envoi et envoyer votre première vidéo.",
  "Clique ou arraste o arquivo .VTT ou .SRT": "Cliquez ou déposez le fichier .VTT ou .SRT",
  "Clique ou arraste o arquivo aqui": "Cliquez ou déposez le fichier ici",
  "Clique para Editar": "Cliquez pour modifier",
  "Clique para ajustar o pitch": "Cliquez pour ajuster l'argumentaire de vente",
  "Clique para alterar": "Cliquez pour changer",
  "Clique para editar tempo": "Cliquez pour modifier le temps",
  "Clique para escolher. Máximo: 5MB": "Cliquez pour choisir. Maximum : 5 Mo",
  "Clique para fazer upload": "Cliquez pour importer",
  "Clique para fazer upload (1920×700px)": "Cliquez pour importer (1920×700px)",
  "Clique para ouvir": "Cliquez pour écouter",
  "Clique para selecionar .SRT ou .VTT": "Cliquez pour sélectionner un fichier .SRT ou .VTT",
  "Clique para trocar": "Cliquez pour remplacer",
  "Clique para ver os uploads": "Cliquez pour voir les envois",
  "Cliques": "Clics",
  "Cliques CTA": "Clics CTA",
  "Cliques Totais": "Clics totaux",
  "Cliques no Botão": "Clics sur le bouton",
  "Cliques no CTA": "Clics sur le CTA",
  "Cliques no CTA de entrada": "Clics sur le CTA d'entrée",
  "Cliques no CTA final": "Clics sur le CTA final",
  "Cliques sobre exibições": "Clics par rapport aux affichages",
  "Cliques Únicos": "Clics uniques",
  "Cliques:": "Clics :",
  "Cloaker": "Cloaker",
  "Cloaker VSL": "Cloaker VSL",
  "Cloaker de VSL": "Cloaker de VSL",
  "Cloaker de VSL reformulado": "Cloaker de VSL repensé",
  "Cloaker — Sistema de Regras": "Cloaker — Système de règles",
  "Clone páginas existentes em minutos para acelerar testes": "Clonez des pages existantes en quelques minutes pour accélérer les tests",
  "Clone páginas validadas": "Clonez des pages validées",
  "Close": "Fermer",
  "Cloudflare": "Cloudflare",
  "Clássico para satisfação rápida.": "Classique pour évaluer rapidement la satisfaction.",
  "Cobrança automática após 15 dias. Cancele a qualquer momento.": "Facturation automatique après 15 jours. Résiliez à tout moment.",
  "Cole a URL completa, incluindo https://.": "Collez l'URL complète, y compris https://.",
  "Cole a URL de webhook abaixo no painel": "Collez l'URL de webhook ci-dessous dans le panneau",
  "Cole a integration_key configurada na Payt": "Collez l'integration_key configurée dans Payt",
  "Cole aqui o token gerado pela plataforma": "Collez ici le jeton généré par la plateforme",
  "Cole este código onde deseja exibir o vídeo. A proteção será aplicada automaticamente conforme a regra configurada.": "Collez ce code à l'endroit où vous souhaitez afficher la vidéo. La protection sera appliquée automatiquement selon la règle configurée.",
  "Cole na página onde o vídeo deve aparecer. O código não muda quando você publica de novo.": "Collez-le sur la page où la vidéo doit apparaître. Le code ne change pas lorsque vous republiez.",
  "Cole o ID do pixel fornecido pela plataforma de anúncios": "Collez l'identifiant de pixel fourni par la plateforme publicitaire",
  "Cole o código abaixo na tag": "Collez le code ci-dessous dans la balise",
  "Cole o código de acesso aqui": "Collez le code d'accès ici",
  "Cole o código em um bloco HTML da sua página de vendas. Publique a página e pronto: seu vídeo já estará no ar.": "Collez le code dans un bloc HTML de votre page de vente. Publiez la page et votre vidéo sera en ligne.",
  "Cole o código na sua landing page para ativar a proteção.": "Collez le code dans votre page de destination pour activer la protection.",
  "Cole o token do pixel": "Collez le jeton du pixel",
  "Cole seu código HTML aqui...\nAceita HTML, CSS inline e scripts leves.": "Collez votre code HTML ici...\nAccepte le HTML, le CSS inline et les scripts légers.",
  "Cole seu código HTML aqui...&#10;Aceita HTML, CSS inline e scripts leves.": "Collez votre code HTML ici...&#10;Accepte le HTML, le CSS inline et les scripts légers.",
  "Coleta Nome, E-mail, WhatsApp e ativa formulário no player.": "Recueille le nom, l'e-mail, le WhatsApp et active le formulaire dans le lecteur.",
  "Coletando dados em tempo real": "Collecte de données en temps réel",
  "Colete avaliações dos espectadores diretamente no player": "Recueillez les avis des spectateurs directement dans le lecteur",
  "Coloque um vídeo de entrada antes da sua VSL e um de saída depois, no estilo anúncio do YouTube, pra conduzir o espectador até a próxima ação.": "Placez une vidéo d'entrée avant votre VSL et une vidéo de sortie après, comme une publicité YouTube, pour guider le spectateur vers l'action suivante.",
  "Colunas": "Colonnes",
  "Colunas (": "Colonnes (",
  "Colunas visíveis": "Colonnes visibles",
  "Com 100 indicações no plano Premium, você ganha": "Avec 100 parrainages sur le forfait Premium, vous gagnez",
  "Com a AdSniper você espiona em tempo real as ofertas que estão escalando na Meta Ads e descobre rapidamente quais criativos, ângulos e funis estão convertendo. Use o cupom 50%OFF e garanta 50% de desconto em qualquer plano.": "Avec AdSniper, observez en temps réel les offres en pleine croissance sur Meta Ads et découvrez rapidement les créations, les angles et les tunnels qui convertissent. Utilisez le code 50%OFF pour obtenir 50% de réduction sur n'importe quel forfait.",
  "Com as legendas ativadas, você pode adicionar arquivos": "Lorsque les sous-titres sont activés, vous pouvez ajouter des fichiers",
  "Com as legendas ativadas, você pode adicionar arquivos .SRT ou .VTT ao seu vídeo. O espectador poderá ativar ou desativar a legenda pelo botão CC nos controles.": "Lorsque les sous-titres sont activés, vous pouvez ajouter des fichiers .SRT ou .VTT à votre vidéo. Le spectateur pourra activer ou désactiver les sous-titres avec le bouton CC des commandes.",
  "Com base nos dados coletados,": "Selon les données recueillies,",
  "Com base nos dados reais, descubra qual introdução tem melhor performance e finalize o teste.": "À partir des données réelles, identifiez l'introduction la plus performante et terminez le test.",
  "Com base nos dados reais, descubra qual variante tem melhor performance e finalize o teste quando tiver confiança.": "À partir des données réelles, identifiez la variante la plus performante et terminez le test lorsque vous êtes sûr du résultat.",
  "Com o Teste de hook, nossos usuários relatam em média:": "Avec le test d'accroche, nos utilisateurs constatent en moyenne :",
  "Comandos Úteis": "Commandes utiles",
  "Combine com Botão de Ação e Headline para reforçar a oferta": "Combinez avec le bouton d'action et le titre pour renforcer l'offre",
  "Comece a usar direto pelo menu Ferramentas": "Commencez directement depuis le menu Outils",
  "Comece com seu primeiro Mini-Hook": "Commencez avec votre premier Mini-Hook",
  "Comece com um vídeo perguntando “Qual é o seu maior desafio?”. A resposta “Estou começando” leva a uma explicação dos fundamentos; “Já vendo e quero crescer” leva a um vídeo mais avançado. Cada sequência pode terminar em uma oferta específica ou encaminhar a pessoa para conversar no WhatsApp. É o visitante quem escolhe a próxima etapa, sem sair do player entre os vídeos.": "Commencez avec une vidéo demandant « Quel est votre plus grand défi ? ». La réponse « Je débute » mène à une explication des bases ; « Je vends déjà et je veux me développer » mène à une vidéo plus avancée. Chaque séquence peut se terminer par une offre spécifique ou orienter la personne vers WhatsApp. Le visiteur choisit l'étape suivante sans quitter le lecteur entre les vidéos.",
  "Comece com uma pergunta intrigante ou uma afirmação surpreendente que gere interesse imediato.": "Commencez par une question intrigante ou une affirmation surprenante pour susciter un intérêt immédiat.",
  "Comece conectando suas plataformas 🎯": "Commencez par connecter vos plateformes 🎯",
  "Comece criando sua primeira pasta para organizar seus vídeos": "Commencez par créer votre premier dossier pour organiser vos vidéos",
  "Comece dando um nome ao seu teste": "Commencez par donner un nom à votre test",
  "Comece enviando seu primeiro vídeo para acompanhar métricas e performance.": "Commencez par envoyer votre première vidéo pour suivre les indicateurs et les performances.",
  "Comece enviando seu primeiro vídeo.": "Commencez par envoyer votre première vidéo.",
  "Comece fazendo upload do seu primeiro vídeo.": "Commencez par importer votre première vidéo.",
  "Comentários recentes": "Commentaires récents",
  "Começa com": "Commence par",
  "Começa em": "Commence à",
  "Começar pela etapa": "Commencer par l'étape",
  "Comissão": "Commission",
  "Comissão Individual": "Commission individuelle",
  "Comissão Recorrente": "Commission récurrente",
  "Comissão Recorrente Mensal (20%)": "Commission mensuelle récurrente (20%)",
  "Comissão do Seller:": "Commission du vendeur :",
  "Comissão do seller atualizada com sucesso!": "Commission du vendeur mise à jour avec succès !",
  "Comissões Recebidas": "Commissions reçues",
  "Como Funciona": "Comment ça marche",
  "Como Ganhar Com Sua Rede": "Comment gagner grâce à votre réseau",
  "Como Usar Headlines/Subheadlines": "Comment utiliser les titres et sous-titres",
  "Como acompanhar os resultados": "Comment suivre les résultats",
  "Como acompanho meus resultados?": "Comment suivre mes résultats ?",
  "Como ficará no vídeo": "Rendu dans la vidéo",
  "Como funciona a Proteção Anti-Plágio?": "Comment fonctionne la protection anti-plagiat ?",
  "Como funciona a VSL Dinâmica": "Comment fonctionne la VSL dynamique",
  "Como funciona a comparação de VSLs": "Comment fonctionne la comparaison de VSL",
  "Como funciona o Teste de hook": "Comment fonctionne le test d'accroche",
  "Como funciona o pagamento da comissão?": "Comment fonctionne le versement des commissions ?",
  "Como funciona o programa?": "Comment fonctionne le programme ?",
  "Como funciona o recurso de legendas": "Comment fonctionne la fonctionnalité de sous-titrage",
  "Como funciona o teste de velocidade?": "Comment fonctionne le test de vitesse ?",
  "Como funciona o teste?": "Comment fonctionne le test ?",
  "Como funciona os plays extras": "Comment fonctionnent les lectures supplémentaires",
  "Como funciona?": "Comment ça marche ?",
  "Como funcionam os testes A/B": "Comment fonctionnent les tests A/B",
  "Como funcionam os testes de introduções": "Comment fonctionnent les tests d'introductions",
  "Como interpretar o gráfico de retenção": "Comment lire le graphique de rétention",
  "Como interpretar os testes de velocidade": "Comment interpréter les tests de vitesse",
  "Como interpretar?": "Comment interpréter les résultats ?",
  "Como montar seu fluxo": "Comment construire votre parcours",
  "Como o vídeo começa": "Démarrage de la vidéo",
  "Como o vídeo deve se comportar quando o formulário aparece": "Comportement de la vidéo à l'apparition du formulaire",
  "Como podemos te ajudar?": "Comment pouvons-nous vous aider ?",
  "Como seu público está acessando": "Comment votre audience accède au contenu",
  "Como seu público interagiu": "Comment votre audience a interagi",
  "Como subir seu primeiro vídeo": "Comment importer votre première vidéo",
  "Como usar": "Comment utiliser",
  "Como usar:": "Comment utiliser :",
  "Como você avalia este conteúdo?": "Comment évaluez-vous ce contenu ?",
  "Como você deseja continuar?": "Comment souhaitez-vous continuer ?",
  "Como você deseja proteger seus vídeos?": "Comment souhaitez-vous protéger vos vidéos ?",
  "Comp. Média da Conta": "Compar. moyenne du compte",
  "Comp. Vídeo Anterior": "Compar. vidéo précédente",
  "Compacto": "Compact",
  "Comparado aos 30d anteriores": "Par rapport aux 30 jours précédents",
  "Comparar VSL": "Comparer des VSL",
  "Comparar agora": "Comparer maintenant",
  "Comparativo das Introduções": "Comparaison des introductions",
  "Comparativo de Performance": "Comparaison des performances",
  "Comparativo dos Vídeos": "Comparaison des vidéos",
  "Comparativo por Variação": "Comparaison par variante",
  "Comparativo por Velocidade": "Comparaison par vitesse",
  "Comparação Visual": "Comparaison visuelle",
  "Comparação da retenção de audiência entre diferentes introduções": "Comparaison de la rétention d'audience entre différentes introductions",
  "Comparação da retenção de audiência entre diferentes vídeos": "Comparaison de la rétention d'audience entre différentes vidéos",
  "Comparação de Plataformas": "Comparaison des plateformes",
  "Comparação dos melhores horários por device": "Comparaison des meilleurs horaires par appareil",
  "Compare VSLs, distribua o tráfego automaticamente e otimize sua conversão com dados reais": "Comparez des VSL, répartissez automatiquement le trafic et optimisez les conversions grâce à des données réelles",
  "Compare como cada variação influencia a permanência da audiência ao longo do vídeo.": "Comparez l'influence de chaque variante sur la durée de visionnage de l'audience au fil de la vidéo.",
  "Compare como cada velocidade influencia a permanência da audiência ao longo do vídeo.": "Comparez l'influence de chaque vitesse sur la durée de visionnage de l'audience au fil de la vidéo.",
  "Compare diferentes aberturas do seu vídeo e descubra qual gera mais engajamento.": "Comparez différentes ouvertures de votre vidéo et découvrez celle qui génère le plus d'engagement.",
  "Compare diferentes variações do seu vídeo e descubra qual converte melhor.": "Comparez différentes variantes de votre vidéo et découvrez celle qui convertit le mieux.",
  "Compare horários recomendados com ranking de melhores faixas": "Comparez les horaires recommandés avec le classement des meilleures plages",
  "Compare horários recomendados com ranking de melhores faixas para repetir o que já funciona": "Comparez les horaires recommandés avec le classement des meilleures plages pour reproduire ce qui fonctionne déjà",
  "Compare introduções, distribua o tráfego automaticamente e otimize sua conversão com dados reais": "Comparez des introductions, répartissez automatiquement le trafic et optimisez les conversions grâce à des données réelles",
  "Compare métricas de retenção nos primeiros 30 segundos": "Comparez les indicateurs de rétention des 30 premières secondes",
  "Compare métricas por período": "Comparez les indicateurs par période",
  "Compare no mínimo 3 velocidades diferentes para melhores resultados": "Comparez au moins 3 vitesses différentes pour obtenir de meilleurs résultats",
  "Compare o desempenho das introduções ao longo do vídeo principal.": "Comparez les performances des introductions au fil de la vidéo principale.",
  "Compare plataformas": "Comparez les plateformes",
  "Compare plays, impressões e usuários únicos por fonte de tráfego.": "Comparez les lectures, les impressions et les utilisateurs uniques par source de trafic.",
  "Compare resultados baseados na origem do tráfego (Facebook vs Instagram vs Email).": "Comparez les résultats selon la source du trafic (Facebook vs Instagram vs Email).",
  "Compare suas VSLs lado a lado e descubra qual performa melhor": "Comparez vos VSL côte à côte et découvrez la plus performante",
  "Compare versões e descubra o que mais converte.": "Comparez des versions et découvrez ce qui convertit le mieux.",
  "Compartilhado por": "Partagé par",
  "Compartilhamento de Vídeos com Equipe e Afiliados": "Partage de vidéos avec l'équipe et les affiliés",
  "Compartilhamento desativado": "Partage désactivé",
  "Compartilhamento excluído com sucesso!": "Partage supprimé avec succès !",
  "Compartilhamento não encontrado": "Partage introuvable",
  "Compartilhando vídeo": "Partage de la vidéo",
  "Compartilhar": "Partager",
  "Compartilhar Vídeo com Afiliados": "Partager la vidéo avec des affiliés",
  "Compartilhe o vídeo para começar a coletar avaliações dos espectadores.": "Partagez la vidéo pour commencer à recueillir les avis des spectateurs.",
  "Compartilhe seu link": "Partagez votre lien",
  "Compartilhe vídeos com afiliados por link e acompanhe tudo.": "Partagez des vidéos avec des affiliés par lien et suivez toute l'activité.",
  "Compartilhe vídeos com link seguro": "Partagez des vidéos avec un lien sécurisé",
  "Compartilhe vídeos com seus afiliados para que eles possam divulgar suas ofertas. Acesse seus vídeos e clique em \"Compartilhar\" para começar.": "Partagez des vidéos avec vos affiliés pour qu'ils puissent promouvoir vos offres. Ouvrez vos vidéos et cliquez sur « Partager » pour commencer.",
  "Compatibilidade": "Compatibilité",
  "Complete esta etapa para continuar": "Terminez cette étape pour continuer",
  "Completude dos dados": "Complétude des données",
  "Completude:": "Complétude :",
  "Component Stack:": "Pile des composants :",
  "Componente": "Composant",
  "Componentes Principais": "Composants principaux",
  "Componentes e modais com padrão unificado": "Composants et fenêtres avec un style unifié",
  "Componentes e modais com padrão unificado do novo front": "Composants et fenêtres avec le style unifié de la nouvelle interface",
  "Components": "Composants",
  "Comportamento": "Comportement",
  "Comportamento de Envio": "Comportement lors de l'envoi",
  "Comportamento de Loop": "Comportement de la boucle",
  "Comportamento de visualização dos leads": "Comportement de visionnage des leads",
  "Comportamento do Modal": "Comportement de la fenêtre",
  "Comportamento do Player": "Comportement du lecteur",
  "Comportamento do Vídeo": "Comportement de la vidéo",
  "Comportamento do Vídeo de Fundo": "Comportement de la vidéo d'arrière-plan",
  "Comprados separadamente": "Achetés séparément",
  "Comprar": "Acheter",
  "Comprar agora": "Acheter maintenant",
  "Compras aprovadas na integração do fluxo": "Achats approuvés dans l'intégration du parcours",
  "Compre plays extras para continuar exibindo seus vídeos": "Achetez des lectures supplémentaires pour continuer à diffuser vos vidéos",
  "Comprovante": "Justificatif",
  "Comprovante ampliado": "Justificatif agrandi",
  "Comprovante atual": "Justificatif actuel",
  "Comprovante de Pagamento": "Justificatif de paiement",
  "Comprovante de Transferência": "Justificatif de virement",
  "Comprovante de pagamento": "Justificatif de paiement",
  "Compute": "Calcul",
  "Concluir": "Terminer",
  "Conclusão da entrada": "Fin de la vidéo d'entrée",
  "Conclusão da saída": "Fin de la vidéo de sortie",
  "Concluído": "Terminé",
  "Concluídos": "Terminés",
  "Condição": "Condition",
  "Condição liberada apenas nesta janela.": "Condition disponible uniquement dans cette fenêtre.",
  "Condição secundária": "Condition secondaire",
  "Conectado": "Connecté",
  "Conectado como": "Connecté en tant que",
  "Conectando...": "Connexion...",
  "Conectar": "Connecter",
  "Conectar Google Drive": "Connecter Google Drive",
  "Conectar Novo Pixel": "Connecter un nouveau pixel",
  "Conectar Plataforma": "Connecter une plateforme",
  "Conectar Rastreamento": "Connecter le suivi",
  "Conectar rastreamento": "Connecter le suivi",
  "Conecte com chat e notificações de vendas": "Connectez le chat et les notifications de vente",
  "Conecte ferramentas de automação, analytics, CRM e muito mais.": "Connectez des outils d'automatisation, d'analyse, de CRM et bien plus encore.",
  "Conecte o Google Ads às suas VSLs e envie as conversões de play, oferta e checkout para as suas campanhas.": "Connectez Google Ads à vos VSL et envoyez les conversions de lecture, d'offre et de paiement à vos campagnes.",
  "Conecte pixels do Meta, Google e TikTok para rastrear conversões.": "Connectez les pixels Meta, Google et TikTok pour suivre les conversions.",
  "Conecte seu Tracking para ver receita": "Connectez votre suivi pour voir le chiffre d'affaires",
  "Conecte seu rastreamento para ver o vídeo campeão.": "Connectez votre suivi pour voir la vidéo gagnante.",
  "Conecte sua conta Google": "Connectez votre compte Google",
  "Conecte sua conta Google com permissão somente de leitura — não tocamos em nada do seu Drive": "Connectez votre compte Google avec un accès en lecture seule : nous ne modifions rien dans votre Drive",
  "Conecte sua plataforma para acompanhar vendas e receita. Acesso ao checkout não confirma compra.": "Connectez votre plateforme pour suivre les ventes et le chiffre d'affaires. Un accès à la page de paiement ne confirme pas un achat.",
  "Conecte sua primeira plataforma de pagamentos": "Connectez votre première plateforme de paiement",
  "Conecte uma plataforma de conversão para ver vendas e receita por intro nas métricas do teste.": "Connectez une plateforme de conversion pour voir les ventes et le chiffre d'affaires par intro dans les indicateurs du test.",
  "Conecte uma plataforma em Rastreamento para começar a acumular faturamento.": "Connectez une plateforme dans Suivi pour commencer à comptabiliser le chiffre d'affaires.",
  "Conecte-se com o público através de histórias pessoais ou casos reais que despertem emoção.": "Créez un lien avec le public grâce à des histoires personnelles ou des cas réels qui suscitent de l'émotion.",
  "Config. Player": "Config. lecteur",
  "Configurar": "Configurer",
  "Configurar Distribuição": "Configurer la répartition",
  "Configurar Feedback do Vídeo": "Configurer les avis sur la vidéo",
  "Configurar Funil": "Configurer le tunnel",
  "Configurar Integração": "Configurer l'intégration",
  "Configurar Pitch de Vendas": "Configurer l'argumentaire de vente",
  "Configurar Pixel": "Configurer le pixel",
  "Configurar Pixels": "Configurer les pixels",
  "Configurar Rastreamento": "Configurer le suivi",
  "Configurar Recurso": "Configurer la fonctionnalité",
  "Configurar Tracking": "Configurer le suivi",
  "Configurar integração com": "Configurer l'intégration avec",
  "Configurar integração com Facebook": "Configurer l'intégration avec Facebook",
  "Configuração": "Configuration",
  "Configuração Manual": "Configuration manuelle",
  "Configuração Personalizada": "Configuration personnalisée",
  "Configuração aplicada com sucesso": "Configuration appliquée avec succès",
  "Configuração da thumbnail do vídeo": "Configuration de la miniature vidéo",
  "Configuração de Pixel": "Configuration du pixel",
  "Configuração de Velocidade Manual": "Configuration manuelle de la vitesse",
  "Configuração do Botão": "Configuration du bouton",
  "Configuração dos vídeos": "Configuration des vidéos",
  "Configuração guiada passo a passo": "Configuration guidée étape par étape",
  "Configuração incompleta": "Configuration incomplète",
  "Configuração não encontrada": "Configuration introuvable",
  "Configuração salva com sucesso.": "Configuration enregistrée avec succès.",
  "Configuração salva!": "Configuration enregistrée !",
  "Configurações": "Paramètres",
  "Configurações Avançadas": "Paramètres avancés",
  "Configurações Prime Video Dark": "Paramètres Prime Video Dark",
  "Configurações Técnicas": "Paramètres techniques",
  "Configurações aplicadas em {value0} vídeo(s)": "Paramètres appliqués à {value0} vidéo(s)",
  "Configurações da Borda": "Paramètres de bordure",
  "Configurações da barra de progresso": "Paramètres de la barre de progression",
  "Configurações da legenda": "Paramètres des sous-titres",
  "Configurações da logo atualizadas": "Paramètres du logo mis à jour",
  "Configurações da thumbnail salvas": "Paramètres de miniature enregistrés",
  "Configurações das Seções": "Paramètres des sections",
  "Configurações de Captura de Dados": "Paramètres de collecte des données",
  "Configurações de Idioma": "Paramètres de langue",
  "Configurações de Notificações": "Paramètres des notifications",
  "Configurações de Recebimento": "Paramètres de réception des paiements",
  "Configurações de Sombra": "Paramètres d'ombre",
  "Configurações de Temporizador": "Paramètres du minuteur",
  "Configurações de controle do player": "Paramètres des commandes du lecteur",
  "Configurações importadas!": "Paramètres importés !",
  "Configurações prontas. Clique em \"Aplicar\" para iniciar o teste.": "Paramètres prêts. Cliquez sur « Appliquer » pour lancer le test.",
  "Configurações resetadas": "Paramètres réinitialisés",
  "Configurações salvas!": "Paramètres enregistrés !",
  "Configurações técnicas e avançadas do player de vídeo.": "Paramètres techniques et avancés du lecteur vidéo.",
  "Configure CTAs no momento certo do vídeo.": "Configurez les CTA au bon moment dans la vidéo.",
  "Configure a distribuição de tráfego para continuar": "Configurez la répartition du trafic pour continuer",
  "Configure a página de inscrição do seu webinário. As alterações aparecem na prévia em tempo real.": "Configurez la page d'inscription de votre webinaire. Les modifications apparaissent en temps réel dans l'aperçu.",
  "Configure as informações essenciais do seu webinário.": "Configurez les informations essentielles de votre webinaire.",
  "Configure as informações principais do seu webinário": "Configurez les informations principales de votre webinaire",
  "Configure bordas personalizadas no player.": "Configurez des bordures personnalisées sur le lecteur.",
  "Configure campos, estilo e comportamento da captura de leads": "Configurez les champs, le style et le comportement de la capture de leads",
  "Configure como o autoplay se comporta": "Configurez le comportement de l'Autoplay",
  "Configure como o modal se comporta": "Configurez le comportement de la fenêtre",
  "Configure comportamentos específicos do player dependendo do dispositivo do espectador. Ofereça a melhor experiência em desktop, tablet e mobile de forma automática.": "Configurez des comportements spécifiques du lecteur selon l'appareil du spectateur. Offrez automatiquement une expérience optimale sur ordinateur, tablette et mobile.",
  "Configure domínios personalizados para seus vídeos.": "Configurez des domaines personnalisés pour vos vidéos.",
  "Configure e ative o teste para coletar dados": "Configurez et activez le test pour recueillir des données",
  "Configure formulários de captura integrados ao seu vídeo.": "Configurez des formulaires de capture intégrés à votre vidéo.",
  "Configure integrações para enviar seus leads capturados": "Configurez les intégrations pour envoyer les leads recueillis",
  "Configure limites e regras de entrada": "Configurez les limites et les règles d'accès",
  "Configure manualmente ou execute testes A/B automáticos para otimizar o engajamento.": "Configurez manuellement ou lancez des tests A/B automatiques pour optimiser l'engagement.",
  "Configure no menu Pixel, na aba Configurações, no card \"Google Ads\"": "Configurez dans le menu Pixel, onglet Paramètres, carte « Google Ads »",
  "Configure no menu Pixel, na aba Configurações, no card \"TikTok\"": "Configurez dans le menu Pixel, onglet Paramètres, carte « TikTok »",
  "Configure o agendamento para ver a prévia": "Configurez la programmation pour voir l'aperçu",
  "Configure o botão de ação dos seus vídeos": "Configurez le bouton d'action de vos vidéos",
  "Configure o botão de ação se desejar": "Configurez le bouton d'action si vous le souhaitez",
  "Configure o botão de inscrição": "Configurez le bouton d'inscription",
  "Configure o botão e visualize no preview": "Configurez le bouton et vérifiez l'aperçu",
  "Configure o call-to-action principal": "Configurez l'appel à l'action principal",
  "Configure o comportamento de reprodução do vídeo.": "Configurez le comportement de lecture de la vidéo.",
  "Configure o formulário para ver a prévia": "Configurez le formulaire pour voir l'aperçu",
  "Configure o rastreamento de conversões para ver suas vendas aqui.": "Configurez le suivi des conversions pour voir vos ventes ici.",
  "Configure o termo de consentimento": "Configurez le texte de consentement",
  "Configure o tracking de conversões para acompanhar receita, conversões e performance dos seus vídeos.": "Configurez le suivi des conversions pour suivre le chiffre d'affaires, les conversions et les performances de vos vidéos.",
  "Configure o vídeo para retornar automaticamente ao início quando terminar. Com Autoplay ativo, entra em loop contínuo. Caso contrário, fica pausado no início pronto para ser assistido novamente.": "Configurez la vidéo pour qu'elle revienne automatiquement au début une fois terminée. Si l'Autoplay est activé, elle est lue en boucle continue. Sinon, elle reste en pause au début, prête à être regardée à nouveau.",
  "Configure opções de qualidade adaptativa para diferentes velocidades de internet.": "Configurez les options de qualité adaptative selon la vitesse de connexion Internet.",
  "Configure opções de reprodução automática": "Configurez les options de lecture automatique",
  "Configure opções visuais e de comportamento do formulário": "Configurez l'apparence et le comportement du formulaire",
  "Configure os botões de reprodução e volume.": "Configurez les boutons de lecture et de volume.",
  "Configure os controles disponíveis para o espectador.": "Configurez les commandes accessibles au spectateur.",
  "Configure os módulos e bônus no painel de edição": "Configurez les modules et les bonus dans le panneau d'édition",
  "Configure os textos do botão de ação": "Configurez les textes du bouton d'action",
  "Configure os valores da oferta": "Configurez les valeurs de l'offre",
  "Configure para recarregar plays automaticamente": "Configurez la recharge automatique des lectures",
  "Configure pixels de rastreamento para monitorar conversões": "Configurez des pixels de suivi pour surveiller les conversions",
  "Configure quando a headline aparece e desaparece": "Configurez l'apparition et la disparition du titre",
  "Configure rastreamento avançado para acompanhar todo o funil.": "Configurez le suivi avancé pour suivre l'ensemble du tunnel.",
  "Configure seu link de afiliado e ganhe comissões quando novos usuários se cadastrarem.": "Configurez votre lien affilié et gagnez des commissions lorsque de nouveaux utilisateurs s'inscrivent.",
  "Configure seu primeiro funil": "Configurez votre premier tunnel",
  "Configure seu primeiro pixel": "Configurez votre premier pixel",
  "Configure seu vídeo com recursos inteligentes para máxima conversão": "Configurez votre vidéo avec des fonctionnalités intelligentes pour maximiser les conversions",
  "Configure sua Recarga Automática": "Configurez votre recharge automatique",
  "Configure sua headline para ver o preview no vídeo principal": "Configurez votre titre pour voir l'aperçu dans la vidéo principale",
  "Configure sua primeira proteção em poucos passos.": "Configurez votre première protection en quelques étapes.",
  "Configure suas legendas": "Configurez vos sous-titres",
  "Configure tamanho e posição por dispositivo.": "Configurez la taille et la position pour chaque appareil.",
  "Configure testes A/B automáticos com diferentes velocidades para otimizar o engajamento do seu público.": "Configurez des tests A/B automatiques avec différentes vitesses pour optimiser l'engagement de votre audience.",
  "Configure tudo em uma única jornada": "Configurez tout dans un parcours unique",
  "Configure um teste na aba \"Teste A/B\" para visualizar curvas de retenção.": "Configurez un test dans l'onglet « Test A/B » pour afficher les courbes de rétention.",
  "Confira o player com as alterações atuais. Esta prévia não contabiliza plays. Saídas exibem o endereço de destino.": "Vérifiez le lecteur avec les modifications actuelles. Cet aperçu ne comptabilise pas de lectures. Les sorties affichent l'adresse de destination.",
  "Confira se o arquivo está publicado em:": "Vérifiez que le fichier est publié à l'adresse :",
  "Confirmar": "Confirmer",
  "Confirmar Compra": "Confirmer l'achat",
  "Confirmar Nova Senha": "Confirmer le nouveau mot de passe",
  "Confirmar Plataformas": "Confirmer les plateformes",
  "Confirmar Recarga": "Confirmer la recharge",
  "Confirmar Resgate": "Confirmer le retrait",
  "Confirmar Seleção": "Confirmer la sélection",
  "Confirmar cancelamento": "Confirmer la résiliation",
  "Confirmar e Sacar": "Confirmer et retirer",
  "Confirmar e Sincronizar Banco": "Confirmer et synchroniser la banque",
  "Confirmar exclusão": "Confirmer la suppression",
  "Confirmar senha": "Confirmer le mot de passe",
  "Confirme abaixo para adicionar o vídeo à sua conta HostVSL.": "Confirmez ci-dessous pour ajouter la vidéo à votre compte HostVSL.",
  "Confirme as variações e distribuição de tráfego antes de iniciar o teste.": "Confirmez les variantes et la répartition du trafic avant de lancer le test.",
  "Conforto": "Confort",
  "Conheça a AdSniper com uma condição especial para usuários da Host VSL.": "Découvrez AdSniper avec une offre spéciale pour les utilisateurs de Host VSL.",
  "Conheça a Replic, a nossa ferramenta para criar e clonar sites de alta conversão em poucos minutos. Comece gratuitamente em apenas um clique, sem precisar cadastrar cartão de crédito, e ganhe velocidade para validar suas ofertas.": "Découvrez Replic, notre outil pour créer et cloner des sites à fort taux de conversion en quelques minutes. Commencez gratuitement en un clic, sans carte bancaire, et validez vos offres plus rapidement.",
  "Conheça os pilares da Host VSL e entenda como cada área se conecta para acelerar sua operação.": "Découvrez les piliers de Host VSL et les liens entre ses différentes fonctionnalités pour accélérer votre activité.",
  "Consentimento LGPD": "Consentement LGPD",
  "Considere aumentar o tráfego para": "Envisagez d'augmenter le trafic vers",
  "Considere o público-alvo: usuários mais técnicos geralmente são mais receptivos a velocidades mais rápidas.": "Tenez compte du public cible : les utilisateurs plus techniques sont généralement plus réceptifs aux vitesses élevées.",
  "Considere otimizar o início do pitch.": "Envisagez d'optimiser le début de l'argumentaire de vente.",
  "Considere storytelling": "Envisagez une approche narrative",
  "Considere substituir por uma das outras introduções que performam melhor": "Envisagez de la remplacer par une introduction plus performante",
  "Considere testar campanhas neste horário para explorar oportunidades de crescimento.": "Envisagez de tester des campagnes à cet horaire pour explorer les possibilités de croissance.",
  "Consolida o resumo diário de métricas do período (dia de hoje é lido ao vivo)": "Consolide le résumé quotidien des indicateurs de la période (les données du jour sont lues en direct)",
  "Construa funil de vendas em minutos": "Construisez un tunnel de vente en quelques minutes",
  "Construa quizzes em minutos com editor visual": "Créez des quiz en quelques minutes avec l'éditeur visuel",
  "Construtor visual com etapas conectadas: cada vídeo pode ter uma pergunta e até quatro opções de resposta.": "Éditeur visuel avec étapes reliées : chaque vidéo peut contenir une question et jusqu'à quatre réponses.",
  "Consultores de Vendas": "Conseillers commerciaux",
  "Consumo no seu plano": "Consommation de votre forfait",
  "Conta": "Compte",
  "Conta Bancária": "Compte bancaire",
  "Conta Bancária Tradicional": "Compte bancaire traditionnel",
  "Conta apenas quem está realmente assistindo com o som ativo — audiência engajada de verdade": "Compte uniquement les personnes qui regardent réellement avec le son activé : une audience véritablement engagée",
  "Conta bancária definida como principal!": "Compte bancaire défini comme compte principal !",
  "Conta bancária vinculada com sucesso!": "Compte bancaire associé avec succès !",
  "Conta com dígito": "Numéro de compte avec chiffre de contrôle",
  "Conta corrente": "Compte courant",
  "Conta criada com sucesso! Agora escolha seu plano para começar.": "Compte créé avec succès ! Choisissez maintenant votre forfait pour commencer.",
  "Conta definida pelo usuário para recebimento.": "Compte défini par l'utilisateur pour recevoir les paiements.",
  "Contador de \"assistindo agora\" que se atualiza sozinho a cada poucos segundos": "Compteur de spectateurs actuels qui s'actualise automatiquement toutes les quelques secondes",
  "Contagem": "Décompte",
  "Contagem Final Inteligente": "Compte à rebours final intelligent",
  "Contagem Final salva": "Compte à rebours final enregistré",
  "Contagem base": "Décompte de base",
  "Contagem regressiva de 3 a 60 segundos ao final do vídeo, sobreposta ao player ou em tela cheia": "Compte à rebours de 3 à 60 secondes à la fin de la vidéo, superposé au lecteur ou en plein écran",
  "Container do Formulário": "Conteneur du formulaire",
  "Contas de Recebimento": "Comptes de réception des paiements",
  "Contas vinculadas": "Comptes associés",
  "Conte um pouco mais": "Dites-nous-en un peu plus",
  "Content Preview": "Aperçu du contenu",
  "Contexto Global": "Contexte global",
  "Contexts": "Contextes",
  "Conteúdo": "Contenu",
  "Conteúdo (Content)": "Contenu (Content)",
  "Conteúdo HTML": "Contenu HTML",
  "Conteúdo de Continuar de onde parou": "Contenu de la reprise du visionnage",
  "Conteúdo do Card": "Contenu de la carte",
  "Conteúdo protegido": "Contenu protégé",
  "Continuar": "Continuer",
  "Continuar Assistindo": "Reprendre le visionnage",
  "Continuar agora": "Continuer maintenant",
  "Continuar assistindo": "Continuer à regarder",
  "Continuar assistindo?": "Continuer à regarder ?",
  "Continuar conectado": "Rester connecté",
  "Continuar de onde parou": "Reprendre là où vous en étiez",
  "Continuar e Assistir": "Continuer et regarder",
  "Continuar editando": "Continuer la modification",
  "Continuar enviando": "Continuer les envois",
  "Continuar para o editor": "Continuer vers l'éditeur",
  "Continuar sem rastreamento": "Continuer sans suivi",
  "Continue Assistindo": "Continuez à regarder",
  "Continue com storytelling": "Poursuivez la narration",
  "Continue para a próxima aula": "Passez au cours suivant",
  "Continue para personalizar seu vídeo": "Continuez pour personnaliser votre vidéo",
  "Continue para personalizar seu vídeo com botões inteligentes e mais": "Continuez pour personnaliser votre vidéo avec des boutons intelligents et plus encore",
  "Continue refinando suas histórias. Adicione mais elementos emocionais, conflitos claros e resoluções satisfatórias.": "Continuez à perfectionner vos histoires. Ajoutez des éléments émotionnels, des conflits clairs et des résolutions satisfaisantes.",
  "Continue testando diferentes abordagens para descobrir o que ressoa melhor com seu público.": "Continuez à tester différentes approches pour découvrir celles qui parlent le mieux à votre audience.",
  "Continue usando storytelling eficiente, já que sua curva de retenção mostra alta eficácia.": "Continuez à utiliser une narration efficace : votre courbe de rétention en démontre l'efficacité.",
  "Contornado": "Avec contour",
  "Contraste adequado com o fundo": "Contraste adapté au fond",
  "Contraste adequado:": "Contraste adapté :",
  "Contraste insuficiente (": "Contraste insuffisant (",
  "Contraste insuficiente: {value0}:1 (mínimo 4.5:1 para acessibilidade)": "Contraste insuffisant : {value0}:1 (minimum 4.5:1 pour l'accessibilité)",
  "Controle a velocidade de reprodução.": "Réglez la vitesse de lecture.",
  "Controle como o player aparece em cada dispositivo: Desktop, Tablet e Celular": "Contrôlez l'affichage du lecteur sur chaque appareil : ordinateur, tablette et téléphone",
  "Controle de Volume": "Réglage du volume",
  "Controle de volume": "Réglage du volume",
  "Controle em quais dispositivos o vídeo será exibido: desktop, tablet ou celular.": "Contrôlez les appareils sur lesquels la vidéo s'affiche : ordinateur, tablette ou téléphone.",
  "Controle o acesso com toggle de ativação, limite de cópias e data de expiração": "Contrôlez l'accès avec un interrupteur d'activation, une limite de copies et une date d'expiration",
  "Controle o que é mostrado no formulário": "Contrôlez les éléments affichés dans le formulaire",
  "Controle por localização": "Contrôle par localisation",
  "Controle por origem de tráfego": "Contrôle par source de trafic",
  "Controle quando as opções aparecem, quando o vídeo pausa e se é possível assistir novamente à última etapa.": "Contrôlez l'apparition des options, le moment de la pause vidéo et la possibilité de revoir la dernière étape.",
  "Controle quem pode assistir sua VSL por localização, dispositivo e comportamento.": "Contrôlez l'accès à votre VSL selon la localisation, l'appareil et le comportement.",
  "Controle quem pode copiar seus vídeos": "Contrôlez qui peut copier vos vidéos",
  "Controle total sobre a aparência do seu autoplay.": "Contrôle total de l'apparence de votre Autoplay.",
  "Controles": "Commandes",
  "Controles Adicionais": "Commandes supplémentaires",
  "Controles Principais": "Commandes principales",
  "Controles de Reprodução": "Commandes de lecture",
  "Controles desabilitados": "Commandes désactivées",
  "Controles desativados automaticamente. Barra fake e controles não podem estar ativos ao mesmo tempo.": "Commandes désactivées automatiquement. La barre fictive et les commandes ne peuvent pas être actives simultanément.",
  "Controles do Player": "Commandes du lecteur",
  "Controles do Vídeo": "Commandes vidéo",
  "Controles do player": "Commandes du lecteur",
  "Controles foram desabilitados automaticamente ao ativar autoplay": "Les commandes ont été désactivées automatiquement à l'activation de l'Autoplay",
  "Controles foram desativados automaticamente. Autoplay e controles não podem estar ativos ao mesmo tempo.": "Les commandes ont été désactivées automatiquement. L'Autoplay et les commandes ne peuvent pas être actifs simultanément.",
  "Contém": "Contient",
  "Conv": "Conv",
  "Conv.": "Conv.",
  "Conv:": "Conv. :",
  "Converse com a gente!": "Discutez avec nous !",
  "Conversion Rate": "Taux de conversion",
  "Conversão": "Conversion",
  "Conversão Total do Funil": "Conversion totale du tunnel",
  "Conversão de abertura": "Conversion d'ouverture",
  "Conversão em venda": "Conversion en vente",
  "Conversão final": "Conversion finale",
  "Conversão por Dia": "Conversion par jour",
  "Conversão por Horário": "Conversion par horaire",
  "Conversão:": "Conversion :",
  "Conversões": "Conversions",
  "Conversões & Receita": "Conversions et chiffre d'affaires",
  "Conversões Totais": "Conversions totales",
  "Conversões dividido por visualizações": "Conversions divisées par les vues",
  "Conversões e receita rastreadas pelas plataformas conectadas": "Conversions et chiffre d'affaires suivis par les plateformes connectées",
  "Conversões hoje": "Conversions aujourd'hui",
  "Conversões por dia e horário": "Conversions par jour et horaire",
  "Conversões ÷ Plays únicos no período": "Conversions ÷ lectures uniques pendant la période",
  "Conversões:": "Conversions :",
  "Converta seu texto para o formato aceito.": "Convertissez votre texte au format accepté.",
  "Converter para VTT": "Convertir en VTT",
  "Convidado em:": "Invité le :",
  "Convidar Cliente": "Inviter un client",
  "Convidar Parceiro": "Inviter un partenaire",
  "Convide clientes e vendedores para a Host VSL e receba comissões automáticas sempre que sua rede gerar resultados.": "Invitez des clients et des vendeurs sur Host VSL et recevez des commissions automatiques chaque fois que votre réseau génère des résultats.",
  "Convite enviado com sucesso!": "Invitation envoyée avec succès !",
  "Copiada": "Copiée",
  "Copiado": "Copié",
  "Copiado com sucesso!": "Copié avec succès !",
  "Copiado para a área de transferência": "Copié dans le presse-papiers",
  "Copiado!": "Copié !",
  "Copiando de:": "Copie depuis :",
  "Copiando…": "Copie…",
  "Copiar": "Copier",
  "Copiar Código": "Copier le code",
  "Copiar Código de Integração": "Copier le code d'intégration",
  "Copiar Detalhes": "Copier les détails",
  "Copiar Embed": "Copier le code d'intégration",
  "Copiar Insight": "Copier l'analyse",
  "Copiar URL": "Copier l'URL",
  "Copiar chave": "Copier la clé",
  "Copiar cupom": "Copier le code promo",
  "Copiar código": "Copier le code",
  "Copiar código JS": "Copier le code JS",
  "Copiar código de embed": "Copier le code d'intégration",
  "Copiar código de incorporação": "Copier le code d'intégration",
  "Copiar código de incorporação do vídeo": "Copier le code d'intégration de la vidéo",
  "Copiar código de performance": "Copier le code de performance",
  "Copiar código performance": "Copier le code de performance",
  "Copiar dados": "Copier les données",
  "Copiar e-mail": "Copier l'e-mail",
  "Copiar link": "Copier le lien",
  "Copiar para minha conta": "Copier vers mon compte",
  "Copiar telefone": "Copier le téléphone",
  "Copiar token": "Copier le jeton",
  "Copiar webhook": "Copier le webhook",
  "Copie agora. Por segurança, não guardamos a chave — só uma impressão digital dela, que não tem volta. Esta é a única vez que a chave \"": "Copiez-la maintenant. Par sécurité, nous ne conservons pas la clé, seulement son empreinte, qui est irréversible. C'est la seule fois que la clé «",
  "Copie o código abaixo e cole onde deseja incorporar o player com o botão de ação configurado.": "Copiez le code ci-dessous et collez-le à l'endroit où vous souhaitez intégrer le lecteur avec le bouton d'action configuré.",
  "Copie o código do teste e atualize o embed no seu site para que ele comece a rodar.": "Copiez le code du test et mettez à jour l'intégration sur votre site pour le lancer.",
  "Copie o código do teste e atualize o embed no seu site. Término: {value0}": "Copiez le code du test et mettez à jour l'intégration sur votre site. Fin : {value0}",
  "Cor": "Couleur",
  "Cor 1": "Couleur 1",
  "Cor 2": "Couleur 2",
  "Cor Base": "Couleur de base",
  "Cor Personalizada": "Couleur personnalisée",
  "Cor Primária": "Couleur primaire",
  "Cor Principal": "Couleur principale",
  "Cor Secundária": "Couleur secondaire",
  "Cor Sólida": "Couleur unie",
  "Cor ao passar o mouse": "Couleur au survol",
  "Cor atual:": "Couleur actuelle :",
  "Cor da Barra": "Couleur de la barre",
  "Cor da Borda": "Couleur de la bordure",
  "Cor da Descrição": "Couleur de la description",
  "Cor da Headline": "Couleur du titre",
  "Cor da Subheadline": "Couleur du sous-titre",
  "Cor da barra": "Couleur de la barre",
  "Cor da borda": "Couleur de la bordure",
  "Cor da letra": "Couleur des caractères",
  "Cor da pergunta": "Couleur de la question",
  "Cor da sombra": "Couleur de l'ombre",
  "Cor de Destaque (botões e elementos interativos)": "Couleur d'accentuation (boutons et éléments interactifs)",
  "Cor de Fundo": "Couleur d'arrière-plan",
  "Cor de Fundo do Card": "Couleur d'arrière-plan de la carte",
  "Cor de destaque": "Couleur d'accentuation",
  "Cor de fundo": "Couleur d'arrière-plan",
  "Cor de fundo dos controles": "Couleur d'arrière-plan des commandes",
  "Cor de fundo e opacidade da barra inferior.": "Couleur d'arrière-plan et opacité de la barre inférieure.",
  "Cor do Botão": "Couleur du bouton",
  "Cor do Corpo": "Couleur du corps",
  "Cor do Círculo": "Couleur du cercle",
  "Cor do Fundo": "Couleur d'arrière-plan",
  "Cor do Header": "Couleur de l'en-tête",
  "Cor do Número": "Couleur du nombre",
  "Cor do Play Grande": "Couleur du grand bouton de lecture",
  "Cor do Progresso": "Couleur de la progression",
  "Cor do Rodapé": "Couleur du pied de page",
  "Cor do Texto": "Couleur du texte",
  "Cor do Título": "Couleur du titre",
  "Cor do botão": "Couleur du bouton",
  "Cor do destaque": "Couleur d'accentuation",
  "Cor do fundo": "Couleur d'arrière-plan",
  "Cor do play grande": "Couleur du grand bouton de lecture",
  "Cor do rodapé": "Couleur du pied de page",
  "Cor do texto": "Couleur du texte",
  "Cor do texto no overlay": "Couleur du texte de la superposition",
  "Cor do Ícone": "Couleur de l'icône",
  "Cor do ícone e do texto": "Couleur de l'icône et du texte",
  "Cor dos Controles": "Couleur des commandes",
  "Cor dos controles": "Couleur des commandes",
  "Cor e espessura de cada texto. O tamanho é definido no card de Conteúdo.": "Couleur et graisse de chaque texte. La taille est définie dans la carte Contenu.",
  "Cor personalizada": "Couleur personnalisée",
  "Cor principal": "Couleur principale",
  "Cor sólida uniforme": "Couleur unie uniforme",
  "Cor, espessura e arredondamento da borda.": "Couleur, épaisseur et arrondi de la bordure.",
  "Cores": "Couleurs",
  "Cores Principais": "Couleurs principales",
  "Cores do Autoplay": "Couleurs de l'Autoplay",
  "Cores do Botão": "Couleurs du bouton",
  "Cores do Overlay": "Couleurs de la superposition",
  "Cores do Player": "Couleurs du lecteur",
  "Cores do Texto": "Couleurs du texte",
  "Cores do overlay": "Couleurs de la superposition",
  "Cores do segundo botão em estado normal e ao passar o mouse.": "Couleurs du deuxième bouton à l'état normal et au survol.",
  "Cores do trilho, do preenchimento e do texto exibido sobre a barra.": "Couleurs du rail, du remplissage et du texte affiché sur la barre.",
  "Cores e Estilos": "Couleurs et styles",
  "Corrigida borda azul do vídeo selecionado que estava sendo cortada no modal de upload. Adicionado padding ao grid e substituído ring por border sólida.": "Correction de la bordure bleue de la vidéo sélectionnée qui était coupée dans la fenêtre d'envoi. Ajout d'espacement à la grille et remplacement du ring par une bordure pleine.",
  "Corrigido bug onde isFinalStep calculava incorretamente, fazendo o botão Iniciar Teste aparecer na etapa 2. Alterado de currentStep === totalSteps - 1 para currentStep === totalSteps.": "Correction du calcul de isFinalStep qui affichait le bouton Démarrer le test à l'étape 2. Remplacement de currentStep === totalSteps - 1 par currentStep === totalSteps.",
  "Corrigir Problemas": "Corriger les problèmes",
  "Corrigir agora →": "Corriger maintenant →",
  "Corrija e tente de novo.": "Corrigez et réessayez.",
  "Cpf Cadastrado": "CPF enregistré",
  "Crescimento de 27% nos cliques em botões de ação": "Augmentation de 27% des clics sur les boutons d'action",
  "Crescimento vs Período Anterior": "Croissance par rapport à la période précédente",
  "Cria conexão emocional e aumenta a memorização do conteúdo": "Crée un lien émotionnel et facilite la mémorisation du contenu",
  "Criada em": "Créée le",
  "Criado em": "Créé le",
  "Criado em:": "Créé le :",
  "Criado por": "Créé par",
  "Criando": "Création",
  "Criando conta...": "Création du compte...",
  "Criando cópia do vídeo na sua conta...": "Création d'une copie de la vidéo dans votre compte...",
  "Criando teste...": "Création du test...",
  "Criando uma Nova Feature": "Création d'une nouvelle fonctionnalité",
  "Criando...": "Création...",
  "Criar": "Créer",
  "Criar A/B": "Créer un test A/B",
  "Criar Ação": "Créer une action",
  "Criar Captura": "Créer une capture",
  "Criar Captura com E-mail": "Créer une capture par e-mail",
  "Criar Captura com Senha": "Créer une capture avec mot de passe",
  "Criar Captura de Dados": "Créer une collecte de données",
  "Criar Componentes e Página": "Créer les composants et la page",
  "Criar Formulário com E-mail": "Créer un formulaire par e-mail",
  "Criar Funil": "Créer un tunnel",
  "Criar Mini-Hook": "Créer un Mini-Hook",
  "Criar Nova Ação": "Créer une nouvelle action",
  "Criar Nova Playlist": "Créer une nouvelle playlist",
  "Criar Novo Vídeo": "Créer une nouvelle vidéo",
  "Criar Playlist": "Créer une playlist",
  "Criar Primeira Ação": "Créer la première action",
  "Criar Primeira Pasta": "Créer le premier dossier",
  "Criar Primeiro Webinário": "Créer le premier webinaire",
  "Criar Proteção": "Créer une protection",
  "Criar Quiz": "Créer un quiz",
  "Criar Registro": "Créer un enregistrement",
  "Criar Regra": "Créer une règle",
  "Criar Regra UTM": "Créer une règle UTM",
  "Criar Sites": "Créer des sites",
  "Criar Sites com a Replic": "Créer des sites avec Replic",
  "Criar Teste": "Créer un test",
  "Criar Teste A/B": "Créer un test A/B",
  "Criar Teste de Hook": "Créer un test d'accroche",
  "Criar Teste de Introdução": "Créer un test d'introduction",
  "Criar Teste de Introduções": "Créer un test d'introductions",
  "Criar Teste de Velocidade": "Créer un test de vitesse",
  "Criar Variação": "Créer une variante",
  "Criar Webinário": "Créer un webinaire",
  "Criar chave": "Créer une clé",
  "Criar conta grátis": "Créer un compte gratuit",
  "Criar e abrir o editor": "Créer et ouvrir l'éditeur",
  "Criar fluxo": "Créer un parcours",
  "Criar minha Playlist": "Créer ma playlist",
  "Criar minha primeira proteção": "Créer ma première protection",
  "Criar nova pasta": "Créer un nouveau dossier",
  "Criar nova senha": "Créer un nouveau mot de passe",
  "Criar novo Teste A/B": "Créer un nouveau test A/B",
  "Criar novo Teste de hook": "Créer un nouveau test d'accroche",
  "Criar novo teste": "Créer un nouveau test",
  "Criar o Store (se necessário)": "Créer le store (si nécessaire)",
  "Criar pasta": "Créer un dossier",
  "Criar primeira chave": "Créer la première clé",
  "Criar primeira pasta": "Créer le premier dossier",
  "Criar primeiro Mini-Hook": "Créer le premier Mini-Hook",
  "Criar proteção": "Créer une protection",
  "Criar saída": "Créer une sortie",
  "Criar seu primeiro teste": "Créer votre premier test",
  "Criar teste": "Créer un test",
  "Crie Seu Teste de Hook": "Créez votre test d'accroche",
  "Crie capturas com e-mail ou senha, conecte integrações e acompanhe relatórios completos dos leads gerados.": "Créez des captures par e-mail ou mot de passe, connectez des intégrations et consultez des rapports complets sur les leads générés.",
  "Crie e clone páginas em poucos minutos com a Replic, sem cartão de crédito.": "Créez et clonez des pages en quelques minutes avec Replic, sans carte bancaire.",
  "Crie e clone sites com IA que permite personalizar e hospedar páginas web em segundos.": "Créez et clonez des sites avec une IA permettant de personnaliser et d'héberger des pages web en quelques secondes.",
  "Crie funis de conversão para entender como seus visitantes se comportam ao longo do vídeo.": "Créez des tunnels de conversion pour comprendre le comportement de vos visiteurs au fil de la vidéo.",
  "Crie funis de vídeo em que o visitante escolhe o caminho até a compra": "Créez des tunnels vidéo dans lesquels le visiteur choisit son parcours jusqu'à l'achat",
  "Crie funis interativos de vendas para todos os nichos.": "Créez des tunnels de vente interactifs pour tous les secteurs.",
  "Crie jornadas interativas com botões que levam a vídeos diferentes.": "Créez des parcours interactifs avec des boutons menant à différentes vidéos.",
  "Crie pastas e subpastas ilimitadas": "Créez un nombre illimité de dossiers et de sous-dossiers",
  "Crie pelo menos 2 variações para continuar": "Créez au moins 2 variantes pour continuer",
  "Crie proteções num passo a passo simples, do vídeo às regras": "Créez des protections simplement, de la vidéo aux règles",
  "Crie páginas de alta conversão em poucos cliques.": "Créez des pages à fort taux de conversion en quelques clics.",
  "Crie páginas de captura em cima dos seus vídeos, colete leads e acompanhe o desempenho em tempo real.": "Créez des pages de capture sur vos vidéos, recueillez des leads et suivez les performances en temps réel.",
  "Crie quizzes interativos para qualificar leads e aumentar conversão com a FunnelX.": "Créez des quiz interactifs avec FunnelX pour qualifier les leads et augmenter les conversions.",
  "Crie regras para filtrar e redirecionar tráfego com base em critérios": "Créez des règles pour filtrer et rediriger le trafic selon des critères",
  "Crie seu primeiro teste": "Créez votre premier test",
  "Crie seu primeiro teste A/B": "Créez votre premier test A/B",
  "Crie seu primeiro teste A/B para comparar diferentes versões de vídeos.": "Créez votre premier test A/B pour comparer différentes versions de vidéos.",
  "Crie seu primeiro teste de hook": "Créez votre premier test d'accroche",
  "Crie seu primeiro webinário e comece a converter mais leads com experiências interativas.": "Créez votre premier webinaire et convertissez davantage de leads avec des expériences interactives.",
  "Crie seu primeiro webinário para começar a acompanhar métricas detalhadas de desempenho.": "Créez votre premier webinaire pour commencer à suivre les indicateurs détaillés de performances.",
  "Crie sites do zero com blocos prontos e premium": "Créez des sites de zéro avec des blocs prêts à l'emploi et premium",
  "Crie sua Playlist": "Créez votre playlist",
  "Crie sua conta": "Créez votre compte",
  "Crie sua conta agora!": "Créez votre compte maintenant !",
  "Crie sua primeira ação para começar": "Créez votre première action pour commencer",
  "Crie sua primeira variação": "Créez votre première variante",
  "Crie um Funil Poderoso que permite 1X1 baseado em eventos e disparos em massa multicanais. É tudo o que você precisa para mandar a mensagem certa na hora certa e maximizar as suas vendas!": "Créez un tunnel puissant permettant des échanges individuels fondés sur les événements et des envois multicanaux en masse. Tout ce qu'il vous faut pour envoyer le bon message au bon moment et maximiser vos ventes !",
  "Crie um gancho emocional": "Créez une accroche émotionnelle",
  "Crie um teste para otimizar a velocidade do seu vídeo.": "Créez un test pour optimiser la vitesse de votre vidéo.",
  "Crie um título que prometa valor real e seja irresistível para seu público-alvo. Considere incluir números ou resultados específicos.": "Créez un titre irrésistible qui promet une valeur réelle à votre public cible. Envisagez d'inclure des chiffres ou des résultats précis.",
  "Crie uma chave para conectar o Claude à sua conta e perguntar sobre as métricas dos seus vídeos por conversa.": "Créez une clé pour connecter Claude à votre compte et interroger les indicateurs de vos vidéos par conversation.",
  "Crie uma coleção organizada de vídeos": "Créez une collection organisée de vidéos",
  "Crie uma pasta": "Créez un dossier",
  "Crie uma proteção para controlar quem pode assistir sua VSL, bloquear tráfego suspeito e redirecionar acessos inválidos para um vídeo alternativo.": "Créez une protection pour contrôler l'accès à votre VSL, bloquer le trafic suspect et rediriger les accès invalides vers une autre vidéo.",
  "Crie uma subpasta ou adicione vídeos para organizar seu conteúdo": "Créez un sous-dossier ou ajoutez des vidéos pour organiser votre contenu",
  "Crie vídeos de entrada e saída para conduzir o espectador até a próxima ação": "Créez des vidéos d'entrée et de sortie pour guider le spectateur vers l'action suivante",
  "Crie webinários ao vivo, simulados ou just-in-time": "Créez des webinaires en direct, simulés ou à la demande immédiate",
  "Critério de vitória": "Critère de victoire",
  "Crítico": "Critique",
  "Cupom aplicado": "Code promo appliqué",
  "Cupom aplicado:": "Code promo appliqué :",
  "Cupom de desconto": "Code de réduction",
  "Cupom de desconto (opcional)": "Code de réduction (facultatif)",
  "Cupom de desconto aplicado": "Code de réduction appliqué",
  "Cupom e sorteio (visual apenas no MVP)": "Code promo et tirage au sort (visuel uniquement dans le MVP)",
  "Cupom exclusivo 50%OFF para 50% de desconto em qualquer plano": "Code exclusif 50%OFF pour 50% de réduction sur n'importe quel forfait",
  "Cupom inválido": "Code promo invalide",
  "Cupom inválido. Corrija ou remova o cupom para continuar.": "Code promo invalide. Corrigez ou supprimez le code pour continuer.",
  "Cupom promocional aplicado automaticamente e não pode ser removido.": "Code promotionnel appliqué automatiquement et ne pouvant pas être supprimé.",
  "Curva de Retenção": "Courbe de rétention",
  "Curva de retenção ao longo do vídeo": "Courbe de rétention au fil de la vidéo",
  "Curva de retenção do vídeo ao longo do tempo": "Courbe de rétention de la vidéo au fil du temps",
  "Curva de retenção por origem de tráfego": "Courbe de rétention par source de trafic",
  "Custo Médio/Usuário": "Coût moyen/utilisateur",
  "Custo Total Plataforma": "Coût total de la plateforme",
  "Custo Usuários": "Coût des utilisateurs",
  "Custo atualizado com sucesso!": "Coût mis à jour avec succès !",
  "Custo excluído!": "Coût supprimé !",
  "Custo médio por usuário": "Coût moyen par utilisateur",
  "Custo total plataforma": "Coût total de la plateforme",
  "Custom": "Personnalisé",
  "Custom icon": "Icône personnalisée",
  "Custom overlay": "Superposition personnalisée",
  "Custos": "Coûts",
  "Custos de Infraestrutura": "Coûts d'infrastructure",
  "Custos por Usuário": "Coûts par utilisateur",
  "Câmbio": "Taux de change",
  "Cód. Banco": "Code banque",
  "Código": "Code",
  "Código Copiado!": "Code copié !",
  "Código HTML": "Code HTML",
  "Código HTML personalizado": "Code HTML personnalisé",
  "Código JavaScript:": "Code JavaScript :",
  "Código copiado com sucesso!": "Code copié avec succès !",
  "Código copiado para a área de transferência": "Code copié dans le presse-papiers",
  "Código copiado para a área de transferência!": "Code copié dans le presse-papiers !",
  "Código copiado!": "Code copié !",
  "Código copiado.": "Code copié.",
  "Código copiado. Cole na página onde o vídeo deve aparecer.": "Code copié. Collez-le sur la page où la vidéo doit apparaître.",
  "Código copiado. Ele só mostra o vídeo depois que o fluxo for publicado.": "Code copié. Il n'affichera la vidéo qu'après la publication du parcours.",
  "Código copiado. O fluxo está pausado: o vídeo só aparece quando ele for retomado.": "Code copié. Le parcours est en pause : la vidéo n'apparaîtra qu'à sa reprise.",
  "Código da Máquina": "Code de la machine",
  "Código de E-mail": "Code d'e-mail",
  "Código de acesso": "Code d'accès",
  "Código de acesso é obrigatório": "Le code d'accès est obligatoire",
  "Código de incorporação do fluxo para colar no site.": "Code d'intégration du parcours à coller sur le site.",
  "Código do Funil": "Code du tunnel",
  "Código do fluxo": "Code du parcours",
  "Código do idioma (ex: pt, en, es)": "Code de langue (ex. : pt, en, es)",
  "Código enviado para seu e-mail!": "Code envoyé à votre adresse e-mail !",
  "Código inválido.": "Code invalide.",
  "Código reenviado!": "Code renvoyé !",
  "Cópias (7d)": "Copies (7 j)",
  "Cópias por Dia": "Copies par jour",
  "D = Desativado": "D = Désactivé",
  "DDD": "Indicatif régional",
  "DIA": "JOUR",
  "DOM": "DIM",
  "Dados": "Données",
  "Dados (": "Données (",
  "Dados Bancários": "Coordonnées bancaires",
  "Dados Gerais": "Données générales",
  "Dados bancários inválidos na Stripe.": "Coordonnées bancaires invalides dans Stripe.",
  "Dados cadastrais obrigatórios exigidos pela Stripe Connect.": "Informations d'inscription obligatoires requises par Stripe Connect.",
  "Dados coletados de 01/05/2024 a 15/05/2024 · Total de 1.262 visitantes": "Données recueillies du 01/05/2024 au 15/05/2024 · 1.262 visiteurs au total",
  "Dados de retenção, engajamento e conversão são coletados para cada intro.": "Les données de rétention, d'engagement et de conversion sont recueillies pour chaque intro.",
  "Dados do pagamento não encontrados.": "Données du paiement introuvables.",
  "Dados do titular": "Informations du titulaire",
  "Dados do vídeo não encontrados": "Données de la vidéo introuvables",
  "Dados em tempo real sobre desempenho de captura para este vídeo": "Données en temps réel sur les performances de capture de cette vidéo",
  "Dados enviados! Sua conta está em análise temporária pela Stripe.": "Données envoyées ! Stripe examine temporairement votre compte.",
  "Dados insuficientes": "Données insuffisantes",
  "Dados para Pagamento": "Informations de paiement",
  "Dados por timezone configurável": "Données selon un fuseau horaire configurable",
  "Dados resetados com sucesso!": "Données réinitialisées avec succès !",
  "Dados simulados": "Données simulées",
  "Dados usados para validação da sua conta de recebimento.": "Données utilisées pour valider votre compte de réception des paiements.",
  "Dark Members 2.0 — Template Premium": "Dark Members 2.0 — Modèle premium",
  "Das {value0} pessoas que deram play, {value1} converteram.": "Sur les {value0} personnes ayant lancé la lecture, {value1} ont converti.",
  "Das {value0} pessoas que viram seu vídeo, {value1} deram play.": "Sur les {value0} personnes ayant vu votre vidéo, {value1} ont lancé la lecture.",
  "Dashboard": "Tableau de bord",
  "Dashboard financeiro com totais, gráficos e listagem de custos AWS + despesas manuais.": "Tableau de bord financier avec totaux, graphiques et liste des coûts AWS et des dépenses manuelles.",
  "Dashboard principal (vídeos)": "Tableau de bord principal (vidéos)",
  "Dashboard redesenhado com 6 cards executivos: Overview, TopVSL, PitchHealth, Engagement, ConversionsRevenue, Audience. Altura fixa 260px, skeletons com shimmer.": "Tableau de bord repensé avec 6 cartes de synthèse : Overview, TopVSL, PitchHealth, Engagement, ConversionsRevenue, Audience. Hauteur fixe de 260px et squelettes avec effet de scintillement.",
  "Dashboard — 6 Cards Premium": "Tableau de bord — 6 cartes premium",
  "Data": "Date",
  "Data Fetching": "Récupération des données",
  "Data Solicitação": "Date de la demande",
  "Data da próxima cobrança": "Date du prochain prélèvement",
  "Data de Captura": "Date de capture",
  "Data de Nascimento": "Date de naissance",
  "Data do Convite": "Date de l'invitation",
  "Data e Hora": "Date et heure",
  "Data e Horário": "Date et horaire",
  "Data inicial e data final são obrigatórias": "Les dates de début et de fin sont obligatoires",
  "Data inválida": "Date invalide",
  "Data não disponível": "Date indisponible",
  "Data/Hora": "Date/Heure",
  "De": "De",
  "De R$": "À partir de R$",
  "De até 20% do valor do plano de assinatura do indicado.": "Jusqu'à 20% du montant de l'abonnement de la personne parrainée.",
  "De quem viu as opções": "Parmi les personnes ayant vu les options",
  "Defina a capa ideal para seu vídeo.": "Définissez la couverture idéale pour votre vidéo.",
  "Defina a data, duração e fuso. Nós cuidamos do resto.": "Définissez la date, la durée et le fuseau horaire. Nous nous occupons du reste.",
  "Defina a etapa inicial. Em cada etapa, selecione o vídeo, escreva a pergunta e adicione as respostas. Conecte cada resposta a outra etapa ou crie uma saída com o endereço de destino; você também escolhe se a página abre na mesma aba ou em uma nova.": "Définissez l'étape initiale. Pour chaque étape, sélectionnez la vidéo, rédigez la question et ajoutez les réponses. Reliez chaque réponse à une autre étape ou créez une sortie avec l'adresse de destination. Choisissez également l'ouverture dans le même onglet ou un nouvel onglet.",
  "Defina a ordem das variações": "Définissez l'ordre des variantes",
  "Defina a porcentagem de tráfego que cada intro receberá no teste.": "Définissez le pourcentage de trafic attribué à chaque intro pendant le test.",
  "Defina a porcentagem de tráfego que cada vídeo receberá no teste.": "Définissez le pourcentage de trafic attribué à chaque vidéo pendant le test.",
  "Defina a senha que liberará o acesso ao vídeo": "Définissez le mot de passe qui donnera accès à la vidéo",
  "Defina a senha que o usuário precisará digitar para acessar o vídeo": "Définissez le mot de passe que l'utilisateur devra saisir pour accéder à la vidéo",
  "Defina antes quando as opções aparecem.": "Définissez d'abord le moment d'apparition des options.",
  "Defina as cores do botão e do texto em estado normal e ao passar o mouse.": "Définissez les couleurs du bouton et du texte à l'état normal et au survol.",
  "Defina como o tráfego será distribuído": "Définissez la répartition du trafic",
  "Defina como o tráfego será distribuído entre as introduções. O total deve ser exatamente 100%.": "Définissez la répartition du trafic entre les introductions. Le total doit être exactement égal à 100%.",
  "Defina como o tráfego será distribuído entre os vídeos selecionados. O total deve ser exatamente 100%.": "Définissez la répartition du trafic entre les vidéos sélectionnées. Le total doit être exactement égal à 100%.",
  "Defina como os campos são exibidos no player": "Définissez l'affichage des champs dans le lecteur",
  "Defina imagens estratégicas para reforçar a atenção.": "Définissez des images stratégiques pour renforcer l'attention.",
  "Defina imagens estratégicas para reforçar atenção, retenção e conversão em momentos específicos do vídeo.": "Définissez des images stratégiques pour renforcer l'attention, la rétention et la conversion à des moments précis de la vidéo.",
  "Defina limites de cópias e expiração": "Définissez les limites de copies et l'expiration",
  "Defina o comportamento do player por aparelho.": "Définissez le comportement du lecteur par appareil.",
  "Defina o momento e o comportamento que será executado no vídeo": "Définissez le moment et le comportement à exécuter dans la vidéo",
  "Defina o momento em que a oferta aparece no vídeo. Cada vídeo pode ter até": "Définissez le moment où l'offre apparaît dans la vidéo. Chaque vidéo peut contenir jusqu'à",
  "Defina o momento exato onde sua oferta principal aparece no vídeo": "Définissez le moment exact où votre offre principale apparaît dans la vidéo",
  "Defina o nível de cada recurso: sem acesso, visualização ou edição": "Définissez le niveau de chaque fonctionnalité : sans accès, consultation ou modification",
  "Defina o que acontece quando o espectador envia o feedback.": "Définissez l'action à effectuer lorsque le spectateur envoie son avis.",
  "Defina o ritmo de alteração da audiência para deixar a simulação mais natural.": "Définissez le rythme de variation de l'audience pour rendre la simulation plus naturelle.",
  "Defina o tempo que o formulário será exibido durante o vídeo. O vídeo será pausado neste momento até que o formulário seja preenchido.": "Définissez le moment où le formulaire s'affichera pendant la vidéo. La vidéo sera alors mise en pause jusqu'à ce que le formulaire soit rempli.",
  "Defina o texto e link do seu CTA.": "Définissez le texte et le lien de votre CTA.",
  "Defina o vídeo Principal": "Définissez la vidéo principale",
  "Defina onde esta regra será aplicada": "Définissez où cette règle s'appliquera",
  "Defina quando a oferta será exibida": "Définissez le moment où l'offre sera affichée",
  "Defina quando e como as sessões acontecem": "Définissez quand et comment les sessions ont lieu",
  "Defina quando o botão aparecerá no vídeo.": "Définissez le moment où le bouton apparaîtra dans la vidéo.",
  "Defina quando o formulário deve aparecer (formato min:seg)": "Définissez le moment où le formulaire doit apparaître (format min:sec)",
  "Defina quando o teste deve encerrar": "Définissez la fin du test",
  "Defina se o vídeo deve voltar ao início automaticamente quando a reprodução terminar.": "Définissez si la vidéo doit revenir automatiquement au début à la fin de la lecture.",
  "Defina título e identificação da oferta": "Définissez le titre et l'identification de l'offre",
  "Defina um percentual exclusivo para este seller. Deixe vazio para usar a comissão padrão global.": "Définissez un pourcentage spécifique pour ce vendeur. Laissez vide pour utiliser la commission globale par défaut.",
  "Defina um valor em \"Base\" para exibir um contador numérico junto com a mensagem.": "Définissez une valeur dans « Base » pour afficher un compteur numérique avec le message.",
  "Defina uma data limite para o link funcionar": "Définissez une date limite de fonctionnement du lien",
  "Defina uma data para encerrar o teste automaticamente.": "Définissez une date pour terminer automatiquement le test.",
  "Defina uma data para encerrar o teste e selecionar a melhor velocidade.": "Définissez une date pour terminer le test et sélectionner la meilleure vitesse.",
  "Defina uma velocidade fixa ou rode um teste automático para descobrir a melhor.": "Définissez une vitesse fixe ou lancez un test automatique pour trouver la meilleure.",
  "Defina uma velocidade fixa ou rode um teste automático.": "Définissez une vitesse fixe ou lancez un test automatique.",
  "Define a primeira impressão antes do play": "Définit la première impression avant la lecture",
  "Define o horário de referência para a sessão": "Définit l'horaire de référence de la session",
  "Define quando o formulário de senha será exibido durante o vídeo": "Définit le moment où le formulaire de mot de passe s'affiche pendant la vidéo",
  "Define se o vídeo repete automaticamente.": "Définit si la vidéo se répète automatiquement.",
  "Definir": "Définir",
  "Definir URL": "Définir l'URL",
  "Definir como atual": "Définir comme actuel",
  "Definir como cartão padrão": "Définir comme carte par défaut",
  "Definir como início": "Définir comme début",
  "Definir como padrão/principal": "Définir par défaut/principal",
  "Definir como principal": "Définir comme principal",
  "Definir pitch": "Définir l'argumentaire de vente",
  "Definir trecho do autoplay": "Définir l'extrait d'Autoplay",
  "Definição do Vídeo Base": "Définition de la vidéo de base",
  "Deixe vazio para exibir apenas a mensagem, sem contador numérico.": "Laissez vide pour afficher uniquement le message, sans compteur numérique.",
  "Deixe vazio para ilimitado": "Laissez vide pour ne pas limiter",
  "Deixe vazio para infinito": "Laissez vide pour une durée infinie",
  "Deixe vazio para usar o nome da playlist": "Laissez vide pour utiliser le nom de la playlist",
  "Delay Adicional (ms)": "Délai supplémentaire (ms)",
  "Delay sincronizado com vídeo": "Délai synchronisé avec la vidéo",
  "Deletando...": "Suppression...",
  "Deletar": "Supprimer",
  "Demo: Modal de Incorporação": "Démo : fenêtre d'intégration",
  "Demonstração do dashboard Host VSL": "Démonstration du tableau de bord Host VSL",
  "Dentro do formulário": "Dans le formulaire",
  "Depoimento de Cliente": "Témoignage client",
  "Depois": "Après",
  "Depois do principal": "Après la vidéo principale",
  "Depois você envia os vídeos e monta as etapas no editor.": "Envoyez ensuite les vidéos et organisez les étapes dans l'éditeur.",
  "Deram play": "Ont lancé la lecture",
  "Desabilitado enquanto o Teste Automático estiver ativo.": "Désactivé lorsque le test automatique est actif.",
  "Desabilitar controles": "Désactiver les commandes",
  "Desaparecer em": "Disparaître à",
  "Desativa completamente os controles do player, deixando apenas o vídeo visível.": "Désactive entièrement les commandes du lecteur et ne laisse visible que la vidéo.",
  "Desativada": "Désactivée",
  "Desativadas": "Désactivées",
  "Desativado": "Désactivé",
  "Desativados": "Désactivés",
  "Desativar": "Désactiver",
  "Desativar CTA": "Désactiver le CTA",
  "Desativar captura": "Désactiver la capture",
  "Desativar compartilhamento": "Désactiver le partage",
  "Desativar recorrência": "Désactiver la récurrence",
  "Desative para pausar a ação sem removê-la": "Désactivez pour suspendre l'action sans la supprimer",
  "Desbloquear": "Débloquer",
  "Descer opção {value0}": "Descendre l'option {value0}",
  "Desconectar": "Déconnecter",
  "Desconhecido": "Inconnu",
  "Desconto": "Réduction",
  "Desconto Exclusivo para Seus Clientes": "Réduction exclusive pour vos clients",
  "Descreva o conteúdo da sua playlist...": "Décrivez le contenu de votre playlist...",
  "Descreva o objetivo deste teste...": "Décrivez l'objectif de ce test...",
  "Descreva o problema que você encontrou com este compartilhamento.": "Décrivez le problème rencontré avec ce partage.",
  "Descreva o problema...": "Décrivez le problème...",
  "Descrição": "Description",
  "Descrição (opcional)": "Description (facultative)",
  "Descrição / Rodapé": "Description / Pied de page",
  "Descrição da Aula": "Description du cours",
  "Descrição da Playlist": "Description de la playlist",
  "Descrição da Transação": "Description de la transaction",
  "Descrição da aula será exibida aqui. Esta é uma descrição de exemplo para demonstrar o layout do modal.": "La description du cours s'affichera ici. Ceci est un exemple pour montrer la présentation de la fenêtre.",
  "Descrição do Episódio": "Description de l'épisode",
  "Descubra criativos, ângulos e funis vencedores": "Découvrez les créations, les angles et les tunnels gagnants",
  "Descubra o horário campeão do período com o melhor volume de plays": "Découvrez le meilleur horaire de la période avec le plus grand nombre de lectures",
  "Descubra o horário campeão do período com o melhor volume de plays e visualizações": "Découvrez le meilleur horaire de la période avec le plus grand nombre de lectures et de vues",
  "Descubra ofertas validadas na Meta com a AdSniper e ganhe 50% OFF com o cupom 50%OFF.": "Découvrez des offres validées sur Meta avec AdSniper et obtenez 50% de réduction grâce au code 50%OFF.",
  "Descubra os criativos e ofertas mais escaladas no META": "Découvrez les créations et les offres les plus développées sur META",
  "Descubra os melhores horários para publicar seus vídeos com o novo recurso de Picos de Horários. Analise dados de performance por dia da semana e faixa horária para otimizar suas campanhas.": "Découvrez les meilleurs horaires pour publier vos vidéos grâce aux pics horaires. Analysez les performances par jour de la semaine et plage horaire pour optimiser vos campagnes.",
  "Descubra quais introduções engajam melhor sua audiência": "Découvrez quelles introductions engagent le mieux votre audience",
  "Descubra qual performa melhor": "Découvrez la plus performante",
  "Descubra quando seu público mais assiste seus vídeos.": "Découvrez quand votre audience regarde le plus vos vidéos.",
  "Desde": "Depuis",
  "Deseja aproveitar essa oportunidade?": "Souhaitez-vous profiter de cette opportunité ?",
  "Deseja realmente excluir esta ação?": "Voulez-vous vraiment supprimer cette action ?",
  "Desempenho Baixo": "Faibles performances",
  "Desempenho Médio": "Performances moyennes",
  "Desempenho consolidado por plataforma de pagamento": "Performances consolidées par plateforme de paiement",
  "Desempenho diário": "Performances quotidiennes",
  "Desempenho do Seu Teste A/B": "Performances de votre test A/B",
  "Desempenho do Seu Teste de Introduções": "Performances de votre test d'introductions",
  "Desempenho do vídeo exibido antes do principal.": "Performances de la vidéo affichée avant la vidéo principale.",
  "Desempenho do vídeo exibido depois do principal.": "Performances de la vidéo affichée après la vidéo principale.",
  "Desempenho financeiro das suas VSLs": "Performances financières de vos VSL",
  "Desempenho por vídeo": "Performances par vidéo",
  "Desfazer": "Annuler",
  "Desfocar fundo": "Flouter l'arrière-plan",
  "Desfoque": "Flou",
  "Design System": "Système de design",
  "Design responsivo otimizado para mobile": "Design adaptatif optimisé pour mobile",
  "Desktop": "Ordinateur",
  "Desktop:": "Ordinateur :",
  "Deslizar": "Glisser",
  "Deslizar para cima": "Glisser vers le haut",
  "Deslocamento Horizontal": "Décalage horizontal",
  "Deslocamento Vertical": "Décalage vertical",
  "Desmarcar": "Désélectionner",
  "Desmarcar todas": "Tout désélectionner",
  "Desperte curiosidade nos primeiros segundos": "Suscitez la curiosité dès les premières secondes",
  "Despesa cadastrada com sucesso!": "Dépense enregistrée avec succès !",
  "Despesa recorrente": "Dépense récurrente",
  "Despesas Manuais": "Dépenses manuelles",
  "Destaca o botão central de play": "Met en valeur le bouton central de lecture",
  "Destaque": "Mise en valeur",
  "Destaque o player com borda e sombra.": "Mettez le lecteur en valeur avec une bordure et une ombre.",
  "Destaque o player com bordas modernas e flexíveis, sem perder a identidade visual.": "Mettez le lecteur en valeur avec des bordures modernes et souples, tout en préservant votre identité visuelle.",
  "Destaque o player com uma borda elegante sem pesar no visual.": "Mettez le lecteur en valeur avec une bordure élégante sans alourdir l'apparence.",
  "Destaque pontos de decisão": "Mettez en valeur les points de décision",
  "Destaque sutil do overlay": "Mise en valeur discrète de la superposition",
  "Destaque visual para chamar atenção": "Mise en valeur visuelle pour attirer l'attention",
  "Destaques de Performance": "Temps forts des performances",
  "Destino": "Destination",
  "Destino URL": "URL de destination",
  "Destino da opção {value0}": "Destination de l'option {value0}",
  "Desvanecer": "Fondu",
  "Detalhamento de Custos": "Détail des coûts",
  "Detalhamento de visualizações por navegador e sistema operacional.": "Répartition des vues par navigateur et système d'exploitation.",
  "Detalhamento por Fonte": "Répartition par source",
  "Detalhar por dispositivo": "Détailler par appareil",
  "Detalhar por dispositivo →": "Détailler par appareil →",
  "Detalhes": "Détails",
  "Detalhes Técnicos": "Détails techniques",
  "Detalhes da": "Détails de la",
  "Detalhes da Estratégia": "Détails de la stratégie",
  "Detalhes da integração": "Détails de l'intégration",
  "Detalhes da referência": "Détails de la source référente",
  "Detalhes da solicitação enviada pelo afiliado.": "Détails de la demande envoyée par l'affilié.",
  "Detalhes de Conversões": "Détails des conversions",
  "Detalhes de Receita": "Détails du chiffre d'affaires",
  "Detalhes de Taxa de Conversão": "Détails du taux de conversion",
  "Detalhes de Ticket Médio": "Détails du panier moyen",
  "Detalhes de {value0}": "Détails de {value0}",
  "Detalhes do Pagamento": "Détails du paiement",
  "Detalhes do Ponto": "Détails du point",
  "Detalhes do Usuário": "Détails de l'utilisateur",
  "Detalhes do erro (aberto por padrão)": "Détails de l'erreur (ouverts par défaut)",
  "Detalhes do erro copiados para a área de transferência!": "Détails de l'erreur copiés dans le presse-papiers !",
  "Detalhes do feedback": "Détails de l'avis",
  "Detalhes do vídeo": "Détails de la vidéo",
  "Detalhes por Cidade": "Détails par ville",
  "Detalhes por Dispositivo": "Détails par appareil",
  "Detalhes por Estado": "Détails par État",
  "Detalhes por Navegador": "Détails par navigateur",
  "Detalhes por País": "Détails par pays",
  "Detalhes técnicos": "Détails techniques",
  "Detectado automaticamente": "Détecté automatiquement",
  "Detectar Interação": "Détecter l'interaction",
  "Deutsch": "Deutsch",
  "Deve conter letra maiúscula": "Doit contenir une majuscule",
  "Deve conter letra minúscula": "Doit contenir une minuscule",
  "Deve conter número": "Doit contenir un chiffre",
  "Deve ter no máximo 100 caracteres": "Doit comporter au maximum 100 caractères",
  "Dia Campeão": "Meilleur jour",
  "Dia da semana com melhor desempenho": "Jour de la semaine le plus performant",
  "Diagonal (↘)": "Diagonale (↘)",
  "Diagrama de Fluxo": "Diagramme de flux",
  "Dias da semana": "Jours de la semaine",
  "Dica de Melhoria": "Conseil d'amélioration",
  "Dica para melhor qualidade": "Conseil pour une meilleure qualité",
  "Dica:": "Conseil :",
  "Dica: Amplie o período no calendário.": "Conseil : élargissez la période dans le calendrier.",
  "Dica: Configure um teste na aba 'Automático' para visualizar métricas comparativas por velocidade.": "Conseil : configurez un test dans l'onglet « Automatique » pour afficher les indicateurs comparatifs par vitesse.",
  "Dica: clique na caixa no player para mover e redimensionar.": "Conseil : cliquez sur la zone du lecteur pour la déplacer et la redimensionner.",
  "Dicas de Otimização": "Conseils d'optimisation",
  "Dicas para testes ideais": "Conseils pour des tests efficaces",
  "Diferença": "Écart",
  "Diferença Percentual:": "Écart en pourcentage :",
  "Diferença Significativa:": "Écart significatif :",
  "Dificulte cópias do seu conteúdo e proteja sua propriedade intelectual.": "Rendez la copie de votre contenu plus difficile et protégez votre propriété intellectuelle.",
  "Digital Guru": "Digital Guru",
  "Digite": "Saisissez",
  "Digite a descrição da aula...": "Saisissez la description du cours...",
  "Digite a mensagem que será exibida ao usuário bloqueado": "Saisissez le message à afficher à l'utilisateur bloqué",
  "Digite a senha": "Saisissez le mot de passe",
  "Digite a senha de acesso": "Saisissez le mot de passe d'accès",
  "Digite a senha para acessar o vídeo": "Saisissez le mot de passe pour accéder à la vidéo",
  "Digite apenas números. Ex: 130 = 01:30": "Saisissez uniquement des chiffres. Ex. : 130 = 01:30",
  "Digite as informações do cartão.": "Saisissez les informations de la carte.",
  "Digite e pressione Enter": "Saisissez et appuyez sur Entrée",
  "Digite o ID do pixel": "Saisissez l'identifiant du pixel",
  "Digite o código de 4 dígitos": "Saisissez le code à 4 chiffres",
  "Digite o e-mail": "Saisissez l'e-mail",
  "Digite o e-mail completo": "Saisissez l'adresse e-mail complète",
  "Digite o e-mail completo do usuário": "Saisissez l'adresse e-mail complète de l'utilisateur",
  "Digite o nome completo": "Saisissez le nom complet",
  "Digite o nome da sua playlist": "Saisissez le nom de votre playlist",
  "Digite o nome impresso no cartão": "Saisissez le nom figurant sur la carte",
  "Digite o novo nome": "Saisissez le nouveau nom",
  "Digite o novo nome do vídeo": "Saisissez le nouveau nom de la vidéo",
  "Digite o novo texto": "Saisissez le nouveau texte",
  "Digite o subtítulo": "Saisissez le sous-titre",
  "Digite o tempo no formato mm:ss (ex: 01:30 para 1 minuto e 30 segundos)": "Saisissez le temps au format mm:ss (ex. : 01:30 pour 1 minute et 30 secondes)",
  "Digite o texto da subheadline (opcional)": "Saisissez le texte du sous-titre (facultatif)",
  "Digite o texto principal...": "Saisissez le texte principal...",
  "Digite o texto secundário...": "Saisissez le texte secondaire...",
  "Digite o título do vídeo": "Saisissez le titre de la vidéo",
  "Digite qualquer mensagem. Use {nome}, {cidade} e {produto} opcionalmente para personalizar.": "Saisissez un message. Utilisez éventuellement {nome}, {cidade} et {produto} pour le personnaliser.",
  "Digite seu cupom": "Saisissez votre code promo",
  "Digite seu token...": "Saisissez votre jeton...",
  "Digite sua nova senha para concluir a recuperação de acesso.": "Saisissez votre nouveau mot de passe pour terminer la récupération de l'accès.",
  "Digite um domínio válido. Ex: seusite.com": "Saisissez un domaine valide. Ex. : seusite.com",
  "Digite um e-mail válido": "Saisissez une adresse e-mail valide",
  "Digite um nome para a pasta": "Saisissez un nom pour le dossier",
  "Digite um nome para a variação": "Saisissez un nom pour la variante",
  "Digite um nome para identificar este Mini-Hook.": "Saisissez un nom pour identifier ce Mini-Hook.",
  "Digite um nome para identificar sua playlist": "Saisissez un nom pour identifier votre playlist",
  "Digite uma URL válida": "Saisissez une URL valide",
  "Digite uma expressão regular válida": "Saisissez une expression régulière valide",
  "Dimensões": "Dimensions",
  "Diminuir valor": "Diminuer la valeur",
  "Direcione seus espectadores com um CTA no momento certo.": "Guidez vos spectateurs avec un CTA au bon moment.",
  "Direita": "Droite",
  "Direto / sem origem": "Direct / sans source",
  "Direção": "Direction",
  "Discreto": "Discret",
  "Dispara no clique do botão de compra": "Se déclenche au clic sur le bouton d'achat",
  "Dispara no primeiro play do vídeo": "Se déclenche à la première lecture de la vidéo",
  "Dispara quando a oferta aparece": "Se déclenche à l'apparition de l'offre",
  "Disponível agora no menu Ferramentas.": "Disponible dès maintenant dans le menu Outils.",
  "Disponível apenas em vídeos novos — enviados a partir de agora": "Disponible uniquement pour les nouvelles vidéos envoyées à partir de maintenant",
  "Disponível no modal \"Importar vídeos\" do seu painel.": "Disponible dans la fenêtre « Importer des vidéos » de votre panneau.",
  "Disponível para saque": "Disponible au retrait",
  "Disponível somente nesta página": "Disponible uniquement sur cette page",
  "Disponível só nestes locais.": "Disponible uniquement dans ces lieux.",
  "Dispositivo": "Appareil",
  "Dispositivo mais usado": "Appareil le plus utilisé",
  "Dispositivo principal": "Appareil principal",
  "Dispositivo:": "Appareil :",
  "Dispositivos": "Appareils",
  "Dispositivos & Navegadores": "Appareils et navigateurs",
  "Dispositivos & Origem": "Appareils et sources",
  "Dispositivos permitidos": "Appareils autorisés",
  "Distribua promessas de valor ao longo do vídeo: 'Em breve vou mostrar como...', 'No próximo ponto você vai descobrir...'": "Disséminez des promesses de valeur au fil de la vidéo : « Je vais bientôt vous montrer comment... », « Dans le point suivant, vous découvrirez... »",
  "Distribua seus vídeos com velocidade e controle.": "Diffusez vos vidéos rapidement et avec contrôle.",
  "Distribua seus vídeos com velocidade e controle. Menos etapas, mais escala para sua operação com afiliados.": "Diffusez vos vidéos rapidement et avec contrôle. Moins d'étapes et plus de possibilités de développement pour votre activité avec les affiliés.",
  "Distribuição": "Répartition",
  "Distribuição atualizada": "Répartition mise à jour",
  "Distribuição das avaliações": "Répartition des évaluations",
  "Distribuição de Tráfego": "Répartition du trafic",
  "Distribuição de acessos": "Répartition des accès",
  "Distribuição de tráfego": "Répartition du trafic",
  "Distribuição de tráfego atualizada com sucesso!": "Répartition du trafic mise à jour avec succès !",
  "Distribuição de tráfego atualizada!": "Répartition du trafic mise à jour !",
  "Distribuição de tráfego:": "Répartition du trafic :",
  "Distribuição de visualizações e engajamento por dispositivo.": "Répartition des vues et de l'engagement par appareil.",
  "Distribuição de visualizações e engajamento por origem do tráfego.": "Répartition des vues et de l'engagement par source de trafic.",
  "Distribuição drag-and-drop": "Répartition par glisser-déposer",
  "Distribuição horária dos plays do dia": "Répartition horaire des lectures du jour",
  "Distribuição inválida: {value0}% (deve somar 100%)": "Répartition invalide : {value0}% (le total doit être égal à 100%)",
  "Distribuição por Categoria": "Répartition par catégorie",
  "Distribuição por Cidades": "Répartition par ville",
  "Distribuição por Dia da Semana": "Répartition par jour de la semaine",
  "Distribuição por Dispositivo": "Répartition par appareil",
  "Distribuição por Dispositivos": "Répartition par appareil",
  "Distribuição por Estados": "Répartition par État",
  "Distribuição por Fonte": "Répartition par source",
  "Distribuição por Navegadores": "Répartition par navigateur",
  "Distribuição por Países": "Répartition par pays",
  "Distribuição por Tipo": "Répartition par type",
  "Distribuição por fonte de tráfego": "Répartition par source de trafic",
  "Distribuição por tipo de dispositivo": "Répartition par type d'appareil",
  "Distribuição proporcional dos custos de infraestrutura por usuário com base em métricas de consumo (retenção, plays, vídeos).": "Répartition proportionnelle des coûts d'infrastructure par utilisateur selon les indicateurs de consommation (rétention, lectures, vidéos).",
  "Distribuição válida: 100%": "Répartition valide : 100%",
  "Distância do formulário em relação às bordas do vídeo": "Distance entre le formulaire et les bords de la vidéo",
  "Dividir igualmente": "Répartir équitablement",
  "Diário": "Quotidien",
  "Document indisponível (SSR?)": "Document indisponible (SSR ?)",
  "Documentação - Padronização Cores #1D4FFF": "Documentation - Harmonisation des couleurs #1D4FFF",
  "Documentação Homologada": "Documentation validée",
  "Documentação HostVSL": "Documentation HostVSL",
  "Documentação enviada e associada com sucesso para análise!": "Documents envoyés et associés avec succès pour examen !",
  "Documentação técnica": "Documentation technique",
  "Documento fiscal oficial emitido pelo processador bancário.": "Document fiscal officiel émis par le prestataire bancaire.",
  "Dois botões empilhados, para opções com textos longos.": "Deux boutons empilés pour les options aux textes longs.",
  "Dois botões lado a lado, com o mesmo peso visual.": "Deux boutons côte à côte, avec la même importance visuelle.",
  "Dom": "Dim",
  "Domingo 10-12h: Alta consistência, mas baixa saturação": "Dimanche 10 h-12 h : forte régularité, mais faible saturation",
  "Domínio adicionado com sucesso": "Domaine ajouté avec succès",
  "Domínio atualizado com sucesso": "Domaine mis à jour avec succès",
  "Domínio exato": "Domaine exact",
  "Domínio já cadastrado.": "Domaine déjà enregistré.",
  "Domínio removido com sucesso": "Domaine supprimé avec succès",
  "Domínios": "Domaines",
  "Domínios cadastrados": "Domaines enregistrés",
  "Download": "Téléchargement",
  "Download CSV": "Télécharger le CSV",
  "Download iniciado": "Téléchargement lancé",
  "Download iniciado com sucesso": "Téléchargement lancé avec succès",
  "Drag and Drop": "Glisser-déposer",
  "Drop no final pode apontar problema na oferta ou no CTA.": "Une baisse à la fin peut révéler un problème dans l'offre ou le CTA.",
  "Dropdown de seleção de vídeo agora herda largura exata do botão trigger usando CSS variable do Radix. Aplicados estilos premium: border #E6E8EC, radius 10px, shadow, altura 48px por item.": "La liste déroulante de sélection vidéo hérite désormais de la largeur exacte du bouton déclencheur grâce à la variable CSS de Radix. Styles premium appliqués : bordure #E6E8EC, rayon 10px, ombre et hauteur de 48px par élément.",
  "Dubai (GMT+4)": "Dubaï (GMT+4)",
  "Dupla Escolha": "Double choix",
  "Duplicando…": "Duplication…",
  "Duplicar": "Dupliquer",
  "Duplicar pasta": "Dupliquer le dossier",
  "Duration must be at least 1 second": "La durée doit être d'au moins 1 seconde",
  "Duration too long": "Durée trop longue",
  "Duração": "Durée",
  "Duração (minutos)": "Durée (minutes)",
  "Duração ({value}s)": "Durée ({value}s)",
  "Duração da contagem regressiva": "Durée du compte à rebours",
  "Duração da exibição (segundos)": "Durée d'affichage (secondes)",
  "Duração do Teste": "Durée du test",
  "Duração do teste": "Durée du test",
  "Duração mínima do teste": "Durée minimale du test",
  "Duração total do vídeo. Vídeos mais curtos geralmente têm maior taxa de visualização completa.": "Durée totale de la vidéo. Les vidéos courtes ont généralement un taux de visionnage complet plus élevé.",
  "Duração: {value0}": "Durée : {value0}",
  "Dê acesso ao seu painel para quem trabalha com você, com permissões definidas recurso por recurso.": "Donnez accès à votre panneau à vos collaborateurs avec des autorisations définies fonctionnalité par fonctionnalité.",
  "Dê um nome ao fluxo. Cada fluxo é um funil de vídeos curtos em que o visitante escolhe o próprio caminho.": "Donnez un nom au parcours. Chaque parcours est un tunnel de courtes vidéos dans lequel le visiteur choisit son propre chemin.",
  "Dê um nome para o seu teste de introduções. Escolha um nome descritivo que ajude você a identificar este teste no futuro.": "Donnez un nom à votre test d'introductions. Choisissez un nom descriptif pour retrouver facilement ce test plus tard.",
  "Dê um nome que lembre onde a chave vai ser usada. É por ele que você vai saber qual revogar quando tiver mais de uma.": "Donnez un nom rappelant où la clé sera utilisée. Il vous permettra de savoir laquelle révoquer si vous en avez plusieurs.",
  "E comece a transformar vídeos em conversões reais.": "Et commencez à transformer vos vidéos en conversions réelles.",
  "E-mail": "E-mail",
  "E-mail Cadastrado": "E-mail enregistré",
  "E-mail Corporativo ou Pessoal": "E-mail professionnel ou personnel",
  "E-mail PayPal cadastrado": "E-mail PayPal enregistré",
  "E-mail copiado!": "E-mail copié !",
  "E-mail da Conta PayPal": "E-mail du compte PayPal",
  "E-mail do Usuário": "E-mail de l'utilisateur",
  "E-mail do cliente": "E-mail du client",
  "E-mail inválido": "E-mail invalide",
  "E-mail muito longo": "E-mail trop long",
  "E-mail vinculado ao registro": "E-mail associé à l'enregistrement",
  "E-mail é obrigatório": "L'e-mail est obligatoire",
  "E-mail:": "E-mail :",
  "EUA": "États-Unis",
  "Economia de tempo significativa comparado a criar múltiplas páginas de teste": "Gain de temps considérable par rapport à la création de plusieurs pages de test",
  "Edge": "Edge",
  "Editar": "Modifier",
  "Editar Ação": "Modifier l'action",
  "Editar Captura com E-mail": "Modifier la capture par e-mail",
  "Editar Captura com Senha": "Modifier la capture avec mot de passe",
  "Editar Captura de Dados": "Modifier la collecte de données",
  "Editar Clicks": "Modifier les clics",
  "Editar Clicks —": "Modifier les clics —",
  "Editar Configuração": "Modifier la configuration",
  "Editar Custo": "Modifier le coût",
  "Editar Distribuição de Tráfego": "Modifier la répartition du trafic",
  "Editar Formulário com E-mail": "Modifier le formulaire par e-mail",
  "Editar Membro": "Modifier le membre",
  "Editar País": "Modifier le pays",
  "Editar Permissão": "Modifier l'autorisation",
  "Editar Permissões": "Modifier les autorisations",
  "Editar Pixel": "Modifier le pixel",
  "Editar Playlist": "Modifier la playlist",
  "Editar Região": "Modifier la région",
  "Editar Variação": "Modifier la variante",
  "Editar Variação de Headline": "Modifier la variante de titre",
  "Editar captura": "Modifier la capture",
  "Editar clicks": "Modifier les clics",
  "Editar conteúdo VTT": "Modifier le contenu VTT",
  "Editar domínio": "Modifier le domaine",
  "Editar fluxo": "Modifier le parcours",
  "Editar informações do vídeo": "Modifier les informations de la vidéo",
  "Editar intro": "Modifier l'intro",
  "Editar legenda": "Modifier les sous-titres",
  "Editar membro {value0}": "Modifier le membre {value0}",
  "Editar pagamento": "Modifier le paiement",
  "Editar permissões": "Modifier les autorisations",
  "Editar proteção": "Modifier la protection",
  "Editar texto": "Modifier le texte",
  "Editar tráfego": "Modifier le trafic",
  "Editar término do teste": "Modifier la fin du test",
  "Editar valor": "Modifier la valeur",
  "Editar vídeo": "Modifier la vidéo",
  "Editar {value0}": "Modifier {value0}",
  "Edite texto e estilo direto no painel, com preview em tempo real": "Modifiez le texte et le style directement dans le panneau avec un aperçu en temps réel",
  "Editor": "Éditeur",
  "Editor da VSL Dinâmica (um store por editor)": "Éditeur de VSL dynamique (un store par éditeur)",
  "Editor de playlist": "Éditeur de playlist",
  "Editor unificado": "Éditeur unifié",
  "Editor unificado inline para todos os templates, eliminando navegação entre páginas. Configurações específicas aparecem inline por template.": "Éditeur unifié intégré pour tous les modèles, sans navigation entre les pages. Les paramètres spécifiques apparaissent directement dans chaque modèle.",
  "Editor visual intuitivo, sem necessidade de código": "Éditeur visuel intuitif, sans code",
  "EditorServicesContext ausente": "EditorServicesContext absent",
  "EditorStoreContext ausente": "EditorStoreContext absent",
  "Edição": "Modification",
  "Edição dinâmica": "Modification dynamique",
  "Edição inline de texto e tempos diretamente no painel": "Modification des textes et des temps directement dans le panneau",
  "Eduzz": "Eduzz",
  "Efeito ao passar o mouse": "Effet au survol",
  "Efeito de foco ao passar o mouse: destaca a barra selecionada e suaviza as demais": "Effet de mise au point au survol : met la barre sélectionnée en valeur et atténue les autres",
  "Efeitos": "Effets",
  "Efeitos e Recursos": "Effets et fonctionnalités",
  "Ei, novidade boa por aqui! A gente trabalhou nos bastidores e entregou uma melhoria de performance completa na abertura dos vídeos. Resultado: carregamento mais rápido, menos travamentos e uma experiência muito melhor pra quem assiste o seu conteúdo.": "Bonne nouvelle ! Nous avons amélioré en profondeur les performances au démarrage des vidéos. Résultat : un chargement plus rapide, moins de blocages et une expérience bien meilleure pour les spectateurs de votre contenu.",
  "Ele perderá acesso imediatamente.": "Il perdra immédiatement son accès.",
  "Ele pode ter sido excluído.": "Il a peut-être été supprimé.",
  "Elementos extras para aumentar conversão": "Éléments supplémentaires pour augmenter les conversions",
  "Em Análise": "En cours d'examen",
  "Em Análise Preventiva": "En cours d'examen préventif",
  "Em aberto": "En attente",
  "Em andamento": "En cours",
  "Em breve novos parceiros estarão disponíveis.": "De nouveaux partenaires seront bientôt disponibles.",
  "Em criação": "En cours de création",
  "Em desenvolvimento": "En développement",
  "Em desenvolvimento...": "En développement...",
  "Em execução": "En cours d'exécution",
  "Em tempo personalizado": "À un moment personnalisé",
  "Em teste": "En test",
  "Em uso": "En cours d'utilisation",
  "Em {value0} {value1}": "Dans {value0} {value1}",
  "Email": "E-mail",
  "Email do usuário": "E-mail de l'utilisateur",
  "Email já cadastrado, por favor insira um email diferente, ou recupere sua senha!": "E-mail déjà enregistré. Saisissez une autre adresse e-mail ou récupérez votre mot de passe !",
  "Email:": "E-mail :",
  "Embaixo": "En dessous",
  "Embed": "Intégration",
  "Embed Code Modal — Premium": "Fenêtre de code d'intégration — Premium",
  "Embed para Performance": "Intégration pour les performances",
  "Emojis": "Émojis",
  "Emojis personalizáveis para cada pasta": "Émojis personnalisables pour chaque dossier",
  "Empresa (Opcional)": "Entreprise (facultatif)",
  "Empresa muito longa": "Nom d'entreprise trop long",
  "Empresa {value0} não encontrada no sistema.": "L'entreprise {value0} est introuvable dans le système.",
  "Encerra o teste e deleta a configuração de A/B test.": "Termine le test et supprime la configuration du test A/B.",
  "Encerra o teste e mantém a variação vencedora ativa.": "Termine le test et maintient la variante gagnante active.",
  "Encerrado": "Terminé",
  "Encerrando...": "Finalisation...",
  "Encurte os primeiros 30 segundos e vá direto ao ponto. Elimine qualquer informação que não seja absolutamente essencial.": "Raccourcissez les 30 premières secondes et allez droit au but. Supprimez toute information qui n'est pas absolument essentielle.",
  "Endereço Residencial": "Adresse personnelle",
  "Endereço da página": "Adresse de la page",
  "Endereço inválido: use uma URL http:// ou https://": "Adresse invalide : utilisez une URL http:// ou https://",
  "Engajamento": "Engagement",
  "Engajamento Médio": "Engagement moyen",
  "Engajamento Médio (%)": "Engagement moyen (%)",
  "Engajamento ao Longo do Tempo": "Engagement au fil du temps",
  "Engajamento:": "Engagement :",
  "English": "English",
  "Entenda como funcionam os plays extras do seu plano e como utilizá-los a seu favor.": "Découvrez le fonctionnement des lectures supplémentaires de votre forfait et comment en tirer parti.",
  "Entenda como sua audiência acessa seu conteúdo": "Comprenez comment votre audience accède à votre contenu",
  "Entenda de onde vem sua audiência e como ela se comporta": "Comprenez la provenance et le comportement de votre audience",
  "Entenda onde seu funil converte, onde perde leads e o impacto em cada campanha.": "Comprenez où votre tunnel convertit, où il perd des leads et son impact sur chaque campagne.",
  "Entenda onde sua audiência cai e onde a conversão acontece.": "Comprenez où votre audience décroche et où la conversion se produit.",
  "Entenda os indicadores que importam e tome decisões baseadas em dados.": "Comprenez les indicateurs essentiels et prenez des décisions fondées sur des données.",
  "Entenda qual VSL performa melhor com base em métricas claras.": "Identifiez la VSL la plus performante grâce à des indicateurs clairs.",
  "Entendendo os padrões de engajamento do seu vídeo": "Comprendre les tendances d'engagement de votre vidéo",
  "Entendi": "Compris",
  "Entendi, vamos começar!": "Compris, commençons !",
  "Entrada direta na sala": "Accès direct à la salle",
  "Entradas": "Entrées",
  "Entrando...": "Connexion...",
  "Entrar": "Se connecter",
  "Entrar como suporte": "Se connecter comme support",
  "Entrar na Sala": "Entrer dans la salle",
  "Entre 15 e 480 minutos": "Entre 15 et 480 minutes",
  "Entre 45% e 65%:": "Entre 45% et 65% :",
  "Entre 50% e 70%:": "Entre 50% et 70% :",
  "Entre com as credenciais do cliente e o código de acesso fornecido.": "Saisissez les identifiants du client et le code d'accès fourni.",
  "Entre em contato com nosso time e torne-se um parceiro Host VSL hoje mesmo!": "Contactez notre équipe et devenez partenaire de Host VSL dès aujourd'hui !",
  "Entrega de replay automática": "Mise à disposition automatique du replay",
  "Entregue a experiência ideal em qualquer tela.": "Offrez une expérience optimale sur tous les écrans.",
  "Enviado": "Envoyé",
  "Enviamos um código de 4 dígitos para seu e-mail. Digite-o abaixo para continuar.": "Nous avons envoyé un code à 4 chiffres à votre adresse e-mail. Saisissez-le ci-dessous pour continuer.",
  "Enviando Arquivos e Homologando...": "Envoi des fichiers et validation...",
  "Enviando frente do documento para a Stripe...": "Envoi du recto du document à Stripe...",
  "Enviando para o servidor...": "Envoi au serveur...",
  "Enviando seu vídeo...": "Envoi de votre vidéo...",
  "Enviando verso do documento para a Stripe...": "Envoi du verso du document à Stripe...",
  "Enviando vídeo...": "Envoi de la vidéo...",
  "Enviando ·": "Envoi ·",
  "Enviando...": "Envoi...",
  "Enviando…": "Envoi…",
  "Enviar": "Envoyer",
  "Enviar Convite": "Envoyer une invitation",
  "Enviar Documento de Identidade para Validação": "Envoyer une pièce d'identité pour validation",
  "Enviar Imagem": "Envoyer une image",
  "Enviar Imagem/GIF": "Envoyer une image/un GIF",
  "Enviar Logo (220x60)": "Envoyer un logo (220x60)",
  "Enviar Notificação Teste": "Envoyer une notification de test",
  "Enviar Vídeo": "Envoyer une vidéo",
  "Enviar comprovante": "Envoyer un justificatif",
  "Enviar código": "Envoyer le code",
  "Enviar e entrar na sala": "Envoyer et entrer dans la salle",
  "Enviar e ir para página de obrigado": "Envoyer et aller à la page de remerciement",
  "Enviar feedback": "Envoyer un avis",
  "Enviar mensagem automática quando a oferta abrir": "Envoyer un message automatique à l'ouverture de l'offre",
  "Enviar meu primeiro vídeo": "Envoyer ma première vidéo",
  "Enviar novo vídeo": "Envoyer une nouvelle vidéo",
  "Enviar primeiro vídeo": "Envoyer la première vidéo",
  "Enviar vídeos": "Envoyer des vidéos",
  "Enviar Ícone (SVG recomendado)": "Envoyer une icône (SVG recommandé)",
  "Envie a lista de pitches.": "Envoyez la liste des argumentaires de vente.",
  "Envie acessos bloqueados para um vídeo alternativo, URL segura ou mensagem personalizada.": "Redirigez les accès bloqués vers une autre vidéo, une URL sécurisée ou un message personnalisé.",
  "Envie o arquivo .VTT ou .SRT com as legendas sincronizadas.": "Envoyez le fichier .VTT ou .SRT contenant les sous-titres synchronisés.",
  "Envie o favicon": "Envoyez le favicon",
  "Envie os eventos das suas VSLs para o TikTok Ads e otimize as campanhas com base em quem assistiu de verdade.": "Envoyez les événements de vos VSL à TikTok Ads et optimisez vos campagnes selon les personnes qui ont réellement regardé.",
  "Envie os vídeos dentro do próprio fluxo e aguarde o processamento. Eles ficam na biblioteca desse fluxo, separados de Meus vídeos. Arraste um vídeo para o quadro ou use a opção Usar em nova etapa.": "Envoyez les vidéos dans le parcours et attendez leur traitement. Elles restent dans la bibliothèque de ce parcours, séparées de Mes vidéos. Déposez une vidéo sur le tableau ou utilisez l'option Utiliser dans une nouvelle étape.",
  "Envie ou consulte o comprovante deste pagamento.": "Envoyez ou consultez le justificatif de ce paiement.",
  "Envie seu primeiro vídeo ou ative o rastreamento para ver seu desempenho.": "Envoyez votre première vidéo ou activez le suivi pour voir ses performances.",
  "Envie seu primeiro vídeo para começar": "Envoyez votre première vidéo pour commencer",
  "Envie seu primeiro vídeo para começar a acompanhar a performance.": "Envoyez votre première vidéo pour commencer à suivre les performances.",
  "Envie seu primeiro vídeo para ver o engajamento.": "Envoyez votre première vidéo pour voir l'engagement.",
  "Envie seu vídeo": "Envoyez votre vidéo",
  "Envie sua logo": "Envoyez votre logo",
  "Envie um arquivo .VTT ou .SRT com as legendas sincronizadas. Ambos os formatos são suportados.": "Envoyez un fichier .VTT ou .SRT contenant les sous-titres synchronisés. Les deux formats sont acceptés.",
  "Envie um vídeo para ver a saúde do seu pitch.": "Envoyez une vidéo pour évaluer l'efficacité de votre argumentaire de vente.",
  "Envie uma imagem ou GIF para continuar.": "Envoyez une image ou un GIF pour continuer.",
  "Envie uma imagem ou GIF para seu autoplay": "Envoyez une image ou un GIF pour votre Autoplay",
  "Envie uma imagem para o template personalizado": "Envoyez une image pour le modèle personnalisé",
  "Envie uma imagem para substituir o vídeo.": "Envoyez une image pour remplacer la vidéo.",
  "Envie uma imagem válida do comprovante.": "Envoyez une image valide du justificatif.",
  "Envie vídeos do seu computador com upload rápido e seguro.": "Envoyez des vidéos depuis votre ordinateur avec un transfert rapide et sécurisé.",
  "Envio pausado": "Envoi en pause",
  "Envio pelo servidor: visualização da página, play, retenção e tempo assistido": "Envoi par le serveur : page vue, lecture, rétention et durée regardée",
  "Episode {value0}": "Épisode {value0}",
  "Episódio": "Épisode",
  "Episódio {value0}": "Épisode {value0}",
  "Episódios": "Épisodes",
  "Episódios (": "Épisodes (",
  "Equilíbrio ideal": "Équilibre idéal",
  "Erro": "Erreur",
  "Erro ao adicionar domínio": "Erreur lors de l'ajout du domaine",
  "Erro ao adicionar pixel": "Erreur lors de l'ajout du pixel",
  "Erro ao adicionar pixel!": "Erreur lors de l'ajout du pixel !",
  "Erro ao adicionar vídeos": "Erreur lors de l'ajout des vidéos",
  "Erro ao alterar plano.": "Erreur lors du changement de forfait.",
  "Erro ao alterar senha": "Erreur lors du changement de mot de passe",
  "Erro ao alterar senha.": "Erreur lors du changement de mot de passe.",
  "Erro ao alterar senha. Tente novamente.": "Erreur lors du changement de mot de passe. Réessayez.",
  "Erro ao alterar status": "Erreur lors du changement de statut",
  "Erro ao alterar status do link": "Erreur lors du changement de statut du lien",
  "Erro ao aplicar alterações": "Erreur lors de l'application des modifications",
  "Erro ao aplicar configurações": "Erreur lors de l'application des paramètres",
  "Erro ao aplicar cupom": "Erreur lors de l'application du code promo",
  "Erro ao ativar oferta": "Erreur lors de l'activation de l'offre",
  "Erro ao ativar teste A/B": "Erreur lors de l'activation du test A/B",
  "Erro ao atualizar": "Erreur lors de la mise à jour",
  "Erro ao atualizar assinatura": "Erreur lors de la mise à jour de l'abonnement",
  "Erro ao atualizar clicks.": "Erreur lors de la mise à jour des clics.",
  "Erro ao atualizar cliques.": "Erreur lors de la mise à jour des clics.",
  "Erro ao atualizar comissão do seller.": "Erreur lors de la mise à jour de la commission du vendeur.",
  "Erro ao atualizar domínio": "Erreur lors de la mise à jour du domaine",
  "Erro ao atualizar estratégia": "Erreur lors de la mise à jour de la stratégie",
  "Erro ao atualizar nível.": "Erreur lors de la mise à jour du niveau.",
  "Erro ao atualizar os dados cadastrais.": "Erreur lors de la mise à jour des informations d'inscription.",
  "Erro ao atualizar pagamento.": "Erreur lors de la mise à jour du paiement.",
  "Erro ao atualizar permissões. Tente novamente.": "Erreur lors de la mise à jour des autorisations. Réessayez.",
  "Erro ao atualizar pixel": "Erreur lors de la mise à jour du pixel",
  "Erro ao atualizar status.": "Erreur lors de la mise à jour du statut.",
  "Erro ao atualizar tráfego": "Erreur lors de la mise à jour du trafic",
  "Erro ao atualizar título": "Erreur lors de la mise à jour du titre",
  "Erro ao baixar o vídeo": "Erreur lors du téléchargement de la vidéo",
  "Erro ao baixar o vídeo. Tente novamente.": "Erreur lors du téléchargement de la vidéo. Réessayez.",
  "Erro ao buscar assinaturas": "Erreur lors de la récupération des abonnements",
  "Erro ao buscar cartões": "Erreur lors de la récupération des cartes",
  "Erro ao buscar compartilhamentos": "Erreur lors de la récupération des partages",
  "Erro ao buscar dados do usuário": "Erreur lors de la récupération des données utilisateur",
  "Erro ao buscar informações": "Erreur lors de la récupération des informations",
  "Erro ao buscar informações do pagamento.": "Erreur lors de la récupération des informations du paiement.",
  "Erro ao buscar métricas do teste": "Erreur lors de la récupération des indicateurs du test",
  "Erro ao buscar o vídeo": "Erreur lors de la récupération de la vidéo",
  "Erro ao buscar pixels": "Erreur lors de la récupération des pixels",
  "Erro ao buscar registro.": "Erreur lors de la recherche de l'enregistrement.",
  "Erro ao buscar testes de velocidade": "Erreur lors de la récupération des tests de vitesse",
  "Erro ao buscar usuário.": "Erreur lors de la recherche de l'utilisateur.",
  "Erro ao buscar vídeos": "Erreur lors de la récupération des vidéos",
  "Erro ao cancelar assinatura": "Erreur lors de la résiliation de l'abonnement",
  "Erro ao cancelar assinatura.": "Erreur lors de la résiliation de l'abonnement.",
  "Erro ao carregar a imagem": "Erreur lors du chargement de l'image",
  "Erro ao carregar compartilhamentos": "Erreur lors du chargement des partages",
  "Erro ao carregar configuração": "Erreur lors du chargement de la configuration",
  "Erro ao carregar dados da rede.": "Erreur lors du chargement des données du réseau.",
  "Erro ao carregar detalhes": "Erreur lors du chargement des détails",
  "Erro ao carregar detalhes do usuário.": "Erreur lors du chargement des détails de l'utilisateur.",
  "Erro ao carregar estratégia": "Erreur lors du chargement de la stratégie",
  "Erro ao carregar estratégias": "Erreur lors du chargement des stratégies",
  "Erro ao carregar imagem": "Erreur lors du chargement de l'image",
  "Erro ao carregar membros.": "Erreur lors du chargement des membres.",
  "Erro ao carregar metadados do vídeo": "Erreur lors du chargement des métadonnées vidéo",
  "Erro ao carregar métodos de pagamento.": "Erreur lors du chargement des moyens de paiement.",
  "Erro ao carregar métricas": "Erreur lors du chargement des indicateurs",
  "Erro ao carregar métricas do vídeo": "Erreur lors du chargement des indicateurs vidéo",
  "Erro ao carregar métricas:": "Erreur lors du chargement des indicateurs :",
  "Erro ao carregar regras": "Erreur lors du chargement des règles",
  "Erro ao carregar relatório de custos por usuário.": "Erreur lors du chargement du rapport des coûts par utilisateur.",
  "Erro ao carregar respostas": "Erreur lors du chargement des réponses",
  "Erro ao carregar seu extrato de comissões.": "Erreur lors du chargement de votre relevé de commissions.",
  "Erro ao carregar testes:": "Erreur lors du chargement des tests :",
  "Erro ao carregar vídeos": "Erreur lors du chargement des vidéos",
  "Erro ao carregar vídeos com captura de leads": "Erreur lors du chargement des vidéos avec capture de leads",
  "Erro ao coletar balanço de auditoria.": "Erreur lors de la collecte du bilan d'audit.",
  "Erro ao compartilhar": "Erreur lors du partage",
  "Erro ao compartilhar vídeo": "Erreur lors du partage de la vidéo",
  "Erro ao comprimir favicon": "Erreur lors de la compression du favicon",
  "Erro ao comprimir logo": "Erreur lors de la compression du logo",
  "Erro ao consolidar resumo de métricas.": "Erreur lors de la consolidation du résumé des indicateurs.",
  "Erro ao copiar": "Erreur lors de la copie",
  "Erro ao copiar código": "Erreur lors de la copie du code",
  "Erro ao criar a chave": "Erreur lors de la création de la clé",
  "Erro ao criar assinatura": "Erreur lors de la création de l'abonnement",
  "Erro ao criar cartão": "Erreur lors de la création de la carte",
  "Erro ao criar conta. Tente novamente.": "Erreur lors de la création du compte. Réessayez.",
  "Erro ao criar fatura": "Erreur lors de la création de la facture",
  "Erro ao criar integração": "Erreur lors de la création de l'intégration",
  "Erro ao criar link": "Erreur lors de la création du lien",
  "Erro ao criar link de compartilhamento": "Erreur lors de la création du lien de partage",
  "Erro ao criar pasta": "Erreur lors de la création du dossier",
  "Erro ao criar proteção": "Erreur lors de la création de la protection",
  "Erro ao criar registro.": "Erreur lors de la création de l'enregistrement.",
  "Erro ao criar teste": "Erreur lors de la création du test",
  "Erro ao criar teste A/B": "Erreur lors de la création du test A/B",
  "Erro ao criar teste automático": "Erreur lors de la création du test automatique",
  "Erro ao criar teste de velocidade": "Erreur lors de la création du test de vitesse",
  "Erro ao criar token de suporte": "Erreur lors de la création du jeton de support",
  "Erro ao definir cartão padrão": "Erreur lors de la définition de la carte par défaut",
  "Erro ao definir conta como principal.": "Erreur lors de la définition du compte principal.",
  "Erro ao definir método como padrão.": "Erreur lors de la définition du moyen par défaut.",
  "Erro ao deletar cartão": "Erreur lors de la suppression de la carte",
  "Erro ao deletar método de pagamento.": "Erreur lors de la suppression du moyen de paiement.",
  "Erro ao deletar pixel": "Erreur lors de la suppression du pixel",
  "Erro ao deletar teste": "Erreur lors de la suppression du test",
  "Erro ao deletar teste de velocidade": "Erreur lors de la suppression du test de vitesse",
  "Erro ao desativar recorrência.": "Erreur lors de la désactivation de la récurrence.",
  "Erro ao enviar convite. Tente novamente.": "Erreur lors de l'envoi de l'invitation. Réessayez.",
  "Erro ao enviar código de recuperação.": "Erreur lors de l'envoi du code de récupération.",
  "Erro ao enviar código de recuperação. Tente novamente.": "Erreur lors de l'envoi du code de récupération. Réessayez.",
  "Erro ao enviar e-mail de recuperação": "Erreur lors de l'envoi de l'e-mail de récupération",
  "Erro ao enviar legenda.": "Erreur lors de l'envoi des sous-titres.",
  "Erro ao excluir": "Erreur lors de la suppression",
  "Erro ao excluir alguns trackings.": "Erreur lors de la suppression de certains suivis.",
  "Erro ao excluir compartilhamento": "Erreur lors de la suppression du partage",
  "Erro ao excluir pasta": "Erreur lors de la suppression du dossier",
  "Erro ao excluir registro.": "Erreur lors de la suppression de l'enregistrement.",
  "Erro ao excluir tracking. Tente novamente.": "Erreur lors de la suppression du suivi. Réessayez.",
  "Erro ao excluir vídeo": "Erreur lors de la suppression de la vidéo",
  "Erro ao excluir.": "Erreur lors de la suppression.",
  "Erro ao exportar dados": "Erreur lors de l'exportation des données",
  "Erro ao fazer login": "Erreur de connexion",
  "Erro ao fazer login de suporte": "Erreur lors de la connexion du support",
  "Erro ao fazer login. Tente novamente.": "Erreur de connexion. Réessayez.",
  "Erro ao fazer login. Verifique suas credenciais.": "Erreur de connexion. Vérifiez vos identifiants.",
  "Erro ao fazer logout": "Erreur de déconnexion",
  "Erro ao finalizar teste": "Erreur lors de la finalisation du test",
  "Erro ao gerar PDF. Tente novamente.": "Erreur lors de la génération du PDF. Réessayez.",
  "Erro ao gerar thumbnail": "Erreur lors de la génération de la miniature",
  "Erro ao importar": "Erreur lors de l'importation",
  "Erro ao limpar cache": "Erreur lors du vidage du cache",
  "Erro ao mover vídeo para a pasta": "Erreur lors du déplacement de la vidéo dans le dossier",
  "Erro ao obter URL de download": "Erreur lors de la récupération de l'URL de téléchargement",
  "Erro ao processar arquivo": "Erreur lors du traitement du fichier",
  "Erro ao processar cartão": "Erreur lors du traitement de la carte",
  "Erro ao processar compartilhamento": "Erreur lors du traitement du partage",
  "Erro ao processar compra": "Erreur lors du traitement de l'achat",
  "Erro ao processar pagamento.": "Erreur lors du traitement du paiement.",
  "Erro ao realizar cadastro": "Erreur lors de l'inscription",
  "Erro ao reenviar código.": "Erreur lors du renvoi du code.",
  "Erro ao reenviar código. Tente novamente.": "Erreur lors du renvoi du code. Réessayez.",
  "Erro ao remover cartão": "Erreur lors de la suppression de la carte",
  "Erro ao remover domínio": "Erreur lors de la suppression du domaine",
  "Erro ao remover legenda.": "Erreur lors de la suppression des sous-titres.",
  "Erro ao remover logo": "Erreur lors de la suppression du logo",
  "Erro ao remover thumbnail": "Erreur lors de la suppression de la miniature",
  "Erro ao remover vídeo da pasta": "Erreur lors du retrait de la vidéo du dossier",
  "Erro ao renomear": "Erreur lors du renommage",
  "Erro ao renomear pasta": "Erreur lors du renommage du dossier",
  "Erro ao renomear vídeo": "Erreur lors du renommage de la vidéo",
  "Erro ao renovar token": "Erreur lors du renouvellement du jeton",
  "Erro ao revogar a chave": "Erreur lors de la révocation de la clé",
  "Erro ao salvar": "Erreur lors de l'enregistrement",
  "Erro ao salvar custo.": "Erreur lors de l'enregistrement du coût.",
  "Erro ao salvar estratégia": "Erreur lors de l'enregistrement de la stratégie",
  "Erro ao salvar método de pagamento.": "Erreur lors de l'enregistrement du moyen de paiement.",
  "Erro ao salvar tracking. Tente novamente.": "Erreur lors de l'enregistrement du suivi. Réessayez.",
  "Erro ao salvar velocidade manual": "Erreur lors de l'enregistrement de la vitesse manuelle",
  "Erro ao selecionar todos os vídeos": "Erreur lors de la sélection de toutes les vidéos",
  "Erro ao selecionar vídeo do teste": "Erreur lors de la sélection de la vidéo du test",
  "Erro ao sincronizar com AWS.": "Erreur lors de la synchronisation avec AWS.",
  "Erro ao validar código": "Erreur lors de la validation du code",
  "Erro ao validar código. Tente novamente.": "Erreur lors de la validation du code. Réessayez.",
  "Erro de autenticação": "Erreur d'authentification",
  "Erro de validação": "Erreur de validation",
  "Erro desconhecido": "Erreur inconnue",
  "Erro inesperado ao ativar oferta": "Erreur inattendue lors de l'activation de l'offre",
  "Erro inesperado ao cancelar assinatura.": "Erreur inattendue lors de la résiliation de l'abonnement.",
  "Erro inesperado ao processar compra": "Erreur inattendue lors du traitement de l'achat",
  "Erro inesperado. Tente novamente.": "Erreur inattendue. Réessayez.",
  "Erro interno no servidor ao salvar conta.": "Erreur interne du serveur lors de l'enregistrement du compte.",
  "Erro no Módulo Headline": "Erreur dans le module de titres",
  "Erro no formulário": "Erreur dans le formulaire",
  "Erro no upload": "Erreur lors de l'envoi",
  "Erro: Suba novamente o vídeo": "Erreur : envoyez à nouveau la vidéo",
  "Erros de Reprodução": "Erreurs de lecture",
  "Esc": "Échap",
  "Escala com impacto": "Zoom avec impact",
  "Escala leve": "Zoom léger",
  "Escolha a VSL protegida e um vídeo alternativo para os acessos bloqueados": "Choisissez la VSL protégée et une vidéo de remplacement pour les accès bloqués",
  "Escolha a etapa inicial do fluxo para pré-visualizar.": "Choisissez l'étape initiale du parcours pour afficher l'aperçu.",
  "Escolha a etapa inicial do fluxo.": "Choisissez l'étape initiale du parcours.",
  "Escolha a origem dos vídeos para começar.": "Choisissez la source des vidéos pour commencer.",
  "Escolha a plataforma de anúncios que deseja integrar": "Choisissez la plateforme publicitaire à intégrer",
  "Escolha ao menos uma origem de tráfego para comparar as curvas de retenção.": "Choisissez au moins une source de trafic pour comparer les courbes de rétention.",
  "Escolha como a legenda aparece no player.": "Choisissez l'apparence des sous-titres dans le lecteur.",
  "Escolha como deseja capturar os dados antes do usuário acessar seu vídeo.": "Choisissez comment recueillir les données avant que l'utilisateur accède à votre vidéo.",
  "Escolha como o formulário será exibido sobre o vídeo": "Choisissez l'affichage du formulaire sur la vidéo",
  "Escolha como o player será exibido neste dispositivo.": "Choisissez l'affichage du lecteur sur cet appareil.",
  "Escolha como os campos serão organizados": "Choisissez la disposition des champs",
  "Escolha do Template": "Choix du modèle",
  "Escolha entre bloquear ou liberar seus vídeos em países e regiões específicas. Esta proteção ajuda a controlar onde seu conteúdo será disponibilizado.": "Choisissez de bloquer ou d'autoriser vos vidéos dans certains pays et régions. Cette protection vous aide à contrôler où votre contenu est accessible.",
  "Escolha entre um formato de texto ou imagem personalizados.": "Choisissez un format de texte ou d'image personnalisé.",
  "Escolha manualmente a velocidade de reprodução do vídeo.": "Choisissez manuellement la vitesse de lecture de la vidéo.",
  "Escolha manualmente a velocidade desejada para o seu vídeo. Ideal para testes diretos e controle total sobre a reprodução.": "Choisissez manuellement la vitesse souhaitée pour votre vidéo. Idéal pour des tests directs et un contrôle total de la lecture.",
  "Escolha o arranjo do bloco de oferta que aparece abaixo do vídeo.": "Choisissez la disposition du bloc d'offre sous la vidéo.",
  "Escolha o canto do vídeo, o tamanho, as cores e o arredondamento, com som de caixa registradora opcional": "Choisissez le coin de la vidéo, la taille, les couleurs et l'arrondi, avec un son de caisse enregistreuse facultatif",
  "Escolha o desfecho: redirecionar automaticamente para o seu link ou apenas exibir o aviso": "Choisissez la suite : redirection automatique vers votre lien ou simple affichage de la notification",
  "Escolha o estilo visual do botão de play do seu player.": "Choisissez le style visuel du bouton de lecture de votre lecteur.",
  "Escolha o modelo da sua Playlist": "Choisissez le modèle de votre playlist",
  "Escolha o momento ideal do feedback.": "Choisissez le moment idéal pour demander un avis.",
  "Escolha o tema": "Choisissez le thème",
  "Escolha o tipo de captura": "Choisissez le type de capture",
  "Escolha o tipo e preencha com atenção os dados para repasse.": "Choisissez le type et renseignez soigneusement les informations de versement.",
  "Escolha o trecho que será exibido como gancho no autoplay.": "Choisissez l'extrait qui servira d'accroche dans l'Autoplay.",
  "Escolha o vídeo a integrar": "Choisissez la vidéo à intégrer",
  "Escolha o vídeo base (sem introdução) onde as aberturas serão testadas.": "Choisissez la vidéo de base (sans introduction) sur laquelle tester les ouvertures.",
  "Escolha o vídeo do seu webinar": "Choisissez la vidéo de votre webinaire",
  "Escolha o vídeo onde o formulário será exibido": "Choisissez la vidéo sur laquelle le formulaire sera affiché",
  "Escolha o vídeo que será protegido com senha": "Choisissez la vidéo à protéger par mot de passe",
  "Escolha o ícone": "Choisissez l'icône",
  "Escolha onde exibir no vídeo": "Choisissez où afficher dans la vidéo",
  "Escolha onde suas conversões são processadas.": "Choisissez où vos conversions sont traitées.",
  "Escolha os vídeos direto da sua biblioteca, sem precisar de um novo upload": "Choisissez les vidéos directement dans votre bibliothèque, sans nouvel envoi",
  "Escolha os vídeos no Google Drive": "Choisissez les vidéos dans Google Drive",
  "Escolha os vídeos que deseja comparar": "Choisissez les vidéos à comparer",
  "Escolha os vídeos que deseja comparar lado a lado.": "Choisissez les vidéos à comparer côte à côte.",
  "Escolha os vídeos que você deseja comparar. Cada visitante verá apenas um deles durante o teste.": "Choisissez les vidéos à comparer. Chaque visiteur ne verra qu'une seule vidéo pendant le test.",
  "Escolha outro vídeo para esta etapa.": "Choisissez une autre vidéo pour cette étape.",
  "Escolha quando o card aparece: no final do vídeo, ao pausar ou em um tempo personalizado": "Choisissez l'apparition de la carte : à la fin de la vidéo, à la pause ou à un moment personnalisé",
  "Escolha seu idioma preferido para o aplicativo": "Choisissez votre langue préférée pour l'application",
  "Escolha seu plano": "Choisissez votre forfait",
  "Escolha um cartão ou adicione um novo.": "Choisissez une carte ou ajoutez-en une nouvelle.",
  "Escolha um estilo pronto ou ajuste manualmente abaixo.": "Choisissez un style prédéfini ou personnalisez-le manuellement ci-dessous.",
  "Escolha um modelo abaixo para começar": "Choisissez un modèle ci-dessous pour commencer",
  "Escolha um modelo visual para o overlay": "Choisissez un modèle visuel pour la superposition",
  "Escolha um período de até {value0} dias.": "Choisissez une période maximale de {value0} jours.",
  "Escolha um template para a variação": "Choisissez un modèle pour la variante",
  "Escolha um template pré-configurado para começar rapidamente": "Choisissez un modèle prédéfini pour démarrer rapidement",
  "Escolha um vídeo": "Choisissez une vidéo",
  "Escolha um vídeo acima para visualizar os relatórios de captura.": "Choisissez une vidéo ci-dessus pour afficher les rapports de capture.",
  "Escolha um vídeo da biblioteca": "Choisissez une vidéo de la bibliothèque",
  "Escolha um vídeo da biblioteca para substituir o original.": "Choisissez une vidéo de la bibliothèque pour remplacer l'original.",
  "Escolha um vídeo da sua biblioteca para continuar.": "Choisissez une vidéo de votre bibliothèque pour continuer.",
  "Escolha um vídeo para exibir no autoplay": "Choisissez une vidéo à afficher dans l'Autoplay",
  "Escolha um vídeo processado da sua biblioteca e aplique personalizações avançadas": "Choisissez une vidéo traitée dans votre bibliothèque et appliquez des personnalisations avancées",
  "Escolha um ícone e uma cor para personalizar sua pasta": "Choisissez une icône et une couleur pour personnaliser votre dossier",
  "Escolha uma das opções abaixo": "Choisissez l'une des options ci-dessous",
  "Escolha uma das opções abaixo para receber suporte.": "Choisissez l'une des options ci-dessous pour obtenir de l'aide.",
  "Escolha uma data e horário para encerrar o teste.": "Choisissez une date et une heure pour terminer le test.",
  "Escolha uma opção": "Choisissez une option",
  "Escolha uma opção abaixo para continuar": "Choisissez une option ci-dessous pour continuer",
  "Escolher Arquivo": "Choisir un fichier",
  "Escolher arquivos": "Choisir des fichiers",
  "Escolher intervalo": "Choisir l'intervalle",
  "Escolher pitch": "Choisir l'argumentaire de vente",
  "Escolher vídeos no Drive": "Choisir les vidéos dans Drive",
  "Esconder Início": "Masquer le début",
  "Escopo de aplicação": "Champ d'application",
  "Escreva o texto com nome, cidade e produto — use a sugestão automática ou a sua própria lista": "Rédigez le texte avec le nom, la ville et le produit : utilisez la suggestion automatique ou votre propre liste",
  "Escurecer 5%": "Assombrir de 5%",
  "Escurecer automaticamente": "Assombrir automatiquement",
  "Escurecido": "Assombri",
  "Escurecimento": "Assombrissement",
  "Escurecimento atrás das opções": "Assombrissement derrière les options",
  "Espaçamento Externo (Offset)": "Espacement externe (décalage)",
  "Espaçamento Interno": "Espacement interne",
  "Español": "Español",
  "Espectadores": "Spectateurs",
  "Espere! Oferta especial": "Attendez ! Offre spéciale",
  "Espere! Temos uma condição especial para você": "Attendez ! Nous avons une offre spéciale pour vous",
  "Espessura": "Épaisseur",
  "Espessura da Borda": "Épaisseur de la bordure",
  "Espessura da Linha (1-6px)": "Épaisseur de la ligne (1-6px)",
  "Espessura da barra": "Épaisseur de la barre",
  "Espionar Ofertas com a AdSniper": "Observer les offres avec AdSniper",
  "Esqueceu sua senha?": "Mot de passe oublié ?",
  "Esquerda": "Gauche",
  "Essa atualização deixa a Host VSL ainda mais alinhada com quem busca escala, performance e operação profissional.": "Cette mise à jour adapte encore mieux Host VSL à ceux qui recherchent la croissance, la performance et une gestion professionnelle.",
  "Essa condição está disponível somente nesta página": "Cette offre est disponible uniquement sur cette page",
  "Essa referência representa": "Cette source référente représente",
  "Essas configurações não afetam o funcionamento do vídeo.": "Ces paramètres n'affectent pas le fonctionnement de la vidéo.",
  "Essas opções são usadas apenas quando o redirecionamento automático estiver ativo.": "Ces options sont utilisées uniquement lorsque la redirection automatique est active.",
  "Esse tempo passa da duração do vídeo.": "Ce temps dépasse la durée de la vidéo.",
  "Esse vídeo não pode ser transmitido a partir deste navegador.": "Cette vidéo ne peut pas être diffusée depuis ce navigateur.",
  "Esse vídeo não pôde ser baixado. Os outros continuam.": "Impossible de télécharger cette vidéo. Les autres continuent.",
  "Essencial": "Essentiel",
  "Esses locais serão bloqueados.": "Ces lieux seront bloqués.",
  "Esta ação irá encerrar o teste A/B de introduções e fixar a intro atual como definitiva. Esta ação não pode ser desfeita.": "Cette action terminera le test A/B d'introductions et définira l'intro actuelle comme définitive. Cette action est irréversible.",
  "Esta ação irá encerrar o teste de introduções e nenhum dado adicional será coletado. Você poderá visualizar os resultados, mas não poderá reativar o teste.": "Cette action terminera le test d'introductions et aucune donnée supplémentaire ne sera recueillie. Vous pourrez consulter les résultats, mais vous ne pourrez pas réactiver le test.",
  "Esta ação irá excluir permanentemente este teste e todos os seus dados. Esta ação não pode ser desfeita.": "Cette action supprimera définitivement ce test et toutes ses données. Cette action est irréversible.",
  "Esta ação irá restaurar todas as configurações para os valores padrão.": "Cette action rétablira tous les paramètres par défaut.",
  "Esta ação não bloqueia vídeos já incorporados anteriormente.": "Cette action ne bloque pas les vidéos déjà intégrées.",
  "Esta ação não pode ser desfeita. A introdução \"": "Cette action est irréversible. L'introduction «",
  "Esta ação não pode ser desfeita. A playlist será removida permanentemente.": "Cette action est irréversible. La playlist sera supprimée définitivement.",
  "Esta ação não pode ser desfeita. O teste \"": "Cette action est irréversible. Le test «",
  "Esta ação remove a pasta e suas subpastas da sua organização. Os vídeos não serão apagados do sistema.": "Cette action supprime le dossier et ses sous-dossiers de votre organisation. Les vidéos ne seront pas supprimées du système.",
  "Esta etapa (repetir)": "Cette étape (répéter)",
  "Esta integração está ativa e funcionando": "Cette intégration est active et fonctionne",
  "Esta integração está desativada": "Cette intégration est désactivée",
  "Esta introdução está ativa e coletando dados. Continue monitorando o desempenho.": "Cette introduction est active et recueille des données. Continuez à suivre ses performances.",
  "Esta introdução está com desempenho inferior. Revise o conteúdo ou considere substituí-la.": "Cette introduction a des performances inférieures. Revoyez son contenu ou envisagez de la remplacer.",
  "Esta introdução está performando melhor porque o storytelling ativa mais áreas do cérebro do espectador:": "Cette introduction est plus performante car la narration active davantage de zones du cerveau du spectateur :",
  "Esta introdução está performando melhor que as outras no teste. Considere aumentar o tráfego direcionado a ela.": "Cette introduction est plus performante que les autres dans le test. Envisagez d'augmenter le trafic qui lui est attribué.",
  "Esta introdução está performando muito bem em termos de retenção. Continue aplicando os mesmos princípios em seus próximos vídeos.": "Cette introduction obtient de très bons résultats de rétention. Continuez à appliquer les mêmes principes à vos prochaines vidéos.",
  "Esta pasta está vazia": "Ce dossier est vide",
  "Esta pasta não possui vídeos": "Ce dossier ne contient aucune vidéo",
  "Esta pasta não tem vídeos.": "Ce dossier n'a pas de vidéos.",
  "Esta playlist ainda não possui vídeos.": "Cette playlist ne contient encore aucune vidéo.",
  "Esta regra pode conflitar com outras regras existentes.": "Cette règle peut entrer en conflit avec d'autres règles existantes.",
  "Esta será a senha que os usuários precisarão digitar para desbloquear o vídeo": "Les utilisateurs devront saisir ce mot de passe pour débloquer la vidéo",
  "Esta seção será expandida com novas funcionalidades:": "Cette section sera enrichie de nouvelles fonctionnalités :",
  "Esta seção será implementada em breve.": "Cette section sera bientôt disponible.",
  "Esta versão do player não aceita pré-visualização.": "Cette version du lecteur ne prend pas en charge l'aperçu.",
  "Esta é uma visualização de como seu vídeo será exibido para o público.": "Voici un aperçu de l'affichage de votre vidéo pour le public.",
  "Estabilidade até 1min sugere boa narrativa.": "Une stabilité jusqu'à 1 minute suggère une bonne narration.",
  "Estado": "État",
  "Estado Normal": "État normal",
  "Estados": "États",
  "Estamos preparando este vídeo para compartilhamento. Em instantes ele ficará disponível em": "Nous préparons cette vidéo pour le partage. Elle sera bientôt disponible dans",
  "Estamos prontos para analisar": "Nous sommes prêts à analyser",
  "Estas sugestões são baseadas nas métricas de reprodução, engajamento e conversão.": "Ces suggestions sont fondées sur les indicateurs de lecture, d'engagement et de conversion.",
  "Este GIF é pesado ({size}) e pode impactar a fluidez do preview. Recomendamos usar um GIF mais leve ou reduzir as dimensões.": "Ce GIF est volumineux ({size}) et peut nuire à la fluidité de l'aperçu. Nous recommandons un GIF plus léger ou des dimensions réduites.",
  "Este Mini-Hook se sobrepõe a \"{name}\" no mesmo intervalo.": "Ce Mini-Hook chevauche « {name} » sur le même intervalle.",
  "Este ajuste sobrescreve o modelo selecionado": "Ce réglage remplace le modèle sélectionné",
  "Este compartilhamento não está disponível": "Ce partage est indisponible",
  "Este compartilhamento não está mais disponível": "Ce partage n'est plus disponible",
  "Este código inclui proteção ativa para:": "Ce code comprend une protection active pour :",
  "Este e-mail já foi convidado": "Cet e-mail a déjà été invité",
  "Este e-mail já possui um registro de incremento.": "Cet e-mail possède déjà un enregistrement d'ajout.",
  "Este fluxo ainda não tem vídeos.": "Ce parcours ne contient encore aucune vidéo.",
  "Este fluxo foi alterado em outra aba ou por outra pessoa.": "Ce parcours a été modifié dans un autre onglet ou par une autre personne.",
  "Este fluxo não existe ou foi excluído.": "Ce parcours n'existe pas ou a été supprimé.",
  "Este link atingiu o limite máximo de cópias permitido. Entre em contato com o produtor.": "Ce lien a atteint le nombre maximal de copies autorisées. Contactez le producteur.",
  "Este link de compartilhamento não existe ou foi removido.": "Ce lien de partage n'existe pas ou a été supprimé.",
  "Este link de compartilhamento pertence ao vídeo:": "Ce lien de partage appartient à la vidéo :",
  "Este link expirou e não está mais disponível. Solicite um novo link ao produtor.": "Ce lien a expiré et n'est plus disponible. Demandez un nouveau lien au producteur.",
  "Este mês": "Ce mois-ci",
  "Este nome será usado para identificar o teste na lista": "Ce nom permettra d'identifier le test dans la liste",
  "Este painel mostra quando seu público mais assiste ou carrega seu vídeo. Plays Únicos representam sessões deduplicadas; Visualizações Únicas, impressões deduplicadas. Use os horários mais fortes para agendar campanhas e posts.": "Ce panneau indique les moments où votre audience regarde ou charge le plus votre vidéo. Les lectures uniques correspondent aux sessions dédupliquées ; les vues uniques, aux impressions dédupliquées. Utilisez les meilleurs horaires pour programmer vos campagnes et publications.",
  "Este parâmetro UTM já está sendo usado por outra regra.": "Ce paramètre UTM est déjà utilisé par une autre règle.",
  "Este preview mostra como seus controles aparecerão no player real. As cores e configurações são aplicadas instantaneamente.": "Cet aperçu montre l'apparence de vos commandes dans le lecteur réel. Les couleurs et les paramètres sont appliqués instantanément.",
  "Este script acelera o carregamento do vídeo no seu site.": "Ce script accélère le chargement de la vidéo sur votre site.",
  "Este teste ainda não foi iniciado.": "Ce test n'a pas encore commencé.",
  "Este teste ainda não possui dados suficientes para análise. Os dados começam a ser gerados assim que os vídeos forem visualizados.": "Ce test ne dispose pas encore de suffisamment de données pour une analyse. Les données seront générées dès que les vidéos seront regardées.",
  "Este teste está ativo e recebendo tráfego": "Ce test est actif et reçoit du trafic",
  "Este teste está em andamento. Clique em 'Ver Teste' para acompanhar os resultados em tempo real.": "Ce test est en cours. Cliquez sur « Voir le test » pour suivre les résultats en temps réel.",
  "Este teste foi finalizado.": "Ce test est terminé.",
  "Este teste não possui vídeos associados.": "Ce test ne comporte aucune vidéo associée.",
  "Este token não é mais válido.": "Ce jeton n'est plus valide.",
  "Este usuário já está tem contana plataforma.": "Cet utilisateur possède déjà un compte sur la plateforme.",
  "Este vídeo está em uso numa etapa. Troque o vídeo da etapa antes de excluir.": "Cette vidéo est utilisée dans une étape. Remplacez la vidéo de cette étape avant de la supprimer.",
  "Este vídeo já está sendo usado nesta plataforma.": "Cette vidéo est déjà utilisée sur cette plateforme.",
  "Este vídeo não está mais no fluxo.": "Cette vidéo ne figure plus dans le parcours.",
  "Este vídeo pertence à sua conta. Não é necessário copiá-lo — você já tem acesso completo a ele na seção": "Cette vidéo appartient à votre compte. Il est inutile de la copier : vous y avez déjà un accès complet dans la section",
  "Este vídeo é propriedade intelectual do": "Cette vidéo est la propriété intellectuelle de",
  "Este é o saldo liberado baseado nas indicações da sua carteira que você pode transferir imediatamente.": "Il s'agit du solde disponible provenant des parrainages de votre portefeuille, que vous pouvez transférer immédiatement.",
  "Este é o vídeo usado na estratégia de captura. Clique em Editar para alterar configurações.": "Il s'agit de la vidéo utilisée dans la stratégie de capture. Cliquez sur Modifier pour changer les paramètres.",
  "Este é um horário de pico. Mantenha seus anúncios e campanhas ativos durante este período.": "C'est une plage de forte affluence. Maintenez vos publicités et campagnes actives pendant cette période.",
  "Estilo": "Style",
  "Estilo Avançado": "Style avancé",
  "Estilo TikTok": "Style TikTok",
  "Estilo avançado autoplay": "Style avancé de l'Autoplay",
  "Estilo da Barra": "Style de la barre",
  "Estilo da Headline": "Style du titre",
  "Estilo da Subheadline": "Style du sous-titre",
  "Estilo da legenda": "Style des sous-titres",
  "Estilo das legendas": "Style des sous-titres",
  "Estilo de borda (preset)": "Style de bordure (prédéfini)",
  "Estilo do Autoplay": "Style de l'Autoplay",
  "Estilo do Botão": "Style du bouton",
  "Estilo do Fundo": "Style de l'arrière-plan",
  "Estilo do botão": "Style du bouton",
  "Estilo do card": "Style de la carte",
  "Estilo do destaque": "Style de l'accentuation",
  "Estilo do Ícone": "Style de l'icône",
  "Estilo dos inputs do formulário": "Style des champs de saisie du formulaire",
  "Estilo e Comportamento": "Style et comportement",
  "Estilos Rápidos": "Styles rapides",
  "Estimativa sobre o total": "Estimation sur le total",
  "Estimativa:": "Estimation :",
  "Estratégia ativa": "Stratégie active",
  "Estratégia ativada": "Stratégie activée",
  "Estratégia atualizada": "Stratégie mise à jour",
  "Estratégia atualizada com sucesso ✅": "Stratégie mise à jour avec succès ✅",
  "Estratégia criada com sucesso": "Stratégie créée avec succès",
  "Estratégia de Captura": "Stratégie de capture",
  "Estratégia desativada": "Stratégie désactivée",
  "Estratégia não encontrada ou tipo inválido.": "Stratégie introuvable ou type invalide.",
  "Estratégia removida": "Stratégie supprimée",
  "Estratégias e recomendações para otimizar seus testes e melhorar os resultados.": "Stratégies et recommandations pour optimiser vos tests et améliorer les résultats.",
  "Estratégias para otimizar a retenção de \"": "Stratégies pour optimiser la rétention de «",
  "Estrelas": "Étoiles",
  "Estrutura de Diretórios": "Structure des répertoires",
  "Estruture seu conteúdo em formato de história com início (problema), meio (agravamento) e fim (solução).": "Structurez votre contenu comme une histoire avec un début (problème), un milieu (aggravation) et une fin (solution).",
  "Estude os concorrentes bem-sucedidos para inspiração (sem copiar diretamente).": "Étudiez les concurrents qui réussissent pour vous inspirer, sans les copier directement.",
  "Etapa": "Étape",
  "Etapa inicial": "Étape initiale",
  "Etapa sem nome": "Étape sans nom",
  "Etapa · {value0}": "Étape · {value0}",
  "Etapas da jornada do lead": "Étapes du parcours du lead",
  "Europe/London": "Europe/London",
  "Event handlers inline não são permitidos.": "Les gestionnaires d'événements inline ne sont pas autorisés.",
  "Evento": "Événement",
  "Evento começa em:": "L'événement commence dans :",
  "Evento de Disparo": "Événement déclencheur",
  "Eventos": "Événements",
  "Eventos de Interação": "Événements d'interaction",
  "Eventos enviados": "Événements envoyés",
  "Eventos enviados:": "Événements envoyés :",
  "Evite conclusões precipitadas com poucos dados - espere atingir os valores mínimos recomendados.": "Évitez les conclusions hâtives avec peu de données : attendez d'atteindre les seuils minimaux recommandés.",
  "Evite ofertar sessões em horários sensíveis": "Évitez de proposer des sessions à des horaires sensibles",
  "Evite sobrepor partes importantes": "Évitez de masquer des éléments importants",
  "Evolução da entrada": "Évolution de l'entrée",
  "Evolução da nota média": "Évolution de la note moyenne",
  "Evolução das referências": "Évolution des sources référentes",
  "Evolução de Conversões": "Évolution des conversions",
  "Evolução nos últimos 12 meses": "Évolution au cours des 12 derniers mois",
  "Ex.: Ative o som para melhor experiência": "Ex. : activez le son pour une meilleure expérience",
  "Ex.: Funil Emagrecimento 30D": "Ex. : tunnel perte de poids 30J",
  "Ex.: Oferta principal": "Ex. : offre principale",
  "Ex.: Seu vídeo já começou": "Ex. : votre vidéo a déjà commencé",
  "Ex.: Toque para ativar o som": "Ex. : touchez pour activer le son",
  "Ex: #FF0000, block, 20px": "Ex. : #FF0000, block, 20px",
  "Ex: 0001": "Ex. : 0001",
  "Ex: 12345-6": "Ex. : 12345-6",
  "Ex: 123456-7": "Ex. : 123456-7",
  "Ex: 1234567890123456": "Ex. : 1234567890123456",
  "Ex: 150": "Ex. : 150",
  "Ex: 71 99999-8888": "Ex. : 71 99999-8888",
  "Ex: Acesse todos os módulos do curso...": "Ex. : accédez à tous les modules de la formation...",
  "Ex: Agende agora sem custos": "Ex. : réservez maintenant sans frais",
  "Ex: Ao vivo agora": "Ex. : en direct maintenant",
  "Ex: Assista até o final para descobrir o método": "Ex. : regardez jusqu'à la fin pour découvrir la méthode",
  "Ex: Assista até o final para descobrir o método que está gerando vendas todos os dias": "Ex. : regardez jusqu'à la fin pour découvrir la méthode qui génère des ventes chaque jour",
  "Ex: Autoplay Moderno, Conversão Limpa...": "Ex. : Autoplay moderne, conversion épurée...",
  "Ex: Bem-vindo ao Curso": "Ex. : bienvenue dans la formation",
  "Ex: Botão de Checkout": "Ex. : bouton de paiement",
  "Ex: Brasil, EUA": "Ex. : Brésil, États-Unis",
  "Ex: Bônus Exclusivos": "Ex. : bonus exclusifs",
  "Ex: Comece sua jornada de transformação": "Ex. : commencez votre parcours de transformation",
  "Ex: Como Ganhar R$ 10.000 por Mês com Marketing Digital": "Ex. : comment gagner R$ 10.000 par mois avec le marketing numérique",
  "Ex: Comprar Agora": "Ex. : acheter maintenant",
  "Ex: Concorra a um iPhone 15": "Ex. : tentez de gagner un iPhone 15",
  "Ex: Continuar Assistindo": "Ex. : reprendre le visionnage",
  "Ex: Continue agora mesmo": "Ex. : continuez dès maintenant",
  "Ex: Copie este vídeo para começar a divulgar...": "Ex. : copiez cette vidéo pour commencer à la promouvoir...",
  "Ex: Curso Completo de Marketing": "Ex. : formation complète en marketing",
  "Ex: Curso Completo de Marketing Digital": "Ex. : formation complète en marketing numérique",
  "Ex: Curso Premium": "Ex. : formation premium",
  "Ex: Diagnóstico Comercial Gratuito": "Ex. : diagnostic commercial gratuit",
  "Ex: Funil Low Ticket / Campanha Fevereiro": "Ex. : tunnel à petit prix / campagne de février",
  "Ex: Headline Moderna, Conversão Limpa...": "Ex. : titre moderne, conversion épurée...",
  "Ex: IPINFO API, Amazon EC2...": "Ex. : IPINFO API, Amazon EC2...",
  "Ex: João Silva": "Ex. : João Silva",
  "Ex: Libere o acesso ao vídeo": "Ex. : débloquez l'accès à la vidéo",
  "Ex: Marketing, VSLs, Tutoriais...": "Ex. : marketing, VSL, tutoriels...",
  "Ex: Materiais extras para acelerar seus resultados": "Ex. : ressources supplémentaires pour accélérer vos résultats",
  "Ex: Mostrar botão de compra": "Ex. : afficher le bouton d'achat",
  "Ex: Módulos Iniciais": "Ex. : modules initiaux",
  "Ex: Oferta Black Friday 2024": "Ex. : offre Black Friday 2024",
  "Ex: Olá! Tenho interesse no conteúdo da sua playlist.": "Ex. : bonjour ! Le contenu de votre playlist m'intéresse.",
  "Ex: Plano Pro - 10k requests/mês": "Ex. : forfait Pro - 10k requêtes/mois",
  "Ex: Proteção principal": "Ex. : protection principale",
  "Ex: Próximo passo da sua jornada": "Ex. : prochaine étape de votre parcours",
  "Ex: Reforço da promessa inicial": "Ex. : renforcement de la promesse initiale",
  "Ex: Restam poucas vagas": "Ex. : il reste peu de places",
  "Ex: SSL Seguro": "Ex. : SSL sécurisé",
  "Ex: Seu vídeo já começou": "Ex. : votre vidéo a déjà commencé",
  "Ex: Seus dados estão seguros conosco": "Ex. : vos données sont en sécurité avec nous",
  "Ex: São Paulo, Rio de Janeiro": "Ex. : São Paulo, Rio de Janeiro",
  "Ex: Teste de Aberturas – Produto X": "Ex. : test d'ouvertures – Produit X",
  "Ex: Teste de Introduções - VSL Principal": "Ex. : test d'introductions - VSL principale",
  "Ex: Teste de VSLs - Produto X": "Ex. : test de VSL - Produit X",
  "Ex: Teste de VSLs – Produto X": "Ex. : test de VSL – Produit X",
  "Ex: Toque para ativar o som": "Ex. : touchez pour activer le son",
  "Ex: VSL Principal vs Variação Curta": "Ex. : VSL principale vs variante courte",
  "Ex: Webinário de Lançamento Produto X": "Ex. : webinaire de lancement du Produit X",
  "Ex: ativo, visivel, destaque": "Ex. : actif, visible, accentuation",
  "Ex: color, background, display": "Ex. : color, background, display",
  "Ex: facebook": "Ex. : facebook",
  "Ex: google, facebook, newsletter": "Ex. : google, facebook, newsletter",
  "Ex: joao@email.com": "Ex. : joao@email.com",
  "Ex: utm_source": "Ex. : utm_source",
  "Ex: Última chance": "Ex. : dernière chance",
  "Excel (.xlsx)": "Excel (.xlsx)",
  "Excelente": "Excellent",
  "Excelente trabalho! Sua introdução está performando bem em todos os aspectos. A combinação de alta taxa de play e bom engajamento mostra que tanto seu thumbnail quanto seu conteúdo estão alinhados com as expectativas do público.": "Excellent travail ! Votre introduction est performante sur tous les plans. Un taux de lecture élevé et un bon engagement montrent que la miniature et le contenu répondent aux attentes du public.",
  "Excelente! Esta introdução com storytelling está performance muito bem. O formato narrativo cria uma conexão emocional com o espectador e mantém o engajamento alto. Continue usando histórias relevantes que ressoam com seu público-alvo.": "Excellent ! Cette introduction narrative obtient de très bons résultats. Le format narratif crée un lien émotionnel avec le spectateur et maintient un engagement élevé. Continuez avec des histoires pertinentes pour votre public cible.",
  "Excluindo...": "Suppression...",
  "Excluir": "Supprimer",
  "Excluir Bônus?": "Supprimer le bonus ?",
  "Excluir Estratégia": "Supprimer la stratégie",
  "Excluir Mini-Hook?": "Supprimer le Mini-Hook ?",
  "Excluir Módulo?": "Supprimer le module ?",
  "Excluir Todos": "Tout supprimer",
  "Excluir Tracking?": "Supprimer le suivi ?",
  "Excluir a etapa \"": "Supprimer l'étape «",
  "Excluir compartilhamento": "Supprimer le partage",
  "Excluir definitivamente": "Supprimer définitivement",
  "Excluir etapa": "Supprimer l'étape",
  "Excluir fluxo e vídeos": "Supprimer le parcours et les vidéos",
  "Excluir fluxo e vídeos?": "Supprimer le parcours et les vidéos ?",
  "Excluir legenda": "Supprimer les sous-titres",
  "Excluir pasta": "Supprimer le dossier",
  "Excluir pasta?": "Supprimer le dossier ?",
  "Excluir playlist?": "Supprimer la playlist ?",
  "Excluir registro": "Supprimer l'enregistrement",
  "Excluir saída": "Supprimer la sortie",
  "Excluir teste A/B?": "Supprimer le test A/B ?",
  "Excluir teste de hook?": "Supprimer le test d'accroche ?",
  "Excluir teste de introduções?": "Supprimer le test d'introductions ?",
  "Excluir variação?": "Supprimer la variante ?",
  "Excluir vídeo": "Supprimer la vidéo",
  "Excluir vídeo da playlist": "Retirer la vidéo de la playlist",
  "Excluir vídeo?": "Supprimer la vidéo ?",
  "Excluir vídeos selecionados": "Supprimer les vidéos sélectionnées",
  "Excluir {value0} pastas?": "Supprimer {value0} dossiers ?",
  "Exemplo do endereço final": "Exemple de l'adresse finale",
  "Exemplo:": "Exemple :",
  "Exemplo: Se o webinário começa às 20h e alguém entra às 20:15, o vídeo inicia automaticamente no minuto 15.": "Exemple : si le webinaire commence à 20 h et qu'une personne arrive à 20 h 15, la vidéo démarre automatiquement à la 15e minute.",
  "Exemplo: StatsCard": "Exemple : StatsCard",
  "Exiba alertas de compras para gerar prova social em tempo real.": "Affichez des notifications d'achat pour générer de la preuve sociale en temps réel.",
  "Exiba imagens ou GIFs em momentos estratégicos do vídeo para reforçar a atenção": "Affichez des images ou des GIF à des moments stratégiques de la vidéo pour renforcer l'attention",
  "Exiba imagens ou GIFs em momentos estratégicos.": "Affichez des images ou des GIF à des moments stratégiques.",
  "Exiba legendas sincronizadas no seu vídeo. Suporta arquivos .SRT e .VTT.": "Affichez des sous-titres synchronisés sur votre vidéo. Accepte les fichiers .SRT et .VTT.",
  "Exiba provas sociais de compras recentes enquanto o vídeo roda": "Affichez des preuves sociales d'achats récents pendant la lecture de la vidéo",
  "Exiba sua logomarca sobre o vídeo e aumente a visibilidade da sua marca.": "Affichez votre logo sur la vidéo et augmentez la visibilité de votre marque.",
  "Exiba sua logomarca sobre o vídeo.": "Affichez votre logo sur la vidéo.",
  "Exiba um botão de ação durante o vídeo de entrada.": "Affichez un bouton d'action pendant la vidéo d'entrée.",
  "Exiba um botão de ação durante o vídeo de saída.": "Affichez un bouton d'action pendant la vidéo de sortie.",
  "Exiba uma ou mais imagens/GIFs em momentos estratégicos do vídeo para reforçar a atenção.": "Affichez une ou plusieurs images/GIF à des moments stratégiques de la vidéo pour renforcer l'attention.",
  "Exibe a barra de progresso na parte inferior do player": "Affiche la barre de progression en bas du lecteur",
  "Exibe a barra inferior com os controles do player. Quando desativada, os controles ficam ocultos mesmo com o tema personalizado.": "Affiche la barre inférieure avec les commandes du lecteur. Lorsqu'elle est désactivée, les commandes restent masquées même avec le thème personnalisé.",
  "Exibe a headline diretamente sobre o vídeo.": "Affiche le titre directement sur la vidéo.",
  "Exibe a logo HostVSL e ativa seu link de afiliado.": "Affiche le logo HostVSL et active votre lien affilié.",
  "Exibe a logo da HostVSL no player e ativa o redirecionamento pelo seu link": "Affiche le logo HostVSL dans le lecteur et active la redirection via votre lien",
  "Exibe controle deslizante de volume no player": "Affiche un curseur de volume dans le lecteur",
  "Exibe miniaturas do vídeo ao passar o mouse na barra de progresso. Requer controles do player ativos (não funciona com a barra fake). Disponível apenas em vídeos processados após esta atualização.": "Affiche des miniatures au survol de la barre de progression. Nécessite les commandes du lecteur actives et ne fonctionne pas avec la barre fictive. Disponible uniquement pour les vidéos traitées après cette mise à jour.",
  "Exibe modal para retomar reprodução de onde o usuário parou.": "Affiche une fenêtre permettant de reprendre la lecture là où l'utilisateur s'était arrêté.",
  "Exibe notificações de compra no player.": "Affiche des notifications d'achat dans le lecteur.",
  "Exibe ou oculta os controles do player (play, pause, volume, etc.)": "Affiche ou masque les commandes du lecteur (lecture, pause, volume, etc.)",
  "Exibe sua logomarca sobre o vídeo.": "Affiche votre logo sur la vidéo.",
  "Exibe um botão para abrir o vídeo em uma janela flutuante (PiP), permitindo que o espectador continue assistindo enquanto navega em outras abas.": "Affiche un bouton pour ouvrir la vidéo dans une fenêtre flottante (PiP), afin de continuer à regarder tout en consultant d'autres onglets.",
  "Exibe um botão permitindo que o usuário pule o preenchimento do formulário e continue assistindo o vídeo": "Affiche un bouton permettant de passer le formulaire et de continuer à regarder la vidéo",
  "Exibe um contador de pessoas assistindo no player.": "Affiche un compteur de spectateurs dans le lecteur.",
  "Exibe uma barra visual no rodapé do player durante a reprodução.": "Affiche une barre visuelle en bas du lecteur pendant la lecture.",
  "Exibe uma contagem regressiva ao final do vídeo e redireciona automaticamente.": "Affiche un compte à rebours à la fin de la vidéo et redirige automatiquement.",
  "Exibe uma imagem estática no lugar do player": "Affiche une image fixe à la place du lecteur",
  "Exibe uma mensagem sutil informando que o vídeo iniciou automaticamente.": "Affiche un message discret indiquant que la vidéo a démarré automatiquement.",
  "Exibido antes do principal para preparar o espectador.": "Affichée avant la vidéo principale pour préparer le spectateur.",
  "Exibido após o principal para apresentar sua oferta.": "Affichée après la vidéo principale pour présenter votre offre.",
  "Exibir Vídeo Original": "Afficher la vidéo d'origine",
  "Exibir barra": "Afficher la barre",
  "Exibir barra de controles": "Afficher la barre de commandes",
  "Exibir borda": "Afficher la bordure",
  "Exibir botão": "Afficher le bouton",
  "Exibir botão de CTA abaixo do vídeo": "Afficher un bouton CTA sous la vidéo",
  "Exibir contador regressivo": "Afficher le compte à rebours",
  "Exibir contagem regressiva": "Afficher le compte à rebours",
  "Exibir countdown antes do formulário": "Afficher un compte à rebours avant le formulaire",
  "Exibir depoimento": "Afficher le témoignage",
  "Exibir em (minutos:segundos)": "Afficher à (minutes:secondes)",
  "Exibir esta primeiro": "Afficher celle-ci en premier",
  "Exibir legenda por padrão": "Afficher les sous-titres par défaut",
  "Exibir logo também no mobile": "Afficher également le logo sur mobile",
  "Exibir o formulário em um momento específico do vídeo": "Afficher le formulaire à un moment précis de la vidéo",
  "Exibir selos de segurança": "Afficher les badges de sécurité",
  "Exibir senha em um momento específico": "Afficher le mot de passe à un moment précis",
  "Exibir termo de consentimento": "Afficher le texte de consentement",
  "Exibir texto sobre o banner": "Afficher du texte sur la bannière",
  "Exibir título": "Afficher le titre",
  "Exibir vídeo original": "Afficher la vidéo d'origine",
  "Exibição": "Affichage",
  "Exibição e Capacidade": "Affichage et capacité",
  "Exibição por Dispositivo": "Affichage par appareil",
  "Exibição por dispositivo": "Affichage par appareil",
  "Exibição por dispositivo atualizada": "Affichage par appareil mis à jour",
  "Exibição:": "Affichage :",
  "Exibições de entrada": "Affichages de la vidéo d'entrée",
  "Exibições de saída": "Affichages de la vidéo de sortie",
  "Expanda seu formulário com informações complementares": "Enrichissez votre formulaire avec des informations complémentaires",
  "Experimente storytelling": "Essayez la narration",
  "Experiência Nativa": "Expérience native",
  "Experiência imersiva": "Expérience immersive",
  "Experiência mais clara para reduzir erros e acelerar decisões": "Une expérience plus claire pour réduire les erreurs et accélérer les décisions",
  "Experiência mais fluida para a sua audiência": "Une expérience plus fluide pour votre audience",
  "Expira em": "Expire le",
  "Expirada": "Expirée",
  "Expirado": "Expiré",
  "Expiração do Link": "Expiration du lien",
  "Explicação das métricas": "Explication des indicateurs",
  "Exportando dados": "Exportation des données",
  "Exportar": "Exporter",
  "Exportar CSV": "Exporter le CSV",
  "Exportar CSV (linha)": "Exporter le CSV (ligne)",
  "Exportar Dados": "Exporter les données",
  "Exportar Extrato CSV": "Exporter le relevé CSV",
  "Exportar PDF": "Exporter le PDF",
  "Exportação concluída com sucesso!": "Exportation terminée avec succès !",
  "Exporte o histórico de eventos em CSV para seus relatórios": "Exportez l'historique des événements en CSV pour vos rapports",
  "Exporte os dados em CSV para usar em relatórios e rotinas de otimização": "Exportez les données en CSV pour vos rapports et vos processus d'optimisation",
  "Expressão Regular (Regex)": "Expression régulière (Regex)",
  "Expressão regex inválida": "Expression régulière invalide",
  "Extra grande": "Très grand",
  "Extra-negrito": "Extra-gras",
  "Extrato Administrativo": "Relevé administratif",
  "Extrato exportado!": "Relevé exporté !",
  "Extratos e Saques": "Relevés et retraits",
  "Extremamente rápido": "Extrêmement rapide",
  "Facebook": "Facebook",
  "Facilite o controle de tempo durante a reprodução.": "Facilitez le suivi du temps pendant la lecture.",
  "Fade In": "Apparition en fondu",
  "Fade suave": "Fondu doux",
  "Fade-in": "Apparition en fondu",
  "Failed to get canvas context": "Impossible d'obtenir le contexte du canvas",
  "Faixa de urgência": "Bandeau d'urgence",
  "Faixa de urgência e barra de progresso acima da oferta.": "Bandeau d'urgence et barre de progression au-dessus de l'offre.",
  "Falar com especialista": "Parler à un spécialiste",
  "Falar no WhatsApp": "Contacter sur WhatsApp",
  "Falar no chat": "Contacter par chat",
  "Fale com nossa equipe e resolva em poucos minutos.": "Contactez notre équipe pour résoudre le problème en quelques minutes.",
  "Fale com nossa equipe.": "Contactez notre équipe.",
  "Fale conosco no WhatsApp": "Contactez-nous sur WhatsApp",
  "Falha ao baixar {value0}: HTTP {value1}{value2}": "Échec du téléchargement de {value0} : HTTP {value1}{value2}",
  "Falha ao carregar o módulo Picker": "Échec du chargement du module Picker",
  "Falha ao carregar o player": "Échec du chargement du lecteur",
  "Falha ao carregar o vídeo": "Échec du chargement de la vidéo",
  "Falha ao carregar vídeo": "Échec du chargement de la vidéo",
  "Falha ao carregar {value0}": "Échec du chargement de {value0}",
  "Falha ao criar o teste": "Échec de la création du test",
  "Falha ao criar teste": "Échec de la création du test",
  "Falha ao enviar": "Échec de l'envoi",
  "Falha ao salvar alterações": "Échec de l'enregistrement des modifications",
  "Falha ao salvar configuração.": "Échec de l'enregistrement de la configuration.",
  "Falha ao subir a imagem. Tente novamente.": "Échec de l'envoi de l'image. Réessayez.",
  "Falha em {value0}": "Échec dans {value0}",
  "Falha no envio: {value0}": "Échec de l'envoi : {value0}",
  "Falha no processamento": "Échec du traitement",
  "Falhou": "Échec",
  "Falta resolver": "À résoudre",
  "Família da Fonte": "Famille de police",
  "Fantasma": "Fantôme",
  "Faturamento": "Chiffre d'affaires",
  "Favicon": "Favicon",
  "Favicon otimizado": "Favicon optimisé",
  "Favicon preview": "Aperçu du favicon",
  "Favoritos": "Favoris",
  "Fazer Upload e Solicitar Verificação": "Envoyer et demander une vérification",
  "Faça login aqui": "Connectez-vous ici",
  "Faça login para gerenciar testes de velocidade.": "Connectez-vous pour gérer les tests de vitesse.",
  "Faça o upgrade agora e continue usando a HostVSL com player premium, recursos de conversão e mais limite de plays.": "Passez au forfait supérieur et continuez à utiliser HostVSL avec le lecteur premium, les fonctionnalités de conversion et une limite de lectures plus élevée.",
  "Faça perguntas diretas ao espectador em momentos de queda para reconquistar a atenção.": "Posez des questions directes au spectateur aux moments de décrochage pour regagner son attention.",
  "Faça sessões e botões surgirem no momento exato do vídeo.": "Faites apparaître les sections et les boutons au moment précis de la vidéo.",
  "Faça seu site, gere textos persuasivos em segundos, potencialize o relacionamento com seu público por Whatsapp, Instagram, e-mail, SMS e converta mais com a leadlovers!": "Créez votre site, générez des textes persuasifs en quelques secondes, renforcez votre relation avec le public via WhatsApp, Instagram, e-mail et SMS, puis convertissez davantage avec leadlovers !",
  "Faça uma nova conta de parceiro e gere a sua conta de parceiro.": "Créez un nouveau compte partenaire et générez votre compte partenaire.",
  "Faça upload de um ícone personalizado (opcional)": "Importez une icône personnalisée (facultatif)",
  "Faça upload do primeiro vídeo para começar": "Importez la première vidéo pour commencer",
  "Faça upload do seu primeiro vídeo e ajuste as configurações iniciais.": "Importez votre première vidéo et ajustez les paramètres initiaux.",
  "Faça upload do seu vídeo": "Importez votre vidéo",
  "Fecha o vídeo com uma ação clara": "Termine la vidéo avec une action claire",
  "Fechamento bloqueado por": "Fermeture bloquée pendant",
  "Fechando automaticamente...": "Fermeture automatique...",
  "Fechar": "Fermer",
  "Fechar Interpretação": "Fermer l'interprétation",
  "Fechar Janela": "Fermer la fenêtre",
  "Fechar automaticamente": "Fermer automatiquement",
  "Fechar automaticamente após envio bem-sucedido": "Fermer automatiquement après un envoi réussi",
  "Fechar e voltar ao vídeo": "Fermer et revenir à la vidéo",
  "Fechar recursos": "Fermer les fonctionnalités",
  "Fechar sem copiar": "Fermer sans copier",
  "Fechar tour": "Fermer la visite guidée",
  "Feed": "Fil d'actualité",
  "Feed de vídeos": "Fil des vidéos",
  "Feed de vídeos com filtros inteligentes": "Fil des vidéos avec filtres intelligents",
  "Feedback do Vídeo": "Avis sur la vidéo",
  "Feedback do Vídeo salvo": "Avis sur la vidéo enregistré",
  "Ferramentas": "Outils",
  "Ferramentas Administrativas": "Outils administratifs",
  "Ferramentas de Administrador": "Outils d'administration",
  "Ferramentas · AdSniper": "Outils · AdSniper",
  "Ficará disponível como um vídeo enviado por você.": "Elle sera disponible comme une vidéo que vous avez envoyée.",
  "Filled": "Rempli",
  "Filtrar": "Filtrer",
  "Filtrar por Provedor": "Filtrer par fournisseur",
  "Filtrar por período": "Filtrer par période",
  "Filtrar por status": "Filtrer par statut",
  "Filtros": "Filtres",
  "Filtros Avançados": "Filtres avancés",
  "Filtros avançados por nicho, formato e tempo no ar": "Filtres avancés par secteur, format et durée de diffusion",
  "Filtros de Período": "Filtres de période",
  "Filtros por UTM (origem, campanha, conteúdo, etc.) para barrar tráfego de espionagem": "Filtres UTM (source, campagne, contenu, etc.) pour bloquer le trafic d'espionnage",
  "Fim": "Fin",
  "Fim da oferta (opcional)": "Fin de l'offre (facultative)",
  "Fim da oferta deve ser após o início": "La fin de l'offre doit être postérieure au début",
  "Fim do dia": "Fin de journée",
  "Final": "Fin",
  "Final (min:seg)": "Fin (min:sec)",
  "Final (opcional)": "Fin (facultative)",
  "Final do período": "Fin de la période",
  "Finalizado": "Terminé",
  "Finalizados": "Terminés",
  "Finalizando em breve:": "Se termine bientôt :",
  "Finalizando processamento de dados": "Finalisation du traitement des données",
  "Finalizar": "Terminer",
  "Finalizar Teste": "Terminer le test",
  "Finalizar Teste de Introduções?": "Terminer le test d'introductions ?",
  "Finalizar agora?": "Terminer maintenant ?",
  "Finalizar automaticamente": "Terminer automatiquement",
  "Finalizar teste": "Terminer le test",
  "Finalizar teste A/B?": "Terminer le test A/B ?",
  "Finalizar teste de intros?": "Terminer le test d'intros ?",
  "Finalize sua configuração para ativar o rastreamento.": "Terminez la configuration pour activer le suivi.",
  "Financeiro": "Financier",
  "Finanças": "Finances",
  "Firefox": "Firefox",
  "Fluxo": "Parcours",
  "Fluxo de Estado - Zustand Stores": "Flux d'état - Stores Zustand",
  "Fluxo excluído.": "Parcours supprimé.",
  "Fluxo não encontrado": "Parcours introuvable",
  "Fluxo publicado": "Parcours publié",
  "Fluxo renomeado.": "Parcours renommé.",
  "Fonte": "Police",
  "Fonte (Source)": "Source",
  "Fonte:": "Source :",
  "Fontes de Tráfego (UTM)": "Sources de trafic (UTM)",
  "Fontes de Tráfego (UTMs)": "Sources de trafic (UTM)",
  "Footer com navegação": "Pied de page avec navigation",
  "Fora (acima do formulário)": "À l'extérieur (au-dessus du formulaire)",
  "Form de mudança da quantidade de clicks do usuário. É um valor numérico manipulável diretamente.": "Formulaire de modification du nombre de clics de l'utilisateur. Il s'agit d'une valeur numérique modifiable directement.",
  "Form de mudança de nível do usuário. Ela é setada com o nível atual do usuário automaticamente.": "Formulaire de modification du niveau de l'utilisateur. Il est automatiquement renseigné avec le niveau actuel de l'utilisateur.",
  "Form de mudança de status do usuário, aceitando os parâmetros operacionais de Ativo (A) ou Desativado (D).": "Formulaire de modification du statut de l'utilisateur, acceptant les paramètres opérationnels Actif (A) ou Désactivé (D).",
  "Form de mudança do plano/subscription do usuário, exibindo dinamicamente o nome do plano atual.": "Formulaire de modification du forfait ou de l'abonnement de l'utilisateur, affichant dynamiquement le nom du forfait actuel.",
  "Forma": "Forme",
  "Forma de Pagamento": "Moyen de paiement",
  "Forma de pagamento": "Moyen de paiement",
  "Forma do Botão": "Forme du bouton",
  "Formas de Pagamento": "Moyens de paiement",
  "Formato": "Format",
  "Formato AIDA adaptado": "Méthode AIDA adaptée",
  "Formato da Imagem": "Format de l'image",
  "Formato da mensagem": "Format du message",
  "Formato de arquivo não suportado. Use MP4, MOV, WEBM ou AVI.": "Format de fichier non pris en charge. Utilisez MP4, MOV, WEBM ou AVI.",
  "Formato de resposta inesperado do servidor.": "Format de réponse du serveur inattendu.",
  "Formato do vídeo": "Format de la vidéo",
  "Formato inválido": "Format invalide",
  "Formato inválido. Use JPG, PNG, WEBP ou GIF.": "Format invalide. Utilisez JPG, PNG, WEBP ou GIF.",
  "Formato inválido. Use PNG, JPG ou GIF.": "Format invalide. Utilisez PNG, JPG ou GIF.",
  "Formato inválido. Use algo como seudominio.com.br.": "Format invalide. Utilisez une adresse comme seudominio.com.br.",
  "Formato não suportado": "Format non pris en charge",
  "Formato não suportado. Use MP4, MOV ou WEBM.": "Format non pris en charge. Utilisez MP4, MOV ou WEBM.",
  "Formato não suportado. Use PNG ou JPG": "Format non pris en charge. Utilisez PNG ou JPG",
  "Formato não suportado. Use PNG ou JPG.": "Format non pris en charge. Utilisez PNG ou JPG.",
  "Formato: minutos:segundos (exemplo: 00:15 para 15 segundos)": "Format : minutes:secondes (exemple : 00:15 pour 15 secondes)",
  "Formatos aceitos: .VTT, .SRT": "Formats acceptés : .VTT, .SRT",
  "Formatos aceitos: MP4, MOV, AVI": "Formats acceptés : MP4, MOV, AVI",
  "Formatos aceitos: MP4, MOV, WEBM • até 5GB • H.264 recomendado": "Formats acceptés : MP4, MOV, WEBM • jusqu'à 5 Go • H.264 recommandé",
  "Formatos suportados": "Formats pris en charge",
  "Formatos suportados: MP4, MOV, AVI • Máximo 500MB": "Formats pris en charge : MP4, MOV, AVI • Maximum 500 Mo",
  "Formulário": "Formulaire",
  "Formulário não disponível para esta integração.": "Formulaire indisponible pour cette intégration.",
  "Formulário vertical": "Formulaire vertical",
  "Fornece recursos para intermediar a relação entre consumidores, afiliados e produtores.": "Fournit des outils pour faciliter la relation entre consommateurs, affiliés et producteurs.",
  "Fortaleça sua narrativa": "Renforcez votre narration",
  "Forte": "Fort",
  "Força da senha": "Robustesse du mot de passe",
  "Forçando atualização...": "Mise à jour forcée...",
  "Forçar Atualização": "Forcer la mise à jour",
  "Forçar atualização completa (limpa cache e recarrega)": "Forcer une mise à jour complète (vider le cache et recharger)",
  "Foto alterada": "Photo modifiée",
  "Foto removida": "Photo supprimée",
  "Français": "Français",
  "Freelancers e Profissionais": "Freelances et professionnels",
  "Frente do Documento (Com Foto)": "Recto du document (avec photo)",
  "Frequência": "Fréquence",
  "Frequência ({value}s)": "Fréquence ({value}s)",
  "Frequência de geração de sessões": "Fréquence de génération des sessions",
  "Funciona Offline": "Fonctionne hors ligne",
  "Funciona ao final da reprodução do vídeo.": "Fonctionne à la fin de la lecture vidéo.",
  "Funciona com AirPlay no Safari (iPhone, iPad, Mac)": "Fonctionne avec AirPlay dans Safari (iPhone, iPad, Mac)",
  "Funciona com Chromecast no Chrome/Edge (Windows, Mac, Android)": "Fonctionne avec Chromecast dans Chrome/Edge (Windows, Mac, Android)",
  "Funciona com a Page Visibility API para máxima compatibilidade": "Utilise Page Visibility API pour une compatibilité maximale",
  "Funciona quando o visitante troca de aba ou minimiza o navegador.": "Fonctionne lorsque le visiteur change d'onglet ou réduit le navigateur.",
  "Funcionalidade de duplicação em breve.": "La fonctionnalité de duplication sera bientôt disponible.",
  "Funcionalidade de excluir em desenvolvimento": "Fonctionnalité de suppression en développement",
  "Funcionalidade em desenvolvimento": "Fonctionnalité en développement",
  "Funcionalidades:": "Fonctionnalités :",
  "Fundo": "Fond",
  "Fundo (Hover)": "Fond (survol)",
  "Fundo Botão": "Fond du bouton",
  "Fundo Sólido": "Fond uni",
  "Fundo botão play": "Fond du bouton de lecture",
  "Fundo botão restart": "Fond du bouton de reprise",
  "Fundo colorido": "Fond coloré",
  "Fundo com blur": "Fond flouté",
  "Fundo da Headline": "Fond du titre",
  "Fundo de cards": "Fond des cartes",
  "Fundo de switch cards": "Fond des cartes à interrupteur",
  "Fundo do overlay": "Fond de la superposition",
  "Fundo principal": "Fond principal",
  "Fundo:": "Fond :",
  "Funil": "Tunnel",
  "Funil Dinâmico": "Tunnel dynamique",
  "Funil de Conversão": "Tunnel de conversion",
  "Funil de Conversão nas Métricas": "Tunnel de conversion dans les indicateurs",
  "Funil de Vídeo": "Tunnel vidéo",
  "Funil de Vídeos": "Tunnel de vidéos",
  "Funil de Vídeos (Dinâmico)": "Tunnel de vidéos (dynamique)",
  "Funil dinâmico": "Tunnel dynamique",
  "Função de ativar/desativar em desenvolvimento.": "Fonction d'activation/désactivation en développement.",
  "Função de duplicar em desenvolvimento.": "Fonction de duplication en développement.",
  "Fuso Horário": "Fuseau horaire",
  "Fuso atual:": "Fuseau actuel :",
  "Futuras Integrações": "Intégrations à venir",
  "GIF animado": "GIF animé",
  "GIF otimizado • {n}% mais leve": "GIF optimisé • {n}% plus léger",
  "GIF pesado pode impactar a fluidez do preview.": "Un GIF volumineux peut nuire à la fluidité de l'aperçu.",
  "GIFs otimizados deixam o Mini-Hook mais fluido.": "Les GIF optimisés rendent le Mini-Hook plus fluide.",
  "Ganhe 20% de comissão sobre tudo enquanto o cliente estiver ativo.": "Gagnez 20% de commission sur tout tant que le client reste actif.",
  "Ganhe comissão recorrente": "Gagnez une commission récurrente",
  "Ganhe de Forma Recorrente com o Programa de Parcerias Host VSL": "Gagnez des revenus récurrents avec le programme de partenariat Host VSL",
  "Ganhe de forma recorrente indicando a plataforma nº1 de VSLs do Brasil": "Gagnez des revenus récurrents en recommandant la plateforme de VSL nº1 au Brésil",
  "Ganhos Estimados": "Gains estimés",
  "Garanta essa condição especial agora": "Profitez de cette offre spéciale maintenant",
  "Garanta maior retenção iniciando o vídeo automaticamente.": "Améliorez la rétention en lançant automatiquement la vidéo.",
  "Garanta que cada segundo do seu vídeo seja assistido.": "Faites en sorte que chaque seconde de votre vidéo soit regardée.",
  "Garantir minha vaga": "Réserver ma place",
  "Gargalo": "Goulot d'étranglement",
  "Georgia": "Georgia",
  "Gerado automaticamente": "Généré automatiquement",
  "Gerando PDF...": "Génération du PDF...",
  "Gerando link público": "Génération du lien public",
  "Gerando token...": "Génération du jeton...",
  "Gerando...": "Génération...",
  "Gerar Análise": "Générer une analyse",
  "Gerar Miniatura": "Générer une miniature",
  "Gerar novo token": "Générer un nouveau jeton",
  "Gere links de compartilhamento para que afiliados copiem seus vídeos rapidamente.": "Générez des liens de partage pour que les affiliés puissent copier rapidement vos vidéos.",
  "Gere um link compartilhável para qualquer vídeo original do seu painel": "Générez un lien partageable pour toute vidéo d'origine de votre panneau",
  "Gerencia tema light/dark/auto": "Gère les thèmes clair/sombre/auto",
  "Gerenciar": "Gérer",
  "Gerenciar Incremento de Clicks": "Gérer les ajouts de clics",
  "Gerenciar Ofertas": "Gérer les offres",
  "Gerenciar compartilhamentos": "Gérer les partages",
  "Gerenciar formulários não enviados": "Gérer les formulaires non envoyés",
  "Gerenciar rastreamento": "Gérer le suivi",
  "Gerencie e visualize seus últimos vídeos": "Gérez et consultez vos dernières vidéos",
  "Gerencie o status da solicitação de saque.": "Gérez le statut de la demande de retrait.",
  "Gerencie os membros da sua equipe. Defina permissões de acesso por feature e por pasta.": "Gérez les membres de votre équipe. Définissez les autorisations d'accès par fonctionnalité et par dossier.",
  "Gerencie os tipos de alertas que você deseja receber sobre suas métricas e conversões": "Gérez les types d'alertes à recevoir sur vos indicateurs et conversions",
  "Gerencie pagamentos, solicitações e repasses da rede de afiliados.": "Gérez les paiements, les demandes et les versements du réseau d'affiliés.",
  "Gerencie seus cartões e métodos de pagamento": "Gérez vos cartes et moyens de paiement",
  "Gerencie suas informações pessoais, segurança e preferências da conta.": "Gérez vos informations personnelles, la sécurité et les préférences du compte.",
  "Gerencie suas plataformas de venda integradas": "Gérez vos plateformes de vente intégrées",
  "Gerencie, pesquise e organize sua biblioteca de vídeos": "Gérez, recherchez et organisez votre bibliothèque vidéo",
  "Gestão com pastas": "Gestion par dossiers",
  "Gestão de Custos": "Gestion des coûts",
  "Gestão de leads integrada ao funil": "Gestion des leads intégrée au tunnel",
  "Go to next page": "Aller à la page suivante",
  "Go to previous page": "Aller à la page précédente",
  "Google Ads": "Google Ads",
  "Google Drive": "Google Drive",
  "Google Identity Services não disponível": "Google Identity Services indisponible",
  "Google Picker não disponível": "Google Picker indisponible",
  "Grade": "Grille",
  "Gradiente": "Dégradé",
  "Grande": "Grand",
  "Gráfico de Momento de Conversão no Vídeo para identificar os pontos de maior interesse": "Graphique des moments de conversion dans la vidéo pour identifier les passages suscitant le plus d'intérêt",
  "Gráfico de retenção": "Graphique de rétention",
  "Gráfico de visualizações": "Graphique des vues",
  "Gráfico opcional": "Graphique facultatif",
  "Gráficos": "Graphiques",
  "Grátis, Segredo, Exclusivo, Novo": "Gratuit, Secret, Exclusif, Nouveau",
  "Guia": "Guide",
  "Guia completo para criar headlines impactantes que convertem": "Guide complet pour créer des titres percutants qui convertissent",
  "Guia de Desenvolvimento": "Guide de développement",
  "Guia prático para desenvolver novas features na HostVSL seguindo os padrões estabelecidos.": "Guide pratique pour développer de nouvelles fonctionnalités dans HostVSL selon les conventions établies.",
  "Guia técnico completo • Última atualização:": "Guide technique complet • Dernière mise à jour :",
  "Guias de snap para alinhamento preciso (centro, bordas)": "Repères d'alignement précis (centre, bords)",
  "HD": "HD",
  "HTML Personalizado": "HTML personnalisé",
  "HTML contains potentially dangerous content": "Le HTML contient du contenu potentiellement dangereux",
  "HTML content too long (max 10,000 characters)": "Contenu HTML trop long (10.000 caractères maximum)",
  "HTML input must be a non-empty string": "Le HTML saisi doit être une chaîne non vide",
  "HTML personalizado": "HTML personnalisé",
  "Habilita a personalização de bordas ao redor do vídeo.": "Active la personnalisation des bordures autour de la vidéo.",
  "Habilita a sincronização inteligente de ações com o vídeo": "Active la synchronisation intelligente des actions avec la vidéo",
  "Habilita o botão de ação no vídeo selecionado": "Active le bouton d'action sur la vidéo sélectionnée",
  "Habilitados": "Activés",
  "Habilitar botão de pular": "Activer le bouton Passer",
  "Habilitar sorteio": "Activer le tirage au sort",
  "Headline": "Titre",
  "Headline Principal": "Titre principal",
  "Headline não ativada": "Titre non activé",
  "Headline por Dispositivo": "Titre par appareil",
  "Headline: \"": "Titre : «",
  "Headlines são textos chamativos que aparecem sobre o vídeo para capturar atenção, transmitir uma mensagem principal e incentivar o espectador a continuar assistindo. Subheadlines complementam com informações adicionais.": "Les titres sont des textes accrocheurs affichés sur la vidéo pour attirer l'attention, transmettre un message principal et inciter le spectateur à continuer à regarder. Les sous-titres apportent des informations complémentaires.",
  "Heatmap de horários": "Carte de chaleur des horaires",
  "Heatmap refinado com cores suavizadas, legenda de intensidade e tooltips premium com sombra unificada.": "Carte de chaleur affinée avec couleurs adoucies, légende d'intensité et infobulles premium avec ombre unifiée.",
  "Herdando valores do Desktop. Altere para personalizar.": "Valeurs héritées de la version ordinateur. Modifiez-les pour personnaliser.",
  "Hero": "Hero",
  "Hero Banner": "Bannière principale",
  "Histórias pessoais ou cases de clientes geram mais conexão emocional e aumentam o interesse inicial.": "Les histoires personnelles ou les témoignages de clients créent un lien émotionnel plus fort et augmentent l'intérêt initial.",
  "Histórico de Eventos": "Historique des événements",
  "Histórico de Faturas": "Historique des factures",
  "Histórico de Saques": "Historique des retraits",
  "Histórico de Testes": "Historique des tests",
  "Histórico de ações e eventos do sistema.": "Historique des actions et événements du système.",
  "Histórico de melhorias e novas funcionalidades implementadas na plataforma. Esta seção é atualizada automaticamente quando novas features são adicionadas.": "Historique des améliorations et des nouvelles fonctionnalités de la plateforme. Cette section est mise à jour automatiquement lors de l'ajout de fonctionnalités.",
  "Hoje": "Aujourd'hui",
  "Home": "Accueil",
  "Hora do dia": "Heure de la journée",
  "Horizontal (campos lado a lado)": "Horizontal (champs côte à côte)",
  "Horizontal (→)": "Horizontal (→)",
  "Horário": "Horaire",
  "Horário Mais Consistente": "Horaire le plus régulier",
  "Horário Mais Consistente (": "Horaire le plus régulier (",
  "Horário Mais Consistente (Conversão)": "Horaire le plus régulier (conversion)",
  "Horário Mais Consistente (Volume)": "Horaire le plus régulier (volume)",
  "Horário campeão do período": "Meilleur horaire de la période",
  "Horário com maior volume de espectadores": "Horaire avec le plus grand nombre de spectateurs",
  "Horário com mais espectadores": "Horaire avec le plus de spectateurs",
  "Horário de funcionamento das sessões": "Horaires de fonctionnement des sessions",
  "Horário de início é obrigatório": "L'heure de début est obligatoire",
  "Horário detectado:": "Horaire détecté :",
  "Horários": "Horaires",
  "Horários alternativos recomendados": "Autres horaires recommandés",
  "Horários de Pico": "Heures de pointe",
  "Horários de Silêncio": "Heures de silence",
  "Horários de pico": "Heures de pointe",
  "Horários de pico por tipo de acesso": "Heures de pointe par type d'accès",
  "Horários ideais por tipo de acesso": "Horaires idéaux par type d'accès",
  "Host VSL": "Host VSL",
  "Host VSL · Atualizações contínuas": "Host VSL · Mises à jour continues",
  "HostVSL": "HostVSL",
  "HostVSL Dashboard": "Tableau de bord HostVSL",
  "HostVSL Documentation v3.0 (Dinâmica) • Última atualização:": "Documentation HostVSL v3.0 (dynamique) • Dernière mise à jour :",
  "HostVSL Player - Plataforma completa para VSLs": "HostVSL Player - Plateforme complète pour VSL",
  "HostVSL é uma plataforma de hospedagem e gerenciamento de VSLs (Video Sales Letters) construída com tecnologias modernas para oferecer a melhor experiência em reprodução de vídeos de vendas.": "HostVSL est une plateforme d'hébergement et de gestion de VSL (Video Sales Letters), développée avec des technologies modernes pour offrir une expérience optimale de lecture des vidéos de vente.",
  "Hotmart": "Hotmart",
  "Houve uma instabilidade ao processar arquivos.": "Une instabilité est survenue lors du traitement des fichiers.",
  "Hover": "Survol",
  "Hover Fundo": "Fond au survol",
  "Hover Texto": "Texte au survol",
  "Há 2 horas": "Il y a 2 heures",
  "Há limite de indicações?": "Le nombre de parrainages est-il limité ?",
  "Há parâmetros com o mesmo nome.": "Certains paramètres portent le même nom.",
  "ID": "ID",
  "ID Usuário": "ID utilisateur",
  "ID Usuário:": "ID utilisateur :",
  "ID copiado!": "ID copié !",
  "ID da assinatura não encontrado.": "Identifiant d'abonnement introuvable.",
  "ID da plataforma não encontrado": "Identifiant de plateforme introuvable",
  "ID da regra": "Identifiant de la règle",
  "ID de conversão inválido. Use AW-123456789.": "Identifiant de conversion invalide. Utilisez AW-123456789.",
  "ID do Afiliado": "ID de l'affilié",
  "ID do Pixel": "ID du pixel",
  "ID do Pixel *": "ID du pixel *",
  "ID do Plano": "ID du forfait",
  "ID do Vídeo": "ID de la vidéo",
  "ID do cliente Stripe não encontrado": "Identifiant du client Stripe introuvable",
  "ID do pagamento não fornecido.": "Identifiant du paiement non fourni.",
  "ID do payout": "ID du versement",
  "ID do usuário não encontrado": "Identifiant utilisateur introuvable",
  "ID do vídeo não encontrado": "Identifiant vidéo introuvable",
  "ID do vídeo não encontrado.": "Identifiant vidéo introuvable.",
  "ID único do vídeo": "Identifiant unique de la vidéo",
  "ID:": "ID :",
  "IDIOMAS": "LANGUES",
  "INÍCIO": "DÉBUT",
  "IP": "IP",
  "Id de etapa inválido": "Identifiant d'étape invalide",
  "Id de opção inválido": "Identifiant d'option invalide",
  "Id de saída inválido": "Identifiant de sortie invalide",
  "Id repetido: {value0}": "ID répété : {value0}",
  "Ideal para aulas e conteúdos rápidos.": "Idéal pour les cours et les contenus courts.",
  "Ideal para campanhas em escala": "Idéal pour les campagnes à grande échelle",
  "Ideal para tráfego quente e vídeos curtos": "Idéal pour le trafic qualifié et les vidéos courtes",
  "Ideal para vídeos corporativos e educacionais": "Idéal pour les vidéos d'entreprise et éducatives",
  "Ideal para vídeos de vitrine, demonstrações e VSLs em loop.": "Idéal pour les vidéos de présentation, les démonstrations et les VSL en boucle.",
  "Ideias personalizadas para otimizar \"": "Idées personnalisées pour optimiser «",
  "Identidade": "Identité",
  "Identidade Visual": "Identité visuelle",
  "Identificamos uma retenção preventiva temporária ou simulação técnica em sua conta Connect. Nossa engenharia interna está validando os repasses junto à Stripe Connect. Nenhuma ação manual é necessária.": "Nous avons détecté une retenue préventive temporaire ou une simulation technique sur votre compte Connect. Notre équipe technique vérifie les versements avec Stripe Connect. Aucune action manuelle n'est nécessaire.",
  "Identificação": "Identification",
  "Identificação da Ação": "Identification de l'action",
  "Identifique a melhor introdução para seu vídeo.": "Identifiez la meilleure introduction pour votre vidéo.",
  "Identifique horários de pico automaticamente": "Identifiez automatiquement les heures de pointe",
  "Identifique momentos específicos onde há queda acentuada de retenção e revise o conteúdo nesses pontos.": "Identifiez les moments précis de forte baisse de rétention et revoyez le contenu à ces endroits.",
  "Identifique padrões de conversão por dia e horário": "Identifiez les tendances de conversion par jour et horaire",
  "Idioma": "Langue",
  "Idioma do navegador": "Langue du navigateur",
  "Ignorar": "Ignorer",
  "Igual a": "Égal à",
  "Igual no banco": "Identique à la banque",
  "Imagem": "Image",
  "Imagem (favicon/logo)": "Image (favicon/logo)",
  "Imagem Desktop": "Image pour ordinateur",
  "Imagem Mobile": "Image pour mobile",
  "Imagem Substituta": "Image de remplacement",
  "Imagem carregada": "Image chargée",
  "Imagem carregada com sucesso!": "Image chargée avec succès !",
  "Imagem de Capa (1920×700px recomendado)": "Image de couverture (1920×700px recommandé)",
  "Imagem de Fundo": "Image d'arrière-plan",
  "Imagem de Fundo (Opcional)": "Image d'arrière-plan (facultative)",
  "Imagem do Autoplay": "Image de l'Autoplay",
  "Imagem do Continuar de onde parou": "Image de reprise du visionnage",
  "Imagem do autoplay atualizada": "Image de l'Autoplay mise à jour",
  "Imagem estática": "Image fixe",
  "Imagem ou GIF": "Image ou GIF",
  "Imagem quadrada PNG, recomendado 256×256 px": "Image PNG carrée, 256×256 px recommandé",
  "Imagem real do momento em que os visitantes chegam ao seu vídeo": "Image réelle du moment où les visiteurs arrivent sur votre vidéo",
  "Imagem removida": "Image supprimée",
  "Imagens da Oferta": "Images de l'offre",
  "Imediato": "Immédiat",
  "Impacto:": "Impact :",
  "Impede a publicação": "Empêche la publication",
  "Impede o espectador de pausar o vídeo": "Empêche le spectateur de mettre la vidéo en pause",
  "Implementado drag-and-drop na distribuição de tráfego, badge de ordem (#1, #2, #3) nos cards de intros, e cards sortáveis com slider Radix idênticos ao Teste A/B.": "Ajout du glisser-déposer dans la répartition du trafic, de badges d'ordre (#1, #2, #3) sur les cartes d'intros et de cartes réorganisables avec curseur Radix identiques au test A/B.",
  "Implementação de registry centralizado para documentação auto-atualizada. Rotas, stores, componentes e design tokens agora são documentados dinamicamente.": "Mise en place d'un registre centralisé pour une documentation mise à jour automatiquement. Les routes, stores, composants et tokens de design sont désormais documentés dynamiquement.",
  "Implemente storytelling": "Mettez en place une narration",
  "Importando do Google Drive": "Importation depuis Google Drive",
  "Importando {value0} vídeo{value1}...": "Importation de {value0} vidéo{value1}...",
  "Importar": "Importer",
  "Importar do Drive": "Importer depuis Drive",
  "Importar vídeos": "Importer des vidéos",
  "Importar vídeos do Google Drive": "Importer des vidéos depuis Google Drive",
  "Importação de {value0} em desenvolvimento": "Importation de {value0} en développement",
  "Importe vídeos direto da sua conta Google Drive.": "Importez des vidéos directement depuis votre compte Google Drive.",
  "Impostos": "Taxes",
  "Impostos Estimados": "Taxes estimées",
  "Inativa": "Inactive",
  "Inativo": "Inactif",
  "Inativos": "Inactifs",
  "Inclui 15 dias grátis": "Comprend 15 jours gratuits",
  "Incluir botão externo": "Inclure un bouton externe",
  "Incorpore seu vídeo no site!": "Intégrez votre vidéo à votre site !",
  "Increment Clicks": "Ajouter des clics",
  "Indicado para usuários avançados. Apenas HTML simples. Scripts não são permitidos.": "Destiné aux utilisateurs avancés. HTML simple uniquement. Les scripts ne sont pas autorisés.",
  "Indicador de Disponibilidade": "Indicateur de disponibilité",
  "Indicador de fuso horário": "Indicateur du fuseau horaire",
  "Indicadores Importantes": "Indicateurs importants",
  "Indicação": "Parrainage",
  "Indicações": "Parrainages",
  "Indique Clientes": "Parrainez des clients",
  "Indique Parceiros": "Parrainez des partenaires",
  "Indique a plataforma nº1 de VSLs do Brasil e receba": "Recommandez la plateforme de VSL nº1 au Brésil et recevez",
  "Indique e Ganhe": "Parrainez et gagnez",
  "Indique e Ganhe e aumente seu valor para o Email.": "Parrainez et gagnez, et augmentez votre valeur pour l'e-mail.",
  "Inferior Centro": "En bas au centre",
  "Inferior Direita": "En bas à droite",
  "Inferior Direito": "En bas à droite",
  "Inferior Esquerda": "En bas à gauche",
  "Inferior Esquerdo": "En bas à gauche",
  "Inferior central": "En bas au centre",
  "Inferior direito": "En bas à droite",
  "Inferior esquerdo": "En bas à gauche",
  "Infinito": "Infini",
  "Influenciadores e Educadores": "Influenceurs et formateurs",
  "Informações Básicas": "Informations de base",
  "Informações Gerais": "Informations générales",
  "Informações Pessoais": "Informations personnelles",
  "Informações atualizadas com sucesso": "Informations mises à jour avec succès",
  "Informações de ajuda não disponíveis para esta etapa.": "Aucune aide disponible pour cette étape.",
  "Informações do Pagamento": "Informations de paiement",
  "Informações do vídeo": "Informations sur la vidéo",
  "Informações sobre sua assinatura e próxima cobrança": "Informations sur votre abonnement et le prochain prélèvement",
  "Informe a integration_key da Payt.": "Saisissez l'integration_key de Payt.",
  "Informe este token ao atendente para autorizar o acesso temporário à sua conta.": "Communiquez ce jeton au conseiller pour autoriser un accès temporaire à votre compte.",
  "Informe no formato mm:ss ou hh:mm:ss.": "Saisissez au format mm:ss ou hh:mm:ss.",
  "Informe o ID de conversão (AW-) e um rótulo para cada ação de conversão criada no Google Ads": "Renseignez l'identifiant de conversion (AW-) et un libellé pour chaque action de conversion créée dans Google Ads",
  "Informe o ID do pixel e o token de acesso gerados no Events Manager do TikTok": "Renseignez l'identifiant du pixel et le jeton d'accès générés dans l'Events Manager TikTok",
  "Informe o Rótulo (Label) da ação de Play do Google Ads.": "Saisissez le libellé (Label) de l'action de lecture Google Ads.",
  "Informe o código de confirmação": "Saisissez le code de confirmation",
  "Informe o token de": "Saisissez le jeton de",
  "Informe seu e-mail e enviaremos um código para redefinir sua senha.": "Saisissez votre adresse e-mail pour recevoir un code de réinitialisation du mot de passe.",
  "Informe um endereço http:// ou https:// válido.": "Saisissez une adresse http:// ou https:// valide.",
  "Informe um link válido iniciando com http:// ou https://.": "Saisissez un lien valide commençant par http:// ou https://.",
  "Informe um nome para a proteção.": "Saisissez un nom pour la protection.",
  "Informe um nome para o teste.": "Saisissez un nom pour le test.",
  "Informe um valor válido.": "Saisissez une valeur valide.",
  "Informe uma URL para ativar o redirecionamento.": "Saisissez une URL pour activer la redirection.",
  "Inicia o vídeo automaticamente ao entrar na página.": "Démarre automatiquement la vidéo à l'arrivée sur la page.",
  "Inicia o vídeo automaticamente quando o participante entra na sala.": "Démarre automatiquement la vidéo lorsque le participant entre dans la salle.",
  "Inicia o vídeo com som sozinho, sem esperar o visitante clicar no aviso do autoplay. Navegadores só liberam som automático para quem já tem histórico na página — quando bloquearem, o aviso continua na tela e o primeiro toque em qualquer lugar libera o som.": "Démarre automatiquement la vidéo avec le son, sans attendre que le visiteur clique sur le message d'Autoplay. Les navigateurs n'autorisent le son automatique qu'aux visiteurs ayant déjà interagi avec la page. En cas de blocage, le message reste affiché et le premier toucher n'importe où active le son.",
  "Iniciado em:": "Démarré le :",
  "Iniciado:": "Démarré :",
  "Iniciando...": "Démarrage...",
  "Iniciar": "Démarrer",
  "Iniciar Teste": "Démarrer le test",
  "Iniciar Teste A/B": "Démarrer le test A/B",
  "Iniciar Teste A/B?": "Démarrer le test A/B ?",
  "Iniciar sem som": "Démarrer sans son",
  "Iniciar teste grátis": "Commencer l'essai gratuit",
  "Iniciar vídeo principal automaticamente": "Démarrer automatiquement la vidéo principale",
  "Inicie com a dor principal + superação antes do depoimento": "Commencez par la difficulté principale et sa résolution avant le témoignage",
  "Inicie com problema → solução → benefício nos primeiros 30 segundos": "Commencez par problème → solution → bénéfice dans les 30 premières secondes",
  "Inicie o teste na aba 'Teste A/B' para começar a coletar métricas.": "Démarrez le test dans l'onglet « Test A/B » pour commencer à recueillir les indicateurs.",
  "Inicie o vídeo automaticamente com a melhor experiência.": "Lancez automatiquement la vidéo avec une expérience optimale.",
  "Inscrição realizada!": "Inscription effectuée !",
  "Inscrição/Plano modificado com sucesso!": "Abonnement/forfait modifié avec succès !",
  "Inserir:": "Insérer :",
  "Insight copiado!": "Analyse copiée !",
  "Insights": "Analyses",
  "Insights Automáticos": "Analyses automatiques",
  "Insights de Dispositivo": "Analyses des appareils",
  "Insira HTML simples. Scripts não são permitidos por segurança.": "Saisissez du HTML simple. Les scripts sont interdits pour des raisons de sécurité.",
  "Insira a senha para acessar o vídeo": "Saisissez le mot de passe pour accéder à la vidéo",
  "Insira ganchos curtos ao longo do vídeo para aumentar retenção e reengajar o espectador.": "Insérez de courtes accroches au fil de la vidéo pour augmenter la rétention et raviver l'attention du spectateur.",
  "Insira o nome do membro": "Saisissez le nom du membre",
  "Insira o nome que aparecerá como criador do conteúdo na Playlist": "Saisissez le nom du créateur de contenu qui apparaîtra dans la playlist",
  "Insira os dados para continuar assistindo": "Saisissez vos informations pour continuer à regarder",
  "Insira perguntas de engajamento": "Insérez des questions pour stimuler l'engagement",
  "Insira seu código HTML personalizado para o botão": "Insérez votre code HTML personnalisé pour le bouton",
  "Insira seu link de afiliado para ganhar comissões. A logo da HostVSL ficará disponível no canto superior direito do player e, ao clicar nela, seu link de afiliado será aberto em uma nova aba.": "Saisissez votre lien affilié pour gagner des commissions. Le logo HostVSL apparaîtra en haut à droite du lecteur et un clic dessus ouvrira votre lien affilié dans un nouvel onglet.",
  "Insira sua chave PIX aqui": "Saisissez votre clé PIX ici",
  "Insira um e-mail válido": "Saisissez une adresse e-mail valide",
  "Inspiração direta para suas próximas VSLs e campanhas": "Une inspiration directe pour vos prochaines VSL et campagnes",
  "Instalando...": "Installation...",
  "Instalar": "Installer",
  "Instalar Agora": "Installer maintenant",
  "Instalar HostVSL": "Installer HostVSL",
  "Instalação não disponível": "Installation indisponible",
  "Instale o HostVSL": "Installez HostVSL",
  "Instale o app para acesso rápido e funcionalidade offline": "Installez l'application pour un accès rapide et un fonctionnement hors ligne",
  "Instituição Bancária": "Établissement bancaire",
  "Instituição Bancária (Cód. Banco)": "Établissement bancaire (code banque)",
  "Instruções para iPhone/iPad": "Instructions pour iPhone/iPad",
  "Integrar rastreamento": "Intégrer le suivi",
  "Integração com APIs de inteligência artificial para criação de conteúdo.": "Intégration d'API d'intelligence artificielle pour la création de contenu.",
  "Integração com {value0} configurada com sucesso.": "Intégration avec {value0} configurée avec succès.",
  "Integração configurada com sucesso": "Intégration configurée avec succès",
  "Integração criada": "Intégration créée",
  "Integração criada. Configure o webhook na plataforma de vendas.": "Intégration créée. Configurez le webhook sur la plateforme de vente.",
  "Integração de rastreamento": "Intégration de suivi",
  "Integração nativa com VSLs e funis da Host VSL": "Intégration native avec les VSL et les tunnels Host VSL",
  "Integração não configurada": "Intégration non configurée",
  "Integração salva com sucesso": "Intégration enregistrée avec succès",
  "Integração vinculada. Vendas aprovadas são recebidas pelo webhook configurado na plataforma.": "Intégration associée. Les ventes approuvées sont reçues via le webhook configuré sur la plateforme.",
  "Integração/Real": "Intégration/Réel",
  "Integrações": "Intégrations",
  "Integrações Disponíveis": "Intégrations disponibles",
  "Integre Hotmart, Kirvano, Cakto, PerfectPay e muito mais.": "Intégrez Hotmart, Kirvano, Cakto, PerfectPay et bien plus encore.",
  "Integre plataformas de pagamento e rastreie conversões dos seus vídeos de forma simples.": "Intégrez des plateformes de paiement et suivez simplement les conversions de vos vidéos.",
  "Integre suas plataformas para acompanhar métricas de vendas e conversões.": "Intégrez vos plateformes pour suivre les indicateurs de vente et de conversion.",
  "Intensidade": "Intensité",
  "Intensidade:": "Intensité :",
  "Intenso": "Intense",
  "Inter": "Inter",
  "Inter (Modern)": "Inter (moderne)",
  "Interação": "Interaction",
  "Interação com Vídeo": "Interaction avec la vidéo",
  "Intercale o talking head com imagens, gráficos ou textos para criar variação visual e manter atenção.": "Alternez les séquences face caméra avec des images, des graphiques ou du texte pour varier les visuels et maintenir l'attention.",
  "Interface otimizada que se comporta como um app nativo": "Interface optimisée qui se comporte comme une application native",
  "Intervalo": "Intervalle",
  "Intervalo de Velocidades": "Plage de vitesses",
  "Intervalo de velocidades": "Plage de vitesses",
  "Intervalo entre sessões": "Intervalle entre les sessions",
  "Intervalo entre uma notificação e outra.": "Intervalle entre deux notifications.",
  "Intervalo testado:": "Intervalle testé :",
  "Intervalos": "Intervalles",
  "Intro #": "Intro nº",
  "Intro #{value0}": "Intro nº{value0}",
  "Intro Curiosidade": "Intro curiosité",
  "Intro Problema-Solução": "Intro problème-solution",
  "Intro Testemunho": "Intro témoignage",
  "Intro adicionada": "Intro ajoutée",
  "Intro atual": "Intro actuelle",
  "Introdução": "Introduction",
  "Introduções": "Introductions",
  "Invalid URL format": "Format d'URL invalide",
  "Invalid URL protocol": "Protocole d'URL invalide",
  "Invalid color code": "Code couleur invalide",
  "Invalid or unsafe HTML content": "Contenu HTML invalide ou non sécurisé",
  "Invalid or unsafe URL": "URL invalide ou non sécurisée",
  "Início": "Début",
  "Início (min:seg)": "Début (min:sec)",
  "Início (mm:ss)": "Début (mm:ss)",
  "Início automático:": "Démarrage automatique :",
  "Início da Sessão": "Début de la session",
  "Início da headline": "Début du titre",
  "Início da oferta": "Début de l'offre",
  "Início do dia": "Début de journée",
  "Início do período": "Début de la période",
  "Início, pausa e final podem ter imagens diferentes.": "Le début, la pause et la fin peuvent utiliser des images différentes.",
  "Início: quando as opções aparecem (vazio = fim do vídeo). Final: quando o vídeo pausa (opcional). Se o vídeo terminar sem escolha, ele congela no último quadro com as opções na tela.": "Début : apparition des options (vide = fin de la vidéo). Fin : moment de la pause vidéo (facultatif). Si la vidéo se termine sans choix, elle reste figée sur la dernière image avec les options affichées.",
  "Ir Agora": "Y aller maintenant",
  "Ir para Meus Vídeos": "Aller à Mes vidéos",
  "Ir para Vídeos Compartilhados": "Aller aux vidéos partagées",
  "Ir para pagamento": "Passer au paiement",
  "Ir para página da HostVSL (afiliado)": "Aller à la page HostVSL (affilié)",
  "Ir para site": "Aller au site",
  "Isso apaga o fluxo \"": "Cela supprime le parcours «",
  "Isso encerra o teste antes do término agendado e o tráfego volta para a VSL Principal. Esta ação não pode ser desfeita.": "Cela termine le test avant la date prévue et ramène le trafic vers la VSL principale. Cette action est irréversible.",
  "Isso interrompe o rastreamento deste vídeo. Esta ação não pode ser desfeita.": "Cela interrompt le suivi de cette vidéo. Cette action est irréversible.",
  "Italiano": "Italiano",
  "Itálico": "Italique",
  "JPG, PNG ou WEBP • Máx 2MB": "JPG, PNG ou WEBP • Max. 2 Mo",
  "JPG, PNG • até": "JPG, PNG • jusqu'à",
  "JPG, PNG, WEBP e GIF • até 20 MB": "JPG, PNG, WEBP et GIF • jusqu'à 20 Mo",
  "JS": "JS",
  "Janela Diária": "Plage quotidienne",
  "Janelas Campeãs de Conversão": "Meilleures plages de conversion",
  "Janelas Campeãs de Receita": "Meilleures plages de chiffre d'affaires",
  "JavaScript": "JavaScript",
  "Jornada de Conversão": "Parcours de conversion",
  "Jornada de Conversão salva": "Parcours de conversion enregistré",
  "João Silva": "João Silva",
  "Just-in-Time": "À la demande immédiate",
  "Já copiado:": "Déjà copié :",
  "Já copiei, fechar": "J'ai déjà copié, fermer",
  "Já disponível na personalização dos seus vídeos.": "Déjà disponible dans la personnalisation de vos vidéos.",
  "Já disponível no menu Cloaker do seu painel.": "Déjà disponible dans le menu Cloaker de votre panneau.",
  "Já disponível no menu Pixel do seu painel.": "Déjà disponible dans le menu Pixel de votre panneau.",
  "Já está disponível na personalização dos seus novos vídeos.": "Déjà disponible dans la personnalisation de vos nouvelles vidéos.",
  "Já está disponível no menu Análises do seu painel.": "Déjà disponible dans le menu Analyses de votre panneau.",
  "Já possui uma conta?": "Vous avez déjà un compte ?",
  "Já registrou": "Déjà enregistré",
  "Kirvano": "Kirvano",
  "Kiwify": "Kiwify",
  "LOCALIZAÇÃO": "LOCALISATION",
  "Labels simplificados: \"Controle de Volume\" → \"Volume\", \"Controle de Velocidade\" → \"Velocidade\", \"Esconder no Início\" → \"Esconder Início\".": "Libellés simplifiés : « Réglage du volume » → « Volume », « Réglage de la vitesse » → « Vitesse », « Masquer au début » → « Masquer le début ».",
  "Largura": "Largeur",
  "Lateral": "Latéral",
  "Lato (Professional)": "Lato (professionnel)",
  "Layout": "Mise en page",
  "Layout do Formulário": "Disposition du formulaire",
  "Layout otimizado para mobile, tablet e desktop": "Présentation optimisée pour mobile, tablette et ordinateur",
  "Layout principal": "Disposition principale",
  "Layout responsivo de cápsula central com largura adaptativa por dispositivo": "Présentation adaptative en capsule centrale avec une largeur adaptée à chaque appareil",
  "Lead capturado com sucesso": "Lead recueilli avec succès",
  "Leads Capturados": "Leads recueillis",
  "Leads Recentes": "Leads récents",
  "Leads por Tipo": "Leads par type",
  "Legenda adicionada com sucesso!": "Sous-titres ajoutés avec succès !",
  "Legenda excluída!": "Sous-titres supprimés !",
  "Legenda removida.": "Sous-titres supprimés.",
  "Legendas": "Sous-titres",
  "Legendas adicionadas": "Sous-titres ajoutés",
  "Legendas desativadas": "Sous-titres désactivés",
  "Legendas salvas": "Sous-titres enregistrés",
  "Leia atentamente as condições operacionais de repasse bancário.": "Lisez attentivement les conditions opérationnelles de versement bancaire.",
  "Leia com atenção os termos operacionais de comissionamento.": "Lisez attentivement les conditions opérationnelles de commissionnement.",
  "Lenta": "Lente",
  "Lento": "Lent",
  "Leva para": "Mène vers",
  "Leve": "Léger",
  "Li e aceito os": "J'ai lu et j'accepte les",
  "Li e concordo com as regras acima": "J'ai lu et j'accepte les règles ci-dessus",
  "Li e concordo com os termos acima": "J'ai lu et j'accepte les conditions ci-dessus",
  "Lib.": "Débloq.",
  "Libera acesso ao vídeo somente após preenchimento de senha definida.": "Donne accès à la vidéo uniquement après saisie du mot de passe défini.",
  "Libera dopamina e mantém a atenção por mais tempo": "Libère de la dopamine et maintient l'attention plus longtemps",
  "Liberado": "Débloqué",
  "Liberar": "Débloquer",
  "Liberar botão após": "Débloquer le bouton après",
  "Liberar ou bloquear por parâmetros UTM.": "Autoriser ou bloquer selon les paramètres UTM.",
  "Libere ou bloqueie países ou regiões específicas.": "Autorisez ou bloquez des pays ou des régions spécifiques.",
  "Libere um editor com botões inteligentes, player customizado e máxima conversão.": "Accédez à un éditeur avec boutons intelligents, lecteur personnalisé et conversion maximale.",
  "Ligeiramente mais rápido": "Légèrement plus rapide",
  "Light": "Clair",
  "Ligue o campo de comentário e peça nome, e-mail e WhatsApp junto com a nota": "Activez le champ de commentaire et demandez le nom, l'e-mail et le WhatsApp avec la note",
  "Ligue vídeos curtos com perguntas e opções, leve cada visitante pela resposta dele até o checkout e veja onde cada um decide": "Reliez de courtes vidéos avec des questions et des options, guidez chaque visiteur vers le paiement selon ses réponses et repérez ses décisions",
  "Limite de Cópias": "Limite de copies",
  "Limite de cópias atingido": "Limite de copies atteinte",
  "Limite de inscrições (opcional)": "Limite d'inscriptions (facultative)",
  "Limite de {value0} vídeos por envio": "Limite de {value0} vidéos par envoi",
  "Limite do plano": "Limite du forfait",
  "Limite:": "Limite :",
  "Limpar": "Effacer",
  "Limpar Filtros": "Réinitialiser les filtres",
  "Limpar busca": "Effacer la recherche",
  "Limpar busca e filtros": "Effacer la recherche et les filtres",
  "Line": "Ligne",
  "Linha Fina": "Ligne fine",
  "Linha estável até 50% = storytelling eficiente.": "Courbe stable jusqu'à 50% = narration efficace.",
  "Linhas": "Lignes",
  "Linhas por página:": "Lignes par page :",
  "Link": "Lien",
  "Link copiado!": "Lien copié !",
  "Link criado com sucesso!": "Lien créé avec succès !",
  "Link de compartilhamento criado e copiado!": "Lien de partage créé et copié !",
  "Link de destino": "Lien de destination",
  "Link de {value0} não encontrado.": "Lien de {value0} introuvable.",
  "Link discreto": "Lien discret",
  "Link do Botão": "Lien du bouton",
  "Link do botão": "Lien du bouton",
  "Link do botão é obrigatório": "Le lien du bouton est obligatoire",
  "Link do segundo botão": "Lien du deuxième bouton",
  "Link expirado": "Lien expiré",
  "Link não encontrado": "Lien introuvable",
  "Link público do webinário:": "Lien public du webinaire :",
  "Link revogado com sucesso!": "Lien révoqué avec succès !",
  "Link verificado • Seguro": "Lien vérifié • Sécurisé",
  "Link único para acessar seu webinário. Exemplo: /w/meu-webinar": "Lien unique pour accéder à votre webinaire. Exemple : /w/meu-webinar",
  "Links do Rodapé": "Liens du pied de page",
  "Lisboa (GMT+0)": "Lisbonne (GMT+0)",
  "Lista": "Liste",
  "Lista de Testes A/B": "Liste des tests A/B",
  "Lista de Testes de Hook": "Liste des tests d'accroche",
  "Lista de cidades": "Liste des villes",
  "Lista de domínios autorizados a exibir seus vídeos": "Liste des domaines autorisés à afficher vos vidéos",
  "Lista de nomes": "Liste des noms",
  "Lista de playlists": "Liste des playlists",
  "Lista personalizada": "Liste personnalisée",
  "Locais": "Lieux",
  "Localização": "Localisation",
  "Localização atual": "Localisation actuelle",
  "Login Falhou": "Échec de la connexion",
  "Login realizado com sucesso!": "Connexion réussie !",
  "Logo": "Logo",
  "Logo Marca": "Logo de marque",
  "Logo Preview": "Aperçu du logo",
  "Logo atualizada": "Logo mis à jour",
  "Logo da HostVSL será exibida no player.": "Le logo HostVSL sera affiché dans le lecteur.",
  "Logo da Playlist": "Logo de la playlist",
  "Logo do Webinário": "Logo du webinaire",
  "Logo no Player": "Logo dans le lecteur",
  "Logo otimizado": "Logo optimisé",
  "Logo personalizado": "Logo personnalisé",
  "Logo removida": "Logo supprimé",
  "Logo {value0}": "Logo {value0}",
  "Logs Recentes": "Journaux récents",
  "Londres (GMT+0)": "Londres (GMT+0)",
  "Loop contínuo": "Boucle continue",
  "Loop contínuo quando combinado com Autoplay ativo": "Boucle continue avec l'Autoplay actif",
  "Los Angeles (GMT-8)": "Los Angeles (GMT-8)",
  "Lógica condicional para personalizar a jornada de cada lead": "Logique conditionnelle pour personnaliser le parcours de chaque lead",
  "MB": "Mo",
  "MM / AA": "MM / AA",
  "MM/AA": "MM/AA",
  "MP4, MOV • até 5GB": "MP4, MOV • jusqu'à 5 Go",
  "MP4, MOV, AVI | Máximo: 100MB": "MP4, MOV, AVI | Maximum : 100 Mo",
  "MP4, MOV, AVI, WebM • Tamanho máximo: 100MB": "MP4, MOV, AVI, WebM • Taille maximale : 100 Mo",
  "MP4, MOV, WEBM • Máximo 2GB": "MP4, MOV, WEBM • Maximum 2 Go",
  "Maior": "Plus grand",
  "Maior Autoridade e Visibilidade": "Plus d'autorité et de visibilité",
  "Maior Ponto de Queda": "Principal point de décrochage",
  "Maior duração": "Durée la plus longue",
  "Maior eficiência": "Efficacité accrue",
  "Maior faturamento": "Chiffre d'affaires le plus élevé",
  "Maior queda (16:00)": "Plus forte baisse (16:00)",
  "Maior valor registrado em 30d": "Valeur maximale enregistrée sur 30 jours",
  "Maior valor registrado no período": "Valeur maximale enregistrée pendant la période",
  "Mais Popular": "Le plus populaire",
  "Mais ativa": "La plus active",
  "Mais ações de {value0}": "Plus d'actions de {value0}",
  "Mais detalhes": "Plus de détails",
  "Mais do que um player de vídeo": "Bien plus qu'un lecteur vidéo",
  "Mais natural e estável": "Plus naturel et stable",
  "Mais opções": "Plus d'options",
  "Mais opções do vídeo {value0}": "Plus d'options de la vidéo {value0}",
  "Mais popular": "Le plus populaire",
  "Mais recente": "Le plus récent",
  "Mais recentes": "Les plus récents",
  "Mais reproduzido": "Le plus lu",
  "Mais vistos": "Les plus vus",
  "Major update": "Mise à jour majeure",
  "Mande vídeos direto da sua conta do Google Drive pra HostVSL, sem precisar baixar antes.": "Envoyez des vidéos directement de votre compte Google Drive vers HostVSL, sans les télécharger au préalable.",
  "Mantenha a excelência": "Maintenez l'excellence",
  "Mantenha a excelência narrativa": "Maintenez l'excellence narrative",
  "Mantenha cada intro entre 30 segundos e 2 minutos": "Gardez chaque intro entre 30 secondes et 2 minutes",
  "Mantenha o gancho inicial que está funcionando bem": "Conservez l'accroche initiale qui fonctionne bien",
  "Mantenha o público colado do início ao fim.": "Gardez votre audience captivée du début à la fin.",
  "Mantenha sua conta protegida": "Protégez votre compte",
  "Manter modal": "Garder la fenêtre ouverte",
  "Manter velocidade campeã após finalização": "Conserver la vitesse gagnante après la fin",
  "Mantém o vídeo padrão neste dispositivo": "Conserve la vidéo par défaut sur cet appareil",
  "Manual": "Manuel",
  "Mapa ao vivo com os espectadores que estão assistindo agora, por cidade e país": "Carte en direct des spectateurs actuels, par ville et pays",
  "Mapa de Calor (Conversão)": "Carte de chaleur (conversion)",
  "Mapa de Calor (Volume)": "Carte de chaleur (volume)",
  "Mapa de Calor Premium": "Carte de chaleur premium",
  "Mapa de Rotas": "Carte des routes",
  "Mapa de calor semanal com plays e visualizações": "Carte de chaleur hebdomadaire avec lectures et vues",
  "Marcador do pitch (opcional)": "Repère de l'argumentaire de vente (facultatif)",
  "Marcar agora": "Marquer maintenant",
  "Marcar aula como concluída": "Marquer le cours comme terminé",
  "Marcar como Concluído": "Marquer comme terminé",
  "Marcar como lidas": "Marquer comme lues",
  "Margem": "Marge",
  "Margens Internas (Padding):": "Marges internes (espacement) :",
  "Master Class": "Master Class",
  "Master Class Host VSL": "Master Class Host VSL",
  "Mede os acessos ao checkout. Não confirma uma compra; vendas dependem do rastreamento conectado.": "Mesure les accès à la page de paiement. Ne confirme pas un achat : les ventes dépendent du suivi connecté.",
  "Medida de quanto tempo os usuários assistem ao vídeo em relação à duração total.": "Mesure de la durée de visionnage par rapport à la durée totale de la vidéo.",
  "Meio": "Milieu",
  "Meio (Medium)": "Support (Medium)",
  "Meio direito": "Au milieu à droite",
  "Meio esquerdo": "Au milieu à gauche",
  "Melhor": "Meilleur",
  "Melhor CTR": "Meilleur CTR",
  "Melhor Janela por Dispositivo": "Meilleure plage par appareil",
  "Melhor Momento de Engajamento": "Meilleur moment d'engagement",
  "Melhor dia": "Meilleur jour",
  "Melhor escolha para campanhas ativas": "Meilleur choix pour les campagnes actives",
  "Melhor horário": "Meilleur horaire",
  "Melhor janela": "Meilleure plage",
  "Melhor momento": "Meilleur moment",
  "Melhor para captar atenção e criar urgência": "Idéal pour attirer l'attention et créer un sentiment d'urgence",
  "Melhor performance": "Meilleures performances",
  "Melhor período de performance": "Période la plus performante",
  "Melhor plataforma": "Meilleure plateforme",
  "Melhor vídeo do período:": "Meilleure vidéo de la période :",
  "Melhores Janelas": "Meilleures plages",
  "Melhores Janelas (Volume)": "Meilleures plages (volume)",
  "Melhores práticas": "Bonnes pratiques",
  "Melhoria": "Amélioration",
  "Melhoria de performance completa na abertura dos vídeos — carregamento mais rápido e menos travamentos.": "Amélioration complète des performances au démarrage des vidéos : chargement plus rapide et moins de blocages.",
  "Membro": "Membre",
  "Membro Atualizado": "Membre mis à jour",
  "Membro Criado": "Membre créé",
  "Membro Removido": "Membre supprimé",
  "Membro adicionado com sucesso!": "Membre ajouté avec succès !",
  "Membro atualizado com sucesso!": "Membre mis à jour avec succès !",
  "Membro bloqueado com sucesso!": "Membre bloqué avec succès !",
  "Membro desbloqueado com sucesso!": "Membre débloqué avec succès !",
  "Membro removido com sucesso!": "Membre supprimé avec succès !",
  "Membros": "Membres",
  "Membros da Rede": "Membres du réseau",
  "Menor": "Plus petit",
  "Menor desvio padrão no período": "Écart-type le plus faible pendant la période",
  "Menos achismo, mais performance.": "Moins d'intuition, plus de performance.",
  "Menos travamentos durante a reprodução": "Moins de blocages pendant la lecture",
  "Mensagem": "Message",
  "Mensagem Adicional": "Message supplémentaire",
  "Mensagem Exibida": "Message affiché",
  "Mensagem Personalizada": "Message personnalisé",
  "Mensagem Principal": "Message principal",
  "Mensagem Secundária": "Message secondaire",
  "Mensagem automática (opcional)": "Message automatique (facultatif)",
  "Mensagem da Notificação": "Message de notification",
  "Mensagem de Erro": "Message d'erreur",
  "Mensagem de agradecimento": "Message de remerciement",
  "Mensagem de bloqueio": "Message de blocage",
  "Mensagem de bloqueio deve ter no máximo 140 caracteres": "Le message de blocage doit comporter au maximum 140 caractères",
  "Mensagem de bloqueio é obrigatória": "Le message de blocage est obligatoire",
  "Mensagem do chat": "Message du chat",
  "Mensagem obrigatória": "Message obligatoire",
  "Mensagem personalizada": "Message personnalisé",
  "Mensagem:": "Message :",
  "Mensagens do Autoplay": "Messages de l'Autoplay",
  "Mensal": "Mensuel",
  "Menu da pasta": "Menu du dossier",
  "Menu drawer mobile": "Menu mobile coulissant",
  "Menu mobile": "Menu mobile",
  "Menu mobile com overlay click blocking, animações sincronizadas, plan card com progress bar animado, navegação reorganizada.": "Menu mobile avec superposition bloquant les clics, animations synchronisées, carte du forfait avec barre de progression animée et navigation réorganisée.",
  "Mesma aba": "Même onglet",
  "Meta Ideal": "Objectif idéal",
  "Meta Pixel": "Meta Pixel",
  "Meta-análise:": "Méta-analyse :",
  "Meta:": "Objectif :",
  "Metas Alcançadas": "Objectifs atteints",
  "Metas alcançadas": "Objectifs atteints",
  "Meu Dispositivo": "Mon appareil",
  "Meu Perfil": "Mon profil",
  "Meu Vídeo": "Ma vidéo",
  "Meu título personalizado": "Mon titre personnalisé",
  "Meus Pixels": "Mes pixels",
  "Meus Vídeos": "Mes vidéos",
  "Meus clientes têm desconto?": "Mes clients bénéficient-ils d'une réduction ?",
  "Meus vídeos": "Mes vidéos",
  "Meça a percepção real do conteúdo": "Mesurez la perception réelle du contenu",
  "Meça conversões do Google Ads (ID AW- + rótulo) nos eventos do seu VSL: play, progresso e clique no checkout.": "Mesurez les conversions Google Ads (ID AW- + libellé) pour les événements de votre VSL : lecture, progression et clic vers le paiement.",
  "Meça eventos do TikTok Ads (Pixel Code) no seu VSL: visualização e clique no botão de compra.": "Mesurez les événements TikTok Ads (Pixel Code) de votre VSL : vue et clic sur le bouton d'achat.",
  "Microguru e Tutor": "Microguru et tuteur",
  "Minas Gerais": "Minas Gerais",
  "Minha Rede": "Mon réseau",
  "Minhas Playlists": "Mes playlists",
  "Mini Hook": "Mini Hook",
  "Mini Hooks": "Mini Hooks",
  "Mini Hooks salvos": "Mini Hooks enregistrés",
  "Mini Hooks são pequenos blocos de texto que aparecem em momentos estratégicos do vídeo para reativar a atenção do espectador. Configure quantos quiser, defina o tempo de exibição e veja o impacto direto na retenção.": "Les Mini Hooks sont de courts blocs de texte qui apparaissent à des moments stratégiques de la vidéo pour raviver l'attention du spectateur. Ajoutez-en autant que vous le souhaitez, définissez leur durée d'affichage et observez leur impact direct sur la rétention.",
  "Mini-Hook": "Mini-Hook",
  "Mini-Hook atualizado com sucesso": "Mini-Hook mis à jour avec succès",
  "Mini-Hook criado com sucesso": "Mini-Hook créé avec succès",
  "Mini-Hook duplicado com sucesso": "Mini-Hook dupliqué avec succès",
  "Mini-Hook removido com sucesso": "Mini-Hook supprimé avec succès",
  "Mini-Hooks": "Mini-Hooks",
  "Mini-preview do frame ao passar o mouse na barra de progresso": "Mini-aperçu de l'image au survol de la barre de progression",
  "Miniaturas ao passar o mouse na barra": "Miniatures au survol de la barre",
  "Minimalista": "Minimaliste",
  "Minutos": "Minutes",
  "Mobile": "Mobile",
  "Mobile Menu — Layout Final": "Menu mobile — Présentation finale",
  "Mobile:": "Mobile :",
  "Modal de código embed com tabs JavaScript/iFrame, cards de código com 160px altura fixa, botões de cópia integrados.": "Fenêtre de code d'intégration avec onglets JavaScript/iFrame, cartes de code d'une hauteur fixe de 160px et boutons de copie intégrés.",
  "Modele páginas com um clique e personalize do seu jeito.": "Copiez des pages en un clic et personnalisez-les à votre façon.",
  "Modelo do bloco": "Modèle du bloc",
  "Moderna": "Moderne",
  "Moderno": "Moderne",
  "Modo Educacional": "Mode pédagogique",
  "Modo HTML": "Mode HTML",
  "Modo HTML (Avançado)": "Mode HTML (avancé)",
  "Modo Imagem": "Mode image",
  "Modo Teste": "Mode test",
  "Modo Texto": "Mode texte",
  "Modo atualizado": "Mode mis à jour",
  "Modo de Exibição": "Mode d'affichage",
  "Modo de Exibição da Thumbnail": "Mode d'affichage de la miniature",
  "Modo de exibição": "Mode d'affichage",
  "Modo de filtragem": "Mode de filtrage",
  "Modo de teste para demonstrações": "Mode test pour les démonstrations",
  "Modo foco": "Mode concentration",
  "Modo foco: só a mesa em evidência": "Mode concentration : seul le tableau est mis en avant",
  "Momento (min:seg)": "Moment (min:sec)",
  "Momento de Exibição": "Moment d'affichage",
  "Momento do Vídeo": "Moment de la vidéo",
  "Momento do vídeo onde a audiência está mais engajada.": "Moment de la vidéo où l'audience est la plus engagée.",
  "Momento exato": "Moment précis",
  "Momentos específicos no vídeo onde uma quantidade significativa de espectadores para de assistir. Revise estes pontos para manter o engajamento.": "Moments précis de la vidéo où un nombre important de spectateurs cesse de regarder. Revoyez ces passages pour maintenir l'engagement.",
  "Momentos onde muitos espectadores abandonam o vídeo. Reduza este número para melhorar a retenção.": "Moments où de nombreux spectateurs quittent la vidéo. Réduisez ce nombre pour améliorer la rétention.",
  "Monetizze": "Monetizze",
  "Monitoramento": "Surveillance",
  "Monitore conversões e eventos importantes do seu vídeo com pixels de rastreamento": "Suivez les conversions et les événements importants de votre vidéo grâce aux pixels de suivi",
  "Monitore ofertas validadas que estão rodando na Meta agora": "Surveillez les offres validées actuellement diffusées sur Meta",
  "Monitore todas as visitas, conversões e registos gerados através do seu tráfego em tempo real no nosso dashboard.": "Suivez en temps réel toutes les visites, conversions et inscriptions générées par votre trafic dans notre tableau de bord.",
  "Monospace": "Chasse fixe",
  "Montserrat": "Montserrat",
  "Montserrat (Impact)": "Montserrat (impact)",
  "More": "Plus",
  "More pages": "Plus de pages",
  "Mostra o interesse inicial no vídeo. Gap alto = título forte, copy fraca.": "Montre l'intérêt initial pour la vidéo. Écart élevé = titre fort, texte faible.",
  "Mostra o preço em destaque com a condição de pagamento.": "Met le prix en valeur avec les conditions de paiement.",
  "Mostra o progresso do vídeo": "Affiche la progression de la vidéo",
  "Mostra o progresso visual": "Affiche la progression visuelle",
  "Mostra o progresso visual do vídeo": "Affiche la progression visuelle de la vidéo",
  "Mostra o tempo atual e duração do vídeo": "Affiche le temps actuel et la durée de la vidéo",
  "Mostra os controles na parte inferior do player": "Affiche les commandes en bas du lecteur",
  "Mostra os controles no rodapé do player": "Affiche les commandes en bas du lecteur",
  "Mostra quanto o vídeo vencedor está à frente do segundo colocado nesta métrica.": "Montre l'avance de la vidéo gagnante sur la deuxième pour cet indicateur.",
  "Mostra um botão para iniciar o vídeo principal manualmente.": "Affiche un bouton pour démarrer manuellement la vidéo principale.",
  "Mostra um vídeo diferente apenas neste dispositivo": "Affiche une autre vidéo uniquement sur cet appareil",
  "Mostrando": "Affichage de",
  "Mostrando 20 de": "Affichage de 20 sur",
  "Mostrando detalhes da integração {value0}": "Affichage des détails de l'intégration {value0}",
  "Mostrar": "Afficher",
  "Mostrar Controles": "Afficher les commandes",
  "Mostrar Imagem": "Afficher l'image",
  "Mostrar Sombras": "Afficher les ombres",
  "Mostrar Tempo": "Afficher le temps",
  "Mostrar barra de progresso": "Afficher la barre de progression",
  "Mostrar barra na parte inferior após fechar": "Afficher la barre en bas après la fermeture",
  "Mostrar borda": "Afficher la bordure",
  "Mostrar botão de legenda": "Afficher le bouton des sous-titres",
  "Mostrar contagem regressiva": "Afficher le compte à rebours",
  "Mostrar controles": "Afficher les commandes",
  "Mostrar controles do vídeo durante o autoplay": "Afficher les commandes vidéo pendant l'Autoplay",
  "Mostrar durante todo o vídeo": "Afficher pendant toute la vidéo",
  "Mostrar elemento": "Afficher l'élément",
  "Mostrar em todo vídeo": "Afficher pendant toute la vidéo",
  "Mostrar formulário em um momento específico do vídeo": "Afficher le formulaire à un moment précis de la vidéo",
  "Mostrar letra A–D": "Afficher les lettres A–D",
  "Mostrar menos": "Afficher moins",
  "Mostrar mensagem de agradecimento": "Afficher un message de remerciement",
  "Mostrar no quadro": "Afficher sur le tableau",
  "Mostrar novamente nos últimos 20 segundos": "Afficher à nouveau pendant les 20 dernières secondes",
  "Mostrar ou ocultar o título do formulário": "Afficher ou masquer le titre du formulaire",
  "Mostrar plataforma": "Afficher la plateforme",
  "Mostrar senha": "Afficher le mot de passe",
  "Mostrar texto na barra": "Afficher du texte sur la barre",
  "Mostrar token": "Afficher le jeton",
  "Mostrar ícone": "Afficher l'icône",
  "Mostre a plataforma de venda ao lado do aviso ou envie a sua própria logo": "Affichez la plateforme de vente à côté de la notification ou envoyez votre propre logo",
  "Mostre avisos de compra por cima da sua VSL e crie prova social enquanto o vídeo roda.": "Affichez des notifications d'achat sur votre VSL et créez de la preuve sociale pendant la lecture.",
  "Mostre elementos que transmitam segurança": "Affichez des éléments qui inspirent confiance",
  "Mostre o avanço do vídeo e aumente a retenção.": "Montrez la progression de la vidéo et augmentez la rétention.",
  "Mostre um contador de pessoas assistindo o vídeo": "Affichez un compteur de personnes regardant la vidéo",
  "Mostre um contador dinâmico de pessoas assistindo para gerar prova social durante o vídeo.": "Affichez un compteur dynamique de spectateurs pour créer de la preuve sociale pendant la vidéo.",
  "Mostre vagas disponíveis ou progresso": "Affichez les places disponibles ou la progression",
  "Mostre vendas recentes para criar prova social.": "Affichez les ventes récentes pour créer de la preuve sociale.",
  "Mostre visualmente o avanço do vídeo e aumente a retenção.": "Montrez visuellement la progression de la vidéo et augmentez la rétention.",
  "Mover": "Déplacer",
  "Mover de pasta": "Changer de dossier",
  "Mover para": "Déplacer vers",
  "Mover para outra pasta": "Déplacer vers un autre dossier",
  "Mover para...": "Déplacer vers...",
  "Mover pasta": "Déplacer le dossier",
  "Mudanças Recentes": "Modifications récentes",
  "Mudo há +24h": "Silencieux depuis plus de 24 h",
  "Muito ruim": "Très mauvais",
  "Muito rápido": "Très rapide",
  "Muito rápido ou muito lento": "Trop rapide ou trop lent",
  "Multiplicador de Velocidade": "Multiplicateur de vitesse",
  "Multiplique as suas vendas de forma automática com o chatbot que vende 24h por dia.": "Multipliez automatiquement vos ventes avec un chatbot qui vend 24 heures sur 24.",
  "MÊS": "MOIS",
  "Máximo": "Maximum",
  "Máximo 140 caracteres": "140 caractères maximum",
  "Máximo 8-10 palavras": "8 à 10 mots maximum",
  "Máximo de": "Maximum de",
  "Máximo de 10 caracteres": "10 caractères maximum",
  "Máximo de 5 modelos simultâneos permitidos": "5 modèles simultanés maximum autorisés",
  "Média": "Moyenne",
  "Média assistida do vídeo": "Durée moyenne de visionnage de la vidéo",
  "Média de Engajamento": "Engagement moyen",
  "Média de quanto do vídeo foi assistido. Valores acima de 60% são considerados bons. Indica que o conteúdo manteve interesse contínuo.": "Part moyenne de la vidéo regardée. Les valeurs supérieures à 60% sont considérées comme bonnes et indiquent que le contenu maintient un intérêt continu.",
  "Média geral": "Moyenne générale",
  "Média mensal:": "Moyenne mensuelle :",
  "Médio": "Moyen",
  "Método avançado JavaScript com todas as opções de personalização e controle do botão de ação.": "Méthode JavaScript avancée avec toutes les options de personnalisation et de contrôle du bouton d'action.",
  "Método de pagamento adicionado com sucesso!": "Moyen de paiement ajouté avec succès !",
  "Método de pagamento definido como padrão!": "Moyen de paiement défini par défaut !",
  "Método de pagamento removido.": "Moyen de paiement supprimé.",
  "Métrica": "Indicateur",
  "Métrica base:": "Indicateur de référence :",
  "Métrica de cliques atualizada com sucesso!": "Indicateur de clics mis à jour avec succès !",
  "Métricas": "Indicateurs",
  "Métricas (7 dias)": "Indicateurs (7 jours)",
  "Métricas (últimos": "Indicateurs (derniers",
  "Métricas Individuais das Introduções": "Indicateurs individuels des introductions",
  "Métricas Rastreadas:": "Indicateurs suivis :",
  "Métricas atualizadas para novo formato!": "Indicateurs mis à jour au nouveau format !",
  "Métricas de Picos de Horários": "Indicateurs des pics horaires",
  "Métricas de Teste": "Indicateurs du test",
  "Métricas de Uso": "Indicateurs d'utilisation",
  "Métricas detalhadas": "Indicateurs détaillés",
  "Métricas do Teste": "Indicateurs du test",
  "Métricas do Teste A/B": "Indicateurs du test A/B",
  "Métricas do Teste de Introduções": "Indicateurs du test d'introductions",
  "Métricas do Vídeo": "Indicateurs de la vidéo",
  "Métricas do Webinário": "Indicateurs du webinaire",
  "Métricas do fluxo": "Indicateurs du parcours",
  "Métricas por etapa: exibições, conclusão, quem pulou, quem chegou ao principal e cliques no CTA": "Indicateurs par étape : affichages, fin de visionnage, personnes ayant passé, personnes ayant atteint la vidéo principale et clics CTA",
  "Métricas — Padrão Visual Definitivo": "Indicateurs — Style visuel définitif",
  "Métricas:": "Indicateurs :",
  "Mês inválido": "Mois invalide",
  "Mín. 8 caracteres": "8 caractères minimum",
  "Mínimo 6 caracteres": "6 caractères minimum",
  "Mínimo: 2 variações": "Minimum : 2 variantes",
  "Módulo": "Module",
  "Módulo 1 Primeiros passos": "Module 1 Premiers pas",
  "Módulo 2 Personalização": "Module 2 Personnalisation",
  "Módulo 3 Recursos de conversão": "Module 3 Fonctionnalités de conversion",
  "Módulo 4 Análises e performance": "Module 4 Analyses et performances",
  "Módulo 5 Plano e plays": "Module 5 Forfait et lectures",
  "Módulo não encontrado": "Module introuvable",
  "Módulos": "Modules",
  "Módulos (até 6)": "Modules (jusqu'à 6)",
  "Na Payt, cadastre esta URL para o evento de pagamento aprovado e use a mesma chave de integração.": "Dans Payt, enregistrez cette URL pour l'événement de paiement approuvé et utilisez la même clé d'intégration.",
  "Na aba Métricas: nota média, total de respostas, distribuição, evolução e os comentários mais recentes": "Dans l'onglet Indicateurs : note moyenne, total des réponses, répartition, évolution et commentaires les plus récents",
  "Na aba Tema, ajuste o visual do player. Escolha o formato, as cores da pergunta e dos botões, a posição das opções, o escurecimento do fundo, a borda, o progresso e os controles. Você pode começar com uma prévia sem som ou com um clique para iniciar.": "Dans l'onglet Thème, ajustez l'apparence du lecteur. Choisissez le format, les couleurs de la question et des boutons, la position des options, l'assombrissement du fond, la bordure, la progression et les commandes. Vous pouvez commencer avec un aperçu sans son ou un clic pour démarrer.",
  "Na etapa {value0}, a opção \"{value1}\" aponta para uma saída que não existe.": "À l'étape {value0}, l'option « {value1} » pointe vers une sortie inexistante.",
  "Na etapa {value0}, a opção \"{value1}\" não leva a lugar nenhum.": "À l'étape {value0}, l'option « {value1} » ne mène nulle part.",
  "Na etapa {value0}, duas opções têm o texto \"{value1}\".": "À l'étape {value0}, deux options portent le texte « {value1} ».",
  "Na etapa {value0}, uma opção está sem texto.": "À l'étape {value0}, une option n'a pas de texte.",
  "Na mesma aba": "Dans le même onglet",
  "Na playlist": "Dans la playlist",
  "Nada impede a publicação. Vale conferir os avisos.": "Rien n'empêche la publication. Pensez à consulter les avertissements.",
  "Nada novo para publicar": "Aucune nouveauté à publier",
  "Narrativas bem estruturadas podem aumentar conversões em até 30%": "Une narration bien structurée peut augmenter les conversions jusqu'à 30%",
  "Navegador": "Navigateur",
  "Navegador Principal": "Navigateur principal",
  "Navegadores": "Navigateurs",
  "Navegadores e Sistemas": "Navigateurs et systèmes",
  "Navegação": "Navigation",
  "Navegação da série": "Navigation de la série",
  "Navegação do Vídeo": "Navigation vidéo",
  "Navegação lateral": "Navigation latérale",
  "Navegação mais rápida e responsiva em qualquer tela": "Navigation plus rapide et adaptative sur tous les écrans",
  "Navegação rápida com breadcrumbs": "Navigation rapide avec fil d'Ariane",
  "Nederlands": "Nederlands",
  "Negrito": "Gras",
  "Nenhum": "Aucun",
  "Nenhum / Sem Plano Ativo": "Aucun / Aucun forfait actif",
  "Nenhum Mini Hook adicionado ainda.": "Aucun Mini Hook ajouté pour le moment.",
  "Nenhum acesso está ativo agora.": "Aucun accès actif actuellement.",
  "Nenhum banco cadastrado.": "Aucune banque enregistrée.",
  "Nenhum bônus criado. Clique em \"Adicionar Bônus\" para começar.": "Aucun bonus créé. Cliquez sur « Ajouter un bonus » pour commencer.",
  "Nenhum cartão cadastrado": "Aucune carte enregistrée",
  "Nenhum cartão selecionado": "Aucune carte sélectionnée",
  "Nenhum comentário encontrado com esse filtro.": "Aucun commentaire ne correspond à ce filtre.",
  "Nenhum comprovante enviado": "Aucun justificatif envoyé",
  "Nenhum custo encontrado": "Aucun coût trouvé",
  "Nenhum código extra na sua página: o token de acesso fica guardado só no servidor": "Aucun code supplémentaire sur votre page : le jeton d'accès reste uniquement sur le serveur",
  "Nenhum dado de cidade disponível": "Aucune donnée de ville disponible",
  "Nenhum dado de estado disponível": "Aucune donnée d'État disponible",
  "Nenhum dado de funil disponível ainda": "Aucune donnée de tunnel disponible pour le moment",
  "Nenhum dado de localização disponível": "Aucune donnée de localisation disponible",
  "Nenhum dado de país disponível": "Aucune donnée de pays disponible",
  "Nenhum dado disponível ainda": "Aucune donnée disponible pour le moment",
  "Nenhum dado encontrado": "Aucune donnée trouvée",
  "Nenhum dado encontrado para o período selecionado": "Aucune donnée trouvée pour la période sélectionnée",
  "Nenhum dado encontrado para o período selecionado.": "Aucune donnée trouvée pour la période sélectionnée.",
  "Nenhum disparo registrado ainda. Abra o VSL uma vez com som e recarregue esta tela. Se já abriu e nada aparece, confira se a URL vinculada é a página onde o vídeo roda.": "Aucun déclenchement enregistré pour le moment. Ouvrez une fois la VSL avec le son et rechargez cette page. Si rien ne s'affiche après l'ouverture, vérifiez que l'URL associée correspond à la page de lecture de la vidéo.",
  "Nenhum dispositivo": "Aucun appareil",
  "Nenhum dispositivo ainda": "Aucun appareil pour le moment",
  "Nenhum dispositivo encontrado": "Aucun appareil trouvé",
  "Nenhum domínio cadastrado": "Aucun domaine enregistré",
  "Nenhum domínio encontrado para \"": "Aucun domaine trouvé pour «",
  "Nenhum envio ativo": "Aucun envoi actif",
  "Nenhum evento de clique foi registrado ainda.": "Aucun événement de clic enregistré pour le moment.",
  "Nenhum evento detectado ainda. Verifique se o pixel está instalado na página vinculada.": "Aucun événement détecté pour le moment. Vérifiez que le pixel est installé sur la page associée.",
  "Nenhum evento encontrado para este filtro.": "Aucun événement ne correspond à ce filtre.",
  "Nenhum feedback recebido ainda": "Aucun avis reçu pour le moment",
  "Nenhum fluxo encontrado com esse filtro.": "Aucun parcours ne correspond à ce filtre.",
  "Nenhum incremento de clicks foi encontrado para o e-mail informado. Você pode criar um novo registro clicando no botão abaixo.": "Aucun ajout de clics trouvé pour l'adresse e-mail indiquée. Vous pouvez créer un nouvel enregistrement en cliquant sur le bouton ci-dessous.",
  "Nenhum link definido.": "Aucun lien défini.",
  "Nenhum link encontrado para este vídeo": "Aucun lien trouvé pour cette vidéo",
  "Nenhum log disponível ainda": "Aucun journal disponible pour le moment",
  "Nenhum log encontrado com os filtros selecionados.": "Aucun journal ne correspond aux filtres sélectionnés.",
  "Nenhum membro encontrado": "Aucun membre trouvé",
  "Nenhum membro encontrado na sua rede.": "Aucun membre trouvé dans votre réseau.",
  "Nenhum membro encontrado. Adicione membros para gerenciar sua equipe.": "Aucun membre trouvé. Ajoutez des membres pour gérer votre équipe.",
  "Nenhum método de pagamento cadastrado.": "Aucun moyen de paiement enregistré.",
  "Nenhum módulo criado. Clique em \"Adicionar Módulo\" para começar.": "Aucun module créé. Cliquez sur « Ajouter un module » pour commencer.",
  "Nenhum módulo ou bônus ainda": "Aucun module ni bonus pour le moment",
  "Nenhum parâmetro UTM foi registrado ainda.": "Aucun paramètre UTM enregistré pour le moment.",
  "Nenhum país adicionado. Clique em \"Adicionar País\" para começar.": "Aucun pays ajouté. Cliquez sur « Ajouter un pays » pour commencer.",
  "Nenhum pixel": "Aucun pixel",
  "Nenhum pixel configurado": "Aucun pixel configuré",
  "Nenhum pixel corresponde aos filtros selecionados.": "Aucun pixel ne correspond aux filtres sélectionnés.",
  "Nenhum pixel encontrado": "Aucun pixel trouvé",
  "Nenhum problema encontrado no fluxo.": "Aucun problème détecté dans le parcours.",
  "Nenhum recurso encontrado": "Aucune fonctionnalité trouvée",
  "Nenhum recurso encontrado para \"": "Aucune fonctionnalité trouvée pour «",
  "Nenhum registro de incremento cadastrado.": "Aucun enregistrement d'ajout enregistré.",
  "Nenhum registro encontrado": "Aucun enregistrement trouvé",
  "Nenhum registro encontrado para este e-mail. Você pode criar um novo.": "Aucun enregistrement trouvé pour cet e-mail. Vous pouvez en créer un nouveau.",
  "Nenhum registro selecionado": "Aucun enregistrement sélectionné",
  "Nenhum resultado": "Aucun résultat",
  "Nenhum resultado encontrado": "Aucun résultat trouvé",
  "Nenhum resultado.": "Aucun résultat.",
  "Nenhum selecionado": "Aucun élément sélectionné",
  "Nenhum teste A/B encontrado": "Aucun test A/B trouvé",
  "Nenhum teste ativo": "Aucun test actif",
  "Nenhum teste ativo no momento": "Aucun test actif actuellement",
  "Nenhum teste de introdução encontrado.": "Aucun test d'introduction trouvé.",
  "Nenhum teste de velocidade ativo.": "Aucun test de vitesse actif.",
  "Nenhum teste em execução": "Aucun test en cours",
  "Nenhum token ativo.": "Aucun jeton actif.",
  "Nenhum usuário selecionado": "Aucun utilisateur sélectionné",
  "Nenhum vídeo": "Aucune vidéo",
  "Nenhum vídeo adicionado": "Aucune vidéo ajoutée",
  "Nenhum vídeo adicionado a este teste ainda.": "Aucune vidéo ajoutée à ce test pour le moment.",
  "Nenhum vídeo ainda. Envie os vídeos curtos de cada etapa do fluxo.": "Aucune vidéo pour le moment. Envoyez les courtes vidéos de chaque étape du parcours.",
  "Nenhum vídeo alternativo selecionado": "Aucune vidéo de remplacement sélectionnée",
  "Nenhum vídeo compartilhado ainda": "Aucune vidéo partagée pour le moment",
  "Nenhum vídeo de teste adicionado": "Aucune vidéo de test ajoutée",
  "Nenhum vídeo disponível": "Aucune vidéo disponible",
  "Nenhum vídeo disponível para seleção": "Aucune vidéo disponible à la sélection",
  "Nenhum vídeo disponível. Faça upload de um vídeo primeiro.": "Aucune vidéo disponible. Importez d'abord une vidéo.",
  "Nenhum vídeo encontrado": "Aucune vidéo trouvée",
  "Nenhum vídeo encontrado neste teste A/B.": "Aucune vidéo trouvée dans ce test A/B.",
  "Nenhum vídeo encontrado para \"": "Aucune vidéo trouvée pour «",
  "Nenhum vídeo encontrado para \"{value0}\"": "Aucune vidéo trouvée pour « {value0} »",
  "Nenhum vídeo encontrado para análise de performance.": "Aucune vidéo trouvée pour l'analyse des performances.",
  "Nenhum vídeo encontrado para “": "Aucune vidéo trouvée pour «",
  "Nenhum vídeo encontrado.": "Aucune vidéo trouvée.",
  "Nenhum vídeo enviado ainda": "Aucune vidéo envoyée pour le moment",
  "Nenhum vídeo finalizado": "Aucune vidéo terminée",
  "Nenhum vídeo importado": "Aucune vidéo importée",
  "Nenhum vídeo nesta pasta": "Aucune vidéo dans ce dossier",
  "Nenhum vídeo original selecionado": "Aucune vidéo d'origine sélectionnée",
  "Nenhum vídeo selecionado": "Aucune vidéo sélectionnée",
  "Nenhum vídeo selecionado para salvar": "Aucune vidéo sélectionnée à enregistrer",
  "Nenhum webinário criado ainda": "Aucun webinaire créé pour le moment",
  "Nenhuma": "Aucune",
  "Nenhuma alteração foi feita em sua conta.": "Aucune modification n'a été apportée à votre compte.",
  "Nenhuma atualização por aqui": "Aucune mise à jour ici",
  "Nenhuma aula adicionada ainda": "Aucun cours ajouté pour le moment",
  "Nenhuma aula ainda": "Aucun cours pour le moment",
  "Nenhuma aula disponível": "Aucun cours disponible",
  "Nenhuma aula encontrada": "Aucun cours trouvé",
  "Nenhuma aula encontrada.": "Aucun cours trouvé.",
  "Nenhuma aula publicada nesta série ainda.": "Aucun cours publié dans cette série pour le moment.",
  "Nenhuma ação configurada ainda": "Aucune action configurée pour le moment",
  "Nenhuma chave ainda": "Aucune clé pour le moment",
  "Nenhuma chave ativa": "Aucune clé active",
  "Nenhuma conversão registrada ainda. Adicione plataformas e aguarde as primeiras conversões.": "Aucune conversion enregistrée pour le moment. Ajoutez des plateformes et attendez les premières conversions.",
  "Nenhuma cópia registrada ainda": "Aucune copie enregistrée pour le moment",
  "Nenhuma fatura encontrada": "Aucune facture trouvée",
  "Nenhuma fonte de tráfego detectada": "Aucune source de trafic détectée",
  "Nenhuma imagem disponível": "Aucune image disponible",
  "Nenhuma integração encontrada para os filtros selecionados.": "Aucune intégration ne correspond aux filtres sélectionnés.",
  "Nenhuma integração encontrada.": "Aucune intégration trouvée.",
  "Nenhuma intro encontrada": "Aucune intro trouvée",
  "Nenhuma legenda encontrada para \"{q}\"": "Aucun sous-titre trouvé pour « {q} »",
  "Nenhuma métrica disponível": "Aucun indicateur disponible",
  "Nenhuma métrica disponível para o período selecionado.": "Aucun indicateur disponible pour la période sélectionnée.",
  "Nenhuma novidade encontrada.": "Aucune nouveauté trouvée.",
  "Nenhuma novidade por aqui": "Aucune nouveauté ici",
  "Nenhuma opção leva a esta saída": "Aucune option ne mène à cette sortie",
  "Nenhuma origem encontrada": "Aucune source trouvée",
  "Nenhuma pasta criada": "Aucun dossier créé",
  "Nenhuma plataforma selecionada. Adicione plataformas para visualizar os webhooks.": "Aucune plateforme sélectionnée. Ajoutez des plateformes pour afficher les webhooks.",
  "Nenhuma proteção criada ainda": "Aucune protection créée pour le moment",
  "Nenhuma receita identificada": "Aucun chiffre d'affaires identifié",
  "Nenhuma região adicionada. Clique em \"Adicionar Região\" para começar.": "Aucune région ajoutée. Cliquez sur « Ajouter une région » pour commencer.",
  "Nenhuma regra UTM adicionada. Clique em \"Adicionar Regra UTM\" para começar.": "Aucune règle UTM ajoutée. Cliquez sur « Ajouter une règle UTM » pour commencer.",
  "Nenhuma regra criada": "Aucune règle créée",
  "Nenhuma regra criada ainda. Adicione condições para liberar ou bloquear acessos.": "Aucune règle créée pour le moment. Ajoutez des conditions pour autoriser ou bloquer les accès.",
  "Nenhuma saída está marcada como checkout; a conversão não será medida.": "Aucune sortie n'est marquée comme paiement ; la conversion ne sera pas mesurée.",
  "Nenhuma selecionada": "Aucune sélectionnée",
  "Nenhuma solicitação encontrada": "Aucune demande trouvée",
  "Nenhuma transferência ou comissão localizada para esta conta no BD.": "Aucun transfert ni commission trouvé pour ce compte dans la base de données.",
  "Nenhuma variação configurada": "Aucune variante configurée",
  "Nenhuma venda registrada": "Aucune vente enregistrée",
  "Neon": "Neon",
  "Netflix Dark": "Netflix Dark",
  "Networking": "Réseautage",
  "New feature": "Nouvelle fonctionnalité",
  "Next": "Suivant",
  "Next slide": "Diapositive suivante",
  "Ninguém assistindo agora": "Personne ne regarde actuellement",
  "No final do teste, você pode fixar a intro com melhor desempenho.": "À la fin du test, vous pouvez conserver l'intro la plus performante.",
  "No final do vídeo": "À la fin de la vidéo",
  "No menu VSL Dinâmica, crie um fluxo e dê um nome para identificar seu funil. Esse nome é para sua organização no painel.": "Dans le menu VSL dynamique, créez un parcours et donnez-lui un nom pour identifier votre tunnel. Ce nom sert à votre organisation dans le panneau.",
  "No modal de upload, escolha entre \"Upload do computador\" ou \"Google Drive\"": "Dans la fenêtre d'envoi, choisissez « Importer depuis l'ordinateur » ou « Google Drive »",
  "No máximo {value0} parâmetros fixos": "Au maximum {value0} paramètres fixes",
  "No tema, defina o formato do vídeo, as cores, o estilo das opções, a barra de progresso e como o vídeo começa (prévia sem som ou clicar para iniciar).": "Dans le thème, définissez le format vidéo, les couleurs, le style des options, la barre de progression et le démarrage du lecteur (aperçu sans son ou clic pour démarrer).",
  "Nome": "Nom",
  "Nome (opcional)": "Nom (facultatif)",
  "Nome (só você vê)": "Nom (visible uniquement par vous)",
  "Nome A-Z": "Nom A-Z",
  "Nome Completo": "Nom complet",
  "Nome alterado para \"{value0}\"": "Nom remplacé par « {value0} »",
  "Nome atualizado": "Nom mis à jour",
  "Nome completo": "Nom complet",
  "Nome da Ação *": "Nom de l'action *",
  "Nome da Classe": "Nom de la classe",
  "Nome da Playlist": "Nom de la playlist",
  "Nome da Playlist *": "Nom de la playlist *",
  "Nome da Variação": "Nom de la variante",
  "Nome da etapa": "Nom de l'étape",
  "Nome da legenda": "Nom des sous-titres",
  "Nome da pasta": "Nom du dossier",
  "Nome da proteção": "Nom de la protection",
  "Nome de parâmetro inválido": "Nom de paramètre invalide",
  "Nome deve ter pelo menos 2 caracteres.": "Le nom doit comporter au moins 2 caractères.",
  "Nome do Criador": "Nom du créateur",
  "Nome do Evento": "Nom de l'événement",
  "Nome do Serviço *": "Nom du service *",
  "Nome do Teste": "Nom du test",
  "Nome do Teste *": "Nom du test *",
  "Nome do Teste A/B": "Nom du test A/B",
  "Nome do Titular da Conta": "Nom du titulaire du compte",
  "Nome do Usuário": "Nom de l'utilisateur",
  "Nome do Vídeo": "Nom de la vidéo",
  "Nome do Webinário": "Nom du webinaire",
  "Nome do Webinário *": "Nom du webinaire *",
  "Nome do fluxo": "Nom du parcours",
  "Nome do membro": "Nom du membre",
  "Nome do parâmetro": "Nom du paramètre",
  "Nome do produto": "Nom du produit",
  "Nome do teste": "Nom du test",
  "Nome do vídeo": "Nom de la vidéo",
  "Nome exibido ao lado do favicon": "Nom affiché à côté du favicon",
  "Nome igual ao documento": "Nom identique à celui du document",
  "Nome impresso no cartão": "Nom figurant sur la carte",
  "Nome interno": "Nom interne",
  "Nome interno para identificação (não será exibido publicamente)": "Nom interne pour l'identification (non affiché publiquement)",
  "Nome interno para identificação. Não será exibido ao público.": "Nom interne pour l'identification. Il ne sera pas affiché au public.",
  "Nome muito longo": "Nom trop long",
  "Nome muito longo (máximo 80 caracteres)": "Nom trop long (80 caractères maximum)",
  "Nome no cartão": "Nom sur la carte",
  "Nome não pode estar vazio": "Le nom ne peut pas être vide",
  "Nome obrigatório": "Nom obligatoire",
  "Nome usado apenas para organização interna.": "Nom utilisé uniquement pour l'organisation interne.",
  "Nome é obrigatório": "Le nom est obligatoire",
  "Nome:": "Nom :",
  "Nomes": "Noms",
  "Normal": "Normal",
  "Normalizar por dia": "Normaliser par jour",
  "Nossa tecnologia de Cloaker protege sua VSL contra cópias de forma simples.": "Notre technologie de Cloaker protège simplement votre VSL contre les copies.",
  "Nota 1 a 5": "Note de 1 à 5",
  "Nota média": "Note moyenne",
  "Notas internas (opcional)": "Notes internes (facultatives)",
  "Notificação de Vendas": "Notification de ventes",
  "Notificação de Vendas salva": "Notification de ventes enregistrée",
  "Notificação de teste": "Notification de test",
  "Notificação enviada": "Notification envoyée",
  "Notificações": "Notifications",
  "Notificações Ativas": "Notifications actives",
  "Notificações Bloqueadas": "Notifications bloquées",
  "Notificações Desativadas": "Notifications désactivées",
  "Notificações Push": "Notifications push",
  "Notificações ativadas!": "Notifications activées !",
  "Notificações não disponíveis": "Notifications indisponibles",
  "Nova Captura": "Nouvelle capture",
  "Nova Despesa": "Nouvelle dépense",
  "Nova Pasta": "Nouveau dossier",
  "Nova Permissão": "Nouvelle autorisation",
  "Nova Playlist": "Nouvelle playlist",
  "Nova Senha": "Nouveau mot de passe",
  "Nova Subpasta": "Nouveau sous-dossier",
  "Nova Variação": "Nouvelle variante",
  "Nova Variação de Headline": "Nouvelle variante de titre",
  "Nova York (GMT-5)": "New York (GMT-5)",
  "Nova aba": "Nouvel onglet",
  "Nova chave": "Nouvelle clé",
  "Nova chave de API": "Nouvelle clé API",
  "Nova data de término": "Nouvelle date de fin",
  "Nova funcionalidade disponível": "Nouvelle fonctionnalité disponible",
  "Nova integração com {value0} será criada": "Une nouvelle intégration avec {value0} sera créée",
  "Nova pasta": "Nouveau dossier",
  "Nova proteção": "Nouvelle protection",
  "Nova saída": "Nouvelle sortie",
  "Nova senha": "Nouveau mot de passe",
  "Nova senha deve ser diferente da atual": "Le nouveau mot de passe doit être différent du mot de passe actuel",
  "Nova tag...": "Nouveau tag...",
  "Nova venda!": "Nouvelle vente !",
  "Novas Conversões": "Nouvelles conversions",
  "Novas conversões": "Nouvelles conversions",
  "Novidades": "Nouveautés",
  "Novo": "Nouveau",
  "Novo Dashboard Premium Host VSL 2.0": "Nouveau tableau de bord premium Host VSL 2.0",
  "Novo Front Host VSL 2.0": "Nouvelle interface Host VSL 2.0",
  "Novo Mini-Hook": "Nouveau Mini-Hook",
  "Novo Método de Pagamento": "Nouveau moyen de paiement",
  "Novo Player de vídeo da HostVSL": "Nouveau lecteur vidéo HostVSL",
  "Novo Registro": "Nouvel enregistrement",
  "Novo Registro de Incremento": "Nouvel enregistrement d'ajout",
  "Novo Teste": "Nouveau test",
  "Novo Texto": "Nouveau texte",
  "Novo Vídeo": "Nouvelle vidéo",
  "Novo Webinário": "Nouveau webinaire",
  "Novo lead: João Silva": "Nouveau lead : João Silva",
  "Novo link gerado com sucesso!": "Nouveau lien généré avec succès !",
  "Novo nome": "Nouveau nom",
  "Novo recurso": "Nouvelle fonctionnalité",
  "Novo status": "Nouveau statut",
  "Novo template Prime Video Dark com hero banner, grid de aulas com paginação, modal de reprodução com navegação entre episódios.": "Nouveau modèle Prime Video Dark avec bannière principale, grille de cours paginée et fenêtre de lecture avec navigation entre les épisodes.",
  "Novo template de área de membros com hero banner 1920×700, módulos/bônus em grid, progress tracking persistente, CTAs por vídeo.": "Nouveau modèle d'espace membres avec bannière principale 1920×700, modules/bonus en grille, suivi persistant de la progression et CTA par vidéo.",
  "Novo token gerado.": "Nouveau jeton généré.",
  "Novo valor": "Nouvelle valeur",
  "Novos recursos no editor": "Nouvelles fonctionnalités dans l'éditeur",
  "Novos recursos, melhorias e orientações para usar a HostVSL.": "Nouvelles fonctionnalités, améliorations et conseils pour utiliser HostVSL.",
  "Numeração": "Numérotation",
  "Nunito (Rounded)": "Nunito (arrondi)",
  "NÃO, OBRIGADO": "NON MERCI",
  "Não Configurado": "Non configuré",
  "Não assistido": "Non regardé",
  "Não conectado": "Non connecté",
  "Não definida": "Non définie",
  "Não encontramos aulas com os filtros selecionados. Tente ajustar sua busca ou explorar outras categorias.": "Aucun cours ne correspond aux filtres sélectionnés. Ajustez votre recherche ou explorez d'autres catégories.",
  "Não encontramos nenhuma pasta com \"": "Aucun dossier trouvé avec «",
  "Não encontramos um cupom com esse nome.": "Aucun code promo trouvé avec ce nom.",
  "Não encontramos vídeos com \"{value0}\"": "Aucune vidéo trouvée avec « {value0} »",
  "Não exibir localização": "Ne pas afficher la localisation",
  "Não existem testes de velocidade automáticos": "Aucun test automatique de vitesse",
  "Não fechar automaticamente": "Ne pas fermer automatiquement",
  "Não foi possível abrir a transmissão": "Impossible de lancer la diffusion",
  "Não foi possível abrir o fluxo": "Impossible d'ouvrir le parcours",
  "Não foi possível abrir o seletor": "Impossible d'ouvrir le sélecteur",
  "Não foi possível abrir o seletor AirPlay": "Impossible d'ouvrir le sélecteur AirPlay",
  "Não foi possível ativar o seu perfil de afiliado.": "Impossible d'activer votre profil affilié.",
  "Não foi possível atualizar o nome do teste.": "Impossible de mettre à jour le nom du test.",
  "Não foi possível atualizar o nome. Tente novamente.": "Impossible de mettre à jour le nom. Réessayez.",
  "Não foi possível carregar a audiência ao vivo": "Impossible de charger l'audience en direct",
  "Não foi possível carregar a comparação": "Impossible de charger la comparaison",
  "Não foi possível carregar a lista de vídeos": "Impossible de charger la liste des vidéos",
  "Não foi possível carregar a lista de vídeos.": "Impossible de charger la liste des vidéos.",
  "Não foi possível carregar as aulas": "Impossible de charger les cours",
  "Não foi possível carregar as métricas.": "Impossible de charger les indicateurs.",
  "Não foi possível carregar as plataformas.": "Impossible de charger les plateformes.",
  "Não foi possível carregar as plataformas. Tente novamente.": "Impossible de charger les plateformes. Réessayez.",
  "Não foi possível carregar o player da VSL Dinâmica.": "Impossible de charger le lecteur de la VSL dynamique.",
  "Não foi possível carregar os dados para edição.": "Impossible de charger les données pour la modification.",
  "Não foi possível carregar os vídeos. Tentar de novo": "Impossible de charger les vidéos. Réessayer",
  "Não foi possível carregar seus fluxos.": "Impossible de charger vos parcours.",
  "Não foi possível carregar seus vídeos.": "Impossible de charger vos vidéos.",
  "Não foi possível carregar suas chaves": "Impossible de charger vos clés",
  "Não foi possível concluir. Tente novamente.": "Impossible de terminer. Réessayez.",
  "Não foi possível conectar": "Impossible de se connecter",
  "Não foi possível copiar as configurações. Tente novamente.": "Impossible de copier les paramètres. Réessayez.",
  "Não foi possível copiar o código.": "Impossible de copier le code.",
  "Não foi possível copiar o código. Tente novamente.": "Impossible de copier le code. Réessayez.",
  "Não foi possível copiar o token.": "Impossible de copier le jeton.",
  "Não foi possível copiar. Copie o código pelo editor do fluxo.": "Impossible de copier. Copiez le code depuis l'éditeur du parcours.",
  "Não foi possível copiar. Selecione a URL para copiar.": "Impossible de copier. Sélectionnez l'URL pour la copier.",
  "Não foi possível copiar. Selecione o código e copie manualmente.": "Impossible de copier. Sélectionnez le code et copiez-le manuellement.",
  "Não foi possível copiar. Selecione o texto e copie manualmente.": "Impossible de copier. Sélectionnez le texte et copiez-le manuellement.",
  "Não foi possível criar a pasta": "Impossible de créer le dossier",
  "Não foi possível criar contexto do canvas": "Impossible de créer le contexte du canvas",
  "Não foi possível criar o fluxo.": "Impossible de créer le parcours.",
  "Não foi possível criar o teste de velocidade": "Impossible de créer le test de vitesse",
  "Não foi possível criar o teste de velocidade.": "Impossible de créer le test de vitesse.",
  "Não foi possível criar o teste. Tente novamente.": "Impossible de créer le test. Réessayez.",
  "Não foi possível deletar o teste de velocidade.": "Impossible de supprimer le test de vitesse.",
  "Não foi possível deletar o teste. Tente novamente.": "Impossible de supprimer le test. Réessayez.",
  "Não foi possível desativar a captura.": "Impossible de désactiver la capture.",
  "Não foi possível duplicar o vídeo. Tente novamente.": "Impossible de dupliquer la vidéo. Réessayez.",
  "Não foi possível excluir o teste": "Impossible de supprimer le test",
  "Não foi possível gerar a thumbnail. Tente novamente.": "Impossible de générer la miniature. Réessayez.",
  "Não foi possível gerar o código": "Impossible de générer le code",
  "Não foi possível gerar o token. Tentar novamente.": "Impossible de générer le jeton. Réessayer.",
  "Não foi possível identificar o usuário. Faça login novamente.": "Impossible d'identifier l'utilisateur. Reconnectez-vous.",
  "Não foi possível processar este link. Tente novamente ou entre em contato com o produtor.": "Impossible de traiter ce lien. Réessayez ou contactez le producteur.",
  "Não foi possível processar o saque.": "Impossible de traiter le retrait.",
  "Não foi possível renomear o fluxo.": "Impossible de renommer le parcours.",
  "Não foi possível renomear o teste.": "Impossible de renommer le test.",
  "Não foi possível salvar a regra. Tente novamente.": "Impossible d'enregistrer la règle. Réessayez.",
  "Não foi possível salvar a velocidade": "Impossible d'enregistrer la vitesse",
  "Não foi possível salvar as alterações. Tente novamente.": "Impossible d'enregistrer les modifications. Réessayez.",
  "Não foi possível salvar as configurações.": "Impossible d'enregistrer les paramètres.",
  "Não foi possível salvar o pitch. Tente novamente.": "Impossible d'enregistrer l'argumentaire de vente. Réessayez.",
  "Não foi possível salvar o rascunho. Tente novamente.": "Impossible d'enregistrer le brouillon. Réessayez.",
  "Não foi possível salvar. Tente novamente": "Impossible d'enregistrer. Réessayez",
  "Não foi salvo": "Non enregistré",
  "Não há capturas para os filtros aplicados. Tente ajustar os filtros ou selecione outro período.": "Aucune capture ne correspond aux filtres appliqués. Ajustez les filtres ou choisissez une autre période.",
  "Não há dados de vídeos disponíveis para exibir o gráfico de retenção.": "Aucune donnée vidéo disponible pour afficher le graphique de rétention.",
  "Não há dados para exportar.": "Aucune donnée à exporter.",
  "Não há métricas para o período selecionado. Aguarde a coleta de dados ou ajuste o período.": "Aucun indicateur pour la période sélectionnée. Attendez la collecte des données ou ajustez la période.",
  "Não há visualizações com parâmetros UTM neste período. Use parâmetros UTM nas suas URLs para rastrear a origem do tráfego.": "Aucune vue avec des paramètres UTM pendant cette période. Utilisez des paramètres UTM dans vos URL pour suivre la source du trafic.",
  "Não informado": "Non renseigné",
  "Não possui um cadastro?": "Vous n'avez pas de compte ?",
  "Não repetir": "Ne pas répéter",
  "Não salvo": "Non enregistré",
  "Não salvo (conflito)": "Non enregistré (conflit)",
  "Não selecionada": "Non sélectionnée",
  "Não solicitar dados": "Ne pas demander de données",
  "Não! A participação no programa é 100% gratuita. Você só precisa se cadastrar e começar a indicar.": "Non ! La participation au programme est entièrement gratuite. Il suffit de vous inscrire et de commencer à parrainer.",
  "Não! Você pode fazer quantas indicações quiser. Quanto mais clientes ativos você tiver, maior será sua comissão recorrente mensal.": "Non ! Vous pouvez parrainer autant de personnes que vous le souhaitez. Plus vous avez de clients actifs, plus votre commission mensuelle récurrente augmente.",
  "Não, obrigado": "Non merci",
  "Não, obrigado. Quero continuar": "Non merci. Je souhaite continuer",
  "Não, obrigado. Quero continuar sem essa oferta": "Non merci. Je souhaite continuer sans cette offre",
  "Nível de Acesso": "Niveau d'accès",
  "Nível do usuário atualizado com sucesso!": "Niveau de l'utilisateur mis à jour avec succès !",
  "Número": "Numéro",
  "Número da Conta com DV": "Numéro de compte avec chiffre de contrôle",
  "Número de Linhas": "Nombre de lignes",
  "Número de cliques no botão": "Nombre de clics sur le bouton",
  "Número de cliques nos elementos interativos do vídeo.": "Nombre de clics sur les éléments interactifs de la vidéo.",
  "Número de pessoas que clicaram no botão de ação (CTA) dentro do vídeo.": "Nombre de personnes ayant cliqué sur le bouton d'action (CTA) dans la vidéo.",
  "Número de vezes que o vídeo foi iniciado por visitantes.": "Nombre de fois où la vidéo a été lancée par des visiteurs.",
  "Número de visitantes únicos que ativaram este evento": "Nombre de visiteurs uniques ayant déclenché cet événement",
  "Número de visitantes únicos que visualizaram o vídeo.": "Nombre de visiteurs uniques ayant vu la vidéo.",
  "Número do Cartão": "Numéro de carte",
  "Número do WhatsApp": "Numéro WhatsApp",
  "Número do cartão": "Numéro de carte",
  "Número do cartão inválido": "Numéro de carte invalide",
  "Número máximo de afiliados que podem copiar": "Nombre maximal d'affiliés pouvant copier",
  "Número total de carregamentos do seu vídeo.": "Nombre total de chargements de votre vidéo.",
  "Número total de cliques no botão de call-to-action (CTA) do vídeo.": "Nombre total de clics sur le bouton d'appel à l'action (CTA) de la vidéo.",
  "Número total de cliques recebidos por este evento": "Nombre total de clics reçus par cet événement",
  "Número total de vendas confirmadas pelas plataformas de pagamento": "Nombre total de ventes confirmées par les plateformes de paiement",
  "Número total de vezes que o play foi dado no vídeo.": "Nombre total de lancements de la vidéo.",
  "Número total de vezes que o vídeo foi carregado, independente se foi assistido ou não.": "Nombre total de chargements de la vidéo, qu'elle ait été regardée ou non.",
  "Números principais em métricas": "Chiffres principaux dans les indicateurs",
  "Números principais em toda área de Métricas ajustados para font-weight 500, criando hierarquia visual mais clara e premium.": "Les chiffres principaux de toute la section Indicateurs utilisent désormais une graisse de police de 500 pour une hiérarchie visuelle plus claire et premium.",
  "O \"Vídeo Principal\" é o arquivo sem introdução. Depois, você adiciona as intros que serão tocadas antes dele para medir qual abertura gera mais atenção e conversão.": "La « vidéo principale » est le fichier sans introduction. Ajoutez ensuite les intros à lire avant celle-ci pour mesurer l'ouverture qui génère le plus d'attention et de conversions.",
  "O CEP deve conter exatamente 8 dígitos.": "Le code postal brésilien doit comporter exactement 8 chiffres.",
  "O CPF deve conter exatamente 11 dígitos.": "Le CPF doit comporter exactement 11 chiffres.",
  "O HostVSL está sendo instalado": "Installation de HostVSL en cours",
  "O HostVSL está sendo instalado no seu dispositivo.": "Installation de HostVSL sur votre appareil.",
  "O JavaScript oferece mais customização e integração com eventos.": "JavaScript offre davantage de personnalisation et d'intégration avec les événements.",
  "O Meta Pixel é uma ferramenta de automação de marketing que ajuda a aumentar a conversão de vendas e a retenção de clientes.": "Meta Pixel est un outil d'automatisation marketing qui aide à augmenter les conversions de vente et la fidélisation des clients.",
  "O Smart Autoplay exibe um vídeo automático antes do usuário clicar para assistir. Ideal para aumentar retenção e curiosidade.": "Smart Autoplay affiche automatiquement une vidéo avant que l'utilisateur clique pour regarder. Idéal pour augmenter la rétention et la curiosité.",
  "O Teste de hook alterna automaticamente entre intros diferentes e coleta dados como retenção e cliques.": "Le test d'accroche alterne automatiquement entre différentes intros et recueille des données telles que la rétention et les clics.",
  "O URL deve iniciar com https://": "L'URL doit commencer par https://",
  "O app já está instalado ou seu navegador não suporta instalação.": "L'application est déjà installée ou votre navigateur ne permet pas l'installation.",
  "O arquivo deve ter no máximo 100MB": "Le fichier doit faire au maximum 100 Mo",
  "O arquivo deve ter no máximo 100MB.": "Le fichier doit faire au maximum 100 Mo.",
  "O arquivo deve ter no máximo 500KB": "Le fichier doit faire au maximum 500 Ko",
  "O arquivo foi baixado com sucesso.": "Le fichier a été téléchargé avec succès.",
  "O arquivo precisa ter até 10MB.": "Le fichier doit faire au maximum 10 Mo.",
  "O botão foi removido do thumbnail de pausa": "Le bouton a été retiré de la miniature de pause",
  "O botão será aplicado automaticamente ao vídeo ativo no preview": "Le bouton sera appliqué automatiquement à la vidéo active dans l'aperçu",
  "O botão será exibido após este tempo de reprodução do vídeo": "Le bouton s'affichera après cette durée de lecture vidéo",
  "O botão só aparece pra quem tem um dispositivo compatível na rede — sem poluir o player de quem não usa": "Le bouton apparaît uniquement lorsqu'un appareil compatible est présent sur le réseau, sans encombrer le lecteur des autres spectateurs",
  "O contador oscilará dentro deste intervalo durante o vídeo.": "Le compteur variera dans cet intervalle pendant la vidéo.",
  "O cupom aplicado na sua assinatura é mantido na ativação.": "Le code promo de votre abonnement est conservé lors de l'activation.",
  "O código de incorporação foi copiado para a área de transferência": "Le code d'intégration a été copié dans le presse-papiers",
  "O código de incorporação foi copiado para a área de transferência.": "Le code d'intégration a été copié dans le presse-papiers.",
  "O código de integração foi copiado para a área de transferência.": "Le code d'intégration a été copié dans le presse-papiers.",
  "O código de segurança está incorreto.": "Le code de sécurité est incorrect.",
  "O código do teste A/B foi copiado para a área de transferência.": "Le code du test A/B a été copié dans le presse-papiers.",
  "O código foi copiado para a área de transferência.": "Le code a été copié dans le presse-papiers.",
  "O código que já está nos seus sites passa a mostrar esta versão nas próximas visitas. Não precisa colar de novo.": "Le code déjà présent sur vos sites affichera cette version lors des prochaines visites. Vous n'avez pas besoin de le recoller.",
  "O dashboard foi completamente redesenhado com cards executivos de métricas, feed de vídeos em tempo real e insights de performance. Uma experiência visual nível Apple para gerenciar seus vídeos.": "Le tableau de bord a été entièrement repensé avec des cartes d'indicateurs de synthèse, un fil de vidéos en temps réel et des analyses de performances. Une expérience visuelle inspirée d'Apple pour gérer vos vidéos.",
  "O domínio \"": "Le domaine «",
  "O download do arquivo CSV começará em instantes.": "Le téléchargement du fichier CSV commencera dans un instant.",
  "O ecossistema definitivo": "L'écosystème ultime",
  "O editor da VSL Dinâmica precisa de uma tela com pelo menos 1024 px. A lista e as métricas funcionam no celular.": "L'éditeur de VSL dynamique nécessite un écran d'au moins 1024 px. La liste et les indicateurs fonctionnent sur mobile.",
  "O endereço salvo continua o anterior.": "L'adresse enregistrée reste la précédente.",
  "O engajamento em mobile está": "L'engagement sur mobile est",
  "O engajamento está baixo. Isso significa que as pessoas estão desistindo cedo do vídeo. Considere revisar os primeiros 15 segundos - eles são críticos! Adicione um 'gancho' atrativo no início e evite introduções longas.": "L'engagement est faible : les personnes quittent rapidement la vidéo. Revoyez les 15 premières secondes, qui sont essentielles ! Ajoutez une accroche attractive au début et évitez les longues introductions.",
  "O estilo será controlado pelo código HTML inserido na aba Configuração. Use CSS inline ou classes personalizadas para estilizar seu botão.": "Le style sera géré par le code HTML saisi dans l'onglet Configuration. Utilisez du CSS inline ou des classes personnalisées pour styliser votre bouton.",
  "O fim deve ser 0 ou maior/igual ao início.": "La fin doit être égale à 0 ou supérieure ou égale au début.",
  "O fluxo ainda não tem etapas.": "Le parcours ne contient encore aucune étape.",
  "O fluxo ainda não tem opções.": "Le parcours ne contient encore aucune option.",
  "O fluxo ainda não tem saídas.": "Le parcours ne contient encore aucune sortie.",
  "O fluxo continua em rascunho.": "Le parcours reste à l'état de brouillon.",
  "O fluxo pode ter no máximo {value0} etapas.": "Le parcours peut contenir au maximum {value0} étapes.",
  "O fluxo pode ter no máximo {value0} saídas.": "Le parcours peut contenir au maximum {value0} sorties.",
  "O fluxo tem": "Le parcours comporte",
  "O formato de história tem provado ser muito eficaz para manter o engajamento do início ao fim.": "Le format narratif a démontré sa grande efficacité pour maintenir l'engagement du début à la fin.",
  "O formato narrativo está funcionando bem! Continue contando histórias que se conectam emocionalmente com seu público.": "Le format narratif fonctionne bien ! Continuez à raconter des histoires qui créent un lien émotionnel avec votre audience.",
  "O gráfico será atualizado quando houver atividade": "Le graphique sera mis à jour lorsqu'une activité sera détectée",
  "O iFrame é a forma mais simples de incorporar, mas oferece menos customização.": "L'iFrame est la méthode d'intégration la plus simple, mais offre moins de personnalisation.",
  "O ideal: curva lenta e constante, mantendo acima de 50% até o minuto 1.": "L'idéal : une courbe lente et régulière, restant au-dessus de 50% jusqu'à la première minute.",
  "O início deve ser maior ou igual a zero.": "Le début doit être supérieur ou égal à zéro.",
  "O link da playlist foi copiado": "Le lien de la playlist a été copié",
  "O link da playlist foi copiado para a área de transferência.": "Le lien de la playlist a été copié dans le presse-papiers.",
  "O link de afiliado é obrigatório quando o recurso está ativado.": "Le lien affilié est obligatoire lorsque la fonctionnalité est active.",
  "O link para {value0} já está na sua área de transferência.": "Le lien vers {value0} est déjà dans votre presse-papiers.",
  "O nome da estratégia foi atualizado com sucesso.": "Le nom de la stratégie a été mis à jour avec succès.",
  "O nome da pasta não pode estar vazio": "Le nom du dossier ne peut pas être vide",
  "O nome da playlist precisa ter pelo menos 3 caracteres": "Le nom de la playlist doit comporter au moins 3 caractères",
  "O nome deve ter pelo menos 2 caracteres": "Le nom doit comporter au moins 2 caractères",
  "O nome do seu teste não pode estar vazio.": "Le nom de votre test ne peut pas être vide.",
  "O nome do teste foi atualizado com sucesso.": "Le nom du test a été mis à jour avec succès.",
  "O nome do teste precisa ter pelo menos 3 caracteres": "Le nom du test doit comporter au moins 3 caractères",
  "O número definido em \"Base\" será exibido automaticamente após a mensagem.": "Le nombre défini dans « Base » s'affichera automatiquement après le message.",
  "O pitch precisa de ajustes urgentes.": "L'argumentaire de vente nécessite des ajustements urgents.",
  "O pixel do Facebook é uma ferramenta de análise que permite medir a eficácia da sua publicidade ao compreender as ações que as pessoas realizam no seu site.": "Le pixel Facebook est un outil d'analyse permettant de mesurer l'efficacité de votre publicité en comprenant les actions effectuées par les internautes sur votre site.",
  "O pixel foi conectado com sucesso.": "Le pixel a été connecté avec succès.",
  "O pixel foi configurado e ativado com sucesso.": "Le pixel a été configuré et activé avec succès.",
  "O pixel foi desativado com sucesso.": "Le pixel a été désactivé avec succès.",
  "O pixel foi removido com sucesso.": "Le pixel a été supprimé avec succès.",
  "O principal começa logo após o vídeo de entrada.": "La vidéo principale démarre juste après la vidéo d'entrée.",
  "O produtor desativou este compartilhamento. Entre em contato com ele para solicitar um novo link.": "Le producteur a désactivé ce partage. Contactez-le pour demander un nouveau lien.",
  "O que acontece ao terminar ou pular.": "Action à la fin ou lorsque la vidéo est passée.",
  "O que acontece após o usuário enviar o formulário": "Action après l'envoi du formulaire par l'utilisateur",
  "O que acontece quando a regra for atendida": "Action lorsque la règle est satisfaite",
  "O que vai acontecer": "Ce qui va se passer",
  "O que você vai aprender:": "Ce que vous allez apprendre :",
  "O que é o Programa de Parcerias Host VSL?": "Qu'est-ce que le programme de partenariat Host VSL ?",
  "O rascunho continua salvo. Só a publicação fica bloqueada até resolver.": "Le brouillon reste enregistré. Seule la publication est bloquée jusqu'à la résolution.",
  "O rascunho é salvo sozinho e não muda o que está no ar. Pré-visualize, publique e cole o código na sua página. O código é sempre o mesmo: publicar de novo atualiza o vídeo no site.": "Le brouillon est enregistré automatiquement et ne modifie pas la version en ligne. Prévisualisez, publiez et collez le code sur votre page. Le code reste le même : une nouvelle publication met à jour la vidéo sur le site.",
  "O recurso foi desativado com sucesso.": "La fonctionnalité a été désactivée avec succès.",
  "O servidor recusou este vínculo. Preencha primeiro o 'Perfil Comercial' à esquerda antes de adicionar o banco.": "Le serveur a refusé cette association. Remplissez d'abord le « Profil commercial » à gauche avant d'ajouter la banque.",
  "O sistema de rotas é gerenciado pelo React Router v6. Todas as rotas principais são protegidas pelo componente ProtectedRoute que verifica autenticação.": "Le routage est géré par React Router v6. Toutes les routes principales sont protégées par le composant ProtectedRoute, qui vérifie l'authentification.",
  "O sistema distribuirá o tráfego entre as introduções selecionadas, garantindo uma amostra estatística válida.": "Le système répartira le trafic entre les introductions sélectionnées pour garantir un échantillon statistique valide.",
  "O sistema distribuirá o tráfego entre os vídeos selecionados, garantindo uma amostra estatística válida.": "Le système répartira le trafic entre les vidéos sélectionnées pour garantir un échantillon statistique valide.",
  "O status do teste foi atualizado.": "Le statut du test a été mis à jour.",
  "O template da mensagem não pode estar vazio": "Le modèle du message ne peut pas être vide",
  "O tempo de Pitch é:": "Le moment de l'argumentaire de vente est :",
  "O tempo de saída precisa ser maior que o tempo de entrada.": "Le temps de sortie doit être supérieur au temps d'entrée.",
  "O tempo do pitch foi salvo com sucesso.": "Le moment de l'argumentaire de vente a été enregistré avec succès.",
  "O tempo informado é maior que a duração do vídeo.": "Le temps indiqué dépasse la durée de la vidéo.",
  "O teste A/B foi excluído com sucesso.": "Le test A/B a été supprimé avec succès.",
  "O teste A/B foi finalizado com sucesso.": "Le test A/B a été terminé avec succès.",
  "O teste de introduções foi finalizado com sucesso.": "Le test d'introductions a été terminé avec succès.",
  "O teste de velocidade foi criado e está coletando dados": "Le test de vitesse a été créé et recueille des données",
  "O teste está coletando dados em tempo real": "Le test recueille des données en temps réel",
  "O teste foi excluído com sucesso.": "Le test a été supprimé avec succès.",
  "O teste roda normalmente, mas sem as métricas de conversão das plataformas de pagamento.": "Le test fonctionne normalement, sans les indicateurs de conversion des plateformes de paiement.",
  "O teste será encerrado e a variação principal será aplicada. Esta ação não pode ser desfeita.": "Le test sera terminé et la variante principale sera appliquée. Cette action est irréversible.",
  "O teste só encerra quando você clicar em \"Finalizar Teste\".": "Le test ne se termine que lorsque vous cliquez sur « Terminer le test ».",
  "O teste usará as": "Le test utilisera les",
  "O texto da legenda não pode estar vazio.": "Le texte des sous-titres ne peut pas être vide.",
  "O texto foi copiado para a área de transferência.": "Le texte a été copié dans le presse-papiers.",
  "O texto principal que aparece no formulário": "Le texte principal affiché dans le formulaire",
  "O token é de uso único, expira em 30 minutos e não dá acesso ao seu e-mail ou senha.": "Le jeton est à usage unique, expire après 30 minutes et ne donne accès ni à votre e-mail ni à votre mot de passe.",
  "O total deve ser 100%. Atualmente: {value0}%": "Le total doit être égal à 100%. Actuellement : {value0}%",
  "O título deve ter no máximo 100 caracteres": "Le titre doit comporter au maximum 100 caractères",
  "O vídeo": "La vidéo",
  "O vídeo \"": "La vidéo «",
  "O vídeo ainda está processando.": "La vidéo est encore en cours de traitement.",
  "O vídeo começará exatamente no horário agendado. Participantes que entrarem depois verão o vídeo já em andamento.": "La vidéo commencera exactement à l'heure prévue. Les participants qui arrivent ensuite verront la vidéo déjà en cours.",
  "O vídeo da etapa {value0} ainda está processando.": "La vidéo de l'étape {value0} est encore en cours de traitement.",
  "O vídeo da etapa {value0} não existe mais neste fluxo.": "La vidéo de l'étape {value0} n'existe plus dans ce parcours.",
  "O vídeo deve ter no máximo 2GB": "La vidéo doit faire au maximum 2 Go",
  "O vídeo deve ter no máximo 500MB": "La vidéo doit faire au maximum 500 Mo",
  "O vídeo foi adicionado à sua conta com sucesso. Os plays serão contabilizados no seu plano.": "La vidéo a été ajoutée à votre compte avec succès. Les lectures seront décomptées de votre forfait.",
  "O vídeo foi movido para a pasta selecionada.": "La vidéo a été déplacée vers le dossier sélectionné.",
  "O vídeo foi removido da playlist.": "La vidéo a été retirée de la playlist.",
  "O vídeo inicia no momento correspondente ao horário atual": "La vidéo démarre au moment correspondant à l'heure actuelle",
  "O vídeo pausa ao sair da aba e retoma automaticamente ao retornar.": "La vidéo se met en pause lorsque l'utilisateur quitte l'onglet et reprend automatiquement à son retour.",
  "O vídeo pausa após o envio do formulário": "La vidéo se met en pause après l'envoi du formulaire",
  "O vídeo pausa após o usuário enviar a senha correta": "La vidéo se met en pause après la saisie du bon mot de passe",
  "O vídeo pausa automaticamente quando o visitante sai da aba, retomando ao voltar.": "La vidéo se met automatiquement en pause lorsque le visiteur quitte l'onglet et reprend à son retour.",
  "O vídeo pausa quando o formulário aparecer": "La vidéo se met en pause à l'apparition du formulaire",
  "O vídeo pausa quando o formulário de senha aparece": "La vidéo se met en pause à l'apparition du formulaire de mot de passe",
  "O vídeo que mais gerou receita": "La vidéo ayant généré le plus de chiffre d'affaires",
  "O vídeo selecionado não está disponível": "La vidéo sélectionnée est indisponible",
  "O vídeo selecionado, será exibido após todas as introduções testadas.": "La vidéo sélectionnée sera affichée après toutes les introductions testées.",
  "O vídeo será pausado automaticamente nesse tempo": "La vidéo sera automatiquement mise en pause à ce moment",
  "O ícone do HostVSL aparecerá na sua tela inicial": "L'icône HostVSL apparaîtra sur votre écran d'accueil",
  "O ícone será exibido automaticamente conforme a plataforma.": "L'icône sera affichée automatiquement selon la plateforme.",
  "OAuth cancelado": "OAuth annulé",
  "OFERTA ESPECIAL PARA VOCÊ": "OFFRE SPÉCIALE POUR VOUS",
  "OFERTA ÚNICA!": "OFFRE UNIQUE !",
  "ORDENAR POR": "TRIER PAR",
  "Obrigado pelo seu feedback!": "Merci pour votre avis !",
  "Obrigado por nos informar!": "Merci de nous avoir informés !",
  "Obrigatório": "Obligatoire",
  "Observação interna": "Note interne",
  "Observação:": "Remarque :",
  "Observe a taxa de cliques em botões de ação": "Observez le taux de clics sur les boutons d'action",
  "Observe se a diferença se mantém constante ao longo de diversos dias.": "Vérifiez si l'écart reste constant sur plusieurs jours.",
  "Ocorreu um erro ao carregar o conteúdo. Verifique sua conexão e tente novamente.": "Une erreur est survenue lors du chargement du contenu. Vérifiez votre connexion et réessayez.",
  "Ocorreu um erro ao carregar o vídeo": "Une erreur est survenue lors du chargement de la vidéo",
  "Ocorreu um erro ao configurar a integração.": "Une erreur est survenue lors de la configuration de l'intégration.",
  "Ocorreu um erro ao criar o teste. Tente novamente.": "Une erreur est survenue lors de la création du test. Réessayez.",
  "Ocorreu um erro ao gerar o gráfico de retenção. Por favor, tente novamente mais tarde.": "Une erreur est survenue lors de la génération du graphique de rétention. Réessayez plus tard.",
  "Ocorreu um erro ao processar a ativação.": "Une erreur est survenue lors du traitement de l'activation.",
  "Ocorreu um erro ao remover a logo": "Une erreur est survenue lors de la suppression du logo",
  "Ocorreu um erro ao remover a thumbnail": "Une erreur est survenue lors de la suppression de la miniature",
  "Ocorreu um erro ao salvar as configurações. Tente novamente.": "Une erreur est survenue lors de l'enregistrement des paramètres. Réessayez.",
  "Ocorreu um erro ao salvar suas alterações": "Une erreur est survenue lors de l'enregistrement de vos modifications",
  "Ocorreu um erro inesperado ao carregar as configurações de headline.": "Une erreur inattendue est survenue lors du chargement des paramètres de titre.",
  "Ocorreu um erro inesperado ao carregar esta página. Tente recarregar ou limpar o cache.": "Une erreur inattendue est survenue lors du chargement de cette page. Rechargez-la ou videz le cache.",
  "Ocorreu um erro inesperado. Por favor, recarregue a página.": "Une erreur inattendue est survenue. Veuillez recharger la page.",
  "Ocorreu um erro. Tente novamente.": "Une erreur est survenue. Réessayez.",
  "Oculta os controles até a primeira interação": "Masque les commandes jusqu'à la première interaction",
  "Ocultar": "Masquer",
  "Ocultar Feedback": "Masquer les avis",
  "Ocultar Pause": "Masquer la pause",
  "Ocultar Vídeo": "Masquer la vidéo",
  "Ocultar elemento": "Masquer l'élément",
  "Ocultar modal": "Masquer la fenêtre",
  "Ocultar senha": "Masquer le mot de passe",
  "Ocultar token": "Masquer le jeton",
  "Ofereça vantagens especiais para quem comprar com você (ex. bônus exclusivo com link).": "Proposez des avantages spéciaux aux personnes qui achètent avec vous (ex. : bonus exclusif avec lien).",
  "Oferta": "Offre",
  "Oferta Especial": "Offre spéciale",
  "Oferta Especial Liberada!": "Offre spéciale débloquée !",
  "Oferta ativada! Plano atualizado com sucesso.": "Offre activée ! Forfait mis à jour avec succès.",
  "Oferta com Preço": "Offre avec prix",
  "Oferta com Progresso": "Offre avec progression",
  "Oferta com Riscado": "Offre avec prix barré",
  "Oferta disponível somente nesta página": "Offre disponible uniquement sur cette page",
  "Oferta exclusiva": "Offre exclusive",
  "Oferta expirada": "Offre expirée",
  "Oferta relâmpago": "Offre éclair",
  "Oferta termina em": "L'offre se termine dans",
  "Ofertas": "Offres",
  "Ofertas nos Vídeos": "Offres dans les vidéos",
  "Offset Horizontal": "Décalage horizontal",
  "Offset Vertical": "Décalage vertical",
  "Olá, {value0}": "Bonjour, {value0}",
  "Onde o formulário será exibido sobre o vídeo": "Emplacement du formulaire sur la vidéo",
  "Online": "En ligne",
  "Only safe HTML elements are allowed. Scripts and event handlers will be removed.": "Seuls les éléments HTML sûrs sont autorisés. Les scripts et les gestionnaires d'événements seront supprimés.",
  "Ontem": "Hier",
  "Oops! Page not found": "Oups ! Page introuvable",
  "Opacidade": "Opacité",
  "Opacidade ao passar o mouse": "Opacité au survol",
  "Opacidade do fundo": "Opacité du fond",
  "Opacidade:": "Opacité :",
  "Opaco": "Opaque",
  "Open Sans": "Open Sans",
  "Open Sans (Classic)": "Open Sans (classique)",
  "Opera": "Opera",
  "Operador": "Opérateur",
  "Operador obrigatório": "Opérateur obligatoire",
  "Operador é obrigatório": "L'opérateur est obligatoire",
  "Oportunidades Escondidas": "Opportunités cachées",
  "Optimize sua thumbnail": "Optimisez votre miniature",
  "Opção": "Option",
  "Opção de recusa": "Option de refus",
  "Opções": "Options",
  "Opções avançadas": "Options avancées",
  "Opções de personalização em breve.": "Options de personnalisation à venir.",
  "Ordem atualizada": "Ordre mis à jour",
  "Ordem atualizada!": "Ordre mis à jour !",
  "Ordenar por": "Trier par",
  "Organize e personalize os campos de inscrição (arraste para reordenar)": "Organisez et personnalisez les champs d'inscription (faites glisser pour réorganiser)",
  "Organize por campanha ou grupo": "Organisez par campagne ou groupe",
  "Organize seus vídeos como nunca antes com o novo sistema hierárquico de pastas. Crie pastas, subpastas, arraste e solte vídeos para organizar seu conteúdo de forma profissional.": "Organisez vos vidéos comme jamais avec le nouveau système de dossiers hiérarchiques. Créez des dossiers et des sous-dossiers, puis glissez-déposez vos vidéos pour organiser professionnellement votre contenu.",
  "Organize seus vídeos criando pastas e subpastas": "Organisez vos vidéos avec des dossiers et des sous-dossiers",
  "Organize seus vídeos em sequência e compartilhe com seu público": "Organisez vos vidéos en séquence et partagez-les avec votre public",
  "Organize seus vídeos em sequências e publique com 1 clique.": "Organisez vos vidéos en séquences et publiez en 1 clic.",
  "Orientação do Formulário": "Orientation du formulaire",
  "Origem": "Source",
  "Origem (Source)": "Source (Source)",
  "Origem Top": "Meilleure source",
  "Origem dos Leads": "Source des leads",
  "Origem dos visitantes": "Source des visiteurs",
  "Origem principal:": "Source principale :",
  "Origens": "Sources",
  "Origens (": "Sources (",
  "Origens de Tráfego": "Sources de trafic",
  "Origens no gráfico": "Sources dans le graphique",
  "Original": "Original",
  "Original:": "Original :",
  "Os": "Les",
  "Os 3 dígitos no verso do cartão": "Les 3 chiffres au dos de la carte",
  "Os dados de dispositivos aparecerão após os primeiros acessos.": "Les données sur les appareils apparaîtront après les premiers accès.",
  "Os dados estão sendo atualizados para o novo período": "Les données sont en cours de mise à jour pour la nouvelle période",
  "Os dados estão sendo exportados em CSV": "Les données sont en cours d'exportation au format CSV",
  "Os dados serão exibidos aqui quando houver interações com o seu conteúdo.": "Les données s'afficheront ici lorsque votre contenu recevra des interactions.",
  "Os dados são atualizados a cada 15 minutos.": "Les données sont mises à jour toutes les 15 minutes.",
  "Os downloads falharam. Tente novamente.": "Les téléchargements ont échoué. Réessayez.",
  "Os plays serão consumidos do seu plano.": "Les lectures seront décomptées de votre forfait.",
  "Os primeiros 15 segundos são críticos. Considere testar diferentes abordagens com Teste de hook.": "Les 15 premières secondes sont essentielles. Envisagez de tester différentes approches avec le test d'accroche.",
  "Os relatórios de performance ficarão disponíveis aqui após a criação de estratégias.": "Les rapports de performances seront disponibles ici après la création de stratégies.",
  "Os serviços de segurança da Stripe estão carregando. Aguarde.": "Les services de sécurité Stripe se chargent. Veuillez patienter.",
  "Os seus saldos acumulados são liquidados diretamente na sua carteira configurada de forma segura e pontual.": "Vos soldes cumulés sont versés directement dans votre portefeuille configuré, de manière sûre et ponctuelle.",
  "Os sites que já têm o código passam a mostrar esta versão nas próximas visitas.": "Les sites qui possèdent déjà le code afficheront cette version lors des prochaines visites.",
  "Os testes A/B de headlines requerem que o autoplay esteja ativado para garantir que os usuários vejam as variações antes de interagir com o vídeo.": "Les tests A/B de titres nécessitent l'activation de l'Autoplay pour garantir que les utilisateurs voient les variantes avant d'interagir avec la vidéo.",
  "Os testes de velocidade permitem comparar diferentes configurações para encontrar a melhor para seu público.": "Les tests de vitesse permettent de comparer différentes configurations pour trouver celle qui convient le mieux à votre audience.",
  "Os testes de velocidade permitem que você faça testes A/B de diferentes velocidades de reprodução para encontrar a configuração ideal para engajamento e conversões.": "Les tests de vitesse permettent d'effectuer des tests A/B avec différentes vitesses de lecture pour trouver la configuration idéale en matière d'engagement et de conversions.",
  "Os uploads em andamento serão cancelados. Esta ação não pode ser desfeita.": "Les envois en cours seront annulés. Cette action est irréversible.",
  "Os vídeos foram salvos com sucesso.": "Les vidéos ont été enregistrées avec succès.",
  "Os vídeos são enviados dentro do fluxo e ficam só nele: não aparecem em \"Meus vídeos\". Assim que terminam de processar, já podem ser usados nas etapas.": "Les vidéos sont envoyées dans le parcours et y restent : elles n'apparaissent pas dans « Mes vidéos ». Une fois traitées, elles peuvent être utilisées dans les étapes.",
  "Oswald": "Oswald",
  "Oswald (Bold)": "Oswald (gras)",
  "Other": "Autre",
  "Otimizando…": "Optimisation…",
  "Otimizar Introdução": "Optimiser l'introduction",
  "Otimizar automaticamente": "Optimiser automatiquement",
  "Otimização": "Optimisation",
  "Otimize a experiência mobile sem comprometer o desktop": "Optimisez l'expérience mobile sans compromettre celle sur ordinateur",
  "Otimize o Início": "Optimisez le début",
  "Otimize suas ofertas com base em dados de performance": "Optimisez vos offres à partir des données de performances",
  "Ou URL de destino (opcional)": "Ou URL de destination (facultative)",
  "Ou envie um WhatsApp para:": "Ou envoyez un message WhatsApp au :",
  "Outro": "Autre",
  "Outro idioma…": "Autre langue…",
  "Outros": "Autres",
  "Overlay de Pausa": "Superposition de pause",
  "Overlay de Vídeo": "Superposition vidéo",
  "Overlay drag visual": "Superposition visuelle de déplacement",
  "Overlay escuro (VTurb)": "Superposition sombre (VTurb)",
  "Overlay escuro para leitura": "Superposition sombre pour la lecture",
  "Overlay personalizado": "Superposition personnalisée",
  "PDF gerado com sucesso!": "PDF généré avec succès !",
  "PDF pronto para impressão": "PDF prêt à imprimer",
  "PITCH": "ARGUMENTAIRE",
  "PLAYER": "LECTEUR",
  "PNG 256×256px recomendado": "PNG 256×256px recommandé",
  "PNG com fundo transparente • Máx. 1MB": "PNG avec fond transparent • Max. 1 Mo",
  "PNG ou JPG · até 10MB": "PNG ou JPG · jusqu'à 10 Mo",
  "PNG recomendado": "PNG recommandé",
  "PNG transparente branco recomendado": "PNG blanc transparent recommandé",
  "PNG, JPG até 4MB": "PNG, JPG jusqu'à 4 Mo",
  "PNG, JPG ou SVG · até 2 MB": "PNG, JPG ou SVG · jusqu'à 2 Mo",
  "PNG, JPG, GIF • Máx. 5MB": "PNG, JPG, GIF • Max. 5 Mo",
  "PRÉ-VISUALIZAÇÃO": "APERÇU",
  "Padronizar configurações": "Uniformiser les paramètres",
  "Padrão": "Par défaut",
  "Padrão Host": "Par défaut Host",
  "Padrão de Uso": "Tendance d'utilisation",
  "Padrão do player": "Paramètres par défaut du lecteur",
  "Padrão global": "Valeur globale par défaut",
  "Padrões de interrupção": "Ruptures de rythme",
  "Pagamento 100% seguro": "Paiement 100% sécurisé",
  "Pagamento Atualizado": "Paiement mis à jour",
  "Pagamento Criado": "Paiement créé",
  "Pagamento Falhou": "Échec du paiement",
  "Pagamento atualizado com sucesso!": "Paiement mis à jour avec succès !",
  "Pagamento criptografado e processado com segurança.": "Paiement chiffré et traité de manière sécurisée.",
  "Pagar agora": "Payer maintenant",
  "Pago": "Payé",
  "Pague faturas em aberto e baixe as anteriores": "Payez les factures en attente et téléchargez les précédentes",
  "Painel lateral": "Panneau latéral",
  "Painéis": "Panneaux",
  "Palavra por palavra": "Mot par mot",
  "Para VSLs de venda, recomendamos exibir o feedback apenas no final ou após o pitch para não interromper a conversão.": "Pour les VSL de vente, nous recommandons de demander un avis uniquement à la fin ou après l'argumentaire afin de ne pas interrompre la conversion.",
  "Para acompanhar conversões, conecte o Rastreamento.": "Pour suivre les conversions, connectez le suivi.",
  "Para alto volume de tráfego": "Pour un trafic élevé",
  "Para começar com mais limite": "Pour commencer avec une limite plus élevée",
  "Para conteúdos educativos, priorize o engajamento; para vendas, priorize a taxa de conversão": "Pour un contenu éducatif, privilégiez l'engagement ; pour les ventes, privilégiez le taux de conversion",
  "Para exibir a thumbnail de início, desabilite a reprodução automática.": "Pour afficher la miniature de début, désactivez la lecture automatique.",
  "Para finalizar": "Pour terminer",
  "Para melhores resultados, use vídeos com a": "Pour de meilleurs résultats, utilisez des vidéos avec la",
  "Para onde o botão HTML vai redirecionar o visitante.": "Destination du visiteur après un clic sur le bouton HTML.",
  "Para onde o visitante vai ao escolher uma opção: checkout, WhatsApp ou outra página.": "Destination du visiteur après le choix d'une option : paiement, WhatsApp ou autre page.",
  "Para operações com alto volume": "Pour les activités à fort volume",
  "Para otimizar ainda mais, considere aumentar o ritmo ou adicionar elementos visuais entre 45-60% do vídeo.": "Pour optimiser davantage, envisagez d'accélérer le rythme ou d'ajouter des éléments visuels entre 45 et 60% de la vidéo.",
  "Para pausar o vídeo, a etapa precisa de pelo menos uma opção.": "Pour mettre la vidéo en pause, l'étape doit contenir au moins une option.",
  "Para pausar o vídeo, defina quando as opções aparecem.": "Pour mettre la vidéo en pause, définissez l'apparition des options.",
  "Para que as alterações da headline funcionem, você precisa copiar o código do vídeo depois de salvar e colar no seu site.": "Pour appliquer les modifications du titre, copiez le code de la vidéo après l'enregistrement et collez-le sur votre site.",
  "Para que as alterações do botão de ação abaixo do vídeo funcionem, você precisa copiar o código do vídeo depois de salvar e colar no seu site.": "Pour appliquer les modifications du bouton d'action sous la vidéo, copiez le code de la vidéo après l'enregistrement et collez-le sur votre site.",
  "Para resultados confiáveis, espere pelo menos 100-200 visualizações por variação.": "Pour des résultats fiables, attendez au moins 100 à 200 vues par variante.",
  "Para usar a Barra de Progresso personalizada, desative os controles do player.": "Pour utiliser la barre de progression personnalisée, désactivez les commandes du lecteur.",
  "Para visualizar todos os dados de receita, conversões e desempenho, conecte sua plataforma de pagamento. É rápido e seguro.": "Pour voir toutes les données de chiffre d'affaires, de conversions et de performances, connectez votre plateforme de paiement. C'est rapide et sécurisé.",
  "Parabéns!": "Félicitations !",
  "Parabéns! A sua conta de afiliado foi ativada.": "Félicitations ! Votre compte affilié a été activé.",
  "Parabéns! 🏆": "Félicitations ! 🏆",
  "Parado": "Arrêté",
  "Parceiros": "Partenaires",
  "Parceiros Oficiais": "Partenaires officiels",
  "Parceiros oficiais": "Partenaires officiels",
  "Parceiros — Página Premium 10/10": "Partenaires — Page premium 10/10",
  "Parcerias": "Partenariats",
  "Parece que este link não é válido. Verifique e tente novamente.": "Ce lien semble invalide. Vérifiez-le et réessayez.",
  "Paris (GMT+1)": "Paris (GMT+1)",
  "Participantes entram direto na sala sem preencher formulário": "Les participants entrent directement dans la salle sans remplir de formulaire",
  "Parâmetro": "Paramètre",
  "Parâmetro UTM": "Paramètre UTM",
  "Parâmetro UTM é obrigatório": "Le paramètre UTM est obligatoire",
  "Parâmetro da UTM": "Paramètre de l'UTM",
  "Parâmetro obrigatório": "Paramètre obligatoire",
  "Parâmetros": "Paramètres",
  "Parâmetros fixos": "Paramètres fixes",
  "Pasta": "Dossier",
  "Pasta criada": "Dossier créé",
  "Pasta criada.": "Dossier créé.",
  "Pasta excluída": "Dossier supprimé",
  "Pasta excluída.": "Dossier supprimé.",
  "Pasta não encontrada": "Dossier introuvable",
  "Pasta personalizada criada": "Dossier personnalisé créé",
  "Pasta renomeada": "Dossier renommé",
  "Pasta renomeada com sucesso!": "Dossier renommé avec succès !",
  "Pasta renomeada.": "Dossier renommé.",
  "Pasta vazia": "Dossier vide",
  "Pastas": "Dossiers",
  "Pastas Hierárq.": "Dossiers hiérarchiques",
  "Pastas específicas": "Dossiers spécifiques",
  "Pausa": "Pause",
  "Pausa Inteligente": "Pause intelligente",
  "Pausa automática ao detectar que o espectador saiu da aba": "Pause automatique lorsque le spectateur quitte l'onglet",
  "Pausa inteligente ativada": "Pause intelligente activée",
  "Pausa inteligente desativada": "Pause intelligente désactivée",
  "Pausa o vídeo ao sair da aba e retoma ao voltar automaticamente.": "Met la vidéo en pause lorsque l'utilisateur quitte l'onglet et reprend automatiquement à son retour.",
  "Pausa o vídeo automaticamente quando o espectador sai da aba do navegador.": "Met automatiquement la vidéo en pause lorsque le spectateur quitte l'onglet du navigateur.",
  "Pausa o vídeo quando o espectador sai da aba.": "Met la vidéo en pause lorsque le spectateur quitte l'onglet.",
  "Pausado": "En pause",
  "Pausados": "En pause",
  "Pausar": "Mettre en pause",
  "Pausar ao abrir a senha": "Mettre en pause à l'ouverture du mot de passe",
  "Pausar ao enviar senha": "Mettre en pause après l'envoi du mot de passe",
  "Pausar em (min:seg)": "Mettre en pause à (min:sec)",
  "Pausar fluxo": "Mettre le parcours en pause",
  "Pausar vídeo ao abrir": "Mettre la vidéo en pause à l'ouverture",
  "Pausar vídeo ao enviar": "Mettre la vidéo en pause à l'envoi",
  "PayPal (E-mail)": "PayPal (e-mail)",
  "País": "Pays",
  "País das regiões": "Pays des régions",
  "País e região obrigatórios": "Pays et région obligatoires",
  "País e região são obrigatórios": "Le pays et la région sont obligatoires",
  "País não encontrado": "Pays introuvable",
  "País obrigatório": "Pays obligatoire",
  "País sem regiões mapeadas": "Pays sans régions répertoriées",
  "País é obrigatório": "Le pays est obligatoire",
  "País:": "Pays :",
  "País: {value0}": "Pays : {value0}",
  "Países": "Pays",
  "Pendente": "En attente",
  "Pequeno": "Petit",
  "Percentual": "Pourcentage",
  "Percentual da largura do player": "Pourcentage de la largeur du lecteur",
  "Percentual de espectadores que ainda assistia no momento do pitch": "Pourcentage de spectateurs encore présents au moment de l'argumentaire de vente",
  "Percentual de espectadores que ainda assistiam quando cada pitch começou.": "Pourcentage de spectateurs encore présents au début de chaque argumentaire de vente.",
  "Percentual de visitantes que clicaram para iniciar o vídeo. Melhore sua thumbnail para aumentar este número.": "Pourcentage de visiteurs ayant cliqué pour lancer la vidéo. Améliorez votre miniature pour augmenter ce chiffre.",
  "Percentual de visitantes que clicaram play no vídeo. Valores acima de 70% são considerados bons. Impactada principalmente pelo thumbnail e título.": "Pourcentage de visiteurs ayant lancé la vidéo. Les valeurs supérieures à 70% sont considérées comme bonnes. Dépend principalement de la miniature et du titre.",
  "Percentual de visitantes que iniciaram o vídeo": "Pourcentage de visiteurs ayant lancé la vidéo",
  "Percentual do vídeo {value0}": "Pourcentage de la vidéo {value0}",
  "Percentual médio assistido dos vídeos": "Pourcentage moyen des vidéos regardé",
  "Percentual médio de retenção do vídeo assistido": "Pourcentage moyen de rétention de la vidéo regardée",
  "Percentual médio do vídeo que foi assistido pelos espectadores.": "Pourcentage moyen de la vidéo regardé par les spectateurs.",
  "Percepção do conteúdo ao longo do período.": "Perception du contenu pendant la période.",
  "Perda no fim = oferta fraca ou muito longa.": "Perte à la fin = offre faible ou trop longue.",
  "Perdendo": "Perdant",
  "Perfect Pay": "Perfect Pay",
  "Perfeito para vendas e call-to-actions": "Idéal pour les ventes et les appels à l'action",
  "Perfil": "Profil",
  "Perfil Comercial": "Profil commercial",
  "Perfil comercial updated e saques liberados!": "Profil commercial mis à jour et retraits débloqués !",
  "Perfil do usuário": "Profil de l'utilisateur",
  "Perfil salvo": "Profil enregistré",
  "Perfis ideais para o programa de parcerias": "Profils idéaux pour le programme de partenariat",
  "Performance de Engajamento": "Performances d'engagement",
  "Performance neste horário": "Performances à cet horaire",
  "Pergunta (opcional)": "Question (facultative)",
  "Perguntas Frequentes": "Questions fréquentes",
  "Pergunte a quem assistiu o que achou da sua VSL e receba a nota dentro do próprio player.": "Demandez aux spectateurs leur avis sur votre VSL et recevez leur note directement dans le lecteur.",
  "Permissão": "Autorisation",
  "Permissão Alterada": "Autorisation modifiée",
  "Permissão necessária": "Autorisation nécessaire",
  "Permissão é obrigatória": "L'autorisation est obligatoire",
  "Permissão:": "Autorisation :",
  "Permissões agrupadas por área: Vídeos, Conversão, Análises, Otimização, Proteção e Conta": "Autorisations regroupées par section : Vidéos, Conversion, Analyses, Optimisation, Protection et Compte",
  "Permissões atualizadas com sucesso!": "Autorisations mises à jour avec succès !",
  "Permissões limitadas atribuídas.": "Autorisations limitées attribuées.",
  "Permissões por Recurso": "Autorisations par fonctionnalité",
  "Permita interação com o vídeo e aumente controle, retenção e experiência do usuário.": "Permettez l'interaction avec la vidéo et améliorez le contrôle, la rétention et l'expérience utilisateur.",
  "Permita ou bloqueie a reprodução dos seus vídeos com base na localização.": "Autorisez ou bloquez la lecture de vos vidéos selon la localisation.",
  "Permita que espectadores avaliem o vídeo e acompanhe a percepção real do conteúdo.": "Permettez aux spectateurs d'évaluer la vidéo et suivez leur perception réelle du contenu.",
  "Permita que o espectador retome de onde parou.": "Permettez au spectateur de reprendre là où il s'était arrêté.",
  "Permita que o usuário controle a velocidade do vídeo": "Permettez à l'utilisateur de régler la vitesse de la vidéo",
  "Permita uma observação após a nota.": "Autorisez un commentaire après la note.",
  "Permite ajustar a velocidade do vídeo": "Permet de régler la vitesse de la vidéo",
  "Permite ajustar o áudio": "Permet de régler le son",
  "Permite assistir em janela flutuante": "Permet de regarder dans une fenêtre flottante",
  "Permite entrada direta na sala sem formulário de login. Ideal para tráfego qualificado.": "Permet un accès direct à la salle sans formulaire de connexion. Idéal pour le trafic qualifié.",
  "Permite expandir o vídeo para tela cheia": "Permet de passer la vidéo en plein écran",
  "Permite pular o vídeo de entrada.": "Permet de passer la vidéo d'entrée.",
  "Permite pular rapidamente trechos": "Permet de passer rapidement des passages",
  "Permite que o espectador ative ou desative": "Permet au spectateur d'activer ou de désactiver",
  "Permite que o espectador retome o vídeo de onde parou.": "Permet au spectateur de reprendre la vidéo là où il s'était arrêté.",
  "Permite que o usuário continue de onde parou": "Permet à l'utilisateur de reprendre là où il s'était arrêté",
  "Permite que o usuário continue sem preencher o formulário": "Permet à l'utilisateur de continuer sans remplir le formulaire",
  "Permite que o vídeo reinicie automaticamente quando terminar": "Permet à la vidéo de redémarrer automatiquement à la fin",
  "Permite que usuários retomem o vídeo de onde pararam": "Permet aux utilisateurs de reprendre la vidéo là où ils s'étaient arrêtés",
  "Permite que visitantes entrem direto na sala sem fazer login. Útil para maximizar acessos, mas reduz a captação de leads.": "Permet aux visiteurs d'entrer directement dans la salle sans se connecter. Utile pour maximiser les accès, mais réduit la collecte de leads.",
  "Permite reiniciar automaticamente o vídeo assim que ele terminar.": "Permet de relancer automatiquement la vidéo dès la fin.",
  "Permitidas": "Autorisées",
  "Permitido": "Autorisé",
  "Permitido: {value0}": "Autorisé : {value0}",
  "Permitidos": "Autorisés",
  "Permitir": "Autoriser",
  "Permitir apenas": "Autoriser uniquement",
  "Permitir apenas e-mails de domínios específicos": "Autoriser uniquement les e-mails de domaines spécifiques",
  "Permitir comentário após avaliação": "Autoriser un commentaire après l'évaluation",
  "Permitir entrada até (minutos após início)": "Autoriser l'entrée jusqu'à (minutes après le début)",
  "Permitir fechar no \"X\"": "Autoriser la fermeture avec « X »",
  "Permitir repetir este vídeo ao terminar.": "Autoriser la répétition de cette vidéo à la fin.",
  "Permitir selecionados": "Autoriser la sélection",
  "Persistir como barra fixa": "Conserver comme barre fixe",
  "Persistência": "Persistance",
  "Persistência:": "Persistance :",
  "Personalizado": "Personnalisé",
  "Personalizar": "Personnaliser",
  "Personalizar Caixa do Autoplay": "Personnaliser la zone d'Autoplay",
  "Personalizar Logo…": "Personnaliser le logo…",
  "Personalizar Tema": "Personnaliser le thème",
  "Personalizar Vídeo": "Personnaliser la vidéo",
  "Personalizar Vídeos": "Personnaliser les vidéos",
  "Personalização": "Personnalisation",
  "Personalização Total": "Personnalisation complète",
  "Personalização Visual": "Personnalisation visuelle",
  "Personalização da Logo": "Personnalisation du logo",
  "Personalizações": "Personnalisations",
  "Personalize a aparência da página de inscrição": "Personnalisez l'apparence de la page d'inscription",
  "Personalize a aparência do Autoplay": "Personnalisez l'apparence de l'Autoplay",
  "Personalize a barra de progresso do player.": "Personnalisez la barre de progression du lecteur.",
  "Personalize a exibição das legendas no player.": "Personnalisez l'affichage des sous-titres dans le lecteur.",
  "Personalize as cores do botão.": "Personnalisez les couleurs du bouton.",
  "Personalize as cores dos elementos do formulário": "Personnalisez les couleurs des éléments du formulaire",
  "Personalize as cores e aparência do player.": "Personnalisez les couleurs et l'apparence du lecteur.",
  "Personalize as cores e espessura da barra de progresso.": "Personnalisez les couleurs et l'épaisseur de la barre de progression.",
  "Personalize as cores, opacidade e bordas dos controles do player para combinar com sua marca.": "Personnalisez les couleurs, l'opacité et les bordures des commandes du lecteur pour les adapter à votre marque.",
  "Personalize as mensagens do feedback.": "Personnalisez les messages de demande d'avis.",
  "Personalize cores dos controles e da barra inferior.": "Personnalisez les couleurs des commandes et de la barre inférieure.",
  "Personalize cores, animações e efeitos visuais": "Personnalisez les couleurs, les animations et les effets visuels",
  "Personalize estilo, cor e posição do card.": "Personnalisez le style, la couleur et la position de la carte.",
  "Personalize formato, cores, botões, borda, barra de progresso e a forma de iniciar o player, com opções adaptadas ao mobile.": "Personnalisez le format, les couleurs, les boutons, la bordure, la barre de progression et le démarrage du lecteur avec des options adaptées au mobile.",
  "Personalize headline e subheadline": "Personnalisez le titre et le sous-titre",
  "Personalize o Player": "Personnalisez le lecteur",
  "Personalize o comportamento do player para cada tipo de dispositivo": "Personnalisez le comportement du lecteur pour chaque type d'appareil",
  "Personalize o player de forma independente para cada tipo de dispositivo": "Personnalisez le lecteur indépendamment pour chaque type d'appareil",
  "Período": "Période",
  "Período *": "Période *",
  "Período atualizado": "Période mise à jour",
  "Período campeão": "Meilleure période",
  "Período não definido": "Période non définie",
  "Peso da Fonte": "Graisse de la police",
  "Peso:": "Graisse :",
  "Pesquisar nesta pasta...": "Rechercher dans ce dossier...",
  "Pesquisar novidades...": "Rechercher des nouveautés...",
  "Pesquisar vídeo ou pasta...": "Rechercher une vidéo ou un dossier...",
  "Pesquisar vídeos": "Rechercher des vidéos",
  "Pesquisar...": "Rechercher...",
  "Pessoal": "Personnel",
  "Pessoas cadastradas através dos seus links.": "Personnes inscrites via vos liens.",
  "Pessoas que assistiram": "Personnes ayant regardé",
  "Pessoas únicas": "Personnes uniques",
  "Pico Absoluto": "Pic absolu",
  "Pico Absoluto (": "Pic absolu (",
  "Pico Absoluto (Volume)": "Pic absolu (volume)",
  "Pico Absoluto de Conversão": "Pic absolu de conversion",
  "Pico de audiência": "Pic d'audience",
  "Pico no horário de maior audiência": "Pic à l'heure de plus forte audience",
  "Picos de Horário nas Métricas do Vídeo": "Pics horaires dans les indicateurs vidéo",
  "Picture-in-Picture": "Image dans l'image",
  "Pill": "Pilule",
  "Pitch": "Argumentaire de vente",
  "Pitch atualizado": "Argumentaire de vente mis à jour",
  "Pitch atualizado com sucesso!": "Argumentaire de vente mis à jour avec succès !",
  "Pitch não configurado — clique para definir": "Argumentaire non configuré — cliquez pour le définir",
  "Pitch:": "Argumentaire de vente :",
  "Pixel": "Pixel",
  "Pixel ID": "ID du pixel",
  "Pixel ID deve ter 15-16 dígitos numéricos": "L'ID du pixel doit comporter 15 à 16 chiffres",
  "Pixel ID do TikTok inválido. Use o ID alfanumérico do Events Manager.": "ID du pixel TikTok invalide. Utilisez l'identifiant alphanumérique de l'Events Manager.",
  "Pixel adicionado com sucesso!": "Pixel ajouté avec succès !",
  "Pixel ativo": "Pixel actif",
  "Pixel atualizado": "Pixel mis à jour",
  "Pixel atualizado com sucesso!": "Pixel mis à jour avec succès !",
  "Pixel conectado": "Pixel connecté",
  "Pixel configurado": "Pixel configuré",
  "Pixel configurado com sucesso!": "Pixel configuré avec succès !",
  "Pixel desativado": "Pixel désactivé",
  "Pixel do Google Ads": "Pixel Google Ads",
  "Pixel do TikTok": "Pixel TikTok",
  "Pixel excluído com sucesso!": "Pixel supprimé avec succès !",
  "Pixel removido": "Pixel supprimé",
  "Pixels & Integrações": "Pixels et intégrations",
  "Pixels Ativos": "Pixels actifs",
  "Pixels Cadastrados": "Pixels enregistrés",
  "Pixels ativos": "Pixels actifs",
  "Placeholder": "Texte indicatif",
  "Placeholder do comentário": "Texte indicatif du commentaire",
  "Plano": "Forfait",
  "Plano / Subscription": "Forfait / Abonnement",
  "Plano / Valor": "Forfait / Montant",
  "Plano Ativo": "Forfait actif",
  "Plano Ativo — {value0}": "Forfait actif — {value0}",
  "Plano Atual": "Forfait actuel",
  "Plano Selecionado": "Forfait sélectionné",
  "Plano inativo": "Forfait inactif",
  "Plano indisponível no momento": "Forfait indisponible actuellement",
  "Plano mais rápido": "Forfait le plus rapide",
  "Plano {value0}": "Forfait {value0}",
  "Plano {value0} ativado com sucesso! Aproveite os 15 dias grátis!": "Forfait {value0} activé avec succès ! Profitez des 15 jours gratuits !",
  "Plataforma": "Plateforme",
  "Plataforma conectada. Aguardando primeiros eventos de venda.": "Plateforme connectée. En attente des premiers événements de vente.",
  "Plataforma de comunicação para atendimento ao cliente e marketing.": "Plateforme de communication pour le service client et le marketing.",
  "Plataforma de e-commerce para lojas online e pagamentos.": "Plateforme d'e-commerce pour boutiques en ligne et paiements.",
  "Plataforma de origem das conversões registradas. Clique para ver detalhes de cada plataforma.": "Plateforme d'origine des conversions enregistrées. Cliquez pour voir les détails de chaque plateforme.",
  "Plataforma de vendas": "Plateforme de vente",
  "Plataforma para email marketing e automação de campanhas.": "Plateforme d'e-mail marketing et d'automatisation des campagnes.",
  "Plataforma:": "Plateforme :",
  "Plataformas": "Plateformes",
  "Plataformas conectadas": "Plateformes connectées",
  "Play": "Lecture",
  "Play Grande": "Grand bouton de lecture",
  "Play Pequeno": "Petit bouton de lecture",
  "Play Rate": "Taux de lecture",
  "Play Rate Médio": "Taux de lecture moyen",
  "Play Rate do Dia": "Taux de lecture du jour",
  "Play Rate hoje": "Taux de lecture aujourd'hui",
  "Play Rate:": "Taux de lecture :",
  "Play após carregar a página": "Lecture après le chargement de la page",
  "Play extra por R$ 0,02": "Lecture supplémentaire à R$ 0,02",
  "Play rate": "Taux de lecture",
  "Play, som e tela cheia": "Lecture, son et plein écran",
  "PlayRate": "Taux de lecture",
  "Player Simulado": "Lecteur simulé",
  "Player com sua Identidade Visual": "Lecteur avec votre identité visuelle",
  "Player de Vídeo": "Lecteur vidéo",
  "Player grande + lista lateral (desktop) ou lista abaixo (mobile). Layout limpo e profissional.": "Grand lecteur avec liste latérale sur ordinateur ou liste en dessous sur mobile. Présentation épurée et professionnelle.",
  "Player premium desbloqueado": "Lecteur premium débloqué",
  "Playfair Display (Elegant)": "Playfair Display (élégant)",
  "Playlist com {value0}MB. Considere usar imagens menores para evitar problemas.": "Playlist de {value0} Mo. Envisagez des images plus petites pour éviter les problèmes.",
  "Playlist criada!": "Playlist créée !",
  "Playlist excluída": "Playlist supprimée",
  "Playlist não encontrada": "Playlist introuvable",
  "Playlist salva!": "Playlist enregistrée !",
  "Playlist sem título": "Playlist sans titre",
  "Playlist vazia": "Playlist vide",
  "Playlists": "Playlists",
  "Playlists — Sistema Unificado de Edição": "Playlists — Système d'édition unifié",
  "Playrate": "Taux de lecture",
  "Plays": "Lectures",
  "Plays Extras Adquiridos": "Lectures supplémentaires achetées",
  "Plays Totais": "Lectures totales",
  "Plays divididos pelas visualizações únicas do dia": "Lectures divisées par les vues uniques du jour",
  "Plays extras": "Lectures supplémentaires",
  "Plays extras adquiridos": "Lectures supplémentaires achetées",
  "Plays hoje": "Lectures aujourd'hui",
  "Plays restantes": "Lectures restantes",
  "Plays Únicos": "Lectures uniques",
  "Plays ÷ visualizações": "Lectures ÷ vues",
  "Plays únicos": "Lectures uniques",
  "Plays únicos por dia e horário": "Lectures uniques par jour et horaire",
  "Plays únicos por usuário": "Lectures uniques par utilisateur",
  "Plays únicos:": "Lectures uniques :",
  "Plays:": "Lectures :",
  "Plugin de comércio eletrônico para WordPress.": "Extension d'e-commerce pour WordPress.",
  "Pode editar e adicionar vídeos": "Peut modifier et ajouter des vidéos",
  "Pode editar e adicionar vídeos, mas não gerenciar usuários": "Peut modifier et ajouter des vidéos, sans gérer les utilisateurs",
  "Pode impactar performance": "Peut affecter les performances",
  "Pode ver vídeos e métricas": "Peut voir les vidéos et les indicateurs",
  "Poderá solicitar o resgate dos seus valores acumulados assim que atingir o piso mínimo estipulado no extrato.": "Vous pourrez demander le retrait de vos fonds cumulés dès que le seuil minimal indiqué dans le relevé sera atteint.",
  "Polski": "Polski",
  "Política de Cookies": "Politique relative aux cookies",
  "Política de Privacidade": "Politique de confidentialité",
  "Política de privacidade": "Politique de confidentialité",
  "Ponto crítico onde os espectadores abandonam o vídeo.": "Point critique où les spectateurs quittent la vidéo.",
  "Ponto de Entrada": "Point d'entrée",
  "Ponto de entrada": "Point d'entrée",
  "Ponto do pitch": "Repère de l'argumentaire de vente",
  "Pontos de Queda": "Points de décrochage",
  "Pontuação geral de engajamento baseada em múltiplos fatores: retenção, cliques e interações.": "Score global d'engagement fondé sur plusieurs facteurs : rétention, clics et interactions.",
  "Pop / Destaque": "Pop / Accentuation",
  "Poppins": "Poppins",
  "Poppins (Friendly)": "Poppins (convivial)",
  "Popup bloqueado. Permita popups para exportar.": "Fenêtre contextuelle bloquée. Autorisez les fenêtres contextuelles pour exporter.",
  "Por": "Par",
  "Por Categoria": "Par catégorie",
  "Por Dispositivo": "Par appareil",
  "Por Provedor": "Par fournisseur",
  "Por Serviço": "Par service",
  "Por etapa": "Par étape",
  "Por favor, anexe o comprovante de transferência.": "Veuillez joindre le justificatif de virement.",
  "Por favor, corrija os erros antes de continuar.": "Veuillez corriger les erreurs avant de continuer.",
  "Por favor, digite um e-mail.": "Veuillez saisir une adresse e-mail.",
  "Por favor, envie um arquivo de vídeo.": "Veuillez envoyer un fichier vidéo.",
  "Por favor, informe o {value0}": "Veuillez renseigner {value0}",
  "Por favor, insira o nome completo (Nome e Sobrenome) exigido pela Stripe.": "Veuillez saisir le nom complet (prénom et nom) requis par Stripe.",
  "Por favor, insira um nome para o teste.": "Veuillez saisir un nom pour le test.",
  "Por favor, preencha a chave PIX.": "Veuillez renseigner la clé PIX.",
  "Por favor, preencha o e-mail do PayPal.": "Veuillez renseigner l'adresse e-mail PayPal.",
  "Por favor, selecione ambos os arquivos (Frente e Verso) do seu documento.": "Veuillez sélectionner les deux fichiers de votre document (recto et verso).",
  "Por favor, selecione apenas arquivos de vídeo": "Veuillez sélectionner uniquement des fichiers vidéo",
  "Por favor, selecione um arquivo de vídeo": "Veuillez sélectionner un fichier vidéo",
  "Por favor, selecione um país": "Veuillez sélectionner un pays",
  "Por favor, selecione um vídeo": "Veuillez sélectionner une vidéo",
  "Por favor, selecione um vídeo original": "Veuillez sélectionner une vidéo d'origine",
  "Por favor, selecione um vídeo principal.": "Veuillez sélectionner une vidéo principale.",
  "Por favor, selecione uma imagem válida (JPG, PNG, WEBP)": "Veuillez sélectionner une image valide (JPG, PNG, WEBP)",
  "Por favor, selecione uma região": "Veuillez sélectionner une région",
  "Por favor, verifique se a distribuição de tráfego soma 100%": "Veuillez vérifier que la répartition du trafic totalise 100%",
  "Por opção": "Par option",
  "Por quanto tempo a notificação permanece visível.": "Durée pendant laquelle la notification reste visible.",
  "Por que o Storytelling Funciona?": "Pourquoi la narration fonctionne-t-elle ?",
  "Por saída": "Par sortie",
  "Por vídeo": "Par vidéo",
  "Porcentagem": "Pourcentage",
  "Porcentagem de espectadores ao longo do tempo": "Pourcentage de spectateurs au fil du temps",
  "Porcentagem de espectadores que continuam assistindo ao vídeo em cada momento. Quedas bruscas indicam pontos de abandono.": "Pourcentage de spectateurs continuant à regarder la vidéo à chaque instant. Les baisses soudaines indiquent des points d'abandon.",
  "Porcentagem de pessoas que ainda estavam assistindo": "Pourcentage de personnes qui regardaient encore",
  "Porcentagem de visualizadores que iniciam a reprodução do vídeo.": "Pourcentage de personnes ayant lancé la lecture de la vidéo.",
  "Porcentagem de visualizações que resultaram em uma conversão (clique no botão de ação).": "Pourcentage de vues ayant entraîné une conversion (clic sur le bouton d'action).",
  "Porcentagem média de tempo que os espectadores assistem. Um bom número é acima de 70%.": "Pourcentage moyen de la durée regardée. Un bon résultat est supérieur à 70%.",
  "Portugal": "Portugal",
  "Português (BR)": "Português (BR)",
  "Português (Brasil)": "Português (Brasil)",
  "Português (PT)": "Português (PT)",
  "Posicionamento": "Positionnement",
  "Posicionamento estratégico": "Positionnement stratégique",
  "Posição": "Position",
  "Posição H (%)": "Position H (%)",
  "Posição V (%)": "Position V (%)",
  "Posição da Notificação": "Position de la notification",
  "Posição das opções": "Position des options",
  "Posição do Formulário": "Position du formulaire",
  "Posição do Título": "Position du titre",
  "Posição do botão no vídeo": "Position du bouton dans la vidéo",
  "Posição do modal": "Position de la fenêtre",
  "Posição e Tamanho": "Position et taille",
  "Posição média:": "Position moyenne :",
  "Posição na tela": "Position à l'écran",
  "Posição no Vídeo": "Position dans la vidéo",
  "Posição no player": "Position dans le lecteur",
  "Posição:": "Position :",
  "Posso ser parceiro como pessoa física?": "Puis-je devenir partenaire en tant que particulier ?",
  "Powered by HostVSL": "Propulsé par HostVSL",
  "Pra ativar: copie novamente o código do seu vídeo e cole no lugar do antigo, lá onde ele está hospedado": "Pour activer : recopiez le code de votre vidéo et remplacez l'ancien code là où elle est hébergée",
  "Pra liberar o recurso em um vídeo antigo, basta refazer o upload: o processamento gera o storyboard automaticamente": "Pour activer cette fonctionnalité sur une ancienne vidéo, renvoyez-la : le traitement génère automatiquement le storyboard",
  "Prazo de Cookies de infinitos": "Durée illimitée des cookies",
  "Prazo mínimo de processamento das solicitações bancárias:": "Délai minimal de traitement des demandes bancaires :",
  "Precisa de ajuda para criar sua legenda?": "Besoin d'aide pour créer vos sous-titres ?",
  "Precisa de ajuda? Clique aqui": "Besoin d'aide ? Cliquez ici",
  "Precisamos de alguns dados para registrar sua resposta.": "Nous avons besoin de quelques informations pour enregistrer votre réponse.",
  "Preciso pagar para participar?": "Faut-il payer pour participer ?",
  "Preencha Headline ou Subheadline.": "Renseignez le titre ou le sous-titre.",
  "Preencha a data de nascimento completa.": "Renseignez la date de naissance complète.",
  "Preencha abaixo para continuar assistindo.": "Remplissez les champs ci-dessous pour continuer à regarder.",
  "Preencha as informações abaixo para configurar esta etapa": "Renseignez les informations ci-dessous pour configurer cette étape",
  "Preencha o e-mail.": "Renseignez l'e-mail.",
  "Preencha o nome do serviço.": "Renseignez le nom du service.",
  "Preencha para acessar o vídeo": "Remplissez pour accéder à la vidéo",
  "Preencha pelo menos um dos textos": "Renseignez au moins l'un des textes",
  "Preencha seus dados": "Renseignez vos informations",
  "Preencha todos os campos antes de enviar.": "Remplissez tous les champs avant l'envoi.",
  "Preencha todos os campos da conta bancária.": "Remplissez tous les champs du compte bancaire.",
  "Preencha todos os campos obrigatórios": "Remplissez tous les champs obligatoires",
  "Preencha todos os campos para continuar.": "Remplissez tous les champs pour continuer.",
  "Preencha todos os dados bancários obrigatórios.": "Renseignez toutes les coordonnées bancaires obligatoires.",
  "Preenchimento": "Remplissage",
  "Preferências UI": "Préférences de l'interface",
  "Preferências salvas": "Préférences enregistrées",
  "Premium": "Premium",
  "Preparando QR Code": "Préparation du QR code",
  "Preparando compartilhamento": "Préparation du partage",
  "Preparando download...": "Préparation du téléchargement...",
  "Preset de estilo": "Style prédéfini",
  "Pressionado": "Appuyé",
  "Preview": "Aperçu",
  "Preview Dinâmico": "Aperçu dynamique",
  "Preview configurado:": "Aperçu configuré :",
  "Preview da Oferta": "Aperçu de l'offre",
  "Preview da thumbnail": "Aperçu de la miniature",
  "Preview de frames na timeline": "Aperçu des images sur la timeline",
  "Preview de template": "Aperçu du modèle",
  "Preview de vídeo": "Aperçu vidéo",
  "Preview disponível no player real": "Aperçu disponible dans le lecteur réel",
  "Preview do Botão": "Aperçu du bouton",
  "Preview do Gradiente": "Aperçu du dégradé",
  "Preview do Player": "Aperçu du lecteur",
  "Preview do Vídeo": "Aperçu de la vidéo",
  "Preview em Tempo Real": "Aperçu en temps réel",
  "Preview em tempo real do seu template selecionado": "Aperçu en temps réel du modèle sélectionné",
  "Preview gerada automaticamente": "Aperçu généré automatiquement",
  "Preview:": "Aperçu :",
  "Preview: Como a oferta aparecerá no webinário": "Aperçu : affichage de l'offre dans le webinaire",
  "Previous": "Précédent",
  "Previous slide": "Diapositive précédente",
  "Preço antigo riscado e o novo em destaque — ancoragem de valor.": "Ancien prix barré et nouveau prix mis en valeur : ancrage de valeur.",
  "Preço com desconto (opcional)": "Prix réduit (facultatif)",
  "Preço com desconto deve ser menor que o original": "Le prix réduit doit être inférieur au prix initial",
  "Preço em destaque": "Prix mis en valeur",
  "Preço original (opcional)": "Prix initial (facultatif)",
  "Preço principal": "Prix principal",
  "Preço riscado": "Prix barré",
  "Preços": "Prix",
  "Prime Video Dark — Template Substituindo Netflix": "Prime Video Dark — Modèle remplaçant Netflix",
  "Primeira página visualizada pelos visitantes": "Première page consultée par les visiteurs",
  "Primeiro Nome": "Prénom",
  "Primeiro nome": "Prénom",
  "Primeiros passos": "Premiers pas",
  "Primitives": "Primitives",
  "Principais Origens de Tráfego": "Principales sources de trafic",
  "Principal": "Principal",
  "Principal gatilho de conversão": "Principal déclencheur de conversion",
  "Principal origem:": "Source principale :",
  "Princípios Básicos": "Principes de base",
  "Prioridade": "Priorité",
  "Prioridade da regra": "Priorité de la règle",
  "Prioridade deve ser entre 1 e 10": "La priorité doit être comprise entre 1 et 10",
  "Privacidade": "Confidentialité",
  "Privacidade protegida": "Confidentialité protégée",
  "Problemas": "Problèmes",
  "Processado": "Traité",
  "Processamento seguro e imediato": "Traitement sécurisé et immédiat",
  "Processando": "Traitement en cours",
  "Processando no servidor...": "Traitement sur le serveur...",
  "Processando vídeo": "Traitement de la vidéo",
  "Processando vídeo...": "Traitement de la vidéo...",
  "Processando...": "Traitement...",
  "Processando…": "Traitement…",
  "Procure pelo ícone": "Recherchez l'icône",
  "Programa de Afiliados Oficial": "Programme officiel d'affiliation",
  "ProgressBarConfig - Remoção Borda Extra": "ProgressBarConfig - Suppression de la bordure supplémentaire",
  "Progresso": "Progression",
  "Progresso Inicial (0-100%)": "Progression initiale (0-100%)",
  "Progresso de Configuração": "Progression de la configuration",
  "Progresso do Teste": "Progression du test",
  "Progresso do teste": "Progression du test",
  "Progresso salvo por aula e por módulo, com indicadores visuais": "Progression enregistrée par cours et module, avec des indicateurs visuels",
  "Progresso:": "Progression :",
  "Projeção de Hoje": "Projection du jour",
  "Promessas de valor contínuas": "Promesses de valeur continues",
  "Pronto para Começar a Ganhar?": "Prêt à commencer à gagner ?",
  "Pronto para começar a faturar?": "Prêt à commencer à générer des revenus ?",
  "Pronto para editar": "Prêt à modifier",
  "Pronto para envio": "Prêt à envoyer",
  "Pronto! Agora é só colar 🎉": "C'est prêt ! Il ne reste qu'à coller 🎉",
  "Pronto! Depois disso, sua audiência já passa a aproveitar todas as melhorias": "C'est prêt ! Votre audience profite désormais de toutes les améliorations",
  "Propriedade CSS": "Propriété CSS",
  "Proteja suas campanhas e direcione tráfego com inteligência.": "Protégez vos campagnes et orientez intelligemment le trafic.",
  "Proteção": "Protection",
  "Proteção Anti-Plágio de VSL": "Protection anti-plagiat de VSL",
  "Proteção Domínios": "Protection des domaines",
  "Proteção atualizada": "Protection mise à jour",
  "Proteção criada": "Protection créée",
  "Proteção de Acesso": "Protection des accès",
  "Proteção de Domínios": "Protection des domaines",
  "Proteção excluída": "Protection supprimée",
  "Proteção por Domínio": "Protection par domaine",
  "Prova social no momento da oferta": "Preuve sociale au moment de l'offre",
  "Provedor": "Fournisseur",
  "Proxy/VPN": "Proxy/VPN",
  "Proxy/VPN bloqueado": "Proxy/VPN bloqué",
  "Proxy/VPN liberado": "Proxy/VPN autorisé",
  "Pré-Visualizações de Estilos": "Aperçus des styles",
  "Pré-visualizar": "Prévisualiser",
  "Pré-visualizar sala": "Prévisualiser la salle",
  "Pré-visualização": "Aperçu",
  "Pré-visualização do Header": "Aperçu de l'en-tête",
  "Pré-visualização ilustrativa": "Aperçu illustratif",
  "Pré-visualização ilustrativa da barra de progresso": "Aperçu illustratif de la barre de progression",
  "Pré-visualização ilustrativa do HTML personalizado": "Aperçu illustratif du HTML personnalisé",
  "Pré-visualização ilustrativa do botão no vídeo": "Aperçu illustratif du bouton dans la vidéo",
  "Prévia": "Aperçu",
  "Prévia da Pasta": "Aperçu du dossier",
  "Prévia da Página de Inscrição": "Aperçu de la page d'inscription",
  "Prévia da página de inscrição": "Aperçu de la page d'inscription",
  "Prévia do Botão": "Aperçu du bouton",
  "Prévia em Tempo Real": "Aperçu en temps réel",
  "Prévia sem som": "Aperçu sans son",
  "Próxima": "Suivante",
  "Próxima Aula": "Cours suivant",
  "Próxima Renovação": "Prochain renouvellement",
  "Próxima aula": "Cours suivant",
  "Próxima aula em": "Cours suivant dans",
  "Próxima cobrança": "Prochain prélèvement",
  "Próxima sessão aparecerá daqui a pelo menos": "La prochaine session apparaîtra dans au moins",
  "Próximas 24h": "Prochaines 24 h",
  "Próximas sessões": "Prochaines sessions",
  "Próximo": "Suivant",
  "Próximo Pico": "Prochain pic",
  "Próximo episódio em": "Prochain épisode dans",
  "Próximo: Ordem": "Suivant : ordre",
  "Próximo: Tráfego": "Suivant : trafic",
  "Publicados": "Publiés",
  "Publicar": "Publier",
  "Publicar alterações": "Publier les modifications",
  "Publicar alterações?": "Publier les modifications ?",
  "Publicar no chat": "Publier dans le chat",
  "Publicar o fluxo?": "Publier le parcours ?",
  "Publicação rápida com domínio próprio ou subdomínio": "Publication rapide avec votre propre domaine ou sous-domaine",
  "Publique e Compartilhe": "Publiez et partagez",
  "Publique o fluxo, copie o Código do fluxo e cole na página onde o player deve aparecer. O rascunho é salvo automaticamente, mas só entra no ar quando você publica. Nas próximas alterações, publique novamente: o código de incorporação continua o mesmo.": "Publiez le parcours, copiez son code et collez-le sur la page où le lecteur doit apparaître. Le brouillon est enregistré automatiquement, mais seule la publication le met en ligne. Pour les prochaines modifications, republiez : le code d'intégration reste identique.",
  "Pular": "Passer",
  "Pular Dados": "Passer les données",
  "Pular em": "Passer dans",
  "Pular em {segundos}s": "Passer dans {segundos}s",
  "Pular em {value0}": "Passer dans {value0}",
  "Pular →": "Passer →",
  "Pularam": "Ont passé",
  "Pulsar": "Pulsation",
  "Página": "Page",
  "Página específica": "Page spécifique",
  "Página externa": "Page externe",
  "Página não encontrada": "Page introuvable",
  "Página {value0}": "Page {value0}",
  "Páginas ultra rápidas em HTML": "Pages HTML ultrarapides",
  "QR Code baixado!": "QR code téléchargé !",
  "QUA": "MER",
  "QUA • 16h-18h": "MER • 16 h-18 h",
  "QUA • 18h-20h": "MER • 18 h-20 h",
  "QUERO APROVEITAR A OFERTA": "JE VEUX PROFITER DE L'OFFRE",
  "QUERO CONTINUAR": "JE VEUX CONTINUER",
  "QUI": "JEU",
  "QUI • 10h-12h": "JEU • 10 h-12 h",
  "QUI • 20h-22h": "JEU • 20 h-22 h",
  "Qua": "Mer",
  "Quadro do fluxo": "Tableau du parcours",
  "Qual o valor das comissões?": "Quel est le montant des commissions ?",
  "Qual opção combina mais com você?": "Quelle option vous correspond le mieux ?",
  "Qualidade": "Qualité",
  "Qualidade Média": "Qualité moyenne",
  "Qualidade adaptativa": "Qualité adaptative",
  "Qualidade dos Leads": "Qualité des leads",
  "Qualidade dos Leads (Score)": "Qualité des leads (score)",
  "Qualquer dúvida no caminho, é só chamar. Estamos aqui pra ajudar.": "Si vous avez une question, contactez-nous. Nous sommes là pour vous aider.",
  "Qualquer ferramenta que estiver usando esta chave perde o acesso na hora, e não há como reativá-la. Suas outras chaves continuam funcionando.": "Tout outil utilisant cette clé perd immédiatement son accès et elle ne peut pas être réactivée. Vos autres clés continuent de fonctionner.",
  "Quando a headline aparece": "Apparition du titre",
  "Quando a headline desaparece": "Disparition du titre",
  "Quando a regra for atendida": "Lorsque la règle est satisfaite",
  "Quando acessar": "Lors de l'accès",
  "Quando atingir": "Lorsqu'il atteint",
  "Quando ativado, o vídeo reinicia do início ao clicar": "Une fois activé, la vidéo repart du début au clic",
  "Quando ativo, o espectador não consegue pausar o vídeo (clique, botão de pause). Funciona com ou sem controles e com autoplay.": "Lorsque cette option est active, le spectateur ne peut pas mettre la vidéo en pause par clic ou avec le bouton Pause. Fonctionne avec ou sans commandes et avec l'Autoplay.",
  "Quando espectadores avaliarem este vídeo, as respostas aparecerão aqui com nota média, comentários e distribuição das avaliações.": "Lorsque les spectateurs évalueront cette vidéo, leurs réponses apparaîtront ici avec la note moyenne, les commentaires et la répartition des évaluations.",
  "Quando esses dois indicadores estão altos, você tem um vídeo que atrai e mantém a atenção do início ao fim.": "Lorsque ces deux indicateurs sont élevés, votre vidéo attire et maintient l'attention du début à la fin.",
  "Quando exibir": "Moment d'affichage",
  "Quando exibir o CTA": "Moment d'affichage du CTA",
  "Quando houver novidades, elas aparecem neste painel.": "Les nouveautés apparaîtront dans ce panneau.",
  "Quando o formulário deve aparecer (formato: mm:ss)": "Moment d'apparition du formulaire (format : mm:ss)",
  "Quando o visitante rola a página e o vídeo sai da tela, ele vira uma caixinha no canto e continua tocando. Ao rolar de volta, o vídeo retorna ao lugar de origem.": "Lorsque le visiteur fait défiler la page et que la vidéo sort de l'écran, elle se réduit dans un coin et continue de jouer. En revenant, la vidéo retrouve sa position initiale.",
  "Quando o vídeo atingir o tempo definido, ele será pausado automaticamente e a thumbnail de pausa será exibida.": "Lorsque la vidéo atteint le temps défini, elle se met automatiquement en pause et la miniature de pause s'affiche.",
  "Quando o vídeo de saída terminar, o player exibe um": "À la fin de la vidéo de sortie, le lecteur affiche un",
  "Quando o vídeo termina, um card com contagem regressiva conduz o espectador direto pra sua oferta.": "À la fin de la vidéo, une carte avec compte à rebours guide le spectateur directement vers votre offre.",
  "Quando seu vídeo recebe mais interação": "Moments où votre vidéo reçoit le plus d'interactions",
  "Quando tivermos atualizações, elas aparecem nesta tela.": "Les mises à jour apparaîtront sur cette page.",
  "Quando um vídeo terminar o processamento, você verá aqui e poderá editá-lo.": "Lorsqu'une vidéo termine son traitement, elle apparaît ici et vous pouvez la modifier.",
  "Quando você compartilhar um vídeo, ele aparecerá aqui com links e métricas.": "Lorsque vous partagez une vidéo, elle apparaît ici avec ses liens et ses indicateurs.",
  "Quantidade de clicks": "Nombre de clics",
  "Quantidade de cliques nos botões de chamada para ação. Métrica final de conversão do vídeo.": "Nombre de clics sur les boutons d'appel à l'action. Indicateur final de conversion de la vidéo.",
  "Quantidade de conversões registradas a partir deste vídeo.": "Nombre de conversions enregistrées à partir de cette vidéo.",
  "Quantidade de pessoas diferentes que deram play no vídeo.": "Nombre de personnes différentes ayant lancé la vidéo.",
  "Quantidade de pessoas diferentes que visualizaram o vídeo.": "Nombre de personnes différentes ayant vu la vidéo.",
  "Quantidade de vezes que o play foi clicado. A relação Plays/Visualizações gera a Taxa de Reprodução.": "Nombre de clics sur Lecture. Le rapport lectures/vues donne le taux de lecture.",
  "Quantidade de vezes que o vídeo foi carregado na página.": "Nombre de chargements de la vidéo sur la page.",
  "Quanto do seu vídeo é assistido em média pelos espectadores": "Part moyenne de votre vidéo regardée par les spectateurs",
  "Quanto tempo em média os espectadores assistem ao seu vídeo": "Durée moyenne de visionnage de votre vidéo",
  "Quantos horários mostrar ao visitante": "Nombre d'horaires à afficher au visiteur",
  "Quarta 18-20h caiu 15% vs semana passada": "Mercredi 18 h-20 h : baisse de 15% par rapport à la semaine précédente",
  "Quarta-feira, 16h-18h": "Mercredi, 16 h-18 h",
  "Quatro animações disponíveis: Nenhuma, Fade, Pop e Palavra por palavra": "Quatre animations disponibles : aucune, fondu, pop et mot par mot",
  "Que bom ter você por aqui": "Ravi de vous accueillir",
  "Que tal adicionar seu primeiro vídeo aqui?": "Ajoutez votre première vidéo ici !",
  "Queda": "Baisse",
  "Queda acentuada nos primeiros 10-30s = problema no gancho.": "Forte baisse dans les 10 à 30 premières secondes = problème d'accroche.",
  "Queda de": "Baisse de",
  "Queda em": "Baisse à",
  "Quedas acentuadas no início indicam problema no gancho.": "Les fortes baisses au début indiquent un problème d'accroche.",
  "Quedas suaves são normais. Quedas abruptas indicam problemas de conteúdo ou ritmo.": "Les baisses progressives sont normales. Les baisses soudaines indiquent un problème de contenu ou de rythme.",
  "Quem Pode Ser Parceiro": "Qui peut devenir partenaire",
  "Quem assiste te diz o que mudar na próxima versão.": "Les spectateurs vous disent quoi modifier dans la prochaine version.",
  "Quem está assistindo às suas VSLs agora, pelo mundo.": "Les personnes regardant vos VSL en ce moment, partout dans le monde.",
  "Quem tem esta chave consegue ler as métricas dos seus vídeos. Guarde como guardaria uma senha e, se ela vazar, revogue na lista desta tela — a revogação vale na hora e não afeta suas outras chaves.": "Toute personne possédant cette clé peut lire les indicateurs de vos vidéos. Protégez-la comme un mot de passe. En cas de fuite, révoquez-la dans la liste de cette page : la révocation est immédiate et n'affecte pas vos autres clés.",
  "Quero Ser Parceiro Host VSL": "Je veux devenir partenaire de Host VSL",
  "Quero acessar agora": "Je veux y accéder maintenant",
  "Quero aproveitar": "Je veux en profiter",
  "Qui": "Jeu",
  "Quiz Interativo com FunnelX": "Quiz interactif avec FunnelX",
  "R$ 25/mês": "R$ 25/mois",
  "REGIÕES": "RÉGIONS",
  "REGRA": "RÈGLE",
  "RESUME": "REPRENDRE",
  "Raio": "Rayon",
  "Raio da borda": "Rayon de la bordure",
  "Raio de Borda (Arredondamento)": "Rayon de bordure (arrondi)",
  "Raio de canto:": "Rayon des coins :",
  "Raio do card": "Rayon de la carte",
  "Raio dos Cantos": "Rayon des coins",
  "Ranking de Vídeos": "Classement des vidéos",
  "Rankings ao vivo: top vídeos, top lugares (com alternância país/estado) e top fontes de tráfego": "Classements en direct : principales vidéos, principaux lieux avec alternance pays/État et principales sources de trafic",
  "Rascunho": "Brouillon",
  "Rascunho descartado": "Brouillon abandonné",
  "Rascunho salvo": "Brouillon enregistré",
  "Rascunhos": "Brouillons",
  "Rastreamento": "Suivi",
  "Rastreamento com Pixel": "Suivi par pixel",
  "Rastreamento configurado": "Suivi configuré",
  "Rastreamento de vendas": "Suivi des ventes",
  "Rastreamento de vendas por plataforma": "Suivi des ventes par plateforme",
  "Rastreamento e Engajamento": "Suivi et engagement",
  "Rastreamento e análise de tráfego para websites e aplicações.": "Suivi et analyse du trafic pour sites web et applications.",
  "Rastreamento parcial": "Suivi partiel",
  "Rastreie eventos e integre com plataformas de anúncios.": "Suivez les événements et intégrez les plateformes publicitaires.",
  "Rastreie receita": "Suivez le chiffre d'affaires",
  "Reabrir se não enviado": "Rouvrir si non envoyé",
  "React Query": "React Query",
  "React Renderers:": "Moteurs de rendu React :",
  "React Version:": "Version de React :",
  "Reafirme o benefício principal em múltiplos momentos do vídeo para manter o engajamento constante.": "Réaffirmez le bénéfice principal à plusieurs moments de la vidéo pour maintenir un engagement constant.",
  "Real": "Réel",
  "Realize testes com pelo menos 100 visualizações por velocidade": "Effectuez des tests avec au moins 100 vues par vitesse",
  "Reativar": "Réactiver",
  "Reativar plano": "Réactiver le forfait",
  "Recarga Automática": "Recharge automatique",
  "Recarga Automática Ativada": "Recharge automatique activée",
  "Recarga automática de {value0} plays ativada!": "Recharge automatique de {value0} lectures activée !",
  "Recarregar": "Recharger",
  "Recarregar (sem cache)": "Recharger (sans cache)",
  "Recarregar Página": "Recharger la page",
  "Recarregar página": "Recharger la page",
  "Recarregue a página para tentar de novo.": "Rechargez la page pour réessayer.",
  "Receba 10% sobre todas as comissões geradas pelos vendedores indicados diretamente por você.": "Recevez 10% de toutes les commissions générées par les vendeurs que vous avez directement parrainés.",
  "Receba 20% do valor de cada cliente ativo todos os meses.": "Recevez 20% de la valeur de chaque client actif tous les mois.",
  "Receba 25% todos os meses enquanto o cliente permanecer ativo na plataforma.": "Recevez 25% chaque mois tant que le client reste actif sur la plateforme.",
  "Receba alertas em tempo real sobre conversões, métricas importantes e atualizações do sistema.": "Recevez des alertes en temps réel sur les conversions, les indicateurs importants et les mises à jour du système.",
  "Receba alertas quando houver novas conversões nos seus vídeos": "Recevez des alertes lors de nouvelles conversions sur vos vidéos",
  "Receba alertas sobre conversões, métricas e atualizações importantes em tempo real": "Recevez en temps réel des alertes sur les conversions, les indicateurs et les mises à jour importantes",
  "Receba notificações sobre os melhores horários de visualização": "Recevez des notifications sur les meilleurs horaires de visionnage",
  "Receba recomendações personalizadas baseadas nos dados de retenção do seu vídeo.": "Recevez des recommandations personnalisées à partir des données de rétention de votre vidéo.",
  "Receba seu link exclusivo e indique para sua audiência.": "Recevez votre lien unique et recommandez-le à votre audience.",
  "Receba todos os meses enquanto os seus indicados continuarem ativos na plataforma.": "Recevez des revenus chaque mois tant que les personnes parrainées restent actives sur la plateforme.",
  "Receba um insight automático com leitura rápida do comportamento": "Recevez une analyse automatique pour comprendre rapidement le comportement",
  "Receba um insight automático com leitura rápida do comportamento do público": "Recevez une analyse automatique pour comprendre rapidement le comportement du public",
  "Receita": "Chiffre d'affaires",
  "Receita & Conversões (Tracking)": "Chiffre d'affaires et conversions (suivi)",
  "Receita Gerada": "Chiffre d'affaires généré",
  "Receita Total": "Chiffre d'affaires total",
  "Receita atribuída": "Chiffre d'affaires attribué",
  "Receita das compras aprovadas": "Chiffre d'affaires des achats approuvés",
  "Receita total": "Chiffre d'affaires total",
  "Receita total gerada a partir de conversões deste vídeo.": "Chiffre d'affaires total généré par les conversions de cette vidéo.",
  "Receita:": "Chiffre d'affaires :",
  "Recentes": "Récents",
  "Recomenda-se um mínimo de 800 plays únicos por variação para resultados estatisticamente significativos": "Au moins 800 lectures uniques par variante sont recommandées pour obtenir des résultats statistiquement significatifs",
  "Recomendado": "Recommandé",
  "Recomendado: 400×400 px": "Recommandé : 400×400 px",
  "Recomendamos manter opcional.": "Nous recommandons de le laisser facultatif.",
  "Recomendamos usar um tom levemente mais escuro para o hover.": "Nous recommandons une teinte légèrement plus foncée au survol.",
  "Recomendações:": "Recommandations :",
  "Recomende a nossa plataforma e ganhe": "Recommandez notre plateforme et gagnez",
  "Recomeçar": "Recommencer",
  "Recomeçar Vídeo Após o Fim": "Relancer la vidéo après la fin",
  "Recomeçar após finalizar": "Recommencer après la fin",
  "Recomeçar o vídeo ao finalizar": "Relancer la vidéo à la fin",
  "Recomeçar vídeo após o fim": "Relancer la vidéo après la fin",
  "Reconsidere o estilo narrativo": "Revoyez le style narratif",
  "Recorrente": "Récurrent",
  "Recorrência desativada": "Récurrence désactivée",
  "Recorrência desativada com sucesso!": "Récurrence désactivée avec succès !",
  "Recuperar Acesso": "Récupérer l'accès",
  "Recurso Configurado": "Fonctionnalité configurée",
  "Recurso Horários — Premium 10/10": "Fonctionnalité Horaires — Premium 10/10",
  "Recurso desativado!": "Fonctionnalité désactivée !",
  "Recursos Extras": "Fonctionnalités supplémentaires",
  "Recursos de Interação": "Fonctionnalités d'interaction",
  "Recursos do player": "Fonctionnalités du lecteur",
  "Recusar": "Refuser",
  "Redesign completo da página Parceiros seguindo PRD premium. Cards com altura fixa 212px, hover scale + blur, skeleton loading, fade-in animation, ícone chevron animado, acessibilidade completa.": "Refonte complète de la page Partenaires selon le PRD premium. Cartes d'une hauteur fixe de 212px, agrandissement et flou au survol, chargement squelette, apparition en fondu, chevron animé et accessibilité complète.",
  "Redigite a senha": "Saisissez à nouveau le mot de passe",
  "Redimensione e reposicione a caixa de autoplay diretamente no player com arraste visual.": "Redimensionnez et repositionnez la zone d'Autoplay directement dans le lecteur par glisser-déposer.",
  "Redimensione usando os handles nos cantos e laterais": "Redimensionnez avec les poignées aux coins et sur les côtés",
  "Redirecionados": "Redirigés",
  "Redirecionamento": "Redirection",
  "Redirecionamento Inteligente": "Redirection intelligente",
  "Redirecionamentos": "Redirections",
  "Redirecionando para a lista de playlists...": "Redirection vers la liste des playlists...",
  "Redirecionando para configuração de integrações...": "Redirection vers la configuration des intégrations...",
  "Redirecionando para lista de estratégias...": "Redirection vers la liste des stratégies...",
  "Redirecionar automaticamente ao terminar": "Rediriger automatiquement à la fin",
  "Redirecionar para vídeo alternativo ou URL": "Rediriger vers une autre vidéo ou une URL",
  "Reduza a introdução": "Raccourcissez l'introduction",
  "Reduza o tempo até o CTA principal": "Réduisez le délai avant le CTA principal",
  "Reduzido de {value0} para {value1}": "Réduit de {value0} à {value1}",
  "Redução de 42% na taxa de abandono nos primeiros 30 segundos": "Réduction de 42% du taux d'abandon pendant les 30 premières secondes",
  "Reenviar Convite": "Renvoyer l'invitation",
  "Reenviar convite": "Renvoyer l'invitation",
  "Reenviar convite para": "Renvoyer l'invitation à",
  "Reenviar código": "Renvoyer le code",
  "Reenviar código em": "Renvoyer le code dans",
  "Reexibir no final do vídeo": "Réafficher à la fin de la vidéo",
  "Referência": "Source référente",
  "Referência visual de onde começa o pitch da oferta": "Repère visuel du début de l'argumentaire de l'offre",
  "Reforce a curiosidade": "Renforcez la curiosité",
  "Reforce a promessa inicial": "Renforcez la promesse initiale",
  "Reforce provas sociais antes da oferta": "Renforcez les preuves sociales avant l'offre",
  "Reformulamos o Cloaker da HostVSL, a proteção anti-plágio das suas VSLs. Você decide quem pode assistir ao vídeo original por país, região, origem do tráfego (UTM), dispositivo e bloqueio de VPN/Proxy — e quem não se encaixa nas regras é desviado automaticamente para um vídeo alternativo, sem nunca carregar a sua VSL real. Perfeito pra esconder sua oferta de concorrentes, espiões de anúncios e ferramentas de moderação.": "Nous avons repensé le Cloaker HostVSL, la protection anti-plagiat de vos VSL. Choisissez qui peut voir la vidéo d'origine selon le pays, la région, la source de trafic (UTM), l'appareil et le blocage des VPN/proxys. Les personnes qui ne respectent pas les règles sont automatiquement redirigées vers une autre vidéo, sans jamais charger votre véritable VSL. Idéal pour masquer votre offre aux concurrents, aux outils d'espionnage publicitaire et aux outils de modération.",
  "Reformule o gancho inicial": "Reformulez l'accroche initiale",
  "Refresh Token": "Jeton de renouvellement",
  "Regenerar": "Régénérer",
  "Regex inválido": "Expression régulière invalide",
  "Regional": "Régional",
  "Registrando ·": "Enregistrement ·",
  "Registro Encontrado": "Enregistrement trouvé",
  "Registro criado com sucesso!": "Enregistrement créé avec succès !",
  "Registro encontrado!": "Enregistrement trouvé !",
  "Registro excluído com sucesso!": "Enregistrement supprimé avec succès !",
  "Região": "Région",
  "Região não encontrada": "Région introuvable",
  "Região/Estado": "Région/État",
  "Região:": "Région :",
  "Região: {value0}": "Région : {value0}",
  "Regiões": "Régions",
  "Regiões ({value0})": "Régions ({value0})",
  "Regiões ainda não cadastradas para este país.": "Les régions de ce pays ne sont pas encore enregistrées.",
  "Regra UTM": "Règle UTM",
  "Regra ativa": "Règle active",
  "Regra criada com sucesso": "Règle créée avec succès",
  "Regra desativada": "Règle désactivée",
  "Regra do Cloaker": "Règle du Cloaker",
  "Regra salva com sucesso": "Règle enregistrée avec succès",
  "Regras ativas": "Règles actives",
  "Regras de Operação": "Règles de fonctionnement",
  "Regras de UTM": "Règles UTM",
  "Regras de cloaking": "Règles de cloaking",
  "Regras e Distribuição de Comissão": "Règles et répartition des commissions",
  "Regras por país e região: libere só onde você vende ou bloqueie onde não quer aparecer": "Règles par pays et région : autorisez uniquement vos marchés ou bloquez les endroits où vous ne souhaitez pas apparaître",
  "Regular": "Normal",
  "Reinicia a sequência de notificações ao chegar ao fim.": "Relance la séquence de notifications à la fin.",
  "Reinicia automaticamente após exibir todas.": "Recommence automatiquement après l'affichage de toutes les notifications.",
  "Reinicia em": "Recommence dans",
  "Reiniciar preview": "Relancer l'aperçu",
  "Reiniciar tour": "Relancer la visite guidée",
  "Reiniciar vídeo": "Relancer la vidéo",
  "Reinício automático ativado": "Redémarrage automatique activé",
  "Reinício automático desativado": "Redémarrage automatique désactivé",
  "Relatório enviado com sucesso": "Rapport envoyé avec succès",
  "Relatórios": "Rapports",
  "Relatórios de Captura": "Rapports de capture",
  "Remove completamente a interação com os controles do player": "Supprime toute interaction avec les commandes du lecteur",
  "Remove completamente o player neste dispositivo": "Supprime entièrement le lecteur sur cet appareil",
  "Remove distração visual": "Supprime les distractions visuelles",
  "Remove from favorites": "Retirer des favoris",
  "Remove todos os controles do player": "Supprime toutes les commandes du lecteur",
  "Removendo...": "Suppression...",
  "Remover": "Supprimer",
  "Remover Membro": "Supprimer le membre",
  "Remover arquivo?": "Supprimer le fichier ?",
  "Remover cartão": "Supprimer la carte",
  "Remover classe": "Supprimer la classe",
  "Remover da pasta": "Retirer du dossier",
  "Remover do teste": "Retirer du test",
  "Remover domínio": "Supprimer le domaine",
  "Remover domínio?": "Supprimer le domaine ?",
  "Remover dos favoritos": "Retirer des favoris",
  "Remover foto": "Supprimer la photo",
  "Remover foto de perfil": "Supprimer la photo de profil",
  "Remover imagem": "Supprimer l'image",
  "Remover introdução?": "Supprimer l'introduction ?",
  "Remover legenda": "Supprimer les sous-titres",
  "Remover link": "Supprimer le lien",
  "Remover logo": "Supprimer le logo",
  "Remover membro": "Supprimer le membre",
  "Remover opção {value0}": "Supprimer l'option {value0}",
  "Remover parâmetro": "Supprimer le paramètre",
  "Remover pitch": "Supprimer l'argumentaire de vente",
  "Remover pixel": "Supprimer le pixel",
  "Remover pixel?": "Supprimer le pixel ?",
  "Remover plataforma": "Supprimer la plateforme",
  "Remover seleção": "Retirer la sélection",
  "Remover vídeo da fila?": "Retirer la vidéo de la file ?",
  "Remover {value0} do gráfico": "Retirer {value0} du graphique",
  "Removido SectionCard wrapper do preview da barra de progresso para visual mais limpo.": "Suppression du conteneur SectionCard de l'aperçu de la barre de progression pour une apparence plus épurée.",
  "Removido chip X vídeos selecionados do título na etapa de seleção de vídeos. Layout mais limpo e minimalista.": "Suppression de la pastille X vidéos sélectionnées dans le titre de l'étape de sélection. Présentation plus épurée et minimaliste.",
  "Renomear": "Renommer",
  "Renomear estratégia": "Renommer la stratégie",
  "Renomear fluxo": "Renommer le parcours",
  "Renomear pasta": "Renommer le dossier",
  "Renomear vídeo": "Renommer la vidéo",
  "Renova em": "Renouvellement le",
  "Renovação": "Renouvellement",
  "Reordenação por drag-and-drop dos blocos de legenda": "Réorganisation des blocs de sous-titres par glisser-déposer",
  "Repaginamos a Proteção Anti-Plágio de VSL: ficou mais simples de configurar e de esconder sua oferta de concorrentes e espiões.": "Nous avons repensé la protection anti-plagiat de VSL : elle est plus simple à configurer pour masquer votre offre aux concurrents et aux espions.",
  "Repassar os parâmetros da página": "Transmettre les paramètres de la page",
  "Repete o trecho automaticamente": "Répète automatiquement le passage",
  "Repetir": "Répéter",
  "Repetir Vídeo": "Répéter la vidéo",
  "Repetir em loop": "Répéter en boucle",
  "Repetir vídeo (loop)": "Répéter la vidéo (boucle)",
  "Repita a senha": "Répétez le mot de passe",
  "Replique o padrão de benefício + detalhe do VSL principal": "Reproduisez le schéma bénéfice + détail de la VSL principale",
  "Reportar problema": "Signaler un problème",
  "Reproduz um som curto junto da notificação.": "Joue un son bref avec la notification.",
  "Reproduz um som junto da notificação.": "Joue un son avec la notification.",
  "Reproduza o vídeo para ver o formulário aparecendo no tempo configurado.": "Lancez la vidéo pour voir le formulaire apparaître au moment configuré.",
  "Reproduzindo": "Lecture en cours",
  "Reproduzindo...": "Lecture en cours...",
  "Reproduzir": "Lire",
  "Reproduzir agora": "Lire maintenant",
  "Reproduzir automaticamente a próxima aula quando o vídeo terminar": "Lire automatiquement le cours suivant à la fin de la vidéo",
  "Reprodução Automática": "Lecture automatique",
  "Reprodução automática": "Lecture automatique",
  "Reproduções no período": "Lectures pendant la période",
  "Requer que os controles do player estejam habilitados": "Nécessite l'activation des commandes du lecteur",
  "Reset": "Réinitialiser",
  "Resetar Configurações": "Réinitialiser les paramètres",
  "Resolução recomendada: 1920×700 pixels": "Résolution recommandée : 1920×700 pixels",
  "Respeita pausas manuais: só retoma se foi pausado pela função": "Respecte les pauses manuelles : reprend uniquement après une pause déclenchée par la fonctionnalité",
  "Resposta A": "Réponse A",
  "Resposta B": "Réponse B",
  "Respostas": "Réponses",
  "Restaurar padrões": "Rétablir les valeurs par défaut",
  "Restaurar principais origens": "Rétablir les principales sources",
  "Resultado": "Résultat",
  "Resultados do Teste": "Résultats du test",
  "Resultados em tempo real das variações de autoplay": "Résultats en temps réel des variantes d'Autoplay",
  "Resultados em tempo real das variações de headline": "Résultats en temps réel des variantes de titre",
  "Resultados esperados": "Résultats attendus",
  "Resultados segmentados que aumentam a conversão final": "Résultats segmentés pour augmenter la conversion finale",
  "Resumo": "Résumé",
  "Resumo (A vs B)": "Résumé (A vs B)",
  "Resumo Geral": "Résumé général",
  "Resumo da proteção": "Résumé de la protection",
  "Resumo de desempenho desta URL no período selecionado.": "Résumé des performances de cette URL pendant la période sélectionnée.",
  "Resumo de métricas consolidado: {value0} dias processados.": "Résumé des indicateurs consolidé : {value0} jours traités.",
  "Resumo do desempenho no período": "Résumé des performances pendant la période",
  "Retangular": "Rectangulaire",
  "Retenção": "Rétention",
  "Retenção & Tempo": "Rétention et temps",
  "Retenção & Tempo de Exibição": "Rétention et durée de visionnage",
  "Retenção (%)": "Rétention (%)",
  "Retenção Ideal": "Rétention idéale",
  "Retenção Média": "Rétention moyenne",
  "Retenção Pitch": "Rétention de l'argumentaire de vente",
  "Retenção ao Longo do Tempo": "Rétention au fil du temps",
  "Retenção ao Longo do Vídeo": "Rétention au fil de la vidéo",
  "Retenção ao longo do tempo": "Rétention au fil du temps",
  "Retenção de Audiência": "Rétention d'audience",
  "Retenção mostra quantas pessoas continuam assistindo ao vídeo ao longo do tempo.": "La rétention montre le nombre de personnes qui continuent à regarder la vidéo au fil du temps.",
  "Retenção média": "Rétention moyenne",
  "Retenção média hoje": "Rétention moyenne aujourd'hui",
  "Retenção no Pitch": "Rétention au moment de l'argumentaire de vente",
  "Retenção no Vídeo": "Rétention de la vidéo",
  "Retenção no momento": "Rétention à cet instant",
  "Retenção no momento chave": "Rétention au moment clé",
  "Retenção no pitch": "Rétention au moment de l'argumentaire de vente",
  "Retenção por Vídeo": "Rétention par vidéo",
  "Retenção próximo ao pitch": "Rétention à proximité de l'argumentaire de vente",
  "Retenção:": "Rétention :",
  "Retirada Mínima Permitida": "Retrait minimal autorisé",
  "Retoma o vídeo de onde o usuário parou.": "Reprend la vidéo là où l'utilisateur s'était arrêté.",
  "Retomada automática": "Reprise automatique",
  "Retomada instantânea ao voltar, sem precisar clicar em nada": "Reprise instantanée au retour, sans aucun clic",
  "Retomar": "Reprendre",
  "Retomar fluxo": "Reprendre le parcours",
  "Retomar reprodução": "Reprendre la lecture",
  "Retorno automático ao segundo 0:00 ao término do vídeo": "Retour automatique à 0:00 à la fin de la vidéo",
  "Retroceder": "Reculer",
  "Retroceder 10s": "Reculer de 10 s",
  "Return to Home": "Retour à l'accueil",
  "Retângulo": "Rectangle",
  "Retém usuários que saíram do vídeo": "Retient les utilisateurs ayant quitté la vidéo",
  "Revise a etapa atual antes de iniciar o teste.": "Vérifiez l'étape actuelle avant de lancer le test.",
  "Revise seus últimos 5-10 testes para identificar padrões comuns nos vencedores.": "Examinez vos 5 à 10 derniers tests pour repérer les tendances communes aux gagnants.",
  "Revogada": "Révoquée",
  "Revogar": "Révoquer",
  "Revogar \"": "Révoquer «",
  "Revogar a chave {value0}": "Révoquer la clé {value0}",
  "Revogar chave": "Révoquer la clé",
  "Rio de Janeiro": "Rio de Janeiro",
  "Ritmo dinâmico": "Rythme dynamique",
  "Roboto": "Roboto",
  "Roboto (Clean)": "Roboto (épuré)",
  "Rodapé": "Pied de page",
  "Role para baixo e toque em \"Adicionar à Tela de Início\"": "Faites défiler vers le bas et touchez « Ajouter à l'écran d'accueil »",
  "Role para ver mais faturas": "Faites défiler pour voir plus de factures",
  "Role para ver todas as faturas": "Faites défiler pour voir toutes les factures",
  "Rota": "Route",
  "Rotas Protegidas": "Routes protégées",
  "Rotas e Navegação": "Routes et navigation",
  "Routing": "Routage",
  "Rua, Avenida, Número e Complemento": "Rue, avenue, numéro et complément d'adresse",
  "Ruim": "Mauvais",
  "Rápida": "Rapide",
  "Rápido": "Rapide",
  "Rótulo (Label) da conversão de checkout": "Libellé (Label) de la conversion de paiement",
  "Rótulo (Label) da conversão de play": "Libellé (Label) de la conversion de lecture",
  "Rótulo (Label) da conversão do pitch": "Libellé (Label) de la conversion de l'argumentaire de vente",
  "Rótulo da ação \"Checkout\" (opcional)": "Libellé de l'action « Checkout » (facultatif)",
  "Rótulo da ação \"Pitch\" (opcional)": "Libellé de l'action « Pitch » (facultatif)",
  "Rótulo da ação \"Play\" *": "Libellé de l'action « Play » *",
  "Rótulo do campo": "Libellé du champ",
  "SALVAR": "ENREGISTRER",
  "SAÍDA": "SORTIE",
  "SEG": "LUN",
  "SEG • 08h-10h": "LUN • 08 h-10 h",
  "SEG • 18h-20h": "LUN • 18 h-20 h",
  "SEGURANÇA": "SÉCURITÉ",
  "SEX": "VEN",
  "SEX • 14h-16h": "VEN • 14 h-16 h",
  "SEX • 18h-20h": "VEN • 18 h-20 h",
  "SIM, ADICIONAR AO MEU PEDIDO": "OUI, AJOUTER À MA COMMANDE",
  "SIM, EU QUERO": "OUI, JE VEUX",
  "SIM, QUERO ADICIONAR": "OUI, JE VEUX AJOUTER",
  "SIM, QUERO APROVEITAR": "OUI, JE VEUX EN PROFITER",
  "Safari": "Safari",
  "Saiba Mais": "En savoir plus",
  "Saiba mais": "En savoir plus",
  "Saiba mais:": "En savoir plus :",
  "Sair": "Se déconnecter",
  "Sair da tela cheia": "Quitter le plein écran",
  "Sair do modo foco": "Quitter le mode concentration",
  "Sair do modo foco (Esc)": "Quitter le mode concentration (Échap)",
  "Sala do Webinário": "Salle du webinaire",
  "Saldo insuficiente para saque (Mínimo R$ 100,00).": "Solde insuffisant pour le retrait (minimum R$ 100,00).",
  "Salva o progresso do espectador automaticamente": "Enregistre automatiquement la progression du spectateur",
  "Salvando...": "Enregistrement...",
  "Salvando…": "Enregistrement…",
  "Salvar": "Enregistrer",
  "Salvar & Continuar": "Enregistrer et continuer",
  "Salvar / Publicar": "Enregistrer / Publier",
  "Salvar Alterações": "Enregistrer les modifications",
  "Salvar Ação": "Enregistrer l'action",
  "Salvar Configuração": "Enregistrer la configuration",
  "Salvar Configurações": "Enregistrer les paramètres",
  "Salvar Distribuição": "Enregistrer la répartition",
  "Salvar Informações": "Enregistrer les informations",
  "Salvar Método de Recebimento": "Enregistrer le moyen de réception des paiements",
  "Salvar Playlist": "Enregistrer la playlist",
  "Salvar Teste": "Enregistrer le test",
  "Salvar Tracking": "Enregistrer le suivi",
  "Salvar Tudo": "Tout enregistrer",
  "Salvar alteração": "Enregistrer la modification",
  "Salvar alterações": "Enregistrer les modifications",
  "Salvar e Ativar": "Enregistrer et activer",
  "Salvar e Fechar": "Enregistrer et fermer",
  "Salvar e Sincronizar": "Enregistrer et synchroniser",
  "Salvar e copiar código": "Enregistrer et copier le code",
  "Salvar nome": "Enregistrer le nom",
  "Salvar nova senha": "Enregistrer le nouveau mot de passe",
  "Salvar proteção": "Enregistrer la protection",
  "Salvar rascunho": "Enregistrer le brouillon",
  "Salvar todas as configurações no banco de dados": "Enregistrer tous les paramètres dans la base de données",
  "Salvar tudo": "Tout enregistrer",
  "Salve o tracking para liberar a URL": "Enregistrez le suivi pour débloquer l'URL",
  "Salve o vídeo antes de adicionar imagens aos mini-hooks.": "Enregistrez la vidéo avant d'ajouter des images aux Mini-Hooks.",
  "Salve o vídeo para visualizar as métricas de feedback.": "Enregistrez la vidéo pour afficher les indicateurs d'avis.",
  "Salve suas alterações e depois copie o código para colar na sua página de vendas.": "Enregistrez vos modifications, puis copiez le code pour le coller sur votre page de vente.",
  "Salvo": "Enregistré",
  "Sans-serif": "Sans empattement",
  "Saque": "Retrait",
  "Saque solicitado com sucesso!": "Retrait demandé avec succès !",
  "Saques": "Retraits",
  "Saques mínimos autorizados a partir de": "Retraits minimums autorisés à partir de",
  "Satisfação": "Satisfaction",
  "Saída": "Sortie",
  "Saída de checkout": "Sortie vers le paiement",
  "Saída removida": "Sortie supprimée",
  "Saída sem nome": "Sortie sans nom",
  "Saída · {value0}": "Sortie · {value0}",
  "Saúde & Velocidade": "État et vitesse",
  "Saúde do Pitch": "Efficacité de l'argumentaire de vente",
  "Saúde do Player & Velocidade": "État du lecteur et vitesse",
  "Score de Engajamento": "Score d'engagement",
  "Scripts não são permitidos por segurança.": "Les scripts sont interdits pour des raisons de sécurité.",
  "Se": "Si",
  "Se configurado na etapa \"Vendas\"": "Si configuré à l'étape « Ventes »",
  "Se não concordar, você pode recusar e nada será adicionado.": "Si vous n'êtes pas d'accord, vous pouvez refuser et rien ne sera ajouté.",
  "Se o campo \"Final\" estiver vazio, o botão será exibido até o final do vídeo.": "Si le champ « Fin » est vide, le bouton sera affiché jusqu'à la fin de la vidéo.",
  "Se o usuário recarregar a página sem enviar, mostrar novamente": "Si l'utilisateur recharge la page sans envoyer, afficher à nouveau",
  "Se o vídeo estiver dentro de um iframe, a página inteira é trocada.": "Si la vidéo se trouve dans un iframe, la page entière est remplacée.",
  "Se preenchido, redireciona para esta URL em vez do vídeo alternativo": "Si renseigné, redirige vers cette URL au lieu de la vidéo de remplacement",
  "Se vazio, será exibido o nome da playlist": "Si vide, le nom de la playlist sera affiché",
  "Se você adicionar o connector numa organização do Claude (planos Team ou Enterprise), a chave passa a ser compartilhada por toda a equipe — todos os membros verão as métricas da conta HostVSL de quem a cadastrou.": "Si vous ajoutez le connecteur à une organisation Claude (forfaits Team ou Enterprise), la clé sera partagée par toute l'équipe : tous les membres verront les indicateurs du compte HostVSL de la personne qui l'a enregistrée.",
  "Se você não concordar, clique em": "Si vous n'êtes pas d'accord, cliquez sur",
  "Seg": "Lun",
  "Segmentado (Pills)": "Segmenté (pilules)",
  "Segmentação por Fonte:": "Segmentation par source :",
  "Segunda opção": "Deuxième option",
  "Segundo Botão (Opcional)": "Deuxième bouton (facultatif)",
  "Segundo melhor momento": "Deuxième meilleur moment",
  "Segundos": "Secondes",
  "Segurança": "Sécurité",
  "Segurança Avançada": "Sécurité avancée",
  "Seguro": "Sécurisé",
  "Seja notificado quando suas métricas atingirem marcos importantes": "Recevez une notification lorsque vos indicateurs atteignent des étapes importantes",
  "Selecionado": "Sélectionné",
  "Selecionado:": "Sélectionné :",
  "Selecionando...": "Sélection...",
  "Selecionar": "Sélectionner",
  "Selecionar Arquivo": "Sélectionner un fichier",
  "Selecionar Cartão": "Sélectionner une carte",
  "Selecionar Evento": "Sélectionner un événement",
  "Selecionar Imagem": "Sélectionner une image",
  "Selecionar Introdução": "Sélectionner une introduction",
  "Selecionar Modelo": "Sélectionner un modèle",
  "Selecionar Tipo de Pixel": "Sélectionner le type de pixel",
  "Selecionar VSL": "Sélectionner une VSL",
  "Selecionar Vídeo": "Sélectionner une vidéo",
  "Selecionar Vídeo *": "Sélectionner une vidéo *",
  "Selecionar Vídeo Alternativo": "Sélectionner une vidéo de remplacement",
  "Selecionar Vídeo Original": "Sélectionner la vidéo d'origine",
  "Selecionar Vídeo Principal": "Sélectionner la vidéo principale",
  "Selecionar Vídeo da Biblioteca": "Sélectionner une vidéo de la bibliothèque",
  "Selecionar Vídeo para Análise": "Sélectionner une vidéo à analyser",
  "Selecionar Vídeo para Personalizar": "Sélectionner une vidéo à personnaliser",
  "Selecionar cor {value0}": "Sélectionner la couleur {value0}",
  "Selecionar data": "Sélectionner la date",
  "Selecionar idioma": "Sélectionner la langue",
  "Selecionar manualmente": "Sélectionner manuellement",
  "Selecionar período": "Sélectionner la période",
  "Selecionar plano": "Sélectionner le forfait",
  "Selecionar template": "Sélectionner le modèle",
  "Selecionar todos": "Tout sélectionner",
  "Selecionar vídeo": "Sélectionner une vidéo",
  "Selecionar vídeo *": "Sélectionner une vidéo *",
  "Selecionar vídeo de entrada": "Sélectionner la vidéo d'entrée",
  "Selecionar vídeo de saída": "Sélectionner la vidéo de sortie",
  "Selecionar vídeo para comparação": "Sélectionner une vidéo à comparer",
  "Selecionar vídeos": "Sélectionner des vidéos",
  "Selecionar vídeos para upload": "Sélectionner les vidéos à envoyer",
  "Selecione": "Sélectionnez",
  "Selecione a VSL que será protegida.": "Sélectionnez la VSL à protéger.",
  "Selecione a data": "Sélectionnez la date",
  "Selecione a modalidade": "Sélectionnez la modalité",
  "Selecione a parte da VSL sem a introdução. Assim, você poderá testar diferentes começos.": "Sélectionnez la partie de la VSL sans introduction pour tester différentes ouvertures.",
  "Selecione a plataforma": "Sélectionnez la plateforme",
  "Selecione a plataforma e informe o token, ou desative o rastreamento": "Sélectionnez la plateforme et renseignez le jeton, ou désactivez le suivi",
  "Selecione a posição": "Sélectionnez la position",
  "Selecione a prioridade": "Sélectionnez la priorité",
  "Selecione a região": "Sélectionnez la région",
  "Selecione a velocidade desejada": "Sélectionnez la vitesse souhaitée",
  "Selecione a velocidade desejada do seu vídeo": "Sélectionnez la vitesse souhaitée pour votre vidéo",
  "Selecione apenas arquivos de vídeo": "Sélectionnez uniquement des fichiers vidéo",
  "Selecione arquivos de imagem nítidos da sua CNH ou RG (Formatos aceitos: PNG ou JPEG).": "Sélectionnez des images nettes de votre permis de conduire brésilien (CNH) ou de votre carte d'identité (RG). Formats acceptés : PNG ou JPEG.",
  "Selecione as velocidades que deseja testar. Recomendamos testar pelo menos 2 velocidades diferentes para comparar os resultados.": "Sélectionnez les vitesses à tester. Nous recommandons au moins 2 vitesses différentes pour comparer les résultats.",
  "Selecione de 2 a 6 vídeos diferentes para comparar o desempenho em tempo real.": "Sélectionnez de 2 à 6 vidéos différentes pour comparer leurs performances en temps réel.",
  "Selecione diferentes introduções (hooks) para comparar o desempenho em tempo real.": "Sélectionnez différentes introductions (accroches) pour comparer leurs performances en temps réel.",
  "Selecione no máximo 6 vídeos para o teste": "Sélectionnez au maximum 6 vidéos pour le test",
  "Selecione o Vídeo": "Sélectionnez la vidéo",
  "Selecione o comportamento": "Sélectionnez le comportement",
  "Selecione o fuso horário": "Sélectionnez le fuseau horaire",
  "Selecione o layout ideal para o seu conteúdo": "Sélectionnez la présentation idéale pour votre contenu",
  "Selecione o operador": "Sélectionnez l'opérateur",
  "Selecione o parâmetro": "Sélectionnez le paramètre",
  "Selecione o país": "Sélectionnez le pays",
  "Selecione o período.": "Sélectionnez la période.",
  "Selecione o seu banco": "Sélectionnez votre banque",
  "Selecione o tamanho": "Sélectionnez la taille",
  "Selecione o tráfego dos vídeos": "Sélectionnez le trafic des vidéos",
  "Selecione o vídeo": "Sélectionnez la vidéo",
  "Selecione o vídeo alternativo para acessos bloqueados.": "Sélectionnez la vidéo de remplacement pour les accès bloqués.",
  "Selecione o vídeo e informe a chave da plataforma para receber conversões.": "Sélectionnez la vidéo et renseignez la clé de la plateforme pour recevoir les conversions.",
  "Selecione o vídeo onde a captura será exibida": "Sélectionnez la vidéo où la capture sera affichée",
  "Selecione o vídeo original": "Sélectionnez la vidéo d'origine",
  "Selecione o vídeo para a captura": "Sélectionnez la vidéo pour la capture",
  "Selecione o vídeo que deseja adicionar ao slot": "Sélectionnez la vidéo à ajouter au créneau",
  "Selecione os Vídeos": "Sélectionnez les vidéos",
  "Selecione os vídeos de teste": "Sélectionnez les vidéos du test",
  "Selecione os vídeos para teste (min. 2, máx. 6)": "Sélectionnez les vidéos à tester (min. 2, max. 6)",
  "Selecione os vídeos que deseja adicionar à playlist": "Sélectionnez les vidéos à ajouter à la playlist",
  "Selecione os vídeos que participarão do teste A/B": "Sélectionnez les vidéos qui participeront au test A/B",
  "Selecione os vídeos que receberão as configurações do vídeo atual.": "Sélectionnez les vidéos qui recevront les paramètres de la vidéo actuelle.",
  "Selecione ou arraste os arquivos de vídeo para importar na sua biblioteca.": "Sélectionnez ou déposez les fichiers vidéo à importer dans votre bibliothèque.",
  "Selecione pelo menos 2 modelos para iniciar o teste": "Sélectionnez au moins 2 modèles pour lancer le test",
  "Selecione pelo menos 2 velocidades para realizar um teste comparativo.": "Sélectionnez au moins 2 vitesses pour effectuer un test comparatif.",
  "Selecione pelo menos 2 vídeos para o teste": "Sélectionnez au moins 2 vidéos pour le test",
  "Selecione pelo menos um vídeo": "Sélectionnez au moins une vidéo",
  "Selecione pelo menos uma intro para continuar": "Sélectionnez au moins une intro pour continuer",
  "Selecione pelo menos uma playlist": "Sélectionnez au moins une playlist",
  "Selecione um país": "Sélectionnez un pays",
  "Selecione um país para configurar regiões": "Sélectionnez un pays pour configurer les régions",
  "Selecione um período": "Sélectionnez une période",
  "Selecione um plano para continuar": "Sélectionnez un forfait pour continuer",
  "Selecione um template para a tela de retorno": "Sélectionnez un modèle pour l'écran de reprise",
  "Selecione um teste para visualizar as métricas.": "Sélectionnez un test pour afficher les indicateurs.",
  "Selecione um vídeo": "Sélectionnez une vidéo",
  "Selecione um vídeo *": "Sélectionnez une vidéo *",
  "Selecione um vídeo alternativo ou URL": "Sélectionnez une vidéo de remplacement ou une URL",
  "Selecione um vídeo base para continuar": "Sélectionnez une vidéo de base pour continuer",
  "Selecione um vídeo da biblioteca": "Sélectionnez une vidéo de la bibliothèque",
  "Selecione um vídeo da biblioteca ou faça upload de um novo": "Sélectionnez une vidéo de la bibliothèque ou importez-en une nouvelle",
  "Selecione um vídeo da sua biblioteca ou faça upload de um novo": "Sélectionnez une vidéo de votre bibliothèque ou importez-en une nouvelle",
  "Selecione um vídeo da sua biblioteca para começar a personalizar e configurar seus recursos.": "Sélectionnez une vidéo de votre bibliothèque pour commencer à personnaliser et configurer ses fonctionnalités.",
  "Selecione um vídeo diferente.": "Sélectionnez une autre vidéo.",
  "Selecione um vídeo e pelo menos um campo para captura (Nome, E-mail ou WhatsApp).": "Sélectionnez une vidéo et au moins un champ à recueillir (nom, e-mail ou WhatsApp).",
  "Selecione um vídeo e um período com visualizações para ver o funil de conversão.": "Sélectionnez une vidéo et une période comportant des vues pour voir le tunnel de conversion.",
  "Selecione um vídeo para acessar os recursos de personalização.": "Sélectionnez une vidéo pour accéder aux fonctionnalités de personnalisation.",
  "Selecione um vídeo para começar a personalizar": "Sélectionnez une vidéo pour commencer la personnalisation",
  "Selecione um vídeo para continuar.": "Sélectionnez une vidéo pour continuer.",
  "Selecione um vídeo para personalizar": "Sélectionnez une vidéo à personnaliser",
  "Selecione um vídeo para personalizar...": "Sélectionnez une vidéo à personnaliser...",
  "Selecione um vídeo para ver as métricas": "Sélectionnez une vidéo pour voir les indicateurs",
  "Selecione um vídeo para visualizar a captura": "Sélectionnez une vidéo pour afficher la capture",
  "Selecione um vídeo para visualizar o preview": "Sélectionnez une vidéo pour afficher l'aperçu",
  "Selecione um vídeo para visualizar os dados de resultado.": "Sélectionnez une vidéo pour afficher les résultats.",
  "Selecione um vídeo para visualizar os horários de pico.": "Sélectionnez une vidéo pour afficher les heures de pointe.",
  "Selecione um vídeo.": "Sélectionnez une vidéo.",
  "Selecione um vídeo...": "Sélectionnez une vidéo...",
  "Selecione um webinário": "Sélectionnez un webinaire",
  "Selecione uma animação": "Sélectionnez une animation",
  "Selecione uma aula": "Sélectionnez un cours",
  "Selecione uma aula para começar": "Sélectionnez un cours pour commencer",
  "Selecione uma aula para ver a descrição.": "Sélectionnez un cours pour voir la description.",
  "Selecione uma avaliação": "Sélectionnez une évaluation",
  "Selecione uma etapa ou saída no quadro para editar.": "Sélectionnez une étape ou une sortie sur le tableau pour la modifier.",
  "Selecione uma pasta": "Sélectionnez un dossier",
  "Selecione uma permissão": "Sélectionnez une autorisation",
  "Selecione uma plataforma": "Sélectionnez une plateforme",
  "Selecione uma região": "Sélectionnez une région",
  "Selecione uma solicitação.": "Sélectionnez une demande.",
  "Selecione vídeos da sua conta Google Drive.": "Sélectionnez des vidéos de votre compte Google Drive.",
  "Selecione...": "Sélectionnez...",
  "Seletor": "Sélecteur",
  "Seletor CSS *": "Sélecteur CSS *",
  "Seletor copiado!": "Sélecteur copié !",
  "Seletor de cor personalizado": "Sélecteur de couleur personnalisé",
  "Seletor de período": "Sélecteur de période",
  "Seletor de templates": "Sélecteur de modèles",
  "Seletor de vídeo premium": "Sélecteur de vidéo premium",
  "Seleção de pastas em desenvolvimento": "Sélection des dossiers en développement",
  "Seleção de vídeos": "Sélection des vidéos",
  "Seleção de vídeos com badge ordem": "Sélection des vidéos avec badge d'ordre",
  "Seleção de vídeos em desenvolvimento": "Sélection des vidéos en développement",
  "Seleção intros com badge ordem": "Sélection des intros avec badge d'ordre",
  "Selos de Confiança": "Badges de confiance",
  "Sem Borda": "Sans bordure",
  "Sem Eventos": "Aucun événement",
  "Sem Leads ainda": "Aucun lead pour le moment",
  "Sem Pasta": "Sans dossier",
  "Sem Plano": "Sans forfait",
  "Sem VSL protegida": "Aucune VSL protégée",
  "Sem acesso": "Sans accès",
  "Sem animação": "Sans animation",
  "Sem arredondamento (0px)": "Sans arrondi (0px)",
  "Sem conexão com o servidor.": "Aucune connexion au serveur.",
  "Sem conversões": "Sans conversions",
  "Sem conversões ainda": "Aucune conversion pour le moment",
  "Sem dados": "Aucune donnée",
  "Sem dados ao vivo": "Aucune donnée en direct",
  "Sem dados de UTM no período": "Aucune donnée UTM pendant la période",
  "Sem dados de dispositivos disponíveis": "Aucune donnée d'appareil disponible",
  "Sem dados de horários no período": "Aucune donnée horaire pendant la période",
  "Sem dados de performance": "Aucune donnée de performances",
  "Sem dados de referência no período": "Aucune donnée de source référente pendant la période",
  "Sem dados de retenção": "Aucune donnée de rétention",
  "Sem dados de retenção no período": "Aucune donnée de rétention pendant la période",
  "Sem dados de retenção no período selecionado.": "Aucune donnée de rétention pour la période sélectionnée.",
  "Sem dados de {value0} no período": "Aucune donnée de {value0} pendant la période",
  "Sem dados disponíveis": "Aucune donnée disponible",
  "Sem dados no período.": "Aucune donnée pendant la période.",
  "Sem dados para exibir": "Aucune donnée à afficher",
  "Sem dados para mostrar": "Aucune donnée à afficher",
  "Sem dados suficientes": "Données insuffisantes",
  "Sem dados suficientes para exibir": "Données insuffisantes pour l'affichage",
  "Sem engajamento ainda": "Aucun engagement pour le moment",
  "Sem etapa": "Sans étape",
  "Sem eventos": "Aucun événement",
  "Sem fundo visível": "Sans fond visible",
  "Sem http:// — vamos salvar como https://{url}": "Sans http:// — enregistrement sous https://{url}",
  "Sem métricas ainda": "Aucun indicateur pour le moment",
  "Sem nome": "Sans nom",
  "Sem nome (apenas imagem)": "Sans nom (image uniquement)",
  "Sem nome da proteção": "Sans nom de protection",
  "Sem pergunta": "Sans question",
  "Sem permissão": "Sans autorisation",
  "Sem permissão para adicionar pixels": "Vous n'avez pas l'autorisation d'ajouter des pixels",
  "Sem permissão para adicionar vídeos": "Vous n'avez pas l'autorisation d'ajouter des vidéos",
  "Sem permissão para compartilhar vídeos": "Vous n'avez pas l'autorisation de partager des vidéos",
  "Sem permissão para criar Teste de hook": "Vous n'avez pas l'autorisation de créer un test d'accroche",
  "Sem permissão para criar pastas": "Vous n'avez pas l'autorisation de créer des dossiers",
  "Sem permissão para criar regras UTM": "Vous n'avez pas l'autorisation de créer des règles UTM",
  "Sem permissão para criar testes A/B": "Vous n'avez pas l'autorisation de créer des tests A/B",
  "Sem permissão para criar testes de Hook": "Vous n'avez pas l'autorisation de créer des tests d'accroche",
  "Sem permissão para criar testes de velocidade": "Vous n'avez pas l'autorisation de créer des tests de vitesse",
  "Sem permissão para editar ações de sincronização": "Vous n'avez pas l'autorisation de modifier les actions de synchronisation",
  "Sem permissão para editar pitches": "Vous n'avez pas l'autorisation de modifier les argumentaires de vente",
  "Sem permissão para editar pixels": "Vous n'avez pas l'autorisation de modifier les pixels",
  "Sem permissão para editar regras do Cloaker": "Vous n'avez pas l'autorisation de modifier les règles du Cloaker",
  "Sem permissão para editar regras geográficas": "Vous n'avez pas l'autorisation de modifier les règles géographiques",
  "Sem permissão para editar testes A/B": "Vous n'avez pas l'autorisation de modifier les tests A/B",
  "Sem permissão para excluir pastas": "Vous n'avez pas l'autorisation de supprimer des dossiers",
  "Sem permissão para excluir vídeos": "Vous n'avez pas l'autorisation de supprimer des vidéos",
  "Sem permissão para finalizar testes A/B": "Vous n'avez pas l'autorisation de terminer les tests A/B",
  "Sem permissão para remover pixels": "Vous n'avez pas l'autorisation de supprimer des pixels",
  "Sem permissão para renomear pastas": "Vous n'avez pas l'autorisation de renommer des dossiers",
  "Sem permissão para renomear vídeos": "Vous n'avez pas l'autorisation de renommer des vidéos",
  "Sem plano ativo": "Aucun forfait actif",
  "Sem plataforma": "Sans plateforme",
  "Sem plugins complexos": "Sans extensions complexes",
  "Sem redistribuição": "Sans redistribution",
  "Sem regras UTM": "Aucune règle UTM",
  "Sem replay automático se o Autoplay estiver desativado": "Pas de replay automatique lorsque l'Autoplay est désactivé",
  "Sem texto": "Sans texte",
  "Sem thumb": "Sans miniature",
  "Sem término (manual)": "Sans fin (manuel)",
  "Sem uma URL de redirecionamento válida o botão não aparece para o espectador.": "Sans URL de redirection valide, le bouton n'apparaît pas pour le spectateur.",
  "Sem visualizações no período selecionado": "Aucune vue pendant la période sélectionnée",
  "Sem vídeo": "Sans vidéo",
  "Sem vídeo alternativo": "Sans vidéo de remplacement",
  "Semanal": "Hebdomadaire",
  "Semi Bold": "Demi-gras",
  "Semi-negrito": "Demi-gras",
  "Sempre que pausar": "À chaque pause",
  "Sempre uma próxima sessão em poucos minutos": "Toujours une prochaine session dans quelques minutes",
  "Sempre visível": "Toujours visible",
  "Senha": "Mot de passe",
  "Senha (": "Mot de passe (",
  "Senha *": "Mot de passe *",
  "Senha Alterada": "Mot de passe modifié",
  "Senha Atual": "Mot de passe actuel",
  "Senha Definida *": "Mot de passe défini *",
  "Senha alterada com sucesso": "Mot de passe modifié avec succès",
  "Senha alterada com sucesso! Faça login com sua nova senha.": "Mot de passe modifié avec succès ! Connectez-vous avec votre nouveau mot de passe.",
  "Senha atual incorreta": "Mot de passe actuel incorrect",
  "Senha atual é obrigatória": "Le mot de passe actuel est obligatoire",
  "Senha de Acesso": "Mot de passe d'accès",
  "Senha deve ter pelo menos 8 caracteres": "Le mot de passe doit comporter au moins 8 caractères",
  "Senha deve ter pelo menos 8 caracteres.": "Le mot de passe doit comporter au moins 8 caractères.",
  "Senha do cliente": "Mot de passe du client",
  "Senha incorreta. Tente novamente.": "Mot de passe incorrect. Réessayez.",
  "Separe as cidades por vírgula.": "Séparez les villes par des virgules.",
  "Separe múltiplos domínios por vírgula": "Séparez les domaines par des virgules",
  "Separe os nomes por vírgula.": "Séparez les noms par des virgules.",
  "Seria": "Serait",
  "Seria:": "Serait :",
  "Serviço": "Service",
  "Será criada automaticamente no mesmo dia a cada mês": "Sera créée automatiquement le même jour chaque mois",
  "Sessão": "Session",
  "Sessão Agendada": "Session programmée",
  "Sessão atualizada hoje": "Session mise à jour aujourd'hui",
  "Sessões com saída de checkout": "Sessions avec sortie vers le paiement",
  "Seu HTML aparecerá aqui": "Votre HTML apparaîtra ici",
  "Seu HTML aqui": "Votre HTML ici",
  "Seu arquivo excede 2GB. Envie um arquivo menor.": "Votre fichier dépasse 2 Go. Envoyez un fichier plus petit.",
  "Seu cartão está vencido.": "Votre carte est expirée.",
  "Seu cartão foi recusado, tente novamente.": "Votre carte a été refusée. Réessayez.",
  "Seu cartão não possui saldo suficiente.": "Le solde de votre carte est insuffisant.",
  "Seu conteúdo está performando razoavelmente bem, mas há espaço para melhorias. Um bom equilíbrio entre taxa de reprodução e engajamento é essencial - lembre-se que não adianta ter muitos cliques se as pessoas não assistem o vídeo até o final.": "Votre contenu obtient des résultats corrects, avec une marge d'amélioration. Un bon équilibre entre taux de lecture et engagement est essentiel : de nombreux clics ne servent à rien si les personnes ne regardent pas la vidéo jusqu'à la fin.",
  "Seu link de afiliado": "Votre lien affilié",
  "Seu link de indicação estará sempre ativo, nunca expira.": "Votre lien de parrainage restera toujours actif et n'expirera jamais.",
  "Seu maior ponto de queda está antes do pitch. Considere antecipar a proposta de valor ou adicionar um gancho mais forte nos primeiros 15 minutos.": "Votre principal point de décrochage se situe avant l'argumentaire de vente. Envisagez d'avancer la proposition de valeur ou d'ajouter une accroche plus forte pendant les 15 premières minutes.",
  "Seu navegador não suporta a reprodução de vídeo.": "Votre navigateur ne prend pas en charge la lecture vidéo.",
  "Seu navegador não suporta notificações push ou o recurso está desabilitado.": "Votre navigateur ne prend pas en charge les notifications push ou cette fonctionnalité est désactivée.",
  "Seu navegador não suporta notificações push. Utilize Chrome, Firefox ou Safari para ativar este recurso.": "Votre navigateur ne prend pas en charge les notifications push. Utilisez Chrome, Firefox ou Safari pour activer cette fonctionnalité.",
  "Seu navegador não suporta vídeos.": "Votre navigateur ne prend pas en charge les vidéos.",
  "Seu nome": "Votre nom",
  "Seu pitch está performando muito bem!": "Votre argumentaire de vente est très performant !",
  "Seu pitch ocorre quando": "Votre argumentaire de vente intervient lorsque",
  "Seu pitch ocorre quando apenas": "Votre argumentaire de vente intervient alors que seulement",
  "Seu preço hoje: R$ 99": "Votre prix aujourd'hui : R$ 99",
  "Seu progresso foi salvo automaticamente.": "Votre progression a été enregistrée automatiquement.",
  "Seu progresso foi salvo.": "Votre progression a été enregistrée.",
  "Seu público hoje": "Votre audience aujourd'hui",
  "Seu teste \"{value0}\" foi criado e está pronto para uso.": "Votre test « {value0} » a été créé et est prêt à être utilisé.",
  "Seu teste A/B está ativo": "Votre test A/B est actif",
  "Seu teste A/B está ativo e coletando dados.": "Votre test A/B est actif et recueille des données.",
  "Seu teste de introduções está ativo": "Votre test d'introductions est actif",
  "Seu teste de introduções está ativo e coletando dados.": "Votre test d'introductions est actif et recueille des données.",
  "Seu teste de intros foi finalizado com sucesso.": "Votre test d'intros a été terminé avec succès.",
  "Seu time trabalhando junto, cada um no seu lugar.": "Votre équipe travaille ensemble, chacun à sa place.",
  "Seu vídeo está sendo processado…": "Votre vidéo est en cours de traitement…",
  "Seu vídeo já começou": "Votre vidéo a déjà commencé",
  "Seus Melhores Horários desta Semana": "Vos meilleurs horaires de la semaine",
  "Seus Testes A/B": "Vos tests A/B",
  "Seus Testes de Introduções": "Vos tests d'introductions",
  "Seus arquivos de identificación (frente e verso) foram enviados e aprovados com sucesso pelo setor de validação da Stripe Connect. Nenhuma ação adicional é requerida neste bloco.": "Vos fichiers d'identité (recto et verso) ont été envoyés et approuvés par le service de validation de Stripe Connect. Aucune action supplémentaire n'est requise dans ce bloc.",
  "Seus dados estão seguros conosco.": "Vos données sont en sécurité avec nous.",
  "Seus dados serão mantidos por 30 dias": "Vos données seront conservées pendant 30 jours",
  "Seus melhores horários": "Vos meilleurs horaires",
  "Seus testes A/B são mais eficazes quando você entende como interpretar os dados corretamente:": "Vos tests A/B sont plus efficaces lorsque vous savez interpréter correctement les données :",
  "Seus vídeos não serão mais exibidos": "Vos vidéos ne seront plus affichées",
  "Sex": "Ven",
  "Sexta 14-16h subiu 22% vs semana passada": "Vendredi 14 h-16 h : hausse de 22% par rapport à la semaine précédente",
  "Seção de Bônus": "Section des bonus",
  "Seção de Módulos": "Section des modules",
  "Seção de Picos de Horários integrada": "Section des pics horaires intégrée",
  "Sidebar de recursos do vídeo": "Barre latérale des fonctionnalités vidéo",
  "Sidebar desktop com position fixed para estabilidade, main content com margin-left compensatório. Layout Apple-like.": "Barre latérale sur ordinateur avec position fixed pour la stabilité et contenu principal avec margin-left compensatoire. Présentation inspirée d'Apple.",
  "Sidebar — Nova Aba Parceiros": "Barre latérale — Nouvel onglet Partenaires",
  "Sidebar — Posicionamento Fixo": "Barre latérale — Position fixe",
  "Siga estes passos para instalar no Safari": "Suivez ces étapes pour installer dans Safari",
  "Silenciar": "Couper le son",
  "Silencioso": "Silencieux",
  "Sim": "Oui",
  "Sim ou Não": "Oui ou non",
  "Sim! Como parceiro, você pode oferecer vantagens exclusivas aos seus indicados, como bônus especiais e materiais complementares.": "Oui ! En tant que partenaire, vous pouvez offrir des avantages exclusifs aux personnes parrainées, comme des bonus spéciaux et des ressources complémentaires.",
  "Sim! O programa aceita tanto pessoas físicas quanto jurídicas. Basta ter uma conta bancária ou chave PIX para receber os pagamentos.": "Oui ! Le programme accepte les particuliers et les entreprises. Il suffit d'avoir un compte bancaire ou une clé PIX pour recevoir les paiements.",
  "Sim, excluir teste": "Oui, supprimer le test",
  "Sim, finalizar teste": "Oui, terminer le test",
  "Simulada": "Simulée",
  "Simular 10s": "Simuler 10 s",
  "Simular 3s": "Simuler 3 s",
  "Simular Localização": "Simuler une localisation",
  "Simular visualização": "Simuler le visionnage",
  "Simulação de Audiência": "Simulation d'audience",
  "Simulação de Ganhos": "Simulation de gains",
  "Simulação do card no final do vídeo": "Simulation de la carte à la fin de la vidéo",
  "Simule como a regra se comportaria:": "Simulez le comportement de la règle :",
  "Sincronizar Métricas": "Synchroniser les indicateurs",
  "Sincronizar Vídeo com Horário": "Synchroniser la vidéo avec l'horaire",
  "Sincronizar com Horário": "Synchroniser avec l'horaire",
  "Sincronização com AWS concluída!": "Synchronisation avec AWS terminée !",
  "Sincronização com o Vídeo": "Synchronisation avec la vidéo",
  "Sistema Pré-pago": "Système prépayé",
  "Sistema de Documentação Dinâmica": "Système de documentation dynamique",
  "Sistema de Pastas e Subpastas": "Système de dossiers et sous-dossiers",
  "Sistema de webinars": "Système de webinaires",
  "Site URL": "URL du site",
  "Skeleton loading de parceiro": "Chargement squelette du partenaire",
  "Slide": "Glissement",
  "Slide de baixo": "Glissement depuis le bas",
  "Slide direito": "Glissement depuis la droite",
  "Smart Autoplay": "Smart Autoplay",
  "Smart TV": "Smart TV",
  "Sobre a reprodução automática:": "À propos de la lecture automatique :",
  "Sobre esta aula": "À propos de ce cours",
  "Sobre o Vídeo": "À propos de la vidéo",
  "Sobre o vídeo": "À propos de la vidéo",
  "Sobrenome": "Nom de famille",
  "Sobrenome Completo": "Nom de famille complet",
  "Sobrepor no vídeo": "Superposer sur la vidéo",
  "Sobreposições de Conteúdo": "Superpositions de contenu",
  "Sobrescrever com a minha": "Remplacer par la mienne",
  "Solicitado": "Demandé",
  "Solicitado em": "Demandé le",
  "Solicitar Saque Imediato ›": "Demander un retrait immédiat ›",
  "Solicitar nome": "Demander le nom",
  "Solicitar nome e e-mail": "Demander le nom et l'e-mail",
  "Solicitar nome, e-mail e WhatsApp": "Demander le nom, l'e-mail et le WhatsApp",
  "Solicitações Pendentes": "Demandes en attente",
  "Solicitações de Pagamento": "Demandes de paiement",
  "Soltar aqui": "Déposer ici",
  "Solte arquivos aqui, cole, navegue ou importe de": "Déposez des fichiers ici, collez-les, parcourez-les ou importez-les depuis",
  "Solte para enviar": "Déposez pour envoyer",
  "Solte seu vídeo aqui,": "Déposez votre vidéo ici,",
  "Som": "Son",
  "Som de alerta": "Son d'alerte",
  "Sombra": "Ombre",
  "Sombra de dropdowns": "Ombre des menus déroulants",
  "Sombra de tooltips": "Ombre des infobulles",
  "Sombra durante drag": "Ombre pendant le déplacement",
  "Sombra no texto": "Ombre du texte",
  "Sombra nos cards": "Ombre des cartes",
  "Sombra padrão de cards": "Ombre par défaut des cartes",
  "Sombras": "Ombres",
  "Somente hoje": "Aujourd'hui uniquement",
  "Source Sans Pro (Technical)": "Source Sans Pro (technique)",
  "Spark Points": "Spark Points",
  "Stack Trace:": "Trace de pile :",
  "Start time must be non-negative": "Le temps de début ne peut pas être négatif",
  "Start time too large": "Temps de début trop élevé",
  "State Management": "Gestion de l'état",
  "Status": "Statut",
  "Status atual": "Statut actuel",
  "Status atualizado": "Statut mis à jour",
  "Status atualizado com sucesso!": "Statut mis à jour avec succès !",
  "Status da Regra": "Statut de la règle",
  "Status da captura:": "Statut de la capture :",
  "Status da conta atualizado!": "Statut du compte mis à jour !",
  "Status do Cadastro": "Statut de l'inscription",
  "Status do Teste": "Statut du test",
  "Status geral": "Statut général",
  "Status:": "Statut :",
  "Status: Enviado para CRM": "Statut : envoyé au CRM",
  "Step 10 - Em desenvolvimento": "Étape 10 - En développement",
  "Step 6 - Em desenvolvimento": "Étape 6 - En développement",
  "Step 7 - Em desenvolvimento": "Étape 7 - En développement",
  "Step 8 - Em desenvolvimento": "Étape 8 - En développement",
  "Step 9 - Em desenvolvimento": "Étape 9 - En développement",
  "Stepper visual etapas": "Indicateur visuel des étapes",
  "Storage": "Stockage",
  "Stores Principais": "Stores principaux",
  "Storyboard": "Storyboard",
  "Stripe não está carregado": "Stripe n'est pas chargé",
  "Styling": "Mise en style",
  "Sua VSL agora pergunta e escuta: o Feedback do Vídeo é um card de avaliação que aparece dentro do player, no momento que você escolher, e recolhe a opinião de quem assistiu sem tirar a pessoa da página. Você define o formato da nota, o gatilho de exibição, os textos e o visual do card. Na aba Métricas do vídeo você acompanha a nota média, o total de respostas, a distribuição das avaliações e a evolução ao longo do tempo.": "Votre VSL pose désormais des questions et écoute : les avis vidéo sont recueillis via une carte d'évaluation dans le lecteur, au moment de votre choix, sans faire quitter la page au spectateur. Définissez le format de la note, le déclencheur d'affichage, les textes et l'apparence de la carte. Dans l'onglet Indicateurs de la vidéo, suivez la note moyenne, le total des réponses, la répartition des évaluations et leur évolution au fil du temps.",
  "Sua VSL agora pode seguir o caminho de quem está assistindo. Com a VSL Dinâmica 2.0, você monta um funil visual de vídeos, perguntas e opções: o visitante escolhe uma resposta dentro do player e continua no vídeo que faz sentido para ele. Em vez de mostrar a mesma sequência para todo mundo, você pode apresentar argumentos diferentes para cada necessidade e conduzir a pessoa até o checkout, o WhatsApp ou outra página. Tudo é configurado no construtor, com pré-visualização e métricas para acompanhar cada caminho.": "Votre VSL peut désormais suivre le chemin du spectateur. Avec VSL dynamique 2.0, créez un tunnel visuel composé de vidéos, questions et options : le visiteur choisit une réponse dans le lecteur et poursuit avec la vidéo adaptée. Au lieu d'afficher la même séquence à tout le monde, présentez des arguments répondant à chaque besoin et guidez la personne vers le paiement, WhatsApp ou une autre page. Tout se configure dans le constructeur, avec un aperçu et des indicateurs pour suivre chaque chemin.",
  "Sua assinatura está ativa e deve ser renovada na data de": "Votre abonnement est actif et sera renouvelé le",
  "Sua assinatura foi cancelada com sucesso.": "Votre abonnement a été résilié avec succès.",
  "Sua assinatura será encerrada ao final do período atual.": "Votre abonnement prendra fin à la fin de la période actuelle.",
  "Sua audiência passa o mouse na timeline e já vê uma miniatura do frame daquele momento.": "Votre audience survole la timeline pour voir immédiatement une miniature de l'image à cet instant.",
  "Sua audiência pode transmitir o vídeo pra Chromecast ou AirPlay com um clique direto do player.": "Votre audience peut diffuser la vidéo sur Chromecast ou AirPlay en un clic depuis le lecteur.",
  "Sua conta deixou de ser de uma pessoa só. Com Membros, você cadastra quem trabalha com você e define, recurso por recurso, o que cada pessoa pode ver e o que pode editar — ou marca como Administrador e libera todas as áreas de uma vez. Também dá pra liberar apenas as pastas de vídeos que interessam àquela pessoa, deixando o resto da sua biblioteca fora do alcance. Cada um entra com o próprio e-mail e a própria senha, então você para de compartilhar o seu login com o time.": "Votre compte peut désormais être partagé avec votre équipe. Avec Membres, ajoutez vos collaborateurs et définissez, fonctionnalité par fonctionnalité, ce que chacun peut voir et modifier. Vous pouvez aussi attribuer le rôle Administrateur pour ouvrir toutes les sections à la fois. Autorisez uniquement les dossiers vidéo utiles à chaque personne et gardez le reste de votre bibliothèque inaccessible. Chacun se connecte avec son propre e-mail et son propre mot de passe : vous n'avez plus à partager vos identifiants avec l'équipe.",
  "Sua headline aqui": "Votre titre ici",
  "Sua resposta ajuda a melhorar a experiência.": "Votre réponse aide à améliorer l'expérience.",
  "Sua resposta foi registrada com sucesso.": "Votre réponse a été enregistrée avec succès.",
  "Sua senha deve ter pelo menos 8 caracteres, incluindo letras maiúsculas, minúsculas e números": "Votre mot de passe doit comporter au moins 8 caractères, dont des majuscules, des minuscules et des chiffres",
  "Sua taxa de reprodução está abaixo da média. Experimente utilizar thumbnails mais atraentes, cores que chamem atenção e títulos mais impactantes. A primeira impressão é crucial para aumentar os cliques no play.": "Votre taux de lecture est inférieur à la moyenne. Essayez des miniatures plus attractives, des couleurs qui attirent l'attention et des titres plus percutants. La première impression est essentielle pour augmenter les clics sur Lecture.",
  "Suas chaves": "Vos clés",
  "Suas configurações de notificações foram atualizadas.": "Vos paramètres de notification ont été mis à jour.",
  "Suas histórias estão funcionando! Tente adicionar mais elementos de conflito e resolução para aumentar ainda mais o engajamento.": "Vos histoires fonctionnent ! Ajoutez davantage de conflits et de résolutions pour renforcer encore l'engagement.",
  "Suas métricas de conversão aparecerão aqui.": "Vos indicateurs de conversion apparaîtront ici.",
  "Suas últimas alterações não foram salvas.": "Vos dernières modifications n'ont pas été enregistrées.",
  "Suave": "Doux",
  "Suave e limpo": "Doux et épuré",
  "Subdomínio específico": "Sous-domaine spécifique",
  "Subheadline (Opcional)": "Sous-titre (facultatif)",
  "Subheadline: \"": "Sous-titre : «",
  "Subindo arquivo...": "Envoi du fichier...",
  "Subir opção {value0}": "Monter l'option {value0}",
  "Sublinhado": "Souligné",
  "Subpastas": "Sous-dossiers",
  "Substituir": "Remplacer",
  "Substituir arquivo": "Remplacer le fichier",
  "Substituir por Outro Vídeo": "Remplacer par une autre vidéo",
  "Subtexto": "Texte secondaire",
  "Subtítulo": "Sous-titre",
  "Subtítulo (máx 160 caracteres)": "Sous-titre (160 caractères max.)",
  "Subtítulo (opcional)": "Sous-titre (facultatif)",
  "Subtítulo de exemplo": "Exemple de sous-titre",
  "Subtítulo do webinar": "Sous-titre du webinaire",
  "Sucesso": "Succès",
  "Sucesso!": "Succès !",
  "Sugestão Automática": "Suggestion automatique",
  "Sugestão automática": "Suggestion automatique",
  "Sugestão:": "Suggestion :",
  "Sugestões Avançadas": "Suggestions avancées",
  "Sugestões Avançadas de Retenção": "Suggestions avancées de rétention",
  "Sugestões Avançadas para Teste A/B de Vídeos": "Suggestions avancées pour les tests A/B de vidéos",
  "Sugestões baseadas nos dados de dispositivos para otimizar seu conteúdo.": "Suggestions fondées sur les données des appareils pour optimiser votre contenu.",
  "Sugestões de Melhoria": "Suggestions d'amélioration",
  "Supabase": "Supabase",
  "Superior Centro": "En haut au centre",
  "Superior Direita": "En haut à droite",
  "Superior Direito": "En haut à droite",
  "Superior Esquerda": "En haut à gauche",
  "Superior Esquerdo": "En haut à gauche",
  "Superior central": "En haut au centre",
  "Superior direito": "En haut à droite",
  "Superior esquerdo": "En haut à gauche",
  "Suporte": "Support",
  "Suporte Prioritário": "Support prioritaire",
  "Suporte ao cliente e sistema de tickets para resolução de problemas.": "Support client et système de tickets pour résoudre les problèmes.",
  "Suporte e Atendimento": "Support et assistance",
  "Suporte premium HostVSL": "Support premium HostVSL",
  "Suporte: contato@seudominio.com": "Support : contato@seudominio.com",
  "Sydney (GMT+10)": "Sydney (GMT+10)",
  "Sync AWS": "Synchroniser AWS",
  "SÁB": "SAM",
  "Sáb": "Sam",
  "Sábado": "Samedi",
  "São Paulo": "São Paulo",
  "São Paulo, Rio de Janeiro, Belo Horizonte, Brasília, Salvador": "São Paulo, Rio de Janeiro, Belo Horizonte, Brasília, Salvador",
  "Só o botão. É o comportamento clássico.": "Le bouton uniquement. C'est le comportement classique.",
  "Só você vê esse nome.": "Ce nom est visible uniquement par vous.",
  "Sócio gerente": "Associé gérant",
  "Sólido": "Uni",
  "TEMPO:": "TEMPS :",
  "TER": "MAR",
  "TER • 12h-14h": "MAR • 12 h-14 h",
  "TER • 20h-22h": "MAR • 20 h-22 h",
  "TRÁFEGO": "TRAFIC",
  "Tabela Consolidada": "Tableau consolidé",
  "Tablet": "Tablette",
  "Tablet:": "Tablette :",
  "Tags de Campanha": "Tags de campagne",
  "Tamanho": "Taille",
  "Tamanho (px)": "Taille (px)",
  "Tamanho da Fonte": "Taille de police",
  "Tamanho da Fonte (px)": "Taille de police (px)",
  "Tamanho da fonte": "Taille de police",
  "Tamanho do botão": "Taille du bouton",
  "Tamanho do Ícone": "Taille de l'icône",
  "Tamanho dos Cards": "Taille des cartes",
  "Tamanho e Posição": "Taille et position",
  "Tamanho e Transparência": "Taille et transparence",
  "Tamanho máximo de 2GB por vídeo (mesmo limite do upload normal)": "Taille maximale de 2 Go par vidéo (même limite que l'envoi normal)",
  "Tamanho máximo: 2MB": "Taille maximale : 2 Mo",
  "Tamanho recomendado: 1920x1080px • Formatos: JPG, PNG, GIF • Máximo: 10MB": "Taille recommandée : 1920x1080px • Formats : JPG, PNG, GIF • Maximum : 10 Mo",
  "Tamanho:": "Taille :",
  "Taxa": "Taux",
  "Taxa Conv.": "Taux de conv.",
  "Taxa Média": "Taux moyen",
  "Taxa de Conversão": "Taux de conversion",
  "Taxa de E-mail": "Taux d'e-mail",
  "Taxa de Play": "Taux de lecture",
  "Taxa de Play (%)": "Taux de lecture (%)",
  "Taxa de Reprodução": "Taux de lecture",
  "Taxa de Retenção (%)": "Taux de rétention (%)",
  "Taxa de Telefone": "Taux de téléphone",
  "Taxa de acesso ao checkout": "Taux d'accès au paiement",
  "Taxa de conversão": "Taux de conversion",
  "Taxa de conversão final": "Taux de conversion final",
  "Taxa de conversão geral:": "Taux de conversion global :",
  "Taxa de play": "Taux de lecture",
  "Taxa média de conversão calculada entre todas as plataformas": "Taux moyen de conversion calculé sur toutes les plateformes",
  "Taxa média de retenção": "Taux moyen de rétention",
  "Taxa:": "Taux :",
  "Taxas": "Frais",
  "Taxas Acumuladas": "Frais cumulés",
  "Taxas calculadas automaticamente: Play Rate, Click Rate e Conversion Rate": "Taux calculés automatiquement : taux de lecture, taux de clics et taux de conversion",
  "Taxas cobradas sobre pagamentos.": "Frais prélevés sur les paiements.",
  "Tecnologia de": "Technologie de",
  "Tela Cheia": "Plein écran",
  "Tela cheia": "Plein écran",
  "Tela flutuante": "Fenêtre flottante",
  "Telefone": "Téléphone",
  "Telefone copiado!": "Téléphone copié !",
  "Telefone inválido": "Téléphone invalide",
  "Telefone/WhatsApp": "Téléphone/WhatsApp",
  "Telefone:": "Téléphone :",
  "Tem certeza que deseja cancelar?": "Voulez-vous vraiment annuler ?",
  "Tem certeza que deseja deletar este teste de velocidade? Esta ação não pode ser desfeita.": "Voulez-vous vraiment supprimer ce test de vitesse ? Cette action est irréversible.",
  "Tem certeza que deseja desativar a captura de \"": "Voulez-vous vraiment désactiver la capture de «",
  "Tem certeza que deseja desativar o link de compartilhamento? O link deixará de funcionar imediatamente.": "Voulez-vous vraiment désactiver le lien de partage ? Le lien cessera immédiatement de fonctionner.",
  "Tem certeza que deseja excluir": "Voulez-vous vraiment supprimer",
  "Tem certeza que deseja excluir \"": "Voulez-vous vraiment supprimer «",
  "Tem certeza que deseja excluir esta legenda?": "Voulez-vous vraiment supprimer ces sous-titres ?",
  "Tem certeza que deseja excluir esta variação? Esta ação não pode ser desfeita.": "Voulez-vous vraiment supprimer cette variante ? Cette action est irréversible.",
  "Tem certeza que deseja excluir este Mini-Hook? Esta ação não pode ser desfeita.": "Voulez-vous vraiment supprimer ce Mini-Hook ? Cette action est irréversible.",
  "Tem certeza que deseja excluir este compartilhamento? Esta ação não pode ser desfeita.": "Voulez-vous vraiment supprimer ce partage ? Cette action est irréversible.",
  "Tem certeza que deseja excluir o registro de": "Voulez-vous vraiment supprimer l'enregistrement de",
  "Tem certeza que deseja excluir o registro de {value0}?": "Voulez-vous vraiment supprimer l'enregistrement de {value0} ?",
  "Tem certeza que deseja excluir o tracking da plataforma": "Voulez-vous vraiment supprimer le suivi de la plateforme",
  "Tem certeza que deseja excluir os": "Voulez-vous vraiment supprimer les",
  "Tem certeza que deseja excluir permanentemente o vídeo": "Voulez-vous vraiment supprimer définitivement la vidéo",
  "Tem certeza que deseja remover": "Voulez-vous vraiment supprimer",
  "Tem certeza que deseja remover '": "Voulez-vous vraiment supprimer «",
  "Tem certeza que deseja remover esta imagem?": "Voulez-vous vraiment supprimer cette image ?",
  "Tem certeza que deseja remover esta imagem? Esta ação não pode ser desfeita.": "Voulez-vous vraiment supprimer cette image ? Cette action est irréversible.",
  "Tem certeza que deseja remover este método de pagamento?": "Voulez-vous vraiment supprimer ce moyen de paiement ?",
  "Tem certeza que deseja remover sua foto de perfil? Esta ação não pode ser desfeita.": "Voulez-vous vraiment supprimer votre photo de profil ? Cette action est irréversible.",
  "Tem certeza que deseja sair?": "Voulez-vous vraiment quitter ?",
  "Tem certeza? Esta ação não pode ser desfeita.": "Êtes-vous sûr ? Cette action est irréversible.",
  "Tem todas as permissões.": "Possède toutes les autorisations.",
  "Tema": "Thème",
  "Template Base": "Modèle de base",
  "Template horizontal estilo Wistia/Vimeo com player centralizado, grid responsivo 4/2/1 colunas, autoplay sequencial com countdown.": "Modèle horizontal de style Wistia/Vimeo avec lecteur centré, grille adaptative de 4/2/1 colonnes et lecture séquentielle automatique avec compte à rebours.",
  "Template não encontrado": "Modèle introuvable",
  "Template {value0}": "Modèle {value0}",
  "Templates": "Modèles",
  "Templates Sugeridos": "Modèles suggérés",
  "Tempo": "Temps",
  "Tempo Atual": "Temps actuel",
  "Tempo Médio Assistido": "Durée moyenne regardée",
  "Tempo Real": "Temps réel",
  "Tempo atual": "Temps actuel",
  "Tempo atualizado!": "Temps mis à jour !",
  "Tempo até retomar": "Délai avant la reprise",
  "Tempo da contagem": "Durée du décompte",
  "Tempo de Carregamento": "Temps de chargement",
  "Tempo de Exibição": "Durée d'affichage",
  "Tempo de espera mínimo (minutos)": "Délai d'attente minimal (minutes)",
  "Tempo de preenchimento": "Temps de remplissage",
  "Tempo do Pitch": "Moment de l'argumentaire de vente",
  "Tempo do Vídeo": "Temps de la vidéo",
  "Tempo do Vídeo (min:seg) *": "Temps de la vidéo (min:sec) *",
  "Tempo do Vídeo (mm:ss) *": "Temps de la vidéo (mm:ss) *",
  "Tempo do pitch": "Moment de l'argumentaire de vente",
  "Tempo do pitch:": "Moment de l'argumentaire de vente :",
  "Tempo do vídeo": "Temps de la vidéo",
  "Tempo inválido. Use o formato m:ss.s e garanta que início < fim.": "Temps invalide. Utilisez le format m:ss.s et vérifiez que début < fin.",
  "Tempo médio assistido": "Durée moyenne regardée",
  "Tempo médio do pitch:": "Moment moyen de l'argumentaire de vente :",
  "Tempo no vídeo": "Temps dans la vidéo",
  "Tempo para exibir a primeira notificação após o play.": "Délai avant la première notification après le lancement de la lecture.",
  "Tempo para exibição (segundos)": "Délai d'affichage (secondes)",
  "Tempo personalizado": "Temps personnalisé",
  "Tempo real": "Temps réel",
  "Tempo:": "Temps :",
  "Tempo: 00:00 - Início do Vídeo": "Temps : 00:00 - Début de la vidéo",
  "Temporizador": "Minuteur",
  "Temporização": "Synchronisation",
  "Tendência Consistente:": "Tendance régulière :",
  "Tendência Diária": "Tendance quotidienne",
  "Tendência de Captura": "Tendance des captures",
  "Tendência por Hora": "Tendance horaire",
  "Tenha atendimento exclusivo para parceiros.": "Bénéficiez d'un accompagnement exclusif pour les partenaires.",
  "Tentar Novamente": "Réessayer",
  "Tentar de novo": "Réessayer",
  "Tentar novamente": "Réessayer",
  "Tentativas:": "Tentatives :",
  "Tente abrir o vídeo no Chrome (Chromecast) ou Safari (AirPlay).": "Essayez d'ouvrir la vidéo dans Chrome (Chromecast) ou Safari (AirPlay).",
  "Tente ajustar seus filtros de busca ou categoria.": "Essayez d'ajuster les filtres de recherche ou la catégorie.",
  "Tente ajustar sua busca ou limpar os filtros.": "Essayez d'ajuster votre recherche ou de réinitialiser les filtres.",
  "Tente ampliar o período": "Essayez d'élargir la période",
  "Tente ampliar o período ou visualizar outro vídeo.": "Essayez d'élargir la période ou de consulter une autre vidéo.",
  "Tente ampliar o período, escolher outra métrica ou verifique se há uma integração de conversão configurada.": "Essayez d'élargir la période, de choisir un autre indicateur ou de vérifier la configuration d'une intégration de conversion.",
  "Tente buscar por outro termo": "Essayez un autre terme de recherche",
  "Tente buscar por outro termo ou campanha": "Essayez un autre terme ou une autre campagne",
  "Tente novamente": "Réessayez",
  "Tente novamente em instantes. Se o problema persistir, entre em contato com o suporte.": "Réessayez dans un instant. Si le problème persiste, contactez le support.",
  "Tente novamente.": "Réessayez.",
  "Tente outro termo ou revise a ortografia.": "Essayez un autre terme ou vérifiez l'orthographe.",
  "Tente outro termo.": "Essayez un autre terme.",
  "Tente reduzir o tamanho do vídeo ou usar adaptação de qualidade para melhorar o tempo de carregamento.": "Essayez de réduire la taille de la vidéo ou d'utiliser la qualité adaptative pour améliorer le temps de chargement.",
  "Tente selecionar um intervalo de datas diferente.": "Essayez de sélectionner une autre plage de dates.",
  "Tente uma busca diferente.": "Essayez une autre recherche.",
  "Tente verificar a ortografia ou usar palavras-chave diferentes": "Vérifiez l'orthographe ou utilisez d'autres mots-clés",
  "Ter": "Mar",
  "Terceiro melhor momento": "Troisième meilleur moment",
  "Termina com": "Se termine par",
  "Termina em:": "Se termine le :",
  "Termine suas VSLs levando o espectador direto para a decisão.": "Terminez vos VSL en guidant le spectateur directement vers la décision.",
  "Termo (Term)": "Terme (Term)",
  "Termos": "Conditions",
  "Termos de Uso": "Conditions d'utilisation",
  "Termos de uso": "Conditions d'utilisation",
  "Terça 22-00h: Crescimento de 18% nas últimas 3 semanas": "Mardi 22 h-00 h : croissance de 18% au cours des 3 dernières semaines",
  "Terça-feira": "Mardi",
  "Testando...": "Test en cours...",
  "Testar": "Tester",
  "Testar Regra": "Tester la règle",
  "Testar abertura do modal": "Tester l'ouverture de la fenêtre",
  "Testar notificação agora": "Tester la notification maintenant",
  "Testar som": "Tester le son",
  "Teste": "Test",
  "Teste A/B": "Test A/B",
  "Teste A/B - Remoção Badge Contagem": "Test A/B - Suppression du badge de comptage",
  "Teste A/B - Wizard Premium com Drag-and-Drop": "Test A/B - Assistant premium avec glisser-déposer",
  "Teste A/B ativado!": "Test A/B activé !",
  "Teste A/B criado com sucesso!": "Test A/B créé avec succès !",
  "Teste A/B criado e ativado!": "Test A/B créé et activé !",
  "Teste AB": "Test AB",
  "Teste Automático": "Test automatique",
  "Teste Automático com Múltiplas Velocidades": "Test automatique à plusieurs vitesses",
  "Teste Sequencial:": "Test séquentiel :",
  "Teste aplicado com sucesso!": "Test appliqué avec succès !",
  "Teste automático em andamento. A velocidade manual será aplicada quando o teste finalizar.": "Test automatique en cours. La vitesse manuelle sera appliquée à la fin du test.",
  "Teste automático iniciado": "Test automatique démarré",
  "Teste criado com sucesso!": "Test créé avec succès !",
  "Teste criado!": "Test créé !",
  "Teste de Hook - Navegação Corrigida": "Test d'accroche - Navigation corrigée",
  "Teste de Hook - Padronização com Teste A/B": "Test d'accroche - Harmonisation avec le test A/B",
  "Teste de Integrações": "Test des intégrations",
  "Teste de headline carregado!": "Test de titre chargé !",
  "Teste de hook": "Test d'accroche",
  "Teste de hook criado com sucesso!": "Test d'accroche créé avec succès !",
  "Teste de velocidade criado com sucesso.": "Test de vitesse créé avec succès.",
  "Teste de velocidade deletado com sucesso.": "Test de vitesse supprimé avec succès.",
  "Teste de velocidade iniciado": "Test de vitesse démarré",
  "Teste deletado com sucesso!": "Test supprimé avec succès !",
  "Teste deletado!": "Test supprimé !",
  "Teste diferentes introduções e descubra a que converte mais": "Testez différentes introductions et découvrez celle qui convertit le plus",
  "Teste diferentes introduções e descubra qual retém mais a atenção": "Testez différentes introductions et découvrez celle qui retient le mieux l'attention",
  "Teste diferentes posições do vídeo na página. Acima da dobra geralmente tem melhores resultados.": "Testez différentes positions de la vidéo dans la page. Au-dessus de la ligne de flottaison, les résultats sont généralement meilleurs.",
  "Teste diferentes variações e otimize suas conversões.": "Testez différentes variantes et optimisez vos conversions.",
  "Teste diferentes versões de suas VSLs e descubra o que converte mais": "Testez différentes versions de vos VSL et découvrez celle qui convertit le plus",
  "Teste encerrado": "Test terminé",
  "Teste excluído": "Test supprimé",
  "Teste finalizado": "Test terminé",
  "Teste finalizado automaticamente": "Test terminé automatiquement",
  "Teste finalizado com sucesso!": "Test terminé avec succès !",
  "Teste finalizado e deletado com sucesso!": "Test terminé et supprimé avec succès !",
  "Teste grátis": "Essai gratuit",
  "Teste grátis com um clique, sem cartão de crédito": "Essai gratuit en un clic, sans carte bancaire",
  "Teste grátis iniciado! Seu plano {value0} está ativo. Você não será cobrado pelos próximos 15 dias.": "Essai gratuit démarré ! Votre forfait {value0} est actif. Vous ne serez pas facturé pendant les 15 prochains jours.",
  "Teste múltiplos botões ao longo do vídeo (não apenas no final)": "Testez plusieurs boutons au fil de la vidéo, pas seulement à la fin",
  "Teste no mínimo 3 abordagens de intro diferentes": "Testez au moins 3 approches d'introduction différentes",
  "Teste não iniciado": "Test non démarré",
  "Teste renomeado": "Test renommé",
  "Teste sem nome": "Test sans nom",
  "Teste seu vídeo neste navegador para garantir a melhor experiência.": "Testez votre vidéo dans ce navigateur pour garantir une expérience optimale.",
  "Teste títulos com números específicos ou perguntas intrigantes": "Testez des titres avec des chiffres précis ou des questions intrigantes",
  "Teste uma abordagem diferente: se está usando problema-solução, experimente curiosidade ou história de transformação.": "Testez une autre approche : si vous utilisez problème-solution, essayez la curiosité ou une histoire de transformation.",
  "Teste variações": "Testez des variantes",
  "Teste:": "Test :",
  "Testes A/B": "Tests A/B",
  "Testes A/B Integrados": "Tests A/B intégrés",
  "Testes Ativos": "Tests actifs",
  "Testes de Velocidade": "Tests de vitesse",
  "Testes em andamento": "Tests en cours",
  "Texto": "Texte",
  "Texto (Hover)": "Texte (survol)",
  "Texto Botão": "Texte du bouton",
  "Texto Inferior": "Texte inférieur",
  "Texto Personalizado": "Texte personnalisé",
  "Texto Superior": "Texte supérieur",
  "Texto abaixo da imagem": "Texte sous l'image",
  "Texto acima do indicador (opcional, máx 40 caracteres)": "Texte au-dessus de l'indicateur (facultatif, 40 caractères max.)",
  "Texto adicional de segurança ou informação": "Texte supplémentaire de sécurité ou d'information",
  "Texto antes de liberar": "Texte avant le déblocage",
  "Texto atualizado!": "Texte mis à jour !",
  "Texto branco em fundo claro": "Texte blanc sur fond clair",
  "Texto da Headline": "Texte du titre",
  "Texto da Subheadline": "Texte du sous-titre",
  "Texto da barra": "Texte de la barre",
  "Texto da opção {value0}": "Texte de l'option {value0}",
  "Texto de Copyright (editável)": "Texte de copyright (modifiable)",
  "Texto de Exibição": "Texte affiché",
  "Texto dentro da imagem (com overlay)": "Texte dans l'image (avec superposition)",
  "Texto do Botão": "Texte du bouton",
  "Texto do Botão (máx 40 caracteres)": "Texte du bouton (40 caractères max.)",
  "Texto do Campo": "Texte du champ",
  "Texto do Link": "Texte du lien",
  "Texto do Termo (máx 250 caracteres)": "Texte du consentement (250 caractères max.)",
  "Texto do Título": "Texte du titre",
  "Texto do aviso": "Texte de notification",
  "Texto do botão": "Texte du bouton",
  "Texto do botão de envio do formulário": "Texte du bouton d'envoi du formulaire",
  "Texto do botão de início": "Texte du bouton de démarrage",
  "Texto do botão para iniciar": "Texte du bouton pour démarrer",
  "Texto do botão principal": "Texte du bouton principal",
  "Texto do botão é obrigatório": "Le texte du bouton est obligatoire",
  "Texto do link secundário": "Texte du lien secondaire",
  "Texto do overlay": "Texte de la superposition",
  "Texto do segundo botão": "Texte du deuxième bouton",
  "Texto do template": "Texte du modèle",
  "Texto do texto secundário": "Texte secondaire",
  "Texto do timer": "Texte du minuteur",
  "Texto exibido na página de compartilhamento": "Texte affiché sur la page de partage",
  "Texto exibido no overlay para orientar o usuário": "Texte affiché dans la superposition pour guider l'utilisateur",
  "Texto livre permitido - variáveis são opcionais": "Texte libre autorisé - les variables sont facultatives",
  "Texto para pular": "Texte du bouton Passer",
  "Texto personalizado...": "Texte personnalisé...",
  "Texto principal": "Texte principal",
  "Texto principal do formulário": "Texte principal du formulaire",
  "Texto próprio no botão e escolha de abrir na mesma aba ou em uma nova": "Texte personnalisé sur le bouton et choix d'ouverture dans le même onglet ou un nouvel onglet",
  "Texto secundário": "Texte secondaire",
  "Texto sobre a barra": "Texte sur la barre",
  "Textos": "Textes",
  "Textos do bloco": "Textes du bloc",
  "Textos do overlay": "Textes de la superposition",
  "Thumbnail": "Miniature",
  "Thumbnail adicionada com sucesso": "Miniature ajoutée avec succès",
  "Thumbnail aplicada!": "Miniature appliquée !",
  "Thumbnail atualizada": "Miniature mise à jour",
  "Thumbnail gerada!": "Miniature générée !",
  "Thumbnail removida": "Miniature supprimée",
  "Thumbnail removida com sucesso": "Miniature supprimée avec succès",
  "Thumbnail será exibida apenas no trecho específico": "La miniature s'affichera uniquement sur le passage défini",
  "Thumbnail será exibida sempre que pausar": "La miniature s'affichera à chaque pause",
  "Thumbnail será exibida {value0}": "La miniature s'affichera {value0}",
  "Thumbnails atualizadas": "Miniatures mises à jour",
  "Thumbnails do Vídeo": "Miniatures de la vidéo",
  "Ticket": "Panier",
  "Ticket Médio": "Panier moyen",
  "Ticket médio": "Panier moyen",
  "Ticket:": "Panier :",
  "Ticto": "Ticto",
  "Timer e Urgência": "Minuteur et urgence",
  "Timestamp (min:seg)": "Horodatage (min:sec)",
  "Timing:": "Synchronisation :",
  "Tipo": "Type",
  "Tipo Acesso": "Type d'accès",
  "Tipo da Regra": "Type de règle",
  "Tipo de Animação": "Type d'animation",
  "Tipo de Ação *": "Type d'action *",
  "Tipo de Fundo": "Type de fond",
  "Tipo de Indicador": "Type d'indicateur",
  "Tipo de Pixel": "Type de pixel",
  "Tipo de Recebimento": "Type de réception des paiements",
  "Tipo de animação": "Type d'animation",
  "Tipo de arquivo inválido": "Type de fichier invalide",
  "Tipo de botão": "Type de bouton",
  "Tipo de conta": "Type de compte",
  "Tipo de evento": "Type d'événement",
  "Tipo de notificação": "Type de notification",
  "Tipo de regra:": "Type de règle :",
  "Tipo de som": "Type de son",
  "Tipo:": "Type :",
  "Tipografia": "Typographie",
  "Tipografia Premium — Font-weight 500": "Typographie premium — Graisse 500",
  "Tipos de Notificações": "Types de notifications",
  "Tirar dúvidas no WhatsApp": "Poser une question sur WhatsApp",
  "Tire suas dúvidas sobre o programa": "Obtenez des réponses à vos questions sur le programme",
  "Titular": "Titulaire",
  "Todas": "Toutes",
  "Todas as Pastas": "Tous les dossiers",
  "Todas as Plataformas": "Toutes les plateformes",
  "Todas as alterações refletem no embed final automaticamente": "Toutes les modifications sont automatiquement répercutées dans l'intégration finale",
  "Todas as alterações são aplicadas instantaneamente": "Toutes les modifications sont appliquées instantanément",
  "Todas as alterações são aplicadas instantaneamente.": "Toutes les modifications sont appliquées instantanément.",
  "Todas as configurações do seu vídeo foram salvas": "Tous les paramètres de votre vidéo ont été enregistrés",
  "Todas as configurações voltaram ao padrão": "Tous les paramètres ont été rétablis par défaut",
  "Todas as legendas foram removidas do vídeo.": "Tous les sous-titres ont été supprimés de la vidéo.",
  "Todas as personalizações foram aplicadas ao seu vídeo.": "Toutes les personnalisations ont été appliquées à votre vidéo.",
  "Todas as plataformas": "Toutes les plateformes",
  "Todas as regiões bloqueadas": "Toutes les régions bloquées",
  "Todas as regiões permitidas": "Toutes les régions autorisées",
  "Todas as saídas de checkout já possuem uma integração.": "Toutes les sorties vers le paiement possèdent déjà une intégration.",
  "Todas as solicitações enviadas pelos afiliados da plataforma.": "Toutes les demandes envoyées par les affiliés de la plateforme.",
  "Todo o vídeo": "Toute la vidéo",
  "Todos": "Tous",
  "Todos Status": "Tous les statuts",
  "Todos dispositivos": "Tous les appareils",
  "Todos os Custos": "Tous les coûts",
  "Todos os Registros": "Tous les enregistrements",
  "Todos os campos disponíveis foram adicionados": "Tous les champs disponibles ont été ajoutés",
  "Todos os direitos reservados": "Tous droits réservés",
  "Todos os planos incluem": "Tous les forfaits comprennent",
  "Todos os planos incluem 15 dias grátis": "Tous les forfaits comprennent 15 jours gratuits",
  "Todos os recursos da HostVSL": "Toutes les fonctionnalités de HostVSL",
  "Todos os recursos e benefícios para seu negócio": "Toutes les fonctionnalités et tous les avantages pour votre activité",
  "Todos os recursos premium": "Toutes les fonctionnalités premium",
  "Todos os status": "Tous les statuts",
  "Todos os vídeos": "Toutes les vidéos",
  "Todos os vídeos foram carregados": "Toutes les vidéos ont été chargées",
  "Todos os vídeos usados estão prontos": "Toutes les vidéos utilisées sont prêtes",
  "Todos que comprarem hoje participam...": "Tous ceux qui achètent aujourd'hui participent...",
  "Todos que se cadastraram através dos seus links.": "Toutes les personnes inscrites via vos liens.",
  "Toggle": "Basculer",
  "Toggle Sidebar": "Afficher/masquer la barre latérale",
  "Toggle {value0} section": "Afficher/masquer la section {value0}",
  "Token": "Jeton",
  "Token Revogado": "Jeton révoqué",
  "Token copiado para a área de transferência.": "Jeton copié dans le presse-papiers.",
  "Token copiado!": "Jeton copié !",
  "Token da plataforma": "Jeton de la plateforme",
  "Token da plataforma (se exigido)": "Jeton de la plateforme (si nécessaire)",
  "Token de Acesso": "Jeton d'accès",
  "Token de Acesso *": "Jeton d'accès *",
  "Token de Suporte": "Jeton de support",
  "Token de acesso fornecido pelo": "Jeton d'accès fourni par",
  "Token de acesso fornecido pelo Facebook": "Jeton d'accès fourni par Facebook",
  "Token de acesso vive apenas durante a sessão — segurança em primeiro lugar": "Le jeton d'accès existe uniquement pendant la session : la sécurité avant tout",
  "Token de suporte": "Jeton de support",
  "Token de suporte para debug": "Jeton de support pour le débogage",
  "Token de {value0}": "Jeton de {value0}",
  "Token deve ter no máximo 500 caracteres": "Le jeton doit comporter au maximum 500 caractères",
  "Token fornecido pelo Facebook": "Jeton fourni par Facebook",
  "Token não disponível": "Jeton indisponible",
  "Token não pode estar vazio": "Le jeton ne peut pas être vide",
  "Token revogado.": "Jeton révoqué.",
  "Token vazio retornado pelo Google": "Jeton vide renvoyé par Google",
  "Token:": "Jeton :",
  "Top": "Top",
  "Top 10 Usuários por Custo": "10 utilisateurs aux coûts les plus élevés",
  "Top 10 comentários enviados após a avaliação.": "Les 10 principaux commentaires envoyés après l'évaluation.",
  "Top 3 Janelas": "3 meilleures plages",
  "Top 3 Receita": "3 meilleurs chiffres d'affaires",
  "Top 3 Taxa Conv%": "3 meilleurs taux de conversion %",
  "Top 3 horários com maior": "Les 3 horaires ayant le plus de",
  "Top 3 horários com maior consistência": "Les 3 horaires les plus réguliers",
  "Top 3 horários com melhor": "Les 3 horaires ayant le meilleur",
  "Top 3 por visualizações": "Les 3 premiers par nombre de vues",
  "Top 4 por visualizações": "Les 4 premiers par nombre de vues",
  "Top 5 Vídeos por Receita": "5 meilleures vidéos par chiffre d'affaires",
  "Top 5 vídeos com mais captura": "5 vidéos générant le plus de captures",
  "Top Estados": "Principaux États",
  "Top VSL do Período": "Meilleure VSL de la période",
  "Top fontes de tráfego": "Principales sources de trafic",
  "Top lugares": "Principaux lieux",
  "Top vídeos": "Principales vidéos",
  "Topo": "Haut",
  "Topo Direita": "En haut à droite",
  "Topo Esquerda": "En haut à gauche",
  "Topo pode funcionar melhor que rodapé": "Le haut peut être plus efficace que le bas",
  "Toque em \"Adicionar\"": "Touchez « Ajouter »",
  "Toque no botão de compartilhar": "Touchez le bouton de partage",
  "Tornar Principal": "Définir comme principal",
  "Tornar comentário obrigatório": "Rendre le commentaire obligatoire",
  "Tornar obrigatório": "Rendre obligatoire",
  "Torne-se um Afiliado": "Devenez affilié",
  "Totais": "Totaux",
  "Total": "Total",
  "Total (12m):": "Total (12 mois) :",
  "Total BRL": "Total BRL",
  "Total Cliques": "Total des clics",
  "Total Estimado Próxima Cobrança": "Total estimé du prochain prélèvement",
  "Total Plays": "Total des lectures",
  "Total USD": "Total USD",
  "Total Usuários": "Total des utilisateurs",
  "Total Vídeos": "Total des vidéos",
  "Total após taxas aplicadas.": "Total après application des frais.",
  "Total atual:": "Total actuel :",
  "Total c/ Impostos": "Total taxes incluses",
  "Total c/ Taxo": "Total frais inclus",
  "Total consumido": "Total consommé",
  "Total de": "Total de",
  "Total de Capturas": "Total des captures",
  "Total de Comissões": "Total des commissions",
  "Total de Indicados": "Total des personnes parrainées",
  "Total de Leads": "Total des leads",
  "Total de Leads do Vídeo": "Total des leads de la vidéo",
  "Total de Plays Únicos": "Total des lectures uniques",
  "Total de Visualizações Únicas": "Total des vues uniques",
  "Total de conversões registradas hoje": "Total des conversions enregistrées aujourd'hui",
  "Total de integrações:": "Total des intégrations :",
  "Total de pessoas que viram e interagiram com seu vídeo": "Total des personnes ayant vu votre vidéo et interagi avec elle",
  "Total de reproduções": "Total des lectures",
  "Total de visualizações": "Total des vues",
  "Total de visualizações do vídeo": "Total des vues de la vidéo",
  "Total de visualizações únicas do dia": "Total des vues uniques du jour",
  "Total deve ser 100%. Atualmente:": "Le total doit être égal à 100%. Actuellement :",
  "Total do dia": "Total du jour",
  "Total do período": "Total de la période",
  "Total do teste": "Total du test",
  "Total em BRL": "Total en BRL",
  "Total geral": "Total général",
  "Total geral pago (sem descontos):": "Total général payé (sans réduction) :",
  "Total recebido através da sua rede.": "Total reçu par l'intermédiaire de votre réseau.",
  "Total solicitado": "Total demandé",
  "Total:": "Total :",
  "Total: 100%": "Total : 100%",
  "Total: R$": "Total : R$",
  "Totalizadores gerais no sistema:": "Totaux généraux du système :",
  "Tracking": "Suivi",
  "Tracking excluído com sucesso!": "Suivi supprimé avec succès !",
  "Tracking para {value0} adicionado": "Suivi pour {value0} ajouté",
  "Tracking salvo com sucesso!": "Suivi enregistré avec succès !",
  "Transforme curiosidade em conversão.": "Transformez la curiosité en conversion.",
  "Transforme sua VSL em um funil interativo: cada resposta leva ao próximo vídeo ou à oferta certa.": "Transformez votre VSL en tunnel interactif : chaque réponse mène à la vidéo suivante ou à l'offre adaptée.",
  "Transição suave": "Transition douce",
  "Transmissão indisponível": "Diffusion indisponible",
  "Transmissão não suportada neste navegador": "Diffusion non prise en charge par ce navigateur",
  "Transmitir para TV": "Diffuser sur une TV",
  "Transparente": "Transparent",
  "Transparência": "Transparence",
  "Treinamento prático para criar, configurar e abrir sua sala": "Formation pratique pour créer, configurer et ouvrir votre salle",
  "Trilha": "Parcours",
  "Trilha organizada por módulos: Primeiros passos, Personalização, Conversão, Análises e Plano": "Parcours organisé en modules : Premiers pas, Personnalisation, Conversion, Analyses et Forfait",
  "Trilho": "Rail",
  "Trocar": "Changer",
  "Trocar Vídeo": "Changer de vidéo",
  "Trocar vídeo": "Changer de vidéo",
  "Trocar vídeo de fundo": "Changer la vidéo d'arrière-plan",
  "Tráfego": "Trafic",
  "Tráfego dividido igualmente": "Trafic réparti équitablement",
  "Tráfego:": "Trafic :",
  "Três formatos de avaliação: emojis, estrelas ou nota de 1 a 5": "Trois formats d'évaluation : émojis, étoiles ou note de 1 à 5",
  "Três passos simples para começar a faturar hoje mesmo.": "Trois étapes simples pour commencer à générer des revenus dès aujourd'hui.",
  "Tudo OK": "Tout est OK",
  "Tudo certo para publicar": "Tout est prêt pour publier",
  "Tudo para escalar VSLs com automação, proteção e métricas.": "Tout pour développer vos VSL avec automatisation, protection et indicateurs.",
  "Tudo para escalar VSLs com performance, proteção e métricas.": "Tout pour développer vos VSL avec performances, protection et indicateurs.",
  "Tutoriais": "Tutoriels",
  "Tutorial do Produto": "Tutoriel du produit",
  "Type Safety": "Sécurité des types",
  "Técnica do PAS": "Technique PAS",
  "Término": "Fin",
  "Término automático em:": "Fin automatique le :",
  "Término previsto:": "Fin prévue :",
  "Término:": "Fin :",
  "Título": "Titre",
  "Título (Headline)": "Titre (Headline)",
  "Título (opcional)": "Titre (facultatif)",
  "Título Principal (máx 150 caracteres)": "Titre principal (150 caractères max.)",
  "Título Público": "Titre public",
  "Título Público *": "Titre public *",
  "Título atualizado com sucesso!": "Titre mis à jour avec succès !",
  "Título convincente": "Titre convaincant",
  "Título da Oferta": "Titre de l'offre",
  "Título da Playlist": "Titre de la playlist",
  "Título da Página": "Titre de la page",
  "Título da Seção": "Titre de la section",
  "Título da oferta": "Titre de l'offre",
  "Título de Exemplo": "Exemple de titre",
  "Título do Card": "Titre de la carte",
  "Título do Episódio": "Titre de l'épisode",
  "Título do Header (opcional)": "Titre de l'en-tête (facultatif)",
  "Título do Vídeo": "Titre de la vidéo",
  "Título do Webinar": "Titre du webinaire",
  "Título do formulário": "Titre du formulaire",
  "Título do overlay": "Titre de la superposition",
  "Título do sorteio": "Titre du tirage au sort",
  "Título que será exibido na sala para os participantes.": "Titre affiché dans la salle pour les participants.",
  "Título que será exibido para os participantes": "Titre affiché pour les participants",
  "Título é obrigatório": "Le titre est obligatoire",
  "Títulos de tooltips": "Titres des infobulles",
  "Tóquio (GMT+9)": "Tokyo (GMT+9)",
  "Türkçe": "Türkçe",
  "UF": "État",
  "UI Library": "Bibliothèque d'interface",
  "URL": "URL",
  "URL Amigável": "URL conviviale",
  "URL Amigável *": "URL conviviale *",
  "URL MP4 direta": "URL MP4 directe",
  "URL Site": "URL du site",
  "URL Webhook": "URL du webhook",
  "URL com parâmetros UTM": "URL avec paramètres UTM",
  "URL contains suspicious patterns": "L'URL contient des éléments suspects",
  "URL copiada": "URL copiée",
  "URL copiada para a área de transferência": "URL copiée dans le presse-papiers",
  "URL da Página de Obrigado": "URL de la page de remerciement",
  "URL de Destino": "URL de destination",
  "URL de Teste": "URL de test",
  "URL de destino": "URL de destination",
  "URL de download não disponível": "URL de téléchargement indisponible",
  "URL de redirecionamento (opcional)": "URL de redirection (facultative)",
  "URL deve ter no máximo 500 caracteres": "L'URL doit comporter au maximum 500 caractères",
  "URL do Vídeo": "URL de la vidéo",
  "URL do botão principal inválida": "URL du bouton principal invalide",
  "URL do segundo botão inválida": "URL du deuxième bouton invalide",
  "URL do site": "URL du site",
  "URL do site onde o pixel será instalado": "URL du site où le pixel sera installé",
  "URL do vídeo não disponível": "URL de la vidéo indisponible",
  "URL inválida": "URL invalide",
  "URL inválida. Ex: https://seu-site.com": "URL invalide. Ex. : https://seu-site.com",
  "URL inválida. Use http:// ou https://. Ex: https://seu-site.com": "URL invalide. Utilisez http:// ou https://. Ex. : https://seu-site.com",
  "URL must be a non-empty string": "L'URL doit être une chaîne non vide",
  "URL não navegável": "URL non navigable",
  "URL não suportada. Use Vimeo, Bunny, Cloudflare ou MP4 direto.": "URL non prise en charge. Utilisez Vimeo, Bunny, Cloudflare ou un lien MP4 direct.",
  "URL too long": "URL trop longue",
  "URL vinculada:": "URL associée :",
  "URL válida": "URL valide",
  "URLs": "URL",
  "URLs de referência": "URL référentes",
  "USD": "USD",
  "UTM": "UTM",
  "UTM Campaign": "Campagne UTM",
  "UTM Content": "Contenu UTM",
  "UTM Medium": "Support UTM",
  "UTM Source": "Source UTM",
  "UTM Term": "Terme UTM",
  "UTM criada": "UTM créée",
  "UTM •": "UTM •",
  "UTM: {value0}={value1}": "UTM : {value0}={value1}",
  "UTMs": "UTM",
  "UTMs e referências associadas": "UTM et sources référentes associées",
  "UTMs, src, sck e click ids seguem para o destino.": "Les UTM, src, sck et identifiants de clic sont transmis à la destination.",
  "Um exemplo de caminho": "Exemple de chemin",
  "Um funil de vídeos em que cada resposta do visitante leva ao próximo vídeo, até o checkout.": "Un tunnel vidéo où chaque réponse du visiteur mène à la vidéo suivante jusqu'au paiement.",
  "Um vídeo bem-sucedido precisa tanto atrair cliques iniciais quanto manter o interesse ao longo do conteúdo.": "Une vidéo réussie doit à la fois attirer les premiers clics et maintenir l'intérêt au fil du contenu.",
  "Um vídeo foi compartilhado com você": "Une vidéo a été partagée avec vous",
  "Uma chave de API permite que uma ferramenta externa leia, em seu nome, as métricas dos seus vídeos e a lista de vídeos da conta — hoje, o connector da HostVSL no Claude. Ela é de leitura: não altera vídeos, não acessa seus dados de cobrança e não faz login no painel.": "Une clé API permet à un outil externe de lire en votre nom les indicateurs de vos vidéos et la liste des vidéos du compte, actuellement le connecteur HostVSL dans Claude. Elle est en lecture seule : elle ne modifie pas les vidéos, n'accède pas aux données de facturation et ne se connecte pas au panneau.",
  "Uma legenda por idioma": "Un fichier de sous-titres par langue",
  "Uma mensagem principal por vez": "Un message principal à la fois",
  "Uma máquina de conversão": "Une machine à convertir",
  "Uma plataforma de processamento e gerenciamento de pagamentos online.": "Une plateforme de traitement et de gestion des paiements en ligne.",
  "Uma variação vencedora normalmente supera as outras em pelo menos 10-15% em métricas-chave.": "Une variante gagnante dépasse généralement les autres d'au moins 10 à 15% sur les indicateurs clés.",
  "Uma vez por sessão em cada saída. Atualiza a cada minuto.": "Une fois par session pour chaque sortie. Mise à jour toutes les minutes.",
  "Upgrade": "Passer au forfait supérieur",
  "Uplift:": "Gain :",
  "Upload": "Envoi",
  "Upload Modal — Correção Borda Seleção": "Fenêtre d'envoi — Correction de la bordure de sélection",
  "Upload Novo Vídeo": "Envoyer une nouvelle vidéo",
  "Upload Personalizado": "Envoi personnalisé",
  "Upload cancelado": "Envoi annulé",
  "Upload concluído": "Envoi terminé",
  "Upload concluído!": "Envoi terminé !",
  "Upload da Logo": "Envoi du logo",
  "Upload de arquivos .VTT e .SRT com detecção automática de formato": "Importation de fichiers .VTT et .SRT avec détection automatique du format",
  "Upload de vídeo": "Envoi de vidéo",
  "Upload do computador": "Importer depuis l'ordinateur",
  "Upload do vídeo": "Envoi de la vidéo",
  "Upload do Ícone Personalizado": "Envoi de l'icône personnalisée",
  "Upload file": "Envoyer un fichier",
  "UploadBox is deprecated. Use UploadQueueModal from @/components/upload instead.": "UploadBox est obsolète. Utilisez UploadQueueModal depuis @/components/upload.",
  "UploadDialog is deprecated. Use UploadQueueModal from @/components/upload instead.": "UploadDialog est obsolète. Utilisez UploadQueueModal depuis @/components/upload.",
  "Uploads concluídos": "Envois terminés",
  "Upsell + Downsell": "Upsell + Downsell",
  "Usa uma versão menor do botão de play no centro do player": "Utilise une version réduite du bouton de lecture au centre du lecteur",
  "Usada por {value0} {value1}": "Utilisée par {value0} {value1}",
  "Usar Esta Thumbnail": "Utiliser cette miniature",
  "Usar cor do Play": "Utiliser la couleur du bouton de lecture",
  "Usar em nova etapa": "Utiliser dans une nouvelle étape",
  "Usar transparência no fundo": "Utiliser un fond transparent",
  "Usar velocidade fixa": "Utiliser une vitesse fixe",
  "Usaremos este cartão para cobranças futuras.": "Nous utiliserons cette carte pour les prochains prélèvements.",
  "Use \"{count}\" para inserir o número de pessoas dinamicamente.": "Utilisez « {count} » pour insérer dynamiquement le nombre de personnes.",
  "Use #id para IDs ou .classe para classes CSS. Exemplo: #meuBotao ou .minha-secao": "Utilisez #id pour les identifiants ou .classe pour les classes CSS. Exemple : #meuBotao ou .minha-secao",
  "Use Mini-Hooks para exibir imagens ou GIFs em momentos estratégicos do vídeo. Ideal para reforçar promessas, criar avisos visuais e recuperar atenção.": "Utilisez les Mini-Hooks pour afficher des images ou des GIF à des moments stratégiques de la vidéo. Idéal pour renforcer les promesses, créer des notifications visuelles et raviver l'attention.",
  "Use Picos de Horário para alinhar postagem, disparos e tráfego pago com os momentos de maior atenção. Menos achismo, mais performance.": "Utilisez les pics horaires pour aligner publications, envois et trafic payant sur les moments d'attention maximale. Moins d'intuition, plus de performance.",
  "Use UTM, token, chave de URL e bloqueio de VPN/Proxy para reforçar a segurança.": "Utilisez les UTM, les jetons, les clés d'URL et le blocage des VPN/proxys pour renforcer la sécurité.",
  "Use a estrutura Problema, Agitação, Solução para criar tensão e resolução.": "Utilisez la structure Problème, Agitation, Solution pour créer de la tension et une résolution.",
  "Use a gamificação": "Utilisez la gamification",
  "Use a normalização por dia para comparar horários dentro do mesmo dia, independente do volume absoluto.": "Utilisez la normalisation par jour pour comparer les horaires d'une même journée, indépendamment du volume absolu.",
  "Use comandos diretos e claros (\"Clique Agora\" vs \"Saiba Mais\")": "Utilisez des formulations directes et claires (« Cliquez maintenant » plutôt que « En savoir plus »)",
  "Use esse dado para agendar seus conteúdos": "Utilisez cette donnée pour programmer vos contenus",
  "Use esses dados para planejar estratégias e otimizar suas conversões.": "Utilisez ces données pour planifier vos stratégies et optimiser vos conversions.",
  "Use este vídeo como modelo para aplicar as mesmas configurações nos outros vídeos.": "Utilisez cette vidéo comme modèle pour appliquer les mêmes paramètres aux autres vidéos.",
  "Use imagens com proporção 16:9 para melhor resultado": "Utilisez des images au format 16:9 pour de meilleurs résultats",
  "Use imagens de alta qualidade e texto claro que capture a essência do seu conteúdo. Teste diferentes cores de fundo e expressões faciais.": "Utilisez des images de qualité et un texte clair reflétant l'essentiel de votre contenu. Testez différentes couleurs de fond et expressions du visage.",
  "Use imagens/GIFs com proporção 16:9 para melhor resultado": "Utilisez des images/GIF au format 16:9 pour de meilleurs résultats",
  "Use m:ss ou segundos (ex.: 0:38 ou 38,5).": "Utilisez m:ss ou des secondes (ex. : 0:38 ou 38,5).",
  "Use mini hooks para aumentar retenção.": "Utilisez les Mini Hooks pour augmenter la rétention.",
  "Use mudanças de cenário, efeitos sonoros ou visuais para 'acordar' o espectador periodicamente e evitar monotonia.": "Utilisez des changements de décor, des effets sonores ou visuels pour raviver régulièrement l'attention du spectateur et éviter la monotonie.",
  "Use mudanças de câmera, efeitos sonoros ou transições visuais a cada 15-20 segundos para renovar a atenção.": "Utilisez des changements de caméra, des effets sonores ou des transitions visuelles toutes les 15 à 20 secondes pour raviver l'attention.",
  "Use o botão": "Utilisez le bouton",
  "Use o calendário para comparar períodos semelhantes": "Utilisez le calendrier pour comparer des périodes similaires",
  "Use o cupom 50%OFF e comece hoje mesmo.": "Utilisez le code 50%OFF et commencez dès aujourd'hui.",
  "Use o cupom abaixo no checkout do plano que você escolher.": "Utilisez le code promo ci-dessous lors du paiement du forfait choisi.",
  "Use o código abaixo para colocar o vídeo no seu site. Funciona em qualquer plataforma.": "Utilisez le code ci-dessous pour placer la vidéo sur votre site. Fonctionne sur toutes les plateformes.",
  "Use os resultados para melhorar criativos, páginas e escala.": "Utilisez les résultats pour améliorer les créations, les pages et le développement de vos campagnes.",
  "Use parâmetros UTM nas suas URLs para rastrear a origem do tráfego": "Utilisez des paramètres UTM dans vos URL pour suivre la source du trafic",
  "Use pastas para organizar suas VSLs por produto ou campanha.": "Utilisez les dossiers pour organiser vos VSL par produit ou campagne.",
  "Use plays extras se o limite mensal expirar antes da renovação.": "Utilisez des lectures supplémentaires si la limite mensuelle est atteinte avant le renouvellement.",
  "Use só letras, números, \"_\", \"-\" e \".\" no nome do parâmetro.": "Utilisez uniquement des lettres, des chiffres, « _ », « - » et « . » dans le nom du paramètre.",
  "Use tempos com passo de 0,1 s": "Utilisez des temps par pas de 0,1 s",
  "Use thumbnails com expressões faciais fortes e cores contrastantes": "Utilisez des miniatures avec des expressions du visage marquées et des couleurs contrastées",
  "Use um checkout dedicado a este fluxo e cadastre apenas as compras dele neste webhook. Os indicadores passam a receber as vendas após a configuração na plataforma.": "Utilisez une page de paiement dédiée à ce parcours et enregistrez uniquement ses achats dans ce webhook. Les indicateurs recevront les ventes après la configuration sur la plateforme.",
  "Use um nome que ajude você a identificar facilmente este experimento no futuro.": "Utilisez un nom permettant de retrouver facilement cette expérience plus tard.",
  "Use um testemunho mais relativo ao público-alvo": "Utilisez un témoignage plus pertinent pour le public cible",
  "Use uma cor no formato #RRGGBB": "Utilisez une couleur au format #RRGGBB",
  "Use várias quebras de padrão ou fatos surpreendentes": "Utilisez plusieurs ruptures de rythme ou faits surprenants",
  "User ID not found": "Identifiant utilisateur introuvable",
  "User not authenticated": "Utilisateur non authentifié",
  "Uso do Plano": "Utilisation du forfait",
  "Uso interno. Aparece no dashboard, não aparece no player público.": "Usage interne. Apparaît dans le tableau de bord, sans apparaître dans le lecteur public.",
  "Usuário": "Utilisateur",
  "Usuário Comum": "Utilisateur standard",
  "Usuário ID #{value0}": "Utilisateur ID nº{value0}",
  "Usuário carregado com sucesso!": "Utilisateur chargé avec succès !",
  "Usuário não autenticado": "Utilisateur non authentifié",
  "Usuário não encontrado": "Utilisateur introuvable",
  "Usuário não encontrado.": "Utilisateur introuvable.",
  "Usuário não identificado": "Utilisateur non identifié",
  "Usuário não pode fechar sem preencher": "L'utilisateur ne peut pas fermer sans remplir le formulaire",
  "Usuários": "Utilisateurs",
  "Usuários ativos no período": "Utilisateurs actifs pendant la période",
  "Usuários podem entrar até": "Les utilisateurs peuvent entrer jusqu'à",
  "Usuários que clicaram no botão de play e iniciaram o vídeo": "Utilisateurs ayant cliqué sur le bouton de lecture et lancé la vidéo",
  "VER SITE": "VOIR LE SITE",
  "VISUAL": "APPARENCE",
  "VITE_GOOGLE_CLIENT_ID não configurado. Adicione no .env e reinicie o dev server.": "VITE_GOOGLE_CLIENT_ID n'est pas configuré. Ajoutez-le au fichier .env et redémarrez le serveur de développement.",
  "VITE_GOOGLE_DEVELOPER_KEY não configurado. Adicione no .env e reinicie o dev server.": "VITE_GOOGLE_DEVELOPER_KEY n'est pas configuré. Ajoutez-le au fichier .env et redémarrez le serveur de développement.",
  "VSL": "VSL",
  "VSL Alternativa": "VSL de remplacement",
  "VSL Dinâmica": "VSL dynamique",
  "VSL Dinâmica 2.0": "VSL dynamique 2.0",
  "VSL Direcionada A": "VSL ciblée A",
  "VSL Direcionada B": "VSL ciblée B",
  "VSL Dynamic": "VSL dynamique",
  "VSL Original": "VSL d'origine",
  "VSL PROTEGIDA": "VSL PROTÉGÉE",
  "VSL Principal": "VSL principale",
  "VSL alternativa": "VSL de remplacement",
  "VSL protegida": "VSL protégée",
  "VSL {value0}": "VSL {value0}",
  "VSLeads": "VSLeads",
  "Vagas limitadas": "Places limitées",
  "Vai para": "Mène vers",
  "Vai para sua biblioteca": "Va dans votre bibliothèque",
  "Validade": "Validité",
  "Validando cupom...": "Validation du code promo...",
  "Validação falhou": "Échec de la validation",
  "Valor": "Valeur",
  "Valor (R$) *": "Montant (R$) *",
  "Valor Líquido": "Montant net",
  "Valor Mensal": "Montant mensuel",
  "Valor a ser pago": "Montant à payer",
  "Valor do Parâmetro": "Valeur du paramètre",
  "Valor do parâmetro": "Valeur du paramètre",
  "Valor inicial do contador": "Valeur initiale du compteur",
  "Valor inicial do contador de audiência": "Valeur initiale du compteur d'audience",
  "Valor inicial para o contador.": "Valeur initiale du compteur.",
  "Valor inválido": "Valeur invalide",
  "Valor líquido": "Montant net",
  "Valor mensal": "Montant mensuel",
  "Valor médio por venda realizada no período": "Montant moyen par vente pendant la période",
  "Valor numérico": "Valeur numérique",
  "Valor obrigatório": "Valeur obligatoire",
  "Valor pode variar caso você compre plays extras ou caso a recarga automática seja acionada antes da renovação.": "Le montant peut varier si vous achetez des lectures supplémentaires ou si la recharge automatique se déclenche avant le renouvellement.",
  "Valor total": "Montant total",
  "Valor total de vendas confirmadas no período": "Montant total des ventes confirmées pendant la période",
  "Valor total: R$ 999": "Valeur totale : R$ 999",
  "Valor é obrigatório": "La valeur est obligatoire",
  "Valores em tooltips": "Valeurs dans les infobulles",
  "Vantagens exclusivas para parceiros Host VSL": "Avantages exclusifs pour les partenaires Host VSL",
  "Variante": "Variante",
  "Variação": "Variante",
  "Variação adicionada!": "Variante ajoutée !",
  "Variação atualizada!": "Variante mise à jour !",
  "Variação excluída": "Variante supprimée",
  "Variação máxima": "Variation maximale",
  "Variação mínima": "Variation minimale",
  "Variação removida!": "Variante supprimée !",
  "Variação salva!": "Variante enregistrée !",
  "Variação {value0}": "Variante {value0}",
  "Variações": "Variantes",
  "Variações em teste": "Variantes en test",
  "Varie o ritmo da sua narrativa para manter o interesse ao longo do vídeo. Evite longos períodos apenas falando sem estímulos visuais.": "Variez le rythme de votre narration pour maintenir l'intérêt au fil de la vidéo. Évitez les longs passages uniquement parlés, sans stimulation visuelle.",
  "Vega": "Vega",
  "Veja em que ponto do vídeo a audiência se engaja e onde ocorre a maior queda.": "Repérez les moments d'engagement de l'audience et le principal décrochage dans la vidéo.",
  "Veja num mapa-múndi quem está assistindo às suas VSLs agora, em qualquer lugar do mundo.": "Visualisez sur une carte du monde les spectateurs actuels de vos VSL, où qu'ils se trouvent.",
  "Veja o desempenho completo das introduções testadas.": "Consultez les performances complètes des introductions testées.",
  "Veja o desempenho detalhado de cada introdução testada.": "Consultez les performances détaillées de chaque introduction testée.",
  "Veja os horários ideais por tipo de acesso (desktop, mobile, tablet)": "Consultez les horaires idéaux par type d'accès (ordinateur, mobile, tablette)",
  "Veja os horários ideais por tipo de acesso e entenda diferenças entre desktop, mobile e tablet": "Consultez les horaires idéaux par type d'accès et comprenez les différences entre ordinateur, mobile et tablette",
  "Veja plays, retenção, conversão e outros indicadores importantes.": "Consultez les lectures, la rétention, les conversions et d'autres indicateurs importants.",
  "Veja quais páginas enviaram tráfego para este vídeo.": "Consultez les pages ayant envoyé du trafic vers cette vidéo.",
  "Veja quais vídeos convertem mais": "Découvrez les vidéos qui convertissent le plus",
  "Veja quanto você pode ganhar por mês": "Découvrez combien vous pouvez gagner par mois",
  "Veja quantos visitantes passam por cada etapa, qual opção escolhem, quantos chegam ao checkout e a retenção de cada vídeo. Só o primeiro clique de cada visitante conta como play no seu plano.": "Consultez le nombre de visiteurs à chaque étape, les options choisies, les arrivées au paiement et la rétention de chaque vidéo. Seul le premier clic de chaque visiteur compte comme une lecture dans votre forfait.",
  "Velocidade": "Vitesse",
  "Velocidade Fixa": "Vitesse fixe",
  "Velocidade atual": "Vitesse actuelle",
  "Velocidade atual:": "Vitesse actuelle :",
  "Velocidade atual: {value0}": "Vitesse actuelle : {value0}",
  "Velocidade atualizada": "Vitesse mise à jour",
  "Velocidade configurada para {value0}x": "Vitesse réglée sur {value0}x",
  "Velocidade da Simulação": "Vitesse de la simulation",
  "Velocidade das Notificações": "Rythme des notifications",
  "Velocidade de Carregamento": "Vitesse de chargement",
  "Velocidade de Reprodução": "Vitesse de lecture",
  "Velocidade de carregamento": "Vitesse de chargement",
  "Velocidade de reprodução": "Vitesse de lecture",
  "Velocidade de reprodução do vídeo. O padrão é 1.0x.": "Vitesse de lecture de la vidéo. La valeur par défaut est 1.0x.",
  "Velocidade e Teste A/B": "Vitesse et test A/B",
  "Velocidade final": "Vitesse finale",
  "Velocidade inicial": "Vitesse initiale",
  "Velocidade manual salva": "Vitesse manuelle enregistrée",
  "Velocidade normal de reprodução.": "Vitesse de lecture normale.",
  "Velocidade padrão": "Vitesse par défaut",
  "Velocidade {value0}x": "Vitesse {value0}x",
  "Velocidades de teste (": "Vitesses testées (",
  "Velocidades:": "Vitesses :",
  "Vencedor": "Gagnant",
  "Vencedor:": "Gagnant :",
  "Vencedora": "Gagnante",
  "Vencendo": "En tête",
  "Venda do dia": "Vente du jour",
  "Vendas": "Ventes",
  "Vendas aprovadas": "Ventes approuvées",
  "Vendas aprovadas ÷ plays do fluxo": "Ventes approuvées ÷ lectures du parcours",
  "Vendedor gerou R$ 10.000 em comissões": "Le vendeur a généré R$ 10.000 de commissions",
  "Vendedores Ativos": "Vendeurs actifs",
  "Vendedores indicados que já geraram comissões.": "Vendeurs parrainés ayant déjà généré des commissions.",
  "Ver Dados Detalhados": "Voir les données détaillées",
  "Ver Detalhes": "Voir les détails",
  "Ver Feedback": "Voir les avis",
  "Ver Horários de Pico": "Voir les heures de pointe",
  "Ver Meus Vídeos": "Voir mes vidéos",
  "Ver Métricas": "Voir les indicateurs",
  "Ver Módulos": "Voir les modules",
  "Ver Prévia": "Voir l'aperçu",
  "Ver Relatório": "Voir le rapport",
  "Ver Relatório Completo": "Voir le rapport complet",
  "Ver Sugestões": "Voir les suggestions",
  "Ver Teste": "Voir le test",
  "Ver Testes": "Voir les tests",
  "Ver Tracking": "Voir le suivi",
  "Ver UTMs": "Voir les UTM",
  "Ver como funciona": "Voir le fonctionnement",
  "Ver comprovante": "Voir le justificatif",
  "Ver conversões por vídeo": "Voir les conversions par vidéo",
  "Ver detalhes": "Voir les détails",
  "Ver detalhes do teste": "Voir les détails du test",
  "Ver detalhes do vídeo": "Voir les détails de la vidéo",
  "Ver documentação": "Voir la documentation",
  "Ver horários de pico": "Voir les heures de pointe",
  "Ver integrações": "Voir les intégrations",
  "Ver métricas": "Voir les indicateurs",
  "Ver no gráfico": "Voir sur le graphique",
  "Ver opções de importação": "Voir les options d'importation",
  "Ver regra em conflito": "Voir la règle en conflit",
  "Ver relatório completo": "Voir le rapport complet",
  "Ver retenção de {value0}": "Voir la rétention de {value0}",
  "Ver todas ({n})": "Tout voir ({n})",
  "Ver todos os logs": "Voir tous les journaux",
  "Ver todos os logs →": "Voir tous les journaux →",
  "Ver tracking detalhado": "Voir le suivi détaillé",
  "Ver tudo": "Tout voir",
  "Verde ativo": "Vert actif",
  "Verificada": "Vérifiée",
  "Verificando...": "Vérification...",
  "Verifique se o link está correto.": "Vérifiez que le lien est correct.",
  "Verifique se recebeu a notificação de teste.": "Vérifiez que vous avez reçu la notification de test.",
  "Verifique se sua Chromecast/Smart TV está ligada e conectada na mesma rede Wi-Fi.": "Vérifiez que votre Chromecast/Smart TV est allumé et connecté au même réseau Wi-Fi.",
  "Vermelho erro/excluir": "Rouge erreur/suppression",
  "Verso do Documento": "Verso du document",
  "Vertical (campos empilhados)": "Vertical (champs empilés)",
  "Vertical (↓)": "Vertical (↓)",
  "Via {platformName}": "Via {platformName}",
  "Video Preview": "Aperçu vidéo",
  "Video preview": "Aperçu vidéo",
  "Video thumbnail": "Miniature vidéo",
  "VideoControlsTab - Simplificação de Labels": "VideoControlsTab - Simplification des libellés",
  "VideoSelector — Dropdown Alinhado Premium": "VideoSelector — Liste déroulante premium alignée",
  "Vidro escuro": "Verre sombre",
  "Views": "Vues",
  "Views e Plays ao longo do tempo": "Vues et lectures au fil du temps",
  "Views Únicos": "Vues uniques",
  "Views:": "Vues :",
  "Vimeo": "Vimeo",
  "Vinculando documentos ao seu cadastro financeiro...": "Association des documents à votre dossier financier...",
  "Vincular": "Associer",
  "Vincular Conta Bancária": "Associer un compte bancaire",
  "Vincular VSL no Rastreamento": "Associer une VSL au suivi",
  "Vincule a resposta ao lead, quando disponível.": "Associez la réponse au lead lorsqu'il est disponible.",
  "Vincule cada pixel a um vídeo e ao site onde a sua VSL está publicada": "Associez chaque pixel à une vidéo et au site où votre VSL est publiée",
  "Vincule uma plataforma de vendas à saída de checkout deste fluxo. Acessar o checkout não significa comprar.": "Associez une plateforme de vente à la sortie de paiement de ce parcours. Accéder au paiement ne signifie pas acheter.",
  "Vis.": "Vues",
  "Vis. Únicas": "Vues uniques",
  "Visibilidade:": "Visibilité :",
  "Visitar": "Visiter",
  "Visitar parceiro {value0}": "Visiter le partenaire {value0}",
  "Visitas": "Visites",
  "Visual apenas • Sem lógica de sorteio": "Visuel uniquement • Sans logique de tirage au sort",
  "Visual apenas • Sem validação": "Visuel uniquement • Sans validation",
  "Visual premium e consistente em toda a plataforma": "Apparence premium et cohérente sur toute la plateforme",
  "Visual premium, navegação mais rápida e consistência total.": "Apparence premium, navigation plus rapide et cohérence complète.",
  "Visualizador": "Visionneur",
  "Visualizar": "Afficher",
  "Visualizar em dispositivo": "Afficher sur un appareil",
  "Visualizar este vídeo": "Afficher cette vidéo",
  "Visualizar no celular": "Afficher sur mobile",
  "Visualizar no desktop": "Afficher sur ordinateur",
  "Visualizar no tablet": "Afficher sur tablette",
  "Visualização": "Vue",
  "Visualização detalhada": "Vue détaillée",
  "Visualização do fluxo": "Vue du parcours",
  "Visualização do player com": "Vue du lecteur avec",
  "Visualização em barras verticais proporcionais com gradiente azul progressivo": "Affichage en barres verticales proportionnelles avec dégradé bleu progressif",
  "Visualizações": "Vues",
  "Visualizações Totais": "Vues totales",
  "Visualizações e insights sobre o desempenho de captura": "Vues et analyses des performances de capture",
  "Visualizações hoje": "Vues aujourd'hui",
  "Visualizações Únicas": "Vues uniques",
  "Visualizações únicas": "Vues uniques",
  "Visualizações únicas (por usuário)": "Vues uniques (par utilisateur)",
  "Visualizações únicas e plays únicos contam aparelhos diferentes no período. Clique num vídeo para ver a retenção.": "Les vues uniques et les lectures uniques comptent les appareils distincts pendant la période. Cliquez sur une vidéo pour voir la rétention.",
  "Visualize a evolução da retenção durante o vídeo": "Visualisez l'évolution de la rétention pendant la vidéo",
  "Visualize como a retenção evoluiu entre as diferentes introduções testadas.": "Visualisez l'évolution de la rétention entre les différentes introductions testées.",
  "Visualize como a retenção evoluiu entre os diferentes vídeos testados.": "Visualisez l'évolution de la rétention entre les différentes vidéos testées.",
  "Visualize como ficará seu autoplay": "Visualisez le rendu de votre Autoplay",
  "Visualize toda a jornada do seu público em um funil de barras verticais com taxas de conversão entre etapas.": "Visualisez tout le parcours de votre audience dans un tunnel de barres verticales avec les taux de conversion entre les étapes.",
  "Visão Geral": "Vue d'ensemble",
  "Visão Geral da Plataforma": "Vue d'ensemble de la plateforme",
  "Visão em grade": "Vue en grille",
  "Visão em lista": "Vue en liste",
  "Visão geral": "Vue d'ensemble",
  "Visão geral da plataforma": "Vue d'ensemble de la plateforme",
  "Você ainda não compartilhou nenhum vídeo": "Vous n'avez encore partagé aucune vidéo",
  "Você ainda não convidou nenhum membro para sua equipe. Comece adicionando membros para colaborar em seus projetos.": "Vous n'avez encore invité aucun membre dans votre équipe. Commencez par ajouter des membres pour collaborer sur vos projets.",
  "Você ainda não criou nenhum teste de hook.": "Vous n'avez encore créé aucun test d'accroche.",
  "Você ainda não criou playlists": "Vous n'avez pas encore créé de playlists",
  "Você ainda não tem vídeos": "Vous n'avez pas encore de vidéos",
  "Você ainda não tem vídeos processados": "Vous n'avez pas encore de vidéos traitées",
  "Você ainda não tem webinários": "Vous n'avez pas encore de webinaires",
  "Você ainda pode aplicar a regra para o país inteiro.": "Vous pouvez encore appliquer la règle au pays entier.",
  "Você ainda pode enviar {value0} vídeo{value1} agora. Aguarde os atuais terminarem para enviar mais.": "Vous pouvez encore envoyer {value0} vidéo{value1} maintenant. Attendez la fin des envois en cours pour en envoyer davantage.",
  "Você ainda pode importar {value0} vídeo{value1} agora.": "Vous pouvez encore importer {value0} vidéo{value1} maintenant.",
  "Você atingiu o limite de vídeos do período de teste. Ative seu plano agora para voltar a enviar vídeos — leva menos de um minuto.": "Vous avez atteint la limite de vidéos de la période d'essai. Activez votre forfait pour envoyer à nouveau des vidéos : cela prend moins d'une minute.",
  "Você bloqueou as notificações. Para ativá-las novamente, acesse as configurações do seu navegador e permita notificações para este site.": "Vous avez bloqué les notifications. Pour les réactiver, ouvrez les paramètres de votre navigateur et autorisez les notifications pour ce site.",
  "Você bloqueou as notificações. Para ativá-las novamente, acesse as configurações do seu navegador.": "Vous avez bloqué les notifications. Pour les réactiver, ouvrez les paramètres de votre navigateur.",
  "Você completou esta série!": "Vous avez terminé cette série !",
  "Você concluiu toda a playlist \"": "Vous avez terminé toute la playlist «",
  "Você conectou plataformas, agora vincule sua VSL para capturar as vendas.": "Vous avez connecté les plateformes. Associez maintenant votre VSL pour recueillir les ventes.",
  "Você confirma que deseja excluir este vídeo da playlist?": "Confirmez-vous le retrait de cette vidéo de la playlist ?",
  "Você deve aceitar os termos": "Vous devez accepter les conditions",
  "Você encerra o teste quando quiser.": "Vous terminez le test quand vous le souhaitez.",
  "Você encerra quando quiser.": "Vous terminez quand vous le souhaitez.",
  "Você está offline. Verifique sua conexão.": "Vous êtes hors ligne. Vérifiez votre connexion.",
  "Você está prestes a iniciar um teste com": "Vous êtes sur le point de lancer un test avec",
  "Você está recebendo notificações push sobre eventos importantes da sua conta. Configure abaixo quais tipos de alertas deseja receber.": "Vous recevez des notifications push concernant les événements importants de votre compte. Configurez ci-dessous les types d'alertes souhaités.",
  "Você está solicitando o saque do seu saldo liberado de": "Vous demandez le retrait de votre solde disponible de",
  "Você está visualizando o Dashboard no Modo Teste.": "Vous consultez le tableau de bord en mode test.",
  "Você gerou tokens demais hoje. Tente novamente em 1 hora.": "Vous avez généré trop de jetons aujourd'hui. Réessayez dans 1 heure.",
  "Você já clonou este vídeo. Cada vídeo pode ser copiado apenas uma vez para sua conta.": "Vous avez déjà cloné cette vidéo. Chaque vidéo ne peut être copiée qu'une seule fois dans votre compte.",
  "Você já começou a assistir esse vídeo": "Vous avez déjà commencé à regarder cette vidéo",
  "Você já pode acessá-lo em": "Vous pouvez déjà y accéder dans",
  "Você não poderá compartilhar este vídeo com outras pessoas.": "Vous ne pourrez pas partager cette vidéo avec d'autres personnes.",
  "Você não possui nenhum Rastreamento ativo": "Vous n'avez aucun suivi actif",
  "Você não tem permissão para fazer upload de vídeos.": "Vous n'avez pas l'autorisation d'envoyer des vidéos.",
  "Você parou em": "Vous vous êtes arrêté à",
  "Você parou em um ponto importante do vídeo.": "Vous vous êtes arrêté à un moment important de la vidéo.",
  "Você perderá acesso a todos os recursos da HostVSL": "Vous perdrez l'accès à toutes les fonctionnalités de HostVSL",
  "Você pode acessar o HostVSL pela tela inicial": "Vous pouvez accéder à HostVSL depuis l'écran d'accueil",
  "Você pode acessar o HostVSL pela tela inicial do seu dispositivo.": "Vous pouvez accéder à HostVSL depuis l'écran d'accueil de votre appareil.",
  "Você pode adicionar quantos vídeos quiser para testar diferentes abordagens.": "Vous pouvez ajouter autant de vidéos que vous le souhaitez pour tester différentes approches.",
  "Você poderá escolher arquivos da sua conta Google com segurança.": "Vous pourrez choisir des fichiers dans votre compte Google de manière sécurisée.",
  "Você poderá mover vídeos para esta pasta depois. (": "Vous pourrez déplacer des vidéos vers ce dossier plus tard. (",
  "Você precisa aceitar os termos": "Vous devez accepter les conditions",
  "Você precisa aceitar os termos de uso para continuar.": "Vous devez accepter les conditions d'utilisation pour continuer.",
  "Você precisa de um plano ativo para enviar vídeos. Ative um plano para continuar.": "Vous devez disposer d'un forfait actif pour envoyer des vidéos. Activez un forfait pour continuer.",
  "Você precisa estar autenticado.": "Vous devez être authentifié.",
  "Você precisa estar logado para criar um teste.": "Vous devez être connecté pour créer un test.",
  "Você precisa selecionar um vídeo para continuar": "Vous devez sélectionner une vidéo pour continuer",
  "Você recebe": "Vous recevez",
  "Você recebe 20% de comissão recorrente sobre o valor do plano ativo. Por exemplo: se seu indicado possui o plano de R$ 147/mês, você recebe R$ 29,40 todo mês.": "Vous recevez 20% de commission récurrente sur la valeur du forfait actif. Par exemple, si la personne parrainée dispose du forfait à R$ 147/mois, vous recevez R$ 29,40 chaque mois.",
  "Você recusou o compartilhamento": "Vous avez refusé le partage",
  "Você será cobrado R$": "Vous serez facturé R$",
  "Você será redirecionado em alguns segundos…": "Vous serez redirigé dans quelques secondes…",
  "Você será redirecionado para a sala...": "Vous serez redirigé vers la salle...",
  "Você terá acesso a um painel exclusivo onde poderá acompanhar suas indicações, conversões, comissões e pagamentos em tempo real.": "Vous accéderez à un panneau exclusif pour suivre vos parrainages, conversions, commissions et paiements en temps réel.",
  "Você é o dono do vídeo": "Vous êtes le propriétaire de la vidéo",
  "Você é o proprietário deste vídeo": "Vous êtes le propriétaire de cette vidéo",
  "Volta o vídeo ao início quando a reprodução termina.": "Ramène la vidéo au début lorsque la lecture se termine.",
  "Voltando em": "Retour dans",
  "Voltar": "Retour",
  "Voltar 10 segundos": "Reculer de 10 secondes",
  "Voltar ao Dashboard": "Retour au tableau de bord",
  "Voltar ao dashboard": "Retour au tableau de bord",
  "Voltar ao início": "Retour au début",
  "Voltar para Detalhes": "Retour aux détails",
  "Voltar para Extrato Administrativo": "Retour au relevé administratif",
  "Voltar para HostVSL": "Retour à HostVSL",
  "Voltar para Lista": "Retour à la liste",
  "Voltar para Playlists": "Retour aux playlists",
  "Voltar para a lista": "Retour à la liste",
  "Voltar para a lista de fluxos": "Retour à la liste des parcours",
  "Voltar para login": "Retour à la connexion",
  "Voltar para o login": "Retour à la connexion",
  "Volte para revisar momentos": "Revenez pour revoir des passages",
  "Volume": "Volume",
  "Volume ({value}%)": "Volume ({value}%)",
  "Volume Contratado": "Volume souscrit",
  "Vou abrir o menu do vídeo para você ver as opções disponíveis.": "Je vais ouvrir le menu de la vidéo pour vous montrer les options disponibles.",
  "Voxuy é uma plataforma de envio de SMS em massa.": "Voxuy est une plateforme d'envoi de SMS en masse.",
  "VÍDEO ALTERNATIVO": "VIDÉO DE REMPLACEMENT",
  "Vá até a aba Configurações para cadastrar seu primeiro pixel.": "Ouvrez l'onglet Paramètres pour enregistrer votre premier pixel.",
  "Vá para a aba \"Automático\" e ative um teste de velocidade para ver as métricas aqui.": "Ouvrez l'onglet « Automatique » et activez un test de vitesse pour voir les indicateurs ici.",
  "Válida enquanto durar o evento": "Valable pendant toute la durée de l'événement",
  "Válido por:": "Valable pendant :",
  "Vídeo": "Vidéo",
  "Vídeo \"{value0}\" excluído com sucesso": "Vidéo « {value0} » supprimée avec succès",
  "Vídeo \"{value0}\" pronto para personalização!": "Vidéo « {value0} » prête à personnaliser !",
  "Vídeo 1": "Vidéo 1",
  "Vídeo 2": "Vidéo 2",
  "Vídeo 3": "Vidéo 3",
  "Vídeo A": "Vidéo A",
  "Vídeo Alternativo": "Vidéo de remplacement",
  "Vídeo B": "Vidéo B",
  "Vídeo Base": "Vidéo de base",
  "Vídeo C": "Vidéo C",
  "Vídeo ID:": "ID vidéo :",
  "Vídeo Institucional": "Vidéo institutionnelle",
  "Vídeo Original": "Vidéo d'origine",
  "Vídeo Principal": "Vidéo principale",
  "Vídeo adicionado": "Vidéo ajoutée",
  "Vídeo adicionado com sucesso": "Vidéo ajoutée avec succès",
  "Vídeo alternativo ou URL de redirecionamento é obrigatório": "Une vidéo de remplacement ou une URL de redirection est obligatoire",
  "Vídeo atual": "Vidéo actuelle",
  "Vídeo carregado": "Vidéo chargée",
  "Vídeo com Maior Captura": "Vidéo générant le plus de captures",
  "Vídeo compartilhado": "Vidéo partagée",
  "Vídeo copiado para sua biblioteca": "Vidéo copiée dans votre bibliothèque",
  "Vídeo da Captura": "Vidéo de la capture",
  "Vídeo da etapa": "Vidéo de l'étape",
  "Vídeo de Fundo": "Vidéo d'arrière-plan",
  "Vídeo de Fundo Inteligente": "Vidéo d'arrière-plan intelligente",
  "Vídeo de Lançamento": "Vidéo de lancement",
  "Vídeo de entrada": "Vidéo d'entrée",
  "Vídeo de entrada (antes da VSL) e vídeo de saída (depois) — use um ou os dois": "Vidéo d'entrée avant la VSL et vidéo de sortie après : utilisez l'une ou les deux",
  "Vídeo de entrada exibido": "Vidéo d'entrée affichée",
  "Vídeo de fundo começa mutado (recomendado)": "La vidéo d'arrière-plan commence sans son (recommandé)",
  "Vídeo de origem": "Vidéo source",
  "Vídeo de origem não encontrado.": "Vidéo source introuvable.",
  "Vídeo de saída": "Vidéo de sortie",
  "Vídeo de saída não configurado": "Vidéo de sortie non configurée",
  "Vídeo de segurança": "Vidéo de secours",
  "Vídeo de vendas": "Vidéo de vente",
  "Vídeo disponível na biblioteca": "Vidéo disponible dans la bibliothèque",
  "Vídeo duplicado com configurações padrão.": "Vidéo dupliquée avec les paramètres par défaut.",
  "Vídeo e tempos": "Vidéo et temps",
  "Vídeo em preparo": "Vidéo en préparation",
  "Vídeo em preparo. Acesse Vídeos Compartilhados para gerenciar.": "Vidéo en préparation. Ouvrez Vidéos partagées pour la gérer.",
  "Vídeo excluído com sucesso": "Vidéo supprimée avec succès",
  "Vídeo excluído com sucesso!": "Vidéo supprimée avec succès !",
  "Vídeo excluído.": "Vidéo supprimée.",
  "Vídeo final exibido": "Vidéo finale affichée",
  "Vídeo importado com sucesso!": "Vidéo importée avec succès !",
  "Vídeo já clonado": "Vidéo déjà clonée",
  "Vídeo já está sendo usado em": "Vidéo déjà utilisée dans",
  "Vídeo movido para a pasta com sucesso!": "Vidéo déplacée vers le dossier avec succès !",
  "Vídeo não encontrado": "Vidéo introuvable",
  "Vídeo não encontrado para salvar o pitch.": "Vidéo introuvable pour enregistrer l'argumentaire de vente.",
  "Vídeo principal exibido após as variações": "Vidéo principale affichée après les variantes",
  "Vídeo principal não selecionado": "Vidéo principale non sélectionnée",
  "Vídeo pronto para personalização!": "Vidéo prête à personnaliser !",
  "Vídeo removido": "Vidéo supprimée",
  "Vídeo removido da pasta!": "Vidéo retirée du dossier !",
  "Vídeo renomeado": "Vidéo renommée",
  "Vídeo renomeado com sucesso": "Vidéo renommée avec succès",
  "Vídeo renomeado com sucesso!": "Vidéo renommée avec succès !",
  "Vídeo selecionado": "Vidéo sélectionnée",
  "Vídeo sem pitch nesta posição — clique para definir": "Aucun argumentaire à cette position — cliquez pour le définir",
  "Vídeo sem título": "Vidéo sans titre",
  "Vídeo usado como variação no teste": "Vidéo utilisée comme variante dans le test",
  "Vídeo vinculado": "Vidéo associée",
  "Vídeo {value0}": "Vidéo {value0}",
  "Vídeo:": "Vidéo :",
  "Vídeos": "Vidéos",
  "Vídeos & Pastas": "Vidéos et dossiers",
  "Vídeos (1)": "Vidéos (1)",
  "Vídeos Compartilhados": "Vidéos partagées",
  "Vídeos Recentes": "Vidéos récentes",
  "Vídeos adicionados": "Vidéos ajoutées",
  "Vídeos adicionados à fila": "Vidéos ajoutées à la file",
  "Vídeos adicionados!": "Vidéos ajoutées !",
  "Vídeos aplicados:": "Vidéos appliquées :",
  "Vídeos compartilhados": "Vidéos partagées",
  "Vídeos copiados ficam protegidos e não podem ser compartilhados novamente": "Les vidéos copiées restent protégées et ne peuvent pas être partagées à nouveau",
  "Vídeos de Teste": "Vidéos de test",
  "Vídeos disponíveis": "Vidéos disponibles",
  "Vídeos do fluxo": "Vidéos du parcours",
  "Vídeos em HD (1080p) oferecem melhor experiência aos espectadores": "Les vidéos HD (1080p) offrent une meilleure expérience aux spectateurs",
  "Vídeos em Teste": "Vidéos en test",
  "Vídeos específicos": "Vidéos spécifiques",
  "Vídeos ilimitados": "Vidéos illimitées",
  "Vídeos ilimitados sem restrição": "Vidéos illimitées sans restriction",
  "Vídeos na plataforma": "Vidéos sur la plateforme",
  "Vídeos nesta pasta": "Vidéos dans ce dossier",
  "Vídeos rastreados": "Vidéos suivies",
  "Vídeos selecionados:": "Vidéos sélectionnées :",
  "Webhook URL": "URL du webhook",
  "Webhook copiado.": "Webhook copié.",
  "Webhooks": "Webhooks",
  "Webinars": "Webinaires",
  "Webinário de Lançamento": "Webinaire de lancement",
  "Webinários": "Webinaires",
  "WhatsApp": "WhatsApp",
  "WhatsApp inválido": "WhatsApp invalide",
  "WhatsApp inválido.": "WhatsApp invalide.",
  "Wildcard inválido. Use *.seudominio.com.": "Caractère générique invalide. Utilisez *.seudominio.com.",
  "Wizard Teste A/B": "Assistant de test A/B",
  "Wizard Teste Hook": "Assistant de test d'accroche",
  "Wizard completo de criação de Teste A/B com 3 etapas: seleção de vídeos, distribuição de tráfego com drag-and-drop usando DnD-Kit, e cards sortáveis com badge de ordem e slider Radix.": "Assistant complet de création de test A/B en 3 étapes : sélection des vidéos, répartition du trafic par glisser-déposer avec DnD-Kit et cartes réorganisables avec badge d'ordre et curseur Radix.",
  "Wizard criação Teste A/B": "Assistant de création de test A/B",
  "Wizard criação Teste Hook": "Assistant de création de test d'accroche",
  "Your browser does not support the video tag.": "Votre navigateur ne prend pas en charge la balise vidéo.",
  "Zoom": "Zoom",
  "Zoom leve": "Zoom léger",
  "[AO VIVO] Crie seu webinário do zero em 60 minutos": "[EN DIRECT] Créez votre webinaire de zéro en 60 minutes",
  "a qualquer momento.": "à tout moment.",
  "acessos protegidos": "accès protégés",
  "agregado": "agrégé",
  "amostra baixa": "échantillon réduit",
  "ao seu vídeo. O espectador poderá ativar ou desativar a legenda pelo botão": "à votre vidéo. Le spectateur pourra activer ou désactiver les sous-titres avec le bouton",
  "ao vivo": "en direct",
  "as demais estão na tabela abaixo": "les autres figurent dans le tableau ci-dessous",
  "assistindo agora": "regardent actuellement",
  "ativo": "actif",
  "ativos": "actifs",
  "atualizações registradas": "mises à jour enregistrées",
  "até": "jusqu'à",
  "aula": "cours",
  "aula disponível": "cours disponible",
  "aulas": "cours",
  "aulas concluídas": "cours terminés",
  "aulas disponíveis": "cours disponibles",
  "ações configuradas": "actions configurées",
  "blog.exemplo.com": "blog.exemplo.com",
  "breadcrumb": "fil d'Ariane",
  "broip": "broip",
  "cadastrado ainda.": "enregistré pour le moment.",
  "caracteres": "caractères",
  "cliques": "clics",
  "cliques na oferta": "clics sur l'offre",
  "cole": "collez",
  "com": "avec",
  "começa com": "commence par",
  "comissões recorrentes": "commissions récurrentes",
  "compartilhamentos": "partages",
  "computados.": "comptabilisés.",
  "concluído": "terminé",
  "configurações de personalização atuais": "paramètres actuels de personnalisation",
  "conta Google": "compte Google",
  "contém": "contient",
  "conv": "conv",
  "conv.": "conv.",
  "conversões": "conversions",
  "convertido": "converti",
  "cpf:": "CPF :",
  "customer id:": "ID client :",
  "cópia": "copie",
  "cópias": "copies",
  "da audiência ainda está assistindo (": "de l'audience regarde encore (",
  "da sua plataforma": "de votre plateforme",
  "da {value0}": "de {value0}",
  "de": "de",
  "de Conteúdo": "de contenu",
  "de retenção": "de rétention",
  "de taxa de conversão": "de taux de conversion",
  "de variação": "de variation",
  "demais origens": "autres sources",
  "dia": "jour",
  "dias": "jours",
  "dias de teste": "jours d'essai",
  "dias restantes": "jours restants",
  "do seu tráfego vem de dispositivos móveis.": "de votre trafic provient d'appareils mobiles.",
  "do vídeo": "de la vidéo",
  "do vídeo.": "de la vidéo.",
  "dominio.com": "dominio.com",
  "domínio": "domaine",
  "dos seus usuários usam": "de vos utilisateurs utilisent",
  "duração": "durée",
  "e Negócios": "et affaires",
  "e Parceiros": "et partenaires",
  "e as métricas dele. O código colado nos sites para de funcionar. Não dá para desfazer.": "et ses indicateurs. Le code collé sur les sites cesse de fonctionner. Cette action est irréversible.",
  "e congela a tela. O espectador não pode pular nem voltar, apenas clicar no botão para seguir.": "et fige l'écran. Le spectateur ne peut ni passer ni revenir en arrière, seulement cliquer sur le bouton pour continuer.",
  "em execução": "en cours d'exécution",
  "em rascunho": "en brouillon",
  "em receita": "de chiffre d'affaires",
  "em todas as variações, evitando diferenças no tamanho do player.": "dans toutes les variantes, en évitant les différences de taille du lecteur.",
  "em todos os planos": "dans tous les forfaits",
  "em vendas": "de ventes",
  "encontrado": "trouvé",
  "episódios": "épisodes",
  "episódios •": "épisodes •",
  "espectadores": "spectateurs",
  "espectadores ·": "spectateurs ·",
  "está apresentando os melhores resultados.": "obtient les meilleurs résultats.",
  "está com melhor desempenho": "est plus performant",
  "estão desativados. Sem eles, a legenda ficará sempre visível na tela quando ativada e o espectador não terá como desligar.": "sont désactivées. Sans elles, les sous-titres resteront toujours visibles à l'écran lorsqu'ils sont activés et le spectateur ne pourra pas les désactiver.",
  "etapa": "étape",
  "etapas": "étapes",
  "evento(s) nas últimas 24h (": "événement(s) au cours des dernières 24 h (",
  "evento(s), mas nenhum nas últimas 24h (último:": "événement(s), mais aucun au cours des dernières 24 h (dernier :",
  "eventos": "événements",
  "ex: Português": "ex. : portugais",
  "ex: dominio.com ou dominio.com/pagina": "ex. : dominio.com ou dominio.com/pagina",
  "ex: pt-BR, zh-TW": "ex. : pt-BR, zh-TW",
  "exemplo.com": "exemplo.com",
  "exemplo.com/vendas": "exemplo.com/vendas",
  "fatura": "facture",
  "faturas": "factures",
  "ficou no topo": "est arrivé en tête",
  "fim": "fin",
  "foi copiado para sua conta.": "a été copié dans votre compte.",
  "formulário": "formulaire",
  "gapi indisponível após carregar api.js": "gapi indisponible après le chargement de api.js",
  "group-[.toast]:text-muted-foreground": "group-[.toast]:text-muted-foreground",
  "hrs": "h",
  "há 1 dia": "il y a 1 jour",
  "há 1 mês": "il y a 1 mois",
  "iFrame": "iFrame",
  "id:": "ID :",
  "indisponível": "indisponible",
  "inscrições": "inscriptions",
  "intro": "intro",
  "intro será rastreada": "intro sera suivie",
  "introduções": "introductions",
  "intros": "intros",
  "intros serão rastreadas": "intros seront suivies",
  "itens)": "éléments)",
  "leads": "leads",
  "leads (": "leads (",
  "legenda": "sous-titre",
  "legendas": "sous-titres",
  "maior audiência": "plus forte audience",
  "maior número de conversões": "plus grand nombre de conversions",
  "maior receita gerada": "chiffre d'affaires le plus élevé",
  "melhor taxa de conversão": "meilleur taux de conversion",
  "mensal": "mensuel",
  "mesma proporção": "même proportion",
  "min": "min",
  "minutos": "minutes",
  "minutos após o início": "minutes après le début",
  "mm:ss": "mm:ss",
  "modo compacto": "mode compact",
  "média": "moyenne",
  "média hoje": "moyenne aujourd'hui",
  "na barra inferior do Safari": "dans la barre inférieure de Safari",
  "nas variações já criadas.": "dans les variantes déjà créées.",
  "navegue": "parcourez",
  "no 1º mês": "le 1er mois",
  "no menu": "dans le menu",
  "no menu esquerdo.": "dans le menu de gauche.",
  "no primeiro mês": "le premier mois",
  "no total).": "au total).",
  "nos controles.": "dans les commandes.",
  "nova aba": "nouvel onglet",
  "novo": "nouveau",
  "não contém": "ne contient pas",
  "não serão refletidas": "ne seront pas prises en compte",
  "número de conversões": "nombre de conversions",
  "o vídeo de saída começa assim que o principal termina, conduzindo o espectador para a próxima ação.": "la vidéo de sortie commence dès la fin de la vidéo principale pour guider le spectateur vers l'action suivante.",
  "oferta visível": "offre visible",
  "offline": "hors ligne",
  "opções": "options",
  "origem detectada": "source détectée",
  "origens com curva de retenção": "sources avec courbe de rétention",
  "origens detectadas": "sources détectées",
  "origens no gráfico. Veja todas na tabela abaixo.": "sources dans le graphique. Retrouvez-les toutes dans le tableau ci-dessous.",
  "ou": "ou",
  "ou R$ 154,68 à vista": "ou R$ 154,68 en un seul paiement",
  "ou clique no botão abaixo para escolher seus arquivos": "ou cliquez sur le bouton ci-dessous pour choisir vos fichiers",
  "ou clique no botão abaixo para selecionar": "ou cliquez sur le bouton ci-dessous pour sélectionner",
  "ou clique para selecionar": "ou cliquez pour sélectionner",
  "ou clique para selecionar do seu computador": "ou cliquez pour sélectionner depuis votre ordinateur",
  "ou importe de": "ou importez depuis",
  "outras regras...": "autres règles...",
  "padrão": "par défaut",
  "pagination": "pagination",
  "para aumentar a retenção na marca de 1:45, onde ocorre uma queda significativa no engajamento.": "pour augmenter la rétention à 1:45, où l'engagement baisse fortement.",
  "para cada intro. Sem isso, a plataforma não envia as conversões. Você também encontra estas URLs em": "pour chaque intro. Sans cela, la plateforme n'envoie pas les conversions. Vous trouverez aussi ces URL dans",
  "para começar o fluxo.": "pour commencer le parcours.",
  "para confirmar": "pour confirmer",
  "para escalar VSLs.": "pour développer vos VSL.",
  "para melhorar o carregamento.": "pour améliorer le chargement.",
  "pausa": "pause",
  "pitches.": "argumentaires de vente.",
  "plataforma configurada": "plateforme configurée",
  "plataformas atingido": "plateformes atteinte",
  "plataformas configuradas": "plateformes configurées",
  "plataformas para comparar": "plateformes à comparer",
  "plays": "lectures",
  "plays analisados": "lectures analysées",
  "plays extras": "lectures supplémentaires",
  "plays inclusos por mês": "lectures incluses par mois",
  "plays utilizados": "lectures utilisées",
  "plays únicos": "lectures uniques",
  "por": "par",
  "por dia e horário": "par jour et horaire",
  "problema": "problème",
  "problemas": "problèmes",
  "quando seus plays acabarem": "lorsque vos lectures seront épuisées",
  "queda de": "baisse de",
  "rascunho": "brouillon",
  "receita gerada": "chiffre d'affaires généré",
  "registro": "enregistrement",
  "registro(s)": "enregistrement(s)",
  "registros": "enregistrements",
  "regra": "règle",
  "restantes": "restants",
  "retenção": "rétention",
  "rotas •": "routes •",
  "s após abertura": "s après l'ouverture",
  "s do Pitch": "s de l'argumentaire de vente",
  "s do vídeo": "s de la vidéo",
  "s restantes": "s restantes",
  "saída": "sortie",
  "saídas": "sorties",
  "seg": "s",
  "segundo": "seconde",
  "segundos": "secondes",
  "selecionadas)": "sélectionnées)",
  "selecionado": "sélectionné",
  "selecionados": "sélectionnés",
  "sem destino": "sans destination",
  "sem edição": "sans modification",
  "sem window": "sans window",
  "senha": "mot de passe",
  "seu-link": "seu-link",
  "seusite.com": "seusite.com",
  "sobre os planos ativados pelos clientes que você indicar.": "sur les forfaits activés par les clients que vous parrainez.",
  "src/components/": "src/components/",
  "status da inscrição:": "statut de l'inscription :",
  "stores •": "stores •",
  "sua_chave_api_do_activecampaign": "sua_chave_api_do_activecampaign",
  "taxa de conversão": "taux de conversion",
  "terminando em": "se terminant par",
  "todo mês!": "chaque mois !",
  "total": "total",
  "tracking(s)?": "suivi(s) ?",
  "trackings selecionados? Esta ação não pode ser desfeita.": "suivis sélectionnés ? Cette action est irréversible.",
  "usados": "utilisés",
  "useCustomAuth must be used within CustomAuthProvider": "useCustomAuth doit être utilisé dans CustomAuthProvider",
  "useDashboard must be used within a DashboardProvider": "useDashboard doit être utilisé dans DashboardProvider",
  "useDrawer must be used within a DrawerProvider": "useDrawer doit être utilisé dans DrawerProvider",
  "useNewVideoModal must be used within a NewVideoModalProvider": "useNewVideoModal doit être utilisé dans NewVideoModalProvider",
  "useSidebar must be used within a SidebarProvider.": "useSidebar doit être utilisé dans SidebarProvider.",
  "useSupportTokenModal must be used within SupportTokenProvider": "useSupportTokenModal doit être utilisé dans SupportTokenProvider",
  "useTestMode must be used within a TestModeProvider": "useTestMode doit être utilisé dans TestModeProvider",
  "useTheme must be used within ThemeProvider": "useTheme doit être utilisé dans ThemeProvider",
  "useTour must be inside TourProvider": "useTour doit être dans TourProvider",
  "userId é obrigatório para ativar um teste": "userId est obligatoire pour activer un test",
  "userId é obrigatório para criar um teste": "userId est obligatoire pour créer un test",
  "usuário": "utilisateur",
  "utm_campaign": "utm_campaign",
  "utm_campaign (ex: lancamento)": "utm_campaign (ex. : lancement)",
  "utm_content": "utm_content",
  "utm_medium": "utm_medium",
  "utm_medium (ex: video)": "utm_medium (ex. : vidéo)",
  "utm_source": "utm_source",
  "utm_source (ex: youtube)": "utm_source (ex. : youtube)",
  "utm_term": "utm_term",
  "v1.1.0 | dev": "v1.1.0 | dev",
  "variações:": "variantes :",
  "vazio": "vide",
  "vezes": "fois",
  "videoId é obrigatório para criar um teste": "videoId est obligatoire pour créer un test",
  "views": "vues",
  "visualizações": "vues",
  "visualizações únicas": "vues uniques",
  "visualizações)": "vues)",
  "visualizações).": "vues).",
  "vídeo": "vidéo",
  "vídeo selecionado": "vidéo sélectionnée",
  "vídeo(s)": "vidéo(s)",
  "vídeo(s)? Esta ação não pode ser desfeita.": "vidéo(s) ? Cette action est irréversible.",
  "vídeos": "vidéos",
  "vídeos em teste": "vidéos en test",
  "vídeos selecionados": "vidéos sélectionnées",
  "vídeos sem funil configurado": "vidéos sans tunnel configuré",
  "vídeos)": "vidéos)",
  "{nome} de {cidade} acabou de comprar {produto}": "{nome} de {cidade} vient d'acheter {produto}",
  "{value0} (clique duas vezes para renomear)": "{value0} (double-cliquez pour renommer)",
  "{value0} (seletor)": "{value0} (sélecteur)",
  "{value0} (valor)": "{value0} (valeur)",
  "{value0} arquivo(s) acima do limite de 2GB. Baixe pro PC primeiro.": "{value0} fichier(s) dépasse(nt) la limite de 2 Go. Téléchargez-les d'abord sur votre ordinateur.",
  "{value0} de {value1} integrações criadas. Você pode configurar as demais em Rastreamento.": "{value0} intégrations créées sur {value1}. Vous pouvez configurer les autres dans Suivi.",
  "{value0} ficou no topo": "{value0} est arrivé en tête",
  "{value0} indisponível neste ambiente. Tente novamente mais tarde.": "{value0} indisponible dans cet environnement. Réessayez plus tard.",
  "{value0} logo": "Logo {value0}",
  "{value0} notificações não lidas": "{value0} notifications non lues",
  "{value0} plays adicionados com sucesso!": "{value0} lectures ajoutées avec succès !",
  "{value0} registro(s) exportado(s).": "{value0} enregistrement(s) exporté(s).",
  "{value0} removido da seleção": "{value0} retiré de la sélection",
  "{value0} thumbnail": "Miniature {value0}",
  "{value0} tracking(s) excluído(s) com sucesso!": "{value0} suivi(s) supprimé(s) avec succès !",
  "{value0} vídeo(s) adicionado(s) à fila": "{value0} vidéo(s) ajoutée(s) à la file",
  "{value0} vídeo(s) adicionado(s) à pasta": "{value0} vidéo(s) ajoutée(s) au dossier",
  "{value0} vídeo(s) adicionado(s) à playlist.": "{value0} vidéo(s) ajoutée(s) à la playlist.",
  "{value0} vídeo(s) em processamento": "{value0} vidéo(s) en cours de traitement",
  "{value0} vídeo(s) excluído(s) com sucesso": "{value0} vidéo(s) supprimée(s) avec succès",
  "{value0} vídeos": "{value0} vidéos",
  "{value0} vídeos enviando": "{value0} vidéos en cours d'envoi",
  "{value0} vídeo{value1} importado{value2}": "{value0} vidéo{value1} importée{value2}",
  "{value0} vídeo{value1} importado{value2} com sucesso": "{value0} vidéo{value1} importée{value2} avec succès",
  "{value0} vídeo{value1} na fila de envio.": "{value0} vidéo{value1} dans la file d'envoi.",
  "{value0} únicos": "{value0} uniques",
  "{value0} • Atualizado: {value1}": "{value0} • Mis à jour : {value1}",
  "{value0}% (individual)": "{value0}% (individuel)",
  "{value0}% taxa de clique": "Taux de clics de {value0}%",
  "{value0}, {value1}, {value2} {value3} ({value4}% do pico)": "{value0}, {value1}, {value2} {value3} ({value4}% du pic)",
  "{value0}º pitch": "Argumentaire de vente nº{value0}",
  "| Conta: ****": "| Compte : ****",
  "© 2025 Host VSL": "© 2025 Host VSL",
  "© HostVSL. 2025. Todos os direitos reservados.": "© HostVSL. 2025. Tous droits réservés.",
  "± 8% variação": "± 8% de variation",
  "· Página": "· Page",
  "· assistido em média": "· durée moyenne regardée",
  "Área de membros não encontrada": "Espace membres introuvable",
  "Área de upload de vídeo. Pressione Enter para selecionar um arquivo": "Zone d'envoi de vidéo. Appuyez sur Entrée pour sélectionner un fichier",
  "Área restrita a administradores.": "Zone réservée aux administrateurs.",
  "Área restrita a parceiros e gestores.": "Zone réservée aux partenaires et aux gestionnaires.",
  "Área restrita exclusivamente para administradores.": "Zone exclusivement réservée aux administrateurs.",
  "Área segura": "Zone sécurisée",
  "Área segura visual para garantir visibilidade em todos os dispositivos": "Zone de sécurité visuelle pour garantir la visibilité sur tous les appareils",
  "Áudio": "Audio",
  "É necessário definir uma senha.": "Vous devez définir un mot de passe.",
  "É necessário selecionar um vídeo.": "Vous devez sélectionner une vidéo.",
  "É necessário ter pelo menos 2 variações para criar um teste A/B": "Au moins 2 variantes sont nécessaires pour créer un test A/B",
  "É o checkout": "Il s'agit du paiement",
  "É um programa onde você indica a Host VSL e recebe 20% de comissão recorrente sobre os planos ativados pelos clientes que você indicar.": "Ce programme vous permet de recommander Host VSL et de recevoir 20% de commission récurrente sur les forfaits activés par les clients parrainés.",
  "Ícone": "Icône",
  "Ícone Personalizado": "Icône personnalisée",
  "Ícone de Exibição": "Icône affichée",
  "Ícone de som": "Icône de son",
  "Ícone do Play": "Icône de lecture",
  "Ícone personalizado": "Icône personnalisée",
  "Última Interação": "Dernière interaction",
  "Última atividade detectada": "Dernière activité détectée",
  "Última atualização: agora": "Dernière mise à jour : maintenant",
  "Última edição": "Dernière modification",
  "Última legenda removida. Arquivo excluído.": "Derniers sous-titres supprimés. Fichier supprimé.",
  "Últimas 24h": "Dernières 24 h",
  "Últimas Atualizações": "Dernières mises à jour",
  "Últimas atualizações": "Dernières mises à jour",
  "Último Teste": "Dernier test",
  "Último salvamento:": "Dernier enregistrement :",
  "Último uso": "Dernière utilisation",
  "Últimos 30 dias": "30 derniers jours",
  "Últimos 7 dias": "7 derniers jours",
  "Últimos Eventos": "Derniers événements",
  "Únicas": "Uniques",
  "Únicos": "Uniques",
  "é igual a": "est égal à",
  "únicas": "uniques",
  "únicos": "uniques",
  "— Escolha um vídeo —": "— Choisissez une vidéo —",
  "— Sem destino —": "— Sans destination —",
  "• 3 fontes profissionais": "• 3 polices professionnelles",
  "• Analytics avançados": "• Analyses avancées",
  "• Animações CSS": "• Animations CSS",
  "• As notificações funcionam mesmo com o navegador fechado (em segundo plano)": "• Les notifications fonctionnent même lorsque le navigateur est fermé (en arrière-plan)",
  "• As preferências são salvas automaticamente ao alterar qualquer configuração": "• Les préférences sont enregistrées automatiquement à chaque modification de paramètre",
  "• Até 3 variações simultâneas": "• Jusqu'à 3 variantes simultanées",
  "• CTR (Click-through Rate)": "• CTR (taux de clics)",
  "• Compressão automática": "• Compression automatique",
  "• Configurações de qualidade": "• Paramètres de qualité",
  "• Controle total com código": "• Contrôle total par le code",
  "• Cores personalizáveis": "• Couleurs personnalisables",
  "• Cores que não contrastam:": "• Couleurs sans contraste :",
  "• Crie urgência:": "• Créez un sentiment d'urgence :",
  "• Código de embed": "• Code d'intégration",
  "• Dispositivo principal: Mobile (65% das capturas)": "• Appareil principal : mobile (65% des captures)",
  "• Divisão automática de tráfego": "• Répartition automatique du trafic",
  "• Editor visual intuitivo": "• Éditeur visuel intuitif",
  "• Engajamento": "• Engagement",
  "• Escalar campanhas entre 22h-24h": "• Développer les campagnes entre 22 h et 24 h",
  "• Formatos PNG, JPEG, GIF": "• Formats PNG, JPEG, GIF",
  "• Headlines genéricas:": "• Titres génériques :",
  "• Horário campeão: 22h-24h com 238 conversões": "• Meilleur horaire : 22 h-24 h avec 238 conversions",
  "• IMPORTANTE: Após a confirmação, os fundos podem levar até 3 dias úteis para constar em sua conta bancária.": "• IMPORTANT : après confirmation, les fonds peuvent mettre jusqu'à 3 jours ouvrés pour apparaître sur votre compte bancaire.",
  "• Integração com CDN": "• Intégration CDN",
  "• Integração com JS": "• Intégration JS",
  "• Investir mais em tráfego móvel (maior conversão)": "• Investir davantage dans le trafic mobile (conversion supérieure)",
  "• Layouts complexos": "• Présentations complexes",
  "• Mantenha legível:": "• Gardez le texte lisible :",
  "• Métricas em tempo real": "• Indicateurs en temps réel",
  "• Múltiplos focos:": "• Plusieurs points d'attention :",
  "• O repasse será depositado na conta bancária padrão vinculada ao seu cadastro.": "• Le versement sera déposé sur le compte bancaire par défaut associé à votre profil.",
  "• O valor mínimo regulamentado para saques manuais é de": "• Le montant minimal réglementé pour les retraits manuels est de",
  "• Otimização de performance": "• Optimisation des performances",
  "• Para desenvolvedores": "• Pour les développeurs",
  "• Posição que cobre conteúdo:": "• Position qui masque le contenu :",
  "• Preview em tempo real": "• Aperçu en temps réel",
  "• Seja específico:": "• Soyez précis :",
  "• Tamanho máximo: 2MB": "• Taille maximale : 2 Mo",
  "• Tamanhos responsivos": "• Tailles adaptatives",
  "• Taxa de completude de dados: 92% (excelente)": "• Taux de complétude des données : 92% (excellent)",
  "• Taxa de conversão": "• Taux de conversion",
  "• Taxas operacionais de saque serão debitadas de acordo com as regras internas do split.": "• Les frais opérationnels de retrait seront débités selon les règles internes de répartition.",
  "• Tempo médio de exibição": "• Durée moyenne de visionnage",
  "• Testar captura com senha neste horário": "• Tester la capture avec mot de passe à cet horaire",
  "• Teste posições:": "• Testez les positions :",
  "• Texto muito longo:": "• Texte trop long :",
  "• Timing inadequado:": "• Synchronisation inadaptée :",
  "• Upload de imagens/GIFs": "• Importation d'images/GIF",
  "• Use números:": "• Utilisez des chiffres :",
  "• Use o botão \"Enviar Notificação Teste\" para verificar se está tudo funcionando": "• Utilisez le bouton « Envoyer une notification de test » pour vérifier le fonctionnement",
  "• Use power words:": "• Utilisez des mots forts :",
  "• Versões desktop/mobile": "• Versions ordinateur/mobile",
  "• Você pode desativar notificações específicas sem perder as outras": "• Vous pouvez désactiver certaines notifications sans perdre les autres",
  "ℹ️ Formulário configurado para aparecer em:": "ℹ️ Formulaire configuré pour apparaître à :",
  "← Voltar para Métricas": "← Retour aux indicateurs",
  "→ Será salvo como:": "→ Sera enregistré sous :",
  "→ Será salvo como: https://": "→ Sera enregistré sous : https://",
  "⏰ Horário de pico": "⏰ Heure de pointe",
  "⚛️ Componentes React": "⚛️ Composants React",
  "⚠️ Alguns navegadores podem restringir o áudio automático mesmo após interação do visitante.": "⚠️ Certains navigateurs peuvent limiter le son automatique même après une interaction du visiteur.",
  "⚠️ Aviso: Dados grandes": "⚠️ Attention : données volumineuses",
  "⚠️ Este domínio já está cadastrado": "⚠️ Ce domaine est déjà enregistré",
  "⚠️ O usuário ainda não configurou uma conta padrão!": "⚠️ L'utilisateur n'a pas encore configuré de compte par défaut !",
  "⚠️ Velocidades muito altas (acima de 1.5x) podem prejudicar a compreensão e confiança no conteúdo.": "⚠️ Des vitesses très élevées (supérieures à 1.5x) peuvent nuire à la compréhension et à la confiance dans le contenu.",
  "⚠️ ÚLTIMA CHANCE!": "⚠️ DERNIÈRE CHANCE !",
  "⚡ Requisito: Autoplay Ativo": "⚡ Prérequis : Autoplay actif",
  "✅ \"{value0}\" foi movido com sucesso!": "✅ « {value0} » a été déplacé avec succès !",
  "✅ Faça": "✅ À faire",
  "✅ Status: OK": "✅ Statut : OK",
  "✅ Thumbnail adicionada com sucesso": "✅ Miniature ajoutée avec succès",
  "✖ O domínio inserido não é válido": "✖ Le domaine saisi est invalide",
  "✨ 15 dias grátis": "✨ 15 jours gratuits",
  "✨ Proteção geográfica configurada com sucesso!": "✨ Protection géographique configurée avec succès !",
  "✨ Proteção por região configurada com sucesso!": "✨ Protection par région configurée avec succès !",
  "❌ Erro ao importar": "❌ Erreur lors de l'importation",
  "❌ Evite": "❌ À éviter",
  "❓ Como funciona": "❓ Comment ça marche",
  "⭐ Diferenciais Premium": "⭐ Avantages premium",
  "🌍 Proteção por Localização": "🌍 Protection par localisation",
  "🌐 Environment:": "🌐 Environnement :",
  "🎁 Bônus": "🎁 Bonus",
  "🎉 Notificações ativadas!": "🎉 Notifications activées !",
  "🎉 Nova conversão!": "🎉 Nouvelle conversion !",
  "🎥 Taxa de Reprodução": "🎥 Taux de lecture",
  "🎥 Vídeo:": "🎥 Vidéo :",
  "🎨 Cores do Tema": "🎨 Couleurs du thème",
  "🎨 Modos de Criação": "🎨 Modes de création",
  "🎬 Vamos começar sua transformação em vídeo?": "🎬 Commençons votre transformation en vidéo !",
  "🎯 Configurações Netflix": "🎯 Paramètres Netflix",
  "🎯 Melhores Práticas": "🎯 Bonnes pratiques",
  "🎯 O ideal": "🎯 L'idéal",
  "🎯 O ideal: curva estável com retenção >50% até metade da VSL.": "🎯 L'idéal : une courbe stable avec une rétention >50% jusqu'à la moitié de la VSL.",
  "🏆 Estratégias Avançadas": "🏆 Stratégies avancées",
  "🏆 Horário Campeão": "🏆 Meilleur horaire",
  "🏆 Velocidade Campeã": "🏆 Vitesse gagnante",
  "👑 Principal": "👑 Principal",
  "👤 Ações do Usuário": "👤 Actions de l'utilisateur",
  "👤 Criador": "👤 Créateur",
  "💡 Barra verde indica o \"Dia Campeão\"": "💡 La barre verte indique le « Meilleur jour »",
  "💡 Clique no vídeo para reproduzir/pausar e testar o formulário": "💡 Cliquez sur la vidéo pour lire/mettre en pause et tester le formulaire",
  "💡 Dica": "💡 Conseil",
  "💡 Dica Inteligente": "💡 Conseil intelligent",
  "💡 Dica de Ouro": "💡 Conseil précieux",
  "💡 Dica: Configure um teste na aba \"Teste A/B\" para visualizar métricas comparativas por variação.": "💡 Conseil : configurez un test dans l'onglet « Test A/B » pour afficher les indicateurs comparatifs par variante.",
  "💡 Dica: Configure um teste na aba 'Teste A/B' para visualizar métricas comparativas por variação.": "💡 Conseil : configurez un test dans l'onglet « Test A/B » pour afficher les indicateurs comparatifs par variante.",
  "💡 Dicas de Templates": "💡 Conseils sur les modèles",
  "💡 Insight Automático": "💡 Analyse automatique",
  "💡 Insight do Dia": "💡 Analyse du jour",
  "💡 Os vídeos são opcionais e serão aplicados conforme a ação escolhida.": "💡 Les vidéos sont facultatives et seront appliquées selon l'action choisie.",
  "💡 Pronto? Suba seu vídeo agora e surpreenda seus espectadores.": "💡 Prêt ? Envoyez votre vidéo maintenant et surprenez vos spectateurs.",
  "💡 Recomendações": "💡 Recommandations",
  "💡 Sobre as notificações": "💡 À propos des notifications",
  "💾 localStorage (persist)": "💾 localStorage (persist)",
  "📈 Engajamento": "📈 Engagement",
  "📊 Análise de Introduções": "📊 Analyse des introductions",
  "📊 Análise de Retenção – VSLs Testadas": "📊 Analyse de rétention – VSL testées",
  "📊 Interpretando os Resultados": "📊 Interprétation des résultats",
  "📊 Interpretação das Métricas": "📊 Interprétation des indicateurs",
  "📊 Meta alcançada!": "📊 Objectif atteint !",
  "📊 Métricas do Vídeo": "📊 Indicateurs de la vidéo",
  "📊 Métricas —": "📊 Indicateurs —",
  "📊 O teste está ativo, mas ainda não há métricas disponíveis. As métricas aparecerão assim que houver visualizações.": "📊 Le test est actif, mais aucun indicateur n'est encore disponible. Ils apparaîtront dès les premières vues.",
  "📊 Principais Insights": "📊 Principales analyses",
  "📋 Como melhorar?": "📋 Comment améliorer ?",
  "📋 O que são Headlines/Subheadlines?": "📋 Que sont les titres et sous-titres ?",
  "📋 Sugestões Avançadas": "📋 Suggestions avancées",
  "📋 Ver Análise Educacional": "📋 Voir l'analyse pédagogique",
  "📌 Sugestões": "📌 Suggestions",
  "📘 Como interpretar os dados do Teste A/B?": "📘 Comment interpréter les données du test A/B ?",
  "📘 Como interpretar?": "📘 Comment interpréter ?",
  "📝 Rodapé": "📝 Pied de page",
  "📤 Upload iniciado": "📤 Envoi démarré",
  "📦 Código de Incorporação": "📦 Code d'intégration",
  "📱 Mobile": "📱 Mobile",
  "📷 Personalização do Header": "📷 Personnalisation de l'en-tête",
  "🔁 Visualizações x Plays": "🔁 Vues et lectures",
  "🔒 Conexão segura • Dados criptografados • Suporte 24/7": "🔒 Connexion sécurisée • Données chiffrées • Support 24/7",
  "🔒 Site seguro": "🔒 Site sécurisé",
  "🔗 Botão Externo": "🔗 Bouton externe",
  "🔥 Alto engajamento!": "🔥 Engagement élevé !",
  "🔥 Engajamento": "🔥 Engagement",
  "🔥 Excelente desempenho! Alta taxa de play e engajamento sustentado. \n        💡 Sugestão: aumente gradualmente o tráfego para esta variação.": "🔥 Excellentes performances ! Taux de lecture élevé et engagement soutenu. \n        💡 Suggestion : augmentez progressivement le trafic de cette variante.",
  "🔧 Otimizações Comuns": "🔧 Optimisations courantes",
  "🔴 Perda rápida nos primeiros segundos": "🔴 Perte rapide dans les premières secondes",
  "🕐 Timestamp:": "🕐 Horodatage :",
  "🖥️ Desktop": "🖥️ Ordinateur",
  "🖼️ Favicon e Título": "🖼️ Favicon et titre",
  "🖼️ Logo da Playlist": "🖼️ Logo de la playlist",
  "🗄️ Supabase (API)": "🗄️ Supabase (API)",
  "🚀 Para continuar assistindo, preencha seus dados rápidos abaixo!": "🚀 Pour continuer à regarder, renseignez rapidement vos informations ci-dessous !",
  "🛡️ Código de Incorporação com Proteção": "🛡️ Code d'intégration protégé",
  "🛡️ Proteção por Domínio": "🛡️ Protection par domaine",
  "🟡 Retenção cai significativamente aos 15-20s → promessa confusa?": "🟡 La rétention baisse fortement à 15-20 s → promesse peu claire ?",
  "🟢 Boa estabilidade de retenção ao longo do vídeo": "🟢 Bonne stabilité de la rétention au fil de la vidéo",
  "🧪 Notificação de teste": "🧪 Notification de test"
} satisfies Record<string, string>;
